(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree3d9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree3d9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8f2hE", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $60017ef49634633f$export$ffb0004e005737fa; }, function (v) { return $60017ef49634633f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $60017ef49634633f$export$34b9dba7ce09269b; }, function (v) { return $60017ef49634633f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $60017ef49634633f$export$25062201e9e25d76; }, function (v) { return $60017ef49634633f$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $60017ef49634633f$export$ffb0004e005737fa;
var $60017ef49634633f$export$34b9dba7ce09269b;
var $60017ef49634633f$export$25062201e9e25d76;
"use strict";

var $bnENU = parcelRequire("bnENU");
var $60017ef49634633f$var$k = Symbol.for("react.element"), $60017ef49634633f$var$l = Symbol.for("react.fragment"), $60017ef49634633f$var$m = Object.prototype.hasOwnProperty, $60017ef49634633f$var$n = $bnENU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $60017ef49634633f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $60017ef49634633f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$60017ef49634633f$var$m.call(a, b) && !$60017ef49634633f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $60017ef49634633f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $60017ef49634633f$var$n.current
    };
}
$60017ef49634633f$export$ffb0004e005737fa = $60017ef49634633f$var$l;
$60017ef49634633f$export$34b9dba7ce09269b = $60017ef49634633f$var$q;
$60017ef49634633f$export$25062201e9e25d76 = $60017ef49634633f$var$q;

});
parcelRegister("bnENU", function(module, exports) {
"use strict";

module.exports = (parcelRequire("aJe5t"));

});
parcelRegister("aJe5t", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $7cf908cbc36e9c56$export$dca3b0875bd9a954; }, function (v) { return $7cf908cbc36e9c56$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $7cf908cbc36e9c56$export$16fa2f45be04daa8; }, function (v) { return $7cf908cbc36e9c56$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $7cf908cbc36e9c56$export$ffb0004e005737fa; }, function (v) { return $7cf908cbc36e9c56$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $7cf908cbc36e9c56$export$e2c29f18771995cb; }, function (v) { return $7cf908cbc36e9c56$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $7cf908cbc36e9c56$export$221d75b3f55bb0bd; }, function (v) { return $7cf908cbc36e9c56$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $7cf908cbc36e9c56$export$5f8d39834fd61797; }, function (v) { return $7cf908cbc36e9c56$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $7cf908cbc36e9c56$export$74bf444e3cd11ea5; }, function (v) { return $7cf908cbc36e9c56$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $7cf908cbc36e9c56$export$ae55be85d98224ed; }, function (v) { return $7cf908cbc36e9c56$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $7cf908cbc36e9c56$export$e530037191fcd5d7; }, function (v) { return $7cf908cbc36e9c56$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $7cf908cbc36e9c56$export$fd42f52fd3ae1109; }, function (v) { return $7cf908cbc36e9c56$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $7cf908cbc36e9c56$export$c8a8987d4410bf2d; }, function (v) { return $7cf908cbc36e9c56$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $7cf908cbc36e9c56$export$d38cd72104c1f0e9; }, function (v) { return $7cf908cbc36e9c56$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $7cf908cbc36e9c56$export$7d1e3a5e95ceca43; }, function (v) { return $7cf908cbc36e9c56$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $7cf908cbc36e9c56$export$257a8862b851cb5b; }, function (v) { return $7cf908cbc36e9c56$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $7cf908cbc36e9c56$export$a8257692ac88316c; }, function (v) { return $7cf908cbc36e9c56$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $7cf908cbc36e9c56$export$488013bae63b21da; }, function (v) { return $7cf908cbc36e9c56$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $7cf908cbc36e9c56$export$7c73462e0d25e514; }, function (v) { return $7cf908cbc36e9c56$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $7cf908cbc36e9c56$export$7568632d0d33d16d; }, function (v) { return $7cf908cbc36e9c56$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $7cf908cbc36e9c56$export$88948ce120ea2619; }, function (v) { return $7cf908cbc36e9c56$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $7cf908cbc36e9c56$export$35808ee640e87ca7; }, function (v) { return $7cf908cbc36e9c56$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $7cf908cbc36e9c56$export$fae74005e78b1a27; }, function (v) { return $7cf908cbc36e9c56$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $7cf908cbc36e9c56$export$dc8fbce3eb94dc1e; }, function (v) { return $7cf908cbc36e9c56$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $7cf908cbc36e9c56$export$6a7bc4e911dc01cf; }, function (v) { return $7cf908cbc36e9c56$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $7cf908cbc36e9c56$export$6d9c69b0de29b591; }, function (v) { return $7cf908cbc36e9c56$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $7cf908cbc36e9c56$export$f680877a34711e37; }, function (v) { return $7cf908cbc36e9c56$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $7cf908cbc36e9c56$export$d5a552a76deda3c2; }, function (v) { return $7cf908cbc36e9c56$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $7cf908cbc36e9c56$export$aaabe4eda9ed9969; }, function (v) { return $7cf908cbc36e9c56$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $7cf908cbc36e9c56$export$e5c5a5f917a5871c; }, function (v) { return $7cf908cbc36e9c56$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $7cf908cbc36e9c56$export$1538c33de8887b59; }, function (v) { return $7cf908cbc36e9c56$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $7cf908cbc36e9c56$export$13e3392192263954; }, function (v) { return $7cf908cbc36e9c56$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $7cf908cbc36e9c56$export$b8f5890fc79d6aca; }, function (v) { return $7cf908cbc36e9c56$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $7cf908cbc36e9c56$export$60241385465d0a34; }, function (v) { return $7cf908cbc36e9c56$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $7cf908cbc36e9c56$export$306c0aa65ff9ec16; }, function (v) { return $7cf908cbc36e9c56$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $7cf908cbc36e9c56$export$7b286972b8d8ccbf; }, function (v) { return $7cf908cbc36e9c56$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $7cf908cbc36e9c56$export$83d89fbfd8236492; }, function (v) { return $7cf908cbc36e9c56$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7cf908cbc36e9c56$export$dca3b0875bd9a954;
var $7cf908cbc36e9c56$export$16fa2f45be04daa8;
var $7cf908cbc36e9c56$export$ffb0004e005737fa;
var $7cf908cbc36e9c56$export$e2c29f18771995cb;
var $7cf908cbc36e9c56$export$221d75b3f55bb0bd;
var $7cf908cbc36e9c56$export$5f8d39834fd61797;
var $7cf908cbc36e9c56$export$74bf444e3cd11ea5;
var $7cf908cbc36e9c56$export$ae55be85d98224ed;
var $7cf908cbc36e9c56$export$e530037191fcd5d7;
var $7cf908cbc36e9c56$export$fd42f52fd3ae1109;
var $7cf908cbc36e9c56$export$c8a8987d4410bf2d;
var $7cf908cbc36e9c56$export$d38cd72104c1f0e9;
var $7cf908cbc36e9c56$export$7d1e3a5e95ceca43;
var $7cf908cbc36e9c56$export$257a8862b851cb5b;
var $7cf908cbc36e9c56$export$a8257692ac88316c;
var $7cf908cbc36e9c56$export$488013bae63b21da;
var $7cf908cbc36e9c56$export$7c73462e0d25e514;
var $7cf908cbc36e9c56$export$7568632d0d33d16d;
var $7cf908cbc36e9c56$export$88948ce120ea2619;
var $7cf908cbc36e9c56$export$35808ee640e87ca7;
var $7cf908cbc36e9c56$export$fae74005e78b1a27;
var $7cf908cbc36e9c56$export$dc8fbce3eb94dc1e;
var $7cf908cbc36e9c56$export$6a7bc4e911dc01cf;
var $7cf908cbc36e9c56$export$6d9c69b0de29b591;
var $7cf908cbc36e9c56$export$f680877a34711e37;
var $7cf908cbc36e9c56$export$d5a552a76deda3c2;
var $7cf908cbc36e9c56$export$aaabe4eda9ed9969;
var $7cf908cbc36e9c56$export$e5c5a5f917a5871c;
var $7cf908cbc36e9c56$export$1538c33de8887b59;
var $7cf908cbc36e9c56$export$13e3392192263954;
var $7cf908cbc36e9c56$export$b8f5890fc79d6aca;
var $7cf908cbc36e9c56$export$60241385465d0a34;
var $7cf908cbc36e9c56$export$306c0aa65ff9ec16;
var $7cf908cbc36e9c56$export$7b286972b8d8ccbf;
var $7cf908cbc36e9c56$export$83d89fbfd8236492;
"use strict";
var $7cf908cbc36e9c56$var$l = Symbol.for("react.element"), $7cf908cbc36e9c56$var$n = Symbol.for("react.portal"), $7cf908cbc36e9c56$var$p = Symbol.for("react.fragment"), $7cf908cbc36e9c56$var$q = Symbol.for("react.strict_mode"), $7cf908cbc36e9c56$var$r = Symbol.for("react.profiler"), $7cf908cbc36e9c56$var$t = Symbol.for("react.provider"), $7cf908cbc36e9c56$var$u = Symbol.for("react.context"), $7cf908cbc36e9c56$var$v = Symbol.for("react.forward_ref"), $7cf908cbc36e9c56$var$w = Symbol.for("react.suspense"), $7cf908cbc36e9c56$var$x = Symbol.for("react.memo"), $7cf908cbc36e9c56$var$y = Symbol.for("react.lazy"), $7cf908cbc36e9c56$var$z = Symbol.iterator;
function $7cf908cbc36e9c56$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $7cf908cbc36e9c56$var$z && a[$7cf908cbc36e9c56$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7cf908cbc36e9c56$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $7cf908cbc36e9c56$var$C = Object.assign, $7cf908cbc36e9c56$var$D = {};
function $7cf908cbc36e9c56$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7cf908cbc36e9c56$var$D;
    this.updater = e || $7cf908cbc36e9c56$var$B;
}
$7cf908cbc36e9c56$var$E.prototype.isReactComponent = {};
$7cf908cbc36e9c56$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$7cf908cbc36e9c56$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $7cf908cbc36e9c56$var$F() {}
$7cf908cbc36e9c56$var$F.prototype = $7cf908cbc36e9c56$var$E.prototype;
function $7cf908cbc36e9c56$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7cf908cbc36e9c56$var$D;
    this.updater = e || $7cf908cbc36e9c56$var$B;
}
var $7cf908cbc36e9c56$var$H = $7cf908cbc36e9c56$var$G.prototype = new $7cf908cbc36e9c56$var$F;
$7cf908cbc36e9c56$var$H.constructor = $7cf908cbc36e9c56$var$G;
$7cf908cbc36e9c56$var$C($7cf908cbc36e9c56$var$H, $7cf908cbc36e9c56$var$E.prototype);
$7cf908cbc36e9c56$var$H.isPureReactComponent = !0;
var $7cf908cbc36e9c56$var$I = Array.isArray, $7cf908cbc36e9c56$var$J = Object.prototype.hasOwnProperty, $7cf908cbc36e9c56$var$K = {
    current: null
}, $7cf908cbc36e9c56$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7cf908cbc36e9c56$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$7cf908cbc36e9c56$var$J.call(b, d) && !$7cf908cbc36e9c56$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $7cf908cbc36e9c56$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $7cf908cbc36e9c56$var$K.current
    };
}
function $7cf908cbc36e9c56$var$N(a, b) {
    return {
        $$typeof: $7cf908cbc36e9c56$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $7cf908cbc36e9c56$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7cf908cbc36e9c56$var$l;
}
function $7cf908cbc36e9c56$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $7cf908cbc36e9c56$var$P = /\/+/g;
function $7cf908cbc36e9c56$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $7cf908cbc36e9c56$var$escape("" + a.key) : b.toString(36);
}
function $7cf908cbc36e9c56$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $7cf908cbc36e9c56$var$l:
                case $7cf908cbc36e9c56$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $7cf908cbc36e9c56$var$Q(h, 0) : d, $7cf908cbc36e9c56$var$I(c) ? (e = "", null != a && (e = a.replace($7cf908cbc36e9c56$var$P, "$&/") + "/"), $7cf908cbc36e9c56$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($7cf908cbc36e9c56$var$O(c) && (c = $7cf908cbc36e9c56$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($7cf908cbc36e9c56$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($7cf908cbc36e9c56$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $7cf908cbc36e9c56$var$Q(k, g);
        h += $7cf908cbc36e9c56$var$R(k, b, e, f, c);
    }
    else if (f = $7cf908cbc36e9c56$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $7cf908cbc36e9c56$var$Q(k, g++), h += $7cf908cbc36e9c56$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $7cf908cbc36e9c56$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $7cf908cbc36e9c56$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $7cf908cbc36e9c56$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $7cf908cbc36e9c56$var$U = {
    current: null
}, $7cf908cbc36e9c56$var$V = {
    transition: null
}, $7cf908cbc36e9c56$var$W = {
    ReactCurrentDispatcher: $7cf908cbc36e9c56$var$U,
    ReactCurrentBatchConfig: $7cf908cbc36e9c56$var$V,
    ReactCurrentOwner: $7cf908cbc36e9c56$var$K
};
$7cf908cbc36e9c56$export$dca3b0875bd9a954 = {
    map: $7cf908cbc36e9c56$var$S,
    forEach: function(a, b, e) {
        $7cf908cbc36e9c56$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $7cf908cbc36e9c56$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $7cf908cbc36e9c56$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$7cf908cbc36e9c56$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$7cf908cbc36e9c56$export$16fa2f45be04daa8 = $7cf908cbc36e9c56$var$E;
$7cf908cbc36e9c56$export$ffb0004e005737fa = $7cf908cbc36e9c56$var$p;
$7cf908cbc36e9c56$export$e2c29f18771995cb = $7cf908cbc36e9c56$var$r;
$7cf908cbc36e9c56$export$221d75b3f55bb0bd = $7cf908cbc36e9c56$var$G;
$7cf908cbc36e9c56$export$5f8d39834fd61797 = $7cf908cbc36e9c56$var$q;
$7cf908cbc36e9c56$export$74bf444e3cd11ea5 = $7cf908cbc36e9c56$var$w;
$7cf908cbc36e9c56$export$ae55be85d98224ed = $7cf908cbc36e9c56$var$W;
$7cf908cbc36e9c56$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $7cf908cbc36e9c56$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $7cf908cbc36e9c56$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$7cf908cbc36e9c56$var$J.call(b, f) && !$7cf908cbc36e9c56$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $7cf908cbc36e9c56$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$7cf908cbc36e9c56$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $7cf908cbc36e9c56$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $7cf908cbc36e9c56$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$7cf908cbc36e9c56$export$c8a8987d4410bf2d = $7cf908cbc36e9c56$var$M;
$7cf908cbc36e9c56$export$d38cd72104c1f0e9 = function(a) {
    var b = $7cf908cbc36e9c56$var$M.bind(null, a);
    b.type = a;
    return b;
};
$7cf908cbc36e9c56$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$7cf908cbc36e9c56$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $7cf908cbc36e9c56$var$v,
        render: a
    };
};
$7cf908cbc36e9c56$export$a8257692ac88316c = $7cf908cbc36e9c56$var$O;
$7cf908cbc36e9c56$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $7cf908cbc36e9c56$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $7cf908cbc36e9c56$var$T
    };
};
$7cf908cbc36e9c56$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $7cf908cbc36e9c56$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$7cf908cbc36e9c56$export$7568632d0d33d16d = function(a) {
    var b = $7cf908cbc36e9c56$var$V.transition;
    $7cf908cbc36e9c56$var$V.transition = {};
    try {
        a();
    } finally{
        $7cf908cbc36e9c56$var$V.transition = b;
    }
};
$7cf908cbc36e9c56$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$7cf908cbc36e9c56$export$35808ee640e87ca7 = function(a, b) {
    return $7cf908cbc36e9c56$var$U.current.useCallback(a, b);
};
$7cf908cbc36e9c56$export$fae74005e78b1a27 = function(a) {
    return $7cf908cbc36e9c56$var$U.current.useContext(a);
};
$7cf908cbc36e9c56$export$dc8fbce3eb94dc1e = function() {};
$7cf908cbc36e9c56$export$6a7bc4e911dc01cf = function(a) {
    return $7cf908cbc36e9c56$var$U.current.useDeferredValue(a);
};
$7cf908cbc36e9c56$export$6d9c69b0de29b591 = function(a, b) {
    return $7cf908cbc36e9c56$var$U.current.useEffect(a, b);
};
$7cf908cbc36e9c56$export$f680877a34711e37 = function() {
    return $7cf908cbc36e9c56$var$U.current.useId();
};
$7cf908cbc36e9c56$export$d5a552a76deda3c2 = function(a, b, e) {
    return $7cf908cbc36e9c56$var$U.current.useImperativeHandle(a, b, e);
};
$7cf908cbc36e9c56$export$aaabe4eda9ed9969 = function(a, b) {
    return $7cf908cbc36e9c56$var$U.current.useInsertionEffect(a, b);
};
$7cf908cbc36e9c56$export$e5c5a5f917a5871c = function(a, b) {
    return $7cf908cbc36e9c56$var$U.current.useLayoutEffect(a, b);
};
$7cf908cbc36e9c56$export$1538c33de8887b59 = function(a, b) {
    return $7cf908cbc36e9c56$var$U.current.useMemo(a, b);
};
$7cf908cbc36e9c56$export$13e3392192263954 = function(a, b, e) {
    return $7cf908cbc36e9c56$var$U.current.useReducer(a, b, e);
};
$7cf908cbc36e9c56$export$b8f5890fc79d6aca = function(a) {
    return $7cf908cbc36e9c56$var$U.current.useRef(a);
};
$7cf908cbc36e9c56$export$60241385465d0a34 = function(a) {
    return $7cf908cbc36e9c56$var$U.current.useState(a);
};
$7cf908cbc36e9c56$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $7cf908cbc36e9c56$var$U.current.useSyncExternalStore(a, b, e);
};
$7cf908cbc36e9c56$export$7b286972b8d8ccbf = function() {
    return $7cf908cbc36e9c56$var$U.current.useTransition();
};
$7cf908cbc36e9c56$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("34ehV", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $23bcd42a245f9d7b$export$ae55be85d98224ed; }, function (v) { return $23bcd42a245f9d7b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $23bcd42a245f9d7b$export$d39a5bbd09211389; }, function (v) { return $23bcd42a245f9d7b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $23bcd42a245f9d7b$export$882461b6382ed46c; }, function (v) { return $23bcd42a245f9d7b$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $23bcd42a245f9d7b$export$466bfc07425424d5; }, function (v) { return $23bcd42a245f9d7b$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $23bcd42a245f9d7b$export$cd75ccfd720a3cd4; }, function (v) { return $23bcd42a245f9d7b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $23bcd42a245f9d7b$export$fa8d919ba61d84db; }, function (v) { return $23bcd42a245f9d7b$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $23bcd42a245f9d7b$export$757ceba2d55c277e; }, function (v) { return $23bcd42a245f9d7b$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $23bcd42a245f9d7b$export$b3890eb0ae9dca99; }, function (v) { return $23bcd42a245f9d7b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $23bcd42a245f9d7b$export$502457920280e6be; }, function (v) { return $23bcd42a245f9d7b$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $23bcd42a245f9d7b$export$c78a37762a8d58e1; }, function (v) { return $23bcd42a245f9d7b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $23bcd42a245f9d7b$export$dc54d992c10e8a18; }, function (v) { return $23bcd42a245f9d7b$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $23bcd42a245f9d7b$export$83d89fbfd8236492; }, function (v) { return $23bcd42a245f9d7b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $23bcd42a245f9d7b$export$ae55be85d98224ed;
var $23bcd42a245f9d7b$export$d39a5bbd09211389;
var $23bcd42a245f9d7b$export$882461b6382ed46c;
var $23bcd42a245f9d7b$export$466bfc07425424d5;
var $23bcd42a245f9d7b$export$cd75ccfd720a3cd4;
var $23bcd42a245f9d7b$export$fa8d919ba61d84db;
var $23bcd42a245f9d7b$export$757ceba2d55c277e;
var $23bcd42a245f9d7b$export$b3890eb0ae9dca99;
var $23bcd42a245f9d7b$export$502457920280e6be;
var $23bcd42a245f9d7b$export$c78a37762a8d58e1;
var $23bcd42a245f9d7b$export$dc54d992c10e8a18;
var $23bcd42a245f9d7b$export$83d89fbfd8236492;
"use strict";

var $bnENU = parcelRequire("bnENU");

var $fOxuK = parcelRequire("fOxuK");
function $23bcd42a245f9d7b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $23bcd42a245f9d7b$var$da = new Set, $23bcd42a245f9d7b$var$ea = {};
function $23bcd42a245f9d7b$var$fa(a, b) {
    $23bcd42a245f9d7b$var$ha(a, b);
    $23bcd42a245f9d7b$var$ha(a + "Capture", b);
}
function $23bcd42a245f9d7b$var$ha(a, b) {
    $23bcd42a245f9d7b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$23bcd42a245f9d7b$var$da.add(b[a]);
}
var $23bcd42a245f9d7b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $23bcd42a245f9d7b$var$ja = Object.prototype.hasOwnProperty, $23bcd42a245f9d7b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $23bcd42a245f9d7b$var$la = {}, $23bcd42a245f9d7b$var$ma = {};
function $23bcd42a245f9d7b$var$oa(a) {
    if ($23bcd42a245f9d7b$var$ja.call($23bcd42a245f9d7b$var$ma, a)) return !0;
    if ($23bcd42a245f9d7b$var$ja.call($23bcd42a245f9d7b$var$la, a)) return !1;
    if ($23bcd42a245f9d7b$var$ka.test(a)) return $23bcd42a245f9d7b$var$ma[a] = !0;
    $23bcd42a245f9d7b$var$la[a] = !0;
    return !1;
}
function $23bcd42a245f9d7b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $23bcd42a245f9d7b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $23bcd42a245f9d7b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $23bcd42a245f9d7b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $23bcd42a245f9d7b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $23bcd42a245f9d7b$var$z[b] = new $23bcd42a245f9d7b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $23bcd42a245f9d7b$var$ra = /[\-:]([a-z])/g;
function $23bcd42a245f9d7b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($23bcd42a245f9d7b$var$ra, $23bcd42a245f9d7b$var$sa);
    $23bcd42a245f9d7b$var$z[b] = new $23bcd42a245f9d7b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($23bcd42a245f9d7b$var$ra, $23bcd42a245f9d7b$var$sa);
    $23bcd42a245f9d7b$var$z[b] = new $23bcd42a245f9d7b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($23bcd42a245f9d7b$var$ra, $23bcd42a245f9d7b$var$sa);
    $23bcd42a245f9d7b$var$z[b] = new $23bcd42a245f9d7b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$23bcd42a245f9d7b$var$z.xlinkHref = new $23bcd42a245f9d7b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $23bcd42a245f9d7b$var$ta(a, b, c, d) {
    var e = $23bcd42a245f9d7b$var$z.hasOwnProperty(b) ? $23bcd42a245f9d7b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $23bcd42a245f9d7b$var$qa(b, c, e, d) && (c = null), d || null === e ? $23bcd42a245f9d7b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $23bcd42a245f9d7b$var$ua = $bnENU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $23bcd42a245f9d7b$var$va = Symbol.for("react.element"), $23bcd42a245f9d7b$var$wa = Symbol.for("react.portal"), $23bcd42a245f9d7b$var$ya = Symbol.for("react.fragment"), $23bcd42a245f9d7b$var$za = Symbol.for("react.strict_mode"), $23bcd42a245f9d7b$var$Aa = Symbol.for("react.profiler"), $23bcd42a245f9d7b$var$Ba = Symbol.for("react.provider"), $23bcd42a245f9d7b$var$Ca = Symbol.for("react.context"), $23bcd42a245f9d7b$var$Da = Symbol.for("react.forward_ref"), $23bcd42a245f9d7b$var$Ea = Symbol.for("react.suspense"), $23bcd42a245f9d7b$var$Fa = Symbol.for("react.suspense_list"), $23bcd42a245f9d7b$var$Ga = Symbol.for("react.memo"), $23bcd42a245f9d7b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $23bcd42a245f9d7b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $23bcd42a245f9d7b$var$Ja = Symbol.iterator;
function $23bcd42a245f9d7b$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $23bcd42a245f9d7b$var$Ja && a[$23bcd42a245f9d7b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $23bcd42a245f9d7b$var$A = Object.assign, $23bcd42a245f9d7b$var$La;
function $23bcd42a245f9d7b$var$Ma(a) {
    if (void 0 === $23bcd42a245f9d7b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $23bcd42a245f9d7b$var$La = b && b[1] || "";
    }
    return "\n" + $23bcd42a245f9d7b$var$La + a;
}
var $23bcd42a245f9d7b$var$Na = !1;
function $23bcd42a245f9d7b$var$Oa(a, b) {
    if (!a || $23bcd42a245f9d7b$var$Na) return "";
    $23bcd42a245f9d7b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $23bcd42a245f9d7b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $23bcd42a245f9d7b$var$Ma(a) : "";
}
function $23bcd42a245f9d7b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $23bcd42a245f9d7b$var$Ma(a.type);
        case 16:
            return $23bcd42a245f9d7b$var$Ma("Lazy");
        case 13:
            return $23bcd42a245f9d7b$var$Ma("Suspense");
        case 19:
            return $23bcd42a245f9d7b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $23bcd42a245f9d7b$var$Oa(a.type, !1), a;
        case 11:
            return a = $23bcd42a245f9d7b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $23bcd42a245f9d7b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $23bcd42a245f9d7b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $23bcd42a245f9d7b$var$ya:
            return "Fragment";
        case $23bcd42a245f9d7b$var$wa:
            return "Portal";
        case $23bcd42a245f9d7b$var$Aa:
            return "Profiler";
        case $23bcd42a245f9d7b$var$za:
            return "StrictMode";
        case $23bcd42a245f9d7b$var$Ea:
            return "Suspense";
        case $23bcd42a245f9d7b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $23bcd42a245f9d7b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $23bcd42a245f9d7b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $23bcd42a245f9d7b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $23bcd42a245f9d7b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $23bcd42a245f9d7b$var$Qa(a.type) || "Memo";
        case $23bcd42a245f9d7b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $23bcd42a245f9d7b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $23bcd42a245f9d7b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $23bcd42a245f9d7b$var$Qa(b);
        case 8:
            return b === $23bcd42a245f9d7b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $23bcd42a245f9d7b$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $23bcd42a245f9d7b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $23bcd42a245f9d7b$var$Ua(a) {
    var b = $23bcd42a245f9d7b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $23bcd42a245f9d7b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $23bcd42a245f9d7b$var$Ua(a));
}
function $23bcd42a245f9d7b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $23bcd42a245f9d7b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $23bcd42a245f9d7b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $23bcd42a245f9d7b$var$Ya(a, b) {
    var c = b.checked;
    return $23bcd42a245f9d7b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $23bcd42a245f9d7b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $23bcd42a245f9d7b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $23bcd42a245f9d7b$var$ab(a, b) {
    b = b.checked;
    null != b && $23bcd42a245f9d7b$var$ta(a, "checked", b, !1);
}
function $23bcd42a245f9d7b$var$bb(a, b) {
    $23bcd42a245f9d7b$var$ab(a, b);
    var c = $23bcd42a245f9d7b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $23bcd42a245f9d7b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $23bcd42a245f9d7b$var$cb(a, b.type, $23bcd42a245f9d7b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $23bcd42a245f9d7b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $23bcd42a245f9d7b$var$cb(a, b, c) {
    if ("number" !== b || $23bcd42a245f9d7b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $23bcd42a245f9d7b$var$eb = Array.isArray;
function $23bcd42a245f9d7b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $23bcd42a245f9d7b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $23bcd42a245f9d7b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($23bcd42a245f9d7b$var$p(91));
    return $23bcd42a245f9d7b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $23bcd42a245f9d7b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($23bcd42a245f9d7b$var$p(92));
            if ($23bcd42a245f9d7b$var$eb(c)) {
                if (1 < c.length) throw Error($23bcd42a245f9d7b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $23bcd42a245f9d7b$var$Sa(c)
    };
}
function $23bcd42a245f9d7b$var$ib(a, b) {
    var c = $23bcd42a245f9d7b$var$Sa(b.value), d = $23bcd42a245f9d7b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $23bcd42a245f9d7b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $23bcd42a245f9d7b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $23bcd42a245f9d7b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $23bcd42a245f9d7b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $23bcd42a245f9d7b$var$mb, $23bcd42a245f9d7b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $23bcd42a245f9d7b$var$mb = $23bcd42a245f9d7b$var$mb || document.createElement("div");
        $23bcd42a245f9d7b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $23bcd42a245f9d7b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $23bcd42a245f9d7b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $23bcd42a245f9d7b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $23bcd42a245f9d7b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($23bcd42a245f9d7b$var$pb).forEach(function(a) {
    $23bcd42a245f9d7b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $23bcd42a245f9d7b$var$pb[b] = $23bcd42a245f9d7b$var$pb[a];
    });
});
function $23bcd42a245f9d7b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $23bcd42a245f9d7b$var$pb.hasOwnProperty(a) && $23bcd42a245f9d7b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $23bcd42a245f9d7b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $23bcd42a245f9d7b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $23bcd42a245f9d7b$var$tb = $23bcd42a245f9d7b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $23bcd42a245f9d7b$var$ub(a, b) {
    if (b) {
        if ($23bcd42a245f9d7b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($23bcd42a245f9d7b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($23bcd42a245f9d7b$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($23bcd42a245f9d7b$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($23bcd42a245f9d7b$var$p(62));
    }
}
function $23bcd42a245f9d7b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $23bcd42a245f9d7b$var$wb = null;
function $23bcd42a245f9d7b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $23bcd42a245f9d7b$var$yb = null, $23bcd42a245f9d7b$var$zb = null, $23bcd42a245f9d7b$var$Ab = null;
function $23bcd42a245f9d7b$var$Bb(a) {
    if (a = $23bcd42a245f9d7b$var$Cb(a)) {
        if ("function" !== typeof $23bcd42a245f9d7b$var$yb) throw Error($23bcd42a245f9d7b$var$p(280));
        var b = a.stateNode;
        b && (b = $23bcd42a245f9d7b$var$Db(b), $23bcd42a245f9d7b$var$yb(a.stateNode, a.type, b));
    }
}
function $23bcd42a245f9d7b$var$Eb(a) {
    $23bcd42a245f9d7b$var$zb ? $23bcd42a245f9d7b$var$Ab ? $23bcd42a245f9d7b$var$Ab.push(a) : $23bcd42a245f9d7b$var$Ab = [
        a
    ] : $23bcd42a245f9d7b$var$zb = a;
}
function $23bcd42a245f9d7b$var$Fb() {
    if ($23bcd42a245f9d7b$var$zb) {
        var a = $23bcd42a245f9d7b$var$zb, b = $23bcd42a245f9d7b$var$Ab;
        $23bcd42a245f9d7b$var$Ab = $23bcd42a245f9d7b$var$zb = null;
        $23bcd42a245f9d7b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$23bcd42a245f9d7b$var$Bb(b[a]);
    }
}
function $23bcd42a245f9d7b$var$Gb(a, b) {
    return a(b);
}
function $23bcd42a245f9d7b$var$Hb() {}
var $23bcd42a245f9d7b$var$Ib = !1;
function $23bcd42a245f9d7b$var$Jb(a, b, c) {
    if ($23bcd42a245f9d7b$var$Ib) return a(b, c);
    $23bcd42a245f9d7b$var$Ib = !0;
    try {
        return $23bcd42a245f9d7b$var$Gb(a, b, c);
    } finally{
        if ($23bcd42a245f9d7b$var$Ib = !1, null !== $23bcd42a245f9d7b$var$zb || null !== $23bcd42a245f9d7b$var$Ab) $23bcd42a245f9d7b$var$Hb(), $23bcd42a245f9d7b$var$Fb();
    }
}
function $23bcd42a245f9d7b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $23bcd42a245f9d7b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($23bcd42a245f9d7b$var$p(231, b, typeof c));
    return c;
}
var $23bcd42a245f9d7b$var$Lb = !1;
if ($23bcd42a245f9d7b$var$ia) try {
    var $23bcd42a245f9d7b$var$Mb = {};
    Object.defineProperty($23bcd42a245f9d7b$var$Mb, "passive", {
        get: function() {
            $23bcd42a245f9d7b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $23bcd42a245f9d7b$var$Mb, $23bcd42a245f9d7b$var$Mb);
    window.removeEventListener("test", $23bcd42a245f9d7b$var$Mb, $23bcd42a245f9d7b$var$Mb);
} catch (a) {
    $23bcd42a245f9d7b$var$Lb = !1;
}
function $23bcd42a245f9d7b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $23bcd42a245f9d7b$var$Ob = !1, $23bcd42a245f9d7b$var$Pb = null, $23bcd42a245f9d7b$var$Qb = !1, $23bcd42a245f9d7b$var$Rb = null, $23bcd42a245f9d7b$var$Sb = {
    onError: function(a) {
        $23bcd42a245f9d7b$var$Ob = !0;
        $23bcd42a245f9d7b$var$Pb = a;
    }
};
function $23bcd42a245f9d7b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $23bcd42a245f9d7b$var$Ob = !1;
    $23bcd42a245f9d7b$var$Pb = null;
    $23bcd42a245f9d7b$var$Nb.apply($23bcd42a245f9d7b$var$Sb, arguments);
}
function $23bcd42a245f9d7b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $23bcd42a245f9d7b$var$Tb.apply(this, arguments);
    if ($23bcd42a245f9d7b$var$Ob) {
        if ($23bcd42a245f9d7b$var$Ob) {
            var l = $23bcd42a245f9d7b$var$Pb;
            $23bcd42a245f9d7b$var$Ob = !1;
            $23bcd42a245f9d7b$var$Pb = null;
        } else throw Error($23bcd42a245f9d7b$var$p(198));
        $23bcd42a245f9d7b$var$Qb || ($23bcd42a245f9d7b$var$Qb = !0, $23bcd42a245f9d7b$var$Rb = l);
    }
}
function $23bcd42a245f9d7b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $23bcd42a245f9d7b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $23bcd42a245f9d7b$var$Xb(a) {
    if ($23bcd42a245f9d7b$var$Vb(a) !== a) throw Error($23bcd42a245f9d7b$var$p(188));
}
function $23bcd42a245f9d7b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $23bcd42a245f9d7b$var$Vb(a);
        if (null === b) throw Error($23bcd42a245f9d7b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $23bcd42a245f9d7b$var$Xb(e), a;
                if (f === d) return $23bcd42a245f9d7b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($23bcd42a245f9d7b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($23bcd42a245f9d7b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($23bcd42a245f9d7b$var$p(190));
    }
    if (3 !== c.tag) throw Error($23bcd42a245f9d7b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $23bcd42a245f9d7b$var$Zb(a) {
    a = $23bcd42a245f9d7b$var$Yb(a);
    return null !== a ? $23bcd42a245f9d7b$var$$b(a) : null;
}
function $23bcd42a245f9d7b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $23bcd42a245f9d7b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $23bcd42a245f9d7b$var$ac = $fOxuK.unstable_scheduleCallback, $23bcd42a245f9d7b$var$bc = $fOxuK.unstable_cancelCallback, $23bcd42a245f9d7b$var$cc = $fOxuK.unstable_shouldYield, $23bcd42a245f9d7b$var$dc = $fOxuK.unstable_requestPaint, $23bcd42a245f9d7b$var$B = $fOxuK.unstable_now, $23bcd42a245f9d7b$var$ec = $fOxuK.unstable_getCurrentPriorityLevel, $23bcd42a245f9d7b$var$fc = $fOxuK.unstable_ImmediatePriority, $23bcd42a245f9d7b$var$gc = $fOxuK.unstable_UserBlockingPriority, $23bcd42a245f9d7b$var$hc = $fOxuK.unstable_NormalPriority, $23bcd42a245f9d7b$var$ic = $fOxuK.unstable_LowPriority, $23bcd42a245f9d7b$var$jc = $fOxuK.unstable_IdlePriority, $23bcd42a245f9d7b$var$kc = null, $23bcd42a245f9d7b$var$lc = null;
function $23bcd42a245f9d7b$var$mc(a) {
    if ($23bcd42a245f9d7b$var$lc && "function" === typeof $23bcd42a245f9d7b$var$lc.onCommitFiberRoot) try {
        $23bcd42a245f9d7b$var$lc.onCommitFiberRoot($23bcd42a245f9d7b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $23bcd42a245f9d7b$var$oc = Math.clz32 ? Math.clz32 : $23bcd42a245f9d7b$var$nc, $23bcd42a245f9d7b$var$pc = Math.log, $23bcd42a245f9d7b$var$qc = Math.LN2;
function $23bcd42a245f9d7b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($23bcd42a245f9d7b$var$pc(a) / $23bcd42a245f9d7b$var$qc | 0) | 0;
}
var $23bcd42a245f9d7b$var$rc = 64, $23bcd42a245f9d7b$var$sc = 4194304;
function $23bcd42a245f9d7b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $23bcd42a245f9d7b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $23bcd42a245f9d7b$var$tc(h) : (f &= g, 0 !== f && (d = $23bcd42a245f9d7b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $23bcd42a245f9d7b$var$tc(g) : 0 !== f && (d = $23bcd42a245f9d7b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $23bcd42a245f9d7b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $23bcd42a245f9d7b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $23bcd42a245f9d7b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $23bcd42a245f9d7b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $23bcd42a245f9d7b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $23bcd42a245f9d7b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $23bcd42a245f9d7b$var$yc() {
    var a = $23bcd42a245f9d7b$var$rc;
    $23bcd42a245f9d7b$var$rc <<= 1;
    0 === ($23bcd42a245f9d7b$var$rc & 4194240) && ($23bcd42a245f9d7b$var$rc = 64);
    return a;
}
function $23bcd42a245f9d7b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $23bcd42a245f9d7b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $23bcd42a245f9d7b$var$oc(b);
    a[b] = c;
}
function $23bcd42a245f9d7b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $23bcd42a245f9d7b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $23bcd42a245f9d7b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $23bcd42a245f9d7b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $23bcd42a245f9d7b$var$C = 0;
function $23bcd42a245f9d7b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $23bcd42a245f9d7b$var$Ec, $23bcd42a245f9d7b$var$Fc, $23bcd42a245f9d7b$var$Gc, $23bcd42a245f9d7b$var$Hc, $23bcd42a245f9d7b$var$Ic, $23bcd42a245f9d7b$var$Jc = !1, $23bcd42a245f9d7b$var$Kc = [], $23bcd42a245f9d7b$var$Lc = null, $23bcd42a245f9d7b$var$Mc = null, $23bcd42a245f9d7b$var$Nc = null, $23bcd42a245f9d7b$var$Oc = new Map, $23bcd42a245f9d7b$var$Pc = new Map, $23bcd42a245f9d7b$var$Qc = [], $23bcd42a245f9d7b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $23bcd42a245f9d7b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $23bcd42a245f9d7b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $23bcd42a245f9d7b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $23bcd42a245f9d7b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $23bcd42a245f9d7b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $23bcd42a245f9d7b$var$Pc.delete(b.pointerId);
    }
}
function $23bcd42a245f9d7b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $23bcd42a245f9d7b$var$Cb(b), null !== b && $23bcd42a245f9d7b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $23bcd42a245f9d7b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $23bcd42a245f9d7b$var$Lc = $23bcd42a245f9d7b$var$Tc($23bcd42a245f9d7b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $23bcd42a245f9d7b$var$Mc = $23bcd42a245f9d7b$var$Tc($23bcd42a245f9d7b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $23bcd42a245f9d7b$var$Nc = $23bcd42a245f9d7b$var$Tc($23bcd42a245f9d7b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $23bcd42a245f9d7b$var$Oc.set(f, $23bcd42a245f9d7b$var$Tc($23bcd42a245f9d7b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $23bcd42a245f9d7b$var$Pc.set(f, $23bcd42a245f9d7b$var$Tc($23bcd42a245f9d7b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $23bcd42a245f9d7b$var$Vc(a) {
    var b = $23bcd42a245f9d7b$var$Wc(a.target);
    if (null !== b) {
        var c = $23bcd42a245f9d7b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $23bcd42a245f9d7b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $23bcd42a245f9d7b$var$Ic(a.priority, function() {
                        $23bcd42a245f9d7b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $23bcd42a245f9d7b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $23bcd42a245f9d7b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $23bcd42a245f9d7b$var$wb = d;
            c.target.dispatchEvent(d);
            $23bcd42a245f9d7b$var$wb = null;
        } else return b = $23bcd42a245f9d7b$var$Cb(c), null !== b && $23bcd42a245f9d7b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $23bcd42a245f9d7b$var$Zc(a, b, c) {
    $23bcd42a245f9d7b$var$Xc(a) && c.delete(b);
}
function $23bcd42a245f9d7b$var$$c() {
    $23bcd42a245f9d7b$var$Jc = !1;
    null !== $23bcd42a245f9d7b$var$Lc && $23bcd42a245f9d7b$var$Xc($23bcd42a245f9d7b$var$Lc) && ($23bcd42a245f9d7b$var$Lc = null);
    null !== $23bcd42a245f9d7b$var$Mc && $23bcd42a245f9d7b$var$Xc($23bcd42a245f9d7b$var$Mc) && ($23bcd42a245f9d7b$var$Mc = null);
    null !== $23bcd42a245f9d7b$var$Nc && $23bcd42a245f9d7b$var$Xc($23bcd42a245f9d7b$var$Nc) && ($23bcd42a245f9d7b$var$Nc = null);
    $23bcd42a245f9d7b$var$Oc.forEach($23bcd42a245f9d7b$var$Zc);
    $23bcd42a245f9d7b$var$Pc.forEach($23bcd42a245f9d7b$var$Zc);
}
function $23bcd42a245f9d7b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $23bcd42a245f9d7b$var$Jc || ($23bcd42a245f9d7b$var$Jc = !0, $fOxuK.unstable_scheduleCallback($fOxuK.unstable_NormalPriority, $23bcd42a245f9d7b$var$$c)));
}
function $23bcd42a245f9d7b$var$bd(a) {
    function b(b) {
        return $23bcd42a245f9d7b$var$ad(b, a);
    }
    if (0 < $23bcd42a245f9d7b$var$Kc.length) {
        $23bcd42a245f9d7b$var$ad($23bcd42a245f9d7b$var$Kc[0], a);
        for(var c = 1; c < $23bcd42a245f9d7b$var$Kc.length; c++){
            var d = $23bcd42a245f9d7b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $23bcd42a245f9d7b$var$Lc && $23bcd42a245f9d7b$var$ad($23bcd42a245f9d7b$var$Lc, a);
    null !== $23bcd42a245f9d7b$var$Mc && $23bcd42a245f9d7b$var$ad($23bcd42a245f9d7b$var$Mc, a);
    null !== $23bcd42a245f9d7b$var$Nc && $23bcd42a245f9d7b$var$ad($23bcd42a245f9d7b$var$Nc, a);
    $23bcd42a245f9d7b$var$Oc.forEach(b);
    $23bcd42a245f9d7b$var$Pc.forEach(b);
    for(c = 0; c < $23bcd42a245f9d7b$var$Qc.length; c++)d = $23bcd42a245f9d7b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $23bcd42a245f9d7b$var$Qc.length && (c = $23bcd42a245f9d7b$var$Qc[0], null === c.blockedOn);)$23bcd42a245f9d7b$var$Vc(c), null === c.blockedOn && $23bcd42a245f9d7b$var$Qc.shift();
}
var $23bcd42a245f9d7b$var$cd = $23bcd42a245f9d7b$var$ua.ReactCurrentBatchConfig, $23bcd42a245f9d7b$var$dd = !0;
function $23bcd42a245f9d7b$var$ed(a, b, c, d) {
    var e = $23bcd42a245f9d7b$var$C, f = $23bcd42a245f9d7b$var$cd.transition;
    $23bcd42a245f9d7b$var$cd.transition = null;
    try {
        $23bcd42a245f9d7b$var$C = 1, $23bcd42a245f9d7b$var$fd(a, b, c, d);
    } finally{
        $23bcd42a245f9d7b$var$C = e, $23bcd42a245f9d7b$var$cd.transition = f;
    }
}
function $23bcd42a245f9d7b$var$gd(a, b, c, d) {
    var e = $23bcd42a245f9d7b$var$C, f = $23bcd42a245f9d7b$var$cd.transition;
    $23bcd42a245f9d7b$var$cd.transition = null;
    try {
        $23bcd42a245f9d7b$var$C = 4, $23bcd42a245f9d7b$var$fd(a, b, c, d);
    } finally{
        $23bcd42a245f9d7b$var$C = e, $23bcd42a245f9d7b$var$cd.transition = f;
    }
}
function $23bcd42a245f9d7b$var$fd(a, b, c, d) {
    if ($23bcd42a245f9d7b$var$dd) {
        var e = $23bcd42a245f9d7b$var$Yc(a, b, c, d);
        if (null === e) $23bcd42a245f9d7b$var$hd(a, b, d, $23bcd42a245f9d7b$var$id, c), $23bcd42a245f9d7b$var$Sc(a, d);
        else if ($23bcd42a245f9d7b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($23bcd42a245f9d7b$var$Sc(a, d), b & 4 && -1 < $23bcd42a245f9d7b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $23bcd42a245f9d7b$var$Cb(e);
                null !== f && $23bcd42a245f9d7b$var$Ec(f);
                f = $23bcd42a245f9d7b$var$Yc(a, b, c, d);
                null === f && $23bcd42a245f9d7b$var$hd(a, b, d, $23bcd42a245f9d7b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $23bcd42a245f9d7b$var$hd(a, b, d, null, c);
    }
}
var $23bcd42a245f9d7b$var$id = null;
function $23bcd42a245f9d7b$var$Yc(a, b, c, d) {
    $23bcd42a245f9d7b$var$id = null;
    a = $23bcd42a245f9d7b$var$xb(d);
    a = $23bcd42a245f9d7b$var$Wc(a);
    if (null !== a) {
        if (b = $23bcd42a245f9d7b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $23bcd42a245f9d7b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $23bcd42a245f9d7b$var$id = a;
    return null;
}
function $23bcd42a245f9d7b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($23bcd42a245f9d7b$var$ec()){
                case $23bcd42a245f9d7b$var$fc:
                    return 1;
                case $23bcd42a245f9d7b$var$gc:
                    return 4;
                case $23bcd42a245f9d7b$var$hc:
                case $23bcd42a245f9d7b$var$ic:
                    return 16;
                case $23bcd42a245f9d7b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $23bcd42a245f9d7b$var$kd = null, $23bcd42a245f9d7b$var$ld = null, $23bcd42a245f9d7b$var$md = null;
function $23bcd42a245f9d7b$var$nd() {
    if ($23bcd42a245f9d7b$var$md) return $23bcd42a245f9d7b$var$md;
    var a, b = $23bcd42a245f9d7b$var$ld, c = b.length, d, e = "value" in $23bcd42a245f9d7b$var$kd ? $23bcd42a245f9d7b$var$kd.value : $23bcd42a245f9d7b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $23bcd42a245f9d7b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $23bcd42a245f9d7b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $23bcd42a245f9d7b$var$pd() {
    return !0;
}
function $23bcd42a245f9d7b$var$qd() {
    return !1;
}
function $23bcd42a245f9d7b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $23bcd42a245f9d7b$var$pd : $23bcd42a245f9d7b$var$qd;
        this.isPropagationStopped = $23bcd42a245f9d7b$var$qd;
        return this;
    }
    $23bcd42a245f9d7b$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $23bcd42a245f9d7b$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $23bcd42a245f9d7b$var$pd);
        },
        persist: function() {},
        isPersistent: $23bcd42a245f9d7b$var$pd
    });
    return b;
}
var $23bcd42a245f9d7b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $23bcd42a245f9d7b$var$td = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$sd), $23bcd42a245f9d7b$var$ud = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$sd, {
    view: 0,
    detail: 0
}), $23bcd42a245f9d7b$var$vd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$ud), $23bcd42a245f9d7b$var$wd, $23bcd42a245f9d7b$var$xd, $23bcd42a245f9d7b$var$yd, $23bcd42a245f9d7b$var$Ad = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $23bcd42a245f9d7b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $23bcd42a245f9d7b$var$yd && ($23bcd42a245f9d7b$var$yd && "mousemove" === a.type ? ($23bcd42a245f9d7b$var$wd = a.screenX - $23bcd42a245f9d7b$var$yd.screenX, $23bcd42a245f9d7b$var$xd = a.screenY - $23bcd42a245f9d7b$var$yd.screenY) : $23bcd42a245f9d7b$var$xd = $23bcd42a245f9d7b$var$wd = 0, $23bcd42a245f9d7b$var$yd = a);
        return $23bcd42a245f9d7b$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $23bcd42a245f9d7b$var$xd;
    }
}), $23bcd42a245f9d7b$var$Bd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Ad), $23bcd42a245f9d7b$var$Cd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$Ad, {
    dataTransfer: 0
}), $23bcd42a245f9d7b$var$Dd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Cd), $23bcd42a245f9d7b$var$Ed = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$ud, {
    relatedTarget: 0
}), $23bcd42a245f9d7b$var$Fd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Ed), $23bcd42a245f9d7b$var$Gd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $23bcd42a245f9d7b$var$Hd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Gd), $23bcd42a245f9d7b$var$Id = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $23bcd42a245f9d7b$var$Jd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Id), $23bcd42a245f9d7b$var$Kd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$sd, {
    data: 0
}), $23bcd42a245f9d7b$var$Ld = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Kd), $23bcd42a245f9d7b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $23bcd42a245f9d7b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $23bcd42a245f9d7b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $23bcd42a245f9d7b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $23bcd42a245f9d7b$var$Od[a]) ? !!b[a] : !1;
}
function $23bcd42a245f9d7b$var$zd() {
    return $23bcd42a245f9d7b$var$Pd;
}
var $23bcd42a245f9d7b$var$Qd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $23bcd42a245f9d7b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $23bcd42a245f9d7b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $23bcd42a245f9d7b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $23bcd42a245f9d7b$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $23bcd42a245f9d7b$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $23bcd42a245f9d7b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $23bcd42a245f9d7b$var$Rd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Qd), $23bcd42a245f9d7b$var$Sd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $23bcd42a245f9d7b$var$Td = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Sd), $23bcd42a245f9d7b$var$Ud = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $23bcd42a245f9d7b$var$zd
}), $23bcd42a245f9d7b$var$Vd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Ud), $23bcd42a245f9d7b$var$Wd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $23bcd42a245f9d7b$var$Xd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Wd), $23bcd42a245f9d7b$var$Yd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $23bcd42a245f9d7b$var$Zd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Yd), $23bcd42a245f9d7b$var$$d = [
    9,
    13,
    27,
    32
], $23bcd42a245f9d7b$var$ae = $23bcd42a245f9d7b$var$ia && "CompositionEvent" in window, $23bcd42a245f9d7b$var$be = null;
$23bcd42a245f9d7b$var$ia && "documentMode" in document && ($23bcd42a245f9d7b$var$be = document.documentMode);
var $23bcd42a245f9d7b$var$ce = $23bcd42a245f9d7b$var$ia && "TextEvent" in window && !$23bcd42a245f9d7b$var$be, $23bcd42a245f9d7b$var$de = $23bcd42a245f9d7b$var$ia && (!$23bcd42a245f9d7b$var$ae || $23bcd42a245f9d7b$var$be && 8 < $23bcd42a245f9d7b$var$be && 11 >= $23bcd42a245f9d7b$var$be), $23bcd42a245f9d7b$var$ee = String.fromCharCode(32), $23bcd42a245f9d7b$var$fe = !1;
function $23bcd42a245f9d7b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $23bcd42a245f9d7b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $23bcd42a245f9d7b$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $23bcd42a245f9d7b$var$ie = !1;
function $23bcd42a245f9d7b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $23bcd42a245f9d7b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $23bcd42a245f9d7b$var$fe = !0;
            return $23bcd42a245f9d7b$var$ee;
        case "textInput":
            return a = b.data, a === $23bcd42a245f9d7b$var$ee && $23bcd42a245f9d7b$var$fe ? null : a;
        default:
            return null;
    }
}
function $23bcd42a245f9d7b$var$ke(a, b) {
    if ($23bcd42a245f9d7b$var$ie) return "compositionend" === a || !$23bcd42a245f9d7b$var$ae && $23bcd42a245f9d7b$var$ge(a, b) ? (a = $23bcd42a245f9d7b$var$nd(), $23bcd42a245f9d7b$var$md = $23bcd42a245f9d7b$var$ld = $23bcd42a245f9d7b$var$kd = null, $23bcd42a245f9d7b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $23bcd42a245f9d7b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $23bcd42a245f9d7b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $23bcd42a245f9d7b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$23bcd42a245f9d7b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $23bcd42a245f9d7b$var$ne(a, b, c, d) {
    $23bcd42a245f9d7b$var$Eb(d);
    b = $23bcd42a245f9d7b$var$oe(b, "onChange");
    0 < b.length && (c = new $23bcd42a245f9d7b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $23bcd42a245f9d7b$var$pe = null, $23bcd42a245f9d7b$var$qe = null;
function $23bcd42a245f9d7b$var$re(a) {
    $23bcd42a245f9d7b$var$se(a, 0);
}
function $23bcd42a245f9d7b$var$te(a) {
    var b = $23bcd42a245f9d7b$var$ue(a);
    if ($23bcd42a245f9d7b$var$Wa(b)) return a;
}
function $23bcd42a245f9d7b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $23bcd42a245f9d7b$var$we = !1;
if ($23bcd42a245f9d7b$var$ia) {
    var $23bcd42a245f9d7b$var$xe;
    if ($23bcd42a245f9d7b$var$ia) {
        var $23bcd42a245f9d7b$var$ye = "oninput" in document;
        if (!$23bcd42a245f9d7b$var$ye) {
            var $23bcd42a245f9d7b$var$ze = document.createElement("div");
            $23bcd42a245f9d7b$var$ze.setAttribute("oninput", "return;");
            $23bcd42a245f9d7b$var$ye = "function" === typeof $23bcd42a245f9d7b$var$ze.oninput;
        }
        $23bcd42a245f9d7b$var$xe = $23bcd42a245f9d7b$var$ye;
    } else $23bcd42a245f9d7b$var$xe = !1;
    $23bcd42a245f9d7b$var$we = $23bcd42a245f9d7b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $23bcd42a245f9d7b$var$Ae() {
    $23bcd42a245f9d7b$var$pe && ($23bcd42a245f9d7b$var$pe.detachEvent("onpropertychange", $23bcd42a245f9d7b$var$Be), $23bcd42a245f9d7b$var$qe = $23bcd42a245f9d7b$var$pe = null);
}
function $23bcd42a245f9d7b$var$Be(a) {
    if ("value" === a.propertyName && $23bcd42a245f9d7b$var$te($23bcd42a245f9d7b$var$qe)) {
        var b = [];
        $23bcd42a245f9d7b$var$ne(b, $23bcd42a245f9d7b$var$qe, a, $23bcd42a245f9d7b$var$xb(a));
        $23bcd42a245f9d7b$var$Jb($23bcd42a245f9d7b$var$re, b);
    }
}
function $23bcd42a245f9d7b$var$Ce(a, b, c) {
    "focusin" === a ? ($23bcd42a245f9d7b$var$Ae(), $23bcd42a245f9d7b$var$pe = b, $23bcd42a245f9d7b$var$qe = c, $23bcd42a245f9d7b$var$pe.attachEvent("onpropertychange", $23bcd42a245f9d7b$var$Be)) : "focusout" === a && $23bcd42a245f9d7b$var$Ae();
}
function $23bcd42a245f9d7b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $23bcd42a245f9d7b$var$te($23bcd42a245f9d7b$var$qe);
}
function $23bcd42a245f9d7b$var$Ee(a, b) {
    if ("click" === a) return $23bcd42a245f9d7b$var$te(b);
}
function $23bcd42a245f9d7b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $23bcd42a245f9d7b$var$te(b);
}
function $23bcd42a245f9d7b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $23bcd42a245f9d7b$var$He = "function" === typeof Object.is ? Object.is : $23bcd42a245f9d7b$var$Ge;
function $23bcd42a245f9d7b$var$Ie(a, b) {
    if ($23bcd42a245f9d7b$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$23bcd42a245f9d7b$var$ja.call(b, e) || !$23bcd42a245f9d7b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $23bcd42a245f9d7b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $23bcd42a245f9d7b$var$Ke(a, b) {
    var c = $23bcd42a245f9d7b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $23bcd42a245f9d7b$var$Je(c);
    }
}
function $23bcd42a245f9d7b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $23bcd42a245f9d7b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $23bcd42a245f9d7b$var$Me() {
    for(var a = window, b = $23bcd42a245f9d7b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $23bcd42a245f9d7b$var$Xa(a.document);
    }
    return b;
}
function $23bcd42a245f9d7b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $23bcd42a245f9d7b$var$Oe(a) {
    var b = $23bcd42a245f9d7b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $23bcd42a245f9d7b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $23bcd42a245f9d7b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $23bcd42a245f9d7b$var$Ke(c, f);
                var g = $23bcd42a245f9d7b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $23bcd42a245f9d7b$var$Pe = $23bcd42a245f9d7b$var$ia && "documentMode" in document && 11 >= document.documentMode, $23bcd42a245f9d7b$var$Qe = null, $23bcd42a245f9d7b$var$Re = null, $23bcd42a245f9d7b$var$Se = null, $23bcd42a245f9d7b$var$Te = !1;
function $23bcd42a245f9d7b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $23bcd42a245f9d7b$var$Te || null == $23bcd42a245f9d7b$var$Qe || $23bcd42a245f9d7b$var$Qe !== $23bcd42a245f9d7b$var$Xa(d) || (d = $23bcd42a245f9d7b$var$Qe, "selectionStart" in d && $23bcd42a245f9d7b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $23bcd42a245f9d7b$var$Se && $23bcd42a245f9d7b$var$Ie($23bcd42a245f9d7b$var$Se, d) || ($23bcd42a245f9d7b$var$Se = d, d = $23bcd42a245f9d7b$var$oe($23bcd42a245f9d7b$var$Re, "onSelect"), 0 < d.length && (b = new $23bcd42a245f9d7b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $23bcd42a245f9d7b$var$Qe)));
}
function $23bcd42a245f9d7b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $23bcd42a245f9d7b$var$We = {
    animationend: $23bcd42a245f9d7b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $23bcd42a245f9d7b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $23bcd42a245f9d7b$var$Ve("Animation", "AnimationStart"),
    transitionend: $23bcd42a245f9d7b$var$Ve("Transition", "TransitionEnd")
}, $23bcd42a245f9d7b$var$Xe = {}, $23bcd42a245f9d7b$var$Ye = {};
$23bcd42a245f9d7b$var$ia && ($23bcd42a245f9d7b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $23bcd42a245f9d7b$var$We.animationend.animation, delete $23bcd42a245f9d7b$var$We.animationiteration.animation, delete $23bcd42a245f9d7b$var$We.animationstart.animation), "TransitionEvent" in window || delete $23bcd42a245f9d7b$var$We.transitionend.transition);
function $23bcd42a245f9d7b$var$Ze(a) {
    if ($23bcd42a245f9d7b$var$Xe[a]) return $23bcd42a245f9d7b$var$Xe[a];
    if (!$23bcd42a245f9d7b$var$We[a]) return a;
    var b = $23bcd42a245f9d7b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $23bcd42a245f9d7b$var$Ye) return $23bcd42a245f9d7b$var$Xe[a] = b[c];
    return a;
}
var $23bcd42a245f9d7b$var$$e = $23bcd42a245f9d7b$var$Ze("animationend"), $23bcd42a245f9d7b$var$af = $23bcd42a245f9d7b$var$Ze("animationiteration"), $23bcd42a245f9d7b$var$bf = $23bcd42a245f9d7b$var$Ze("animationstart"), $23bcd42a245f9d7b$var$cf = $23bcd42a245f9d7b$var$Ze("transitionend"), $23bcd42a245f9d7b$var$df = new Map, $23bcd42a245f9d7b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $23bcd42a245f9d7b$var$ff(a, b) {
    $23bcd42a245f9d7b$var$df.set(a, b);
    $23bcd42a245f9d7b$var$fa(b, [
        a
    ]);
}
for(var $23bcd42a245f9d7b$var$gf = 0; $23bcd42a245f9d7b$var$gf < $23bcd42a245f9d7b$var$ef.length; $23bcd42a245f9d7b$var$gf++){
    var $23bcd42a245f9d7b$var$hf = $23bcd42a245f9d7b$var$ef[$23bcd42a245f9d7b$var$gf], $23bcd42a245f9d7b$var$jf = $23bcd42a245f9d7b$var$hf.toLowerCase(), $23bcd42a245f9d7b$var$kf = $23bcd42a245f9d7b$var$hf[0].toUpperCase() + $23bcd42a245f9d7b$var$hf.slice(1);
    $23bcd42a245f9d7b$var$ff($23bcd42a245f9d7b$var$jf, "on" + $23bcd42a245f9d7b$var$kf);
}
$23bcd42a245f9d7b$var$ff($23bcd42a245f9d7b$var$$e, "onAnimationEnd");
$23bcd42a245f9d7b$var$ff($23bcd42a245f9d7b$var$af, "onAnimationIteration");
$23bcd42a245f9d7b$var$ff($23bcd42a245f9d7b$var$bf, "onAnimationStart");
$23bcd42a245f9d7b$var$ff("dblclick", "onDoubleClick");
$23bcd42a245f9d7b$var$ff("focusin", "onFocus");
$23bcd42a245f9d7b$var$ff("focusout", "onBlur");
$23bcd42a245f9d7b$var$ff($23bcd42a245f9d7b$var$cf, "onTransitionEnd");
$23bcd42a245f9d7b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$23bcd42a245f9d7b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$23bcd42a245f9d7b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$23bcd42a245f9d7b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$23bcd42a245f9d7b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$23bcd42a245f9d7b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$23bcd42a245f9d7b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$23bcd42a245f9d7b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$23bcd42a245f9d7b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$23bcd42a245f9d7b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $23bcd42a245f9d7b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $23bcd42a245f9d7b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($23bcd42a245f9d7b$var$lf));
function $23bcd42a245f9d7b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $23bcd42a245f9d7b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $23bcd42a245f9d7b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $23bcd42a245f9d7b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $23bcd42a245f9d7b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($23bcd42a245f9d7b$var$Qb) throw a = $23bcd42a245f9d7b$var$Rb, $23bcd42a245f9d7b$var$Qb = !1, $23bcd42a245f9d7b$var$Rb = null, a;
}
function $23bcd42a245f9d7b$var$D(a, b) {
    var c = b[$23bcd42a245f9d7b$var$of];
    void 0 === c && (c = b[$23bcd42a245f9d7b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($23bcd42a245f9d7b$var$pf(b, a, 2, !1), c.add(d));
}
function $23bcd42a245f9d7b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $23bcd42a245f9d7b$var$pf(c, a, d, b);
}
var $23bcd42a245f9d7b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $23bcd42a245f9d7b$var$sf(a) {
    if (!a[$23bcd42a245f9d7b$var$rf]) {
        a[$23bcd42a245f9d7b$var$rf] = !0;
        $23bcd42a245f9d7b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($23bcd42a245f9d7b$var$mf.has(b) || $23bcd42a245f9d7b$var$qf(b, !1, a), $23bcd42a245f9d7b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$23bcd42a245f9d7b$var$rf] || (b[$23bcd42a245f9d7b$var$rf] = !0, $23bcd42a245f9d7b$var$qf("selectionchange", !1, b));
    }
}
function $23bcd42a245f9d7b$var$pf(a, b, c, d) {
    switch($23bcd42a245f9d7b$var$jd(b)){
        case 1:
            var e = $23bcd42a245f9d7b$var$ed;
            break;
        case 4:
            e = $23bcd42a245f9d7b$var$gd;
            break;
        default:
            e = $23bcd42a245f9d7b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$23bcd42a245f9d7b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $23bcd42a245f9d7b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $23bcd42a245f9d7b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $23bcd42a245f9d7b$var$Jb(function() {
        var d = f, e = $23bcd42a245f9d7b$var$xb(c), g = [];
        a: {
            var h = $23bcd42a245f9d7b$var$df.get(a);
            if (void 0 !== h) {
                var k = $23bcd42a245f9d7b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $23bcd42a245f9d7b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $23bcd42a245f9d7b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $23bcd42a245f9d7b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $23bcd42a245f9d7b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $23bcd42a245f9d7b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $23bcd42a245f9d7b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $23bcd42a245f9d7b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $23bcd42a245f9d7b$var$Vd;
                        break;
                    case $23bcd42a245f9d7b$var$$e:
                    case $23bcd42a245f9d7b$var$af:
                    case $23bcd42a245f9d7b$var$bf:
                        k = $23bcd42a245f9d7b$var$Hd;
                        break;
                    case $23bcd42a245f9d7b$var$cf:
                        k = $23bcd42a245f9d7b$var$Xd;
                        break;
                    case "scroll":
                        k = $23bcd42a245f9d7b$var$vd;
                        break;
                    case "wheel":
                        k = $23bcd42a245f9d7b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $23bcd42a245f9d7b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $23bcd42a245f9d7b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $23bcd42a245f9d7b$var$Kb(w, x), null != F && t.push($23bcd42a245f9d7b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $23bcd42a245f9d7b$var$wb && (n = c.relatedTarget || c.fromElement) && ($23bcd42a245f9d7b$var$Wc(n) || n[$23bcd42a245f9d7b$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $23bcd42a245f9d7b$var$Wc(n) : null, null !== n && (J = $23bcd42a245f9d7b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $23bcd42a245f9d7b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $23bcd42a245f9d7b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $23bcd42a245f9d7b$var$ue(k);
                        u = null == n ? h : $23bcd42a245f9d7b$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $23bcd42a245f9d7b$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $23bcd42a245f9d7b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $23bcd42a245f9d7b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $23bcd42a245f9d7b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $23bcd42a245f9d7b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $23bcd42a245f9d7b$var$vf(t);
                                x = $23bcd42a245f9d7b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $23bcd42a245f9d7b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $23bcd42a245f9d7b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $23bcd42a245f9d7b$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $23bcd42a245f9d7b$var$ve;
                else if ($23bcd42a245f9d7b$var$me(h)) {
                    if ($23bcd42a245f9d7b$var$we) na = $23bcd42a245f9d7b$var$Fe;
                    else {
                        na = $23bcd42a245f9d7b$var$De;
                        var xa = $23bcd42a245f9d7b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $23bcd42a245f9d7b$var$Ee);
                if (na && (na = na(a, d))) {
                    $23bcd42a245f9d7b$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $23bcd42a245f9d7b$var$cb(h, "number", h.value);
            }
            xa = d ? $23bcd42a245f9d7b$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($23bcd42a245f9d7b$var$me(xa) || "true" === xa.contentEditable) $23bcd42a245f9d7b$var$Qe = xa, $23bcd42a245f9d7b$var$Re = d, $23bcd42a245f9d7b$var$Se = null;
                    break;
                case "focusout":
                    $23bcd42a245f9d7b$var$Se = $23bcd42a245f9d7b$var$Re = $23bcd42a245f9d7b$var$Qe = null;
                    break;
                case "mousedown":
                    $23bcd42a245f9d7b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $23bcd42a245f9d7b$var$Te = !1;
                    $23bcd42a245f9d7b$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($23bcd42a245f9d7b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $23bcd42a245f9d7b$var$Ue(g, c, e);
            }
            var $a;
            if ($23bcd42a245f9d7b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $23bcd42a245f9d7b$var$ie ? $23bcd42a245f9d7b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($23bcd42a245f9d7b$var$de && "ko" !== c.locale && ($23bcd42a245f9d7b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $23bcd42a245f9d7b$var$ie && ($a = $23bcd42a245f9d7b$var$nd()) : ($23bcd42a245f9d7b$var$kd = e, $23bcd42a245f9d7b$var$ld = "value" in $23bcd42a245f9d7b$var$kd ? $23bcd42a245f9d7b$var$kd.value : $23bcd42a245f9d7b$var$kd.textContent, $23bcd42a245f9d7b$var$ie = !0)), xa = $23bcd42a245f9d7b$var$oe(d, ba), 0 < xa.length && (ba = new $23bcd42a245f9d7b$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $23bcd42a245f9d7b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $23bcd42a245f9d7b$var$ce ? $23bcd42a245f9d7b$var$je(a, c) : $23bcd42a245f9d7b$var$ke(a, c)) d = $23bcd42a245f9d7b$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $23bcd42a245f9d7b$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $23bcd42a245f9d7b$var$se(g, b);
    });
}
function $23bcd42a245f9d7b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $23bcd42a245f9d7b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $23bcd42a245f9d7b$var$Kb(a, c), null != f && d.unshift($23bcd42a245f9d7b$var$tf(a, f, e)), f = $23bcd42a245f9d7b$var$Kb(a, b), null != f && d.push($23bcd42a245f9d7b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $23bcd42a245f9d7b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $23bcd42a245f9d7b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $23bcd42a245f9d7b$var$Kb(c, f), null != k && g.unshift($23bcd42a245f9d7b$var$tf(c, k, h))) : e || (k = $23bcd42a245f9d7b$var$Kb(c, f), null != k && g.push($23bcd42a245f9d7b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $23bcd42a245f9d7b$var$xf = /\r\n?/g, $23bcd42a245f9d7b$var$yf = /\u0000|\uFFFD/g;
function $23bcd42a245f9d7b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($23bcd42a245f9d7b$var$xf, "\n").replace($23bcd42a245f9d7b$var$yf, "");
}
function $23bcd42a245f9d7b$var$Af(a, b, c) {
    b = $23bcd42a245f9d7b$var$zf(b);
    if ($23bcd42a245f9d7b$var$zf(a) !== b && c) throw Error($23bcd42a245f9d7b$var$p(425));
}
function $23bcd42a245f9d7b$var$Bf() {}
var $23bcd42a245f9d7b$var$Cf = null, $23bcd42a245f9d7b$var$Df = null;
function $23bcd42a245f9d7b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $23bcd42a245f9d7b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $23bcd42a245f9d7b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $23bcd42a245f9d7b$var$Hf = "function" === typeof Promise ? Promise : void 0, $23bcd42a245f9d7b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $23bcd42a245f9d7b$var$Hf ? function(a) {
    return $23bcd42a245f9d7b$var$Hf.resolve(null).then(a).catch($23bcd42a245f9d7b$var$If);
} : $23bcd42a245f9d7b$var$Ff;
function $23bcd42a245f9d7b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $23bcd42a245f9d7b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $23bcd42a245f9d7b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $23bcd42a245f9d7b$var$bd(b);
}
function $23bcd42a245f9d7b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $23bcd42a245f9d7b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $23bcd42a245f9d7b$var$Nf = Math.random().toString(36).slice(2), $23bcd42a245f9d7b$var$Of = "__reactFiber$" + $23bcd42a245f9d7b$var$Nf, $23bcd42a245f9d7b$var$Pf = "__reactProps$" + $23bcd42a245f9d7b$var$Nf, $23bcd42a245f9d7b$var$uf = "__reactContainer$" + $23bcd42a245f9d7b$var$Nf, $23bcd42a245f9d7b$var$of = "__reactEvents$" + $23bcd42a245f9d7b$var$Nf, $23bcd42a245f9d7b$var$Qf = "__reactListeners$" + $23bcd42a245f9d7b$var$Nf, $23bcd42a245f9d7b$var$Rf = "__reactHandles$" + $23bcd42a245f9d7b$var$Nf;
function $23bcd42a245f9d7b$var$Wc(a) {
    var b = a[$23bcd42a245f9d7b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$23bcd42a245f9d7b$var$uf] || c[$23bcd42a245f9d7b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $23bcd42a245f9d7b$var$Mf(a); null !== a;){
                if (c = a[$23bcd42a245f9d7b$var$Of]) return c;
                a = $23bcd42a245f9d7b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $23bcd42a245f9d7b$var$Cb(a) {
    a = a[$23bcd42a245f9d7b$var$Of] || a[$23bcd42a245f9d7b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $23bcd42a245f9d7b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($23bcd42a245f9d7b$var$p(33));
}
function $23bcd42a245f9d7b$var$Db(a) {
    return a[$23bcd42a245f9d7b$var$Pf] || null;
}
var $23bcd42a245f9d7b$var$Sf = [], $23bcd42a245f9d7b$var$Tf = -1;
function $23bcd42a245f9d7b$var$Uf(a) {
    return {
        current: a
    };
}
function $23bcd42a245f9d7b$var$E(a) {
    0 > $23bcd42a245f9d7b$var$Tf || (a.current = $23bcd42a245f9d7b$var$Sf[$23bcd42a245f9d7b$var$Tf], $23bcd42a245f9d7b$var$Sf[$23bcd42a245f9d7b$var$Tf] = null, $23bcd42a245f9d7b$var$Tf--);
}
function $23bcd42a245f9d7b$var$G(a, b) {
    $23bcd42a245f9d7b$var$Tf++;
    $23bcd42a245f9d7b$var$Sf[$23bcd42a245f9d7b$var$Tf] = a.current;
    a.current = b;
}
var $23bcd42a245f9d7b$var$Vf = {}, $23bcd42a245f9d7b$var$H = $23bcd42a245f9d7b$var$Uf($23bcd42a245f9d7b$var$Vf), $23bcd42a245f9d7b$var$Wf = $23bcd42a245f9d7b$var$Uf(!1), $23bcd42a245f9d7b$var$Xf = $23bcd42a245f9d7b$var$Vf;
function $23bcd42a245f9d7b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $23bcd42a245f9d7b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $23bcd42a245f9d7b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $23bcd42a245f9d7b$var$$f() {
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf);
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$H);
}
function $23bcd42a245f9d7b$var$ag(a, b, c) {
    if ($23bcd42a245f9d7b$var$H.current !== $23bcd42a245f9d7b$var$Vf) throw Error($23bcd42a245f9d7b$var$p(168));
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$H, b);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Wf, c);
}
function $23bcd42a245f9d7b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($23bcd42a245f9d7b$var$p(108, $23bcd42a245f9d7b$var$Ra(a) || "Unknown", e));
    return $23bcd42a245f9d7b$var$A({}, c, d);
}
function $23bcd42a245f9d7b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $23bcd42a245f9d7b$var$Vf;
    $23bcd42a245f9d7b$var$Xf = $23bcd42a245f9d7b$var$H.current;
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$H, a);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Wf, $23bcd42a245f9d7b$var$Wf.current);
    return !0;
}
function $23bcd42a245f9d7b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($23bcd42a245f9d7b$var$p(169));
    c ? (a = $23bcd42a245f9d7b$var$bg(a, b, $23bcd42a245f9d7b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf), $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$H), $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$H, a)) : $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Wf, c);
}
var $23bcd42a245f9d7b$var$eg = null, $23bcd42a245f9d7b$var$fg = !1, $23bcd42a245f9d7b$var$gg = !1;
function $23bcd42a245f9d7b$var$hg(a) {
    null === $23bcd42a245f9d7b$var$eg ? $23bcd42a245f9d7b$var$eg = [
        a
    ] : $23bcd42a245f9d7b$var$eg.push(a);
}
function $23bcd42a245f9d7b$var$ig(a) {
    $23bcd42a245f9d7b$var$fg = !0;
    $23bcd42a245f9d7b$var$hg(a);
}
function $23bcd42a245f9d7b$var$jg() {
    if (!$23bcd42a245f9d7b$var$gg && null !== $23bcd42a245f9d7b$var$eg) {
        $23bcd42a245f9d7b$var$gg = !0;
        var a = 0, b = $23bcd42a245f9d7b$var$C;
        try {
            var c = $23bcd42a245f9d7b$var$eg;
            for($23bcd42a245f9d7b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $23bcd42a245f9d7b$var$eg = null;
            $23bcd42a245f9d7b$var$fg = !1;
        } catch (e) {
            throw null !== $23bcd42a245f9d7b$var$eg && ($23bcd42a245f9d7b$var$eg = $23bcd42a245f9d7b$var$eg.slice(a + 1)), $23bcd42a245f9d7b$var$ac($23bcd42a245f9d7b$var$fc, $23bcd42a245f9d7b$var$jg), e;
        } finally{
            $23bcd42a245f9d7b$var$C = b, $23bcd42a245f9d7b$var$gg = !1;
        }
    }
    return null;
}
var $23bcd42a245f9d7b$var$kg = [], $23bcd42a245f9d7b$var$lg = 0, $23bcd42a245f9d7b$var$mg = null, $23bcd42a245f9d7b$var$ng = 0, $23bcd42a245f9d7b$var$og = [], $23bcd42a245f9d7b$var$pg = 0, $23bcd42a245f9d7b$var$qg = null, $23bcd42a245f9d7b$var$rg = 1, $23bcd42a245f9d7b$var$sg = "";
function $23bcd42a245f9d7b$var$tg(a, b) {
    $23bcd42a245f9d7b$var$kg[$23bcd42a245f9d7b$var$lg++] = $23bcd42a245f9d7b$var$ng;
    $23bcd42a245f9d7b$var$kg[$23bcd42a245f9d7b$var$lg++] = $23bcd42a245f9d7b$var$mg;
    $23bcd42a245f9d7b$var$mg = a;
    $23bcd42a245f9d7b$var$ng = b;
}
function $23bcd42a245f9d7b$var$ug(a, b, c) {
    $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$rg;
    $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$sg;
    $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$qg;
    $23bcd42a245f9d7b$var$qg = a;
    var d = $23bcd42a245f9d7b$var$rg;
    a = $23bcd42a245f9d7b$var$sg;
    var e = 32 - $23bcd42a245f9d7b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $23bcd42a245f9d7b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $23bcd42a245f9d7b$var$rg = 1 << 32 - $23bcd42a245f9d7b$var$oc(b) + e | c << e | d;
        $23bcd42a245f9d7b$var$sg = f + a;
    } else $23bcd42a245f9d7b$var$rg = 1 << f | c << e | d, $23bcd42a245f9d7b$var$sg = a;
}
function $23bcd42a245f9d7b$var$vg(a) {
    null !== a.return && ($23bcd42a245f9d7b$var$tg(a, 1), $23bcd42a245f9d7b$var$ug(a, 1, 0));
}
function $23bcd42a245f9d7b$var$wg(a) {
    for(; a === $23bcd42a245f9d7b$var$mg;)$23bcd42a245f9d7b$var$mg = $23bcd42a245f9d7b$var$kg[--$23bcd42a245f9d7b$var$lg], $23bcd42a245f9d7b$var$kg[$23bcd42a245f9d7b$var$lg] = null, $23bcd42a245f9d7b$var$ng = $23bcd42a245f9d7b$var$kg[--$23bcd42a245f9d7b$var$lg], $23bcd42a245f9d7b$var$kg[$23bcd42a245f9d7b$var$lg] = null;
    for(; a === $23bcd42a245f9d7b$var$qg;)$23bcd42a245f9d7b$var$qg = $23bcd42a245f9d7b$var$og[--$23bcd42a245f9d7b$var$pg], $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg] = null, $23bcd42a245f9d7b$var$sg = $23bcd42a245f9d7b$var$og[--$23bcd42a245f9d7b$var$pg], $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg] = null, $23bcd42a245f9d7b$var$rg = $23bcd42a245f9d7b$var$og[--$23bcd42a245f9d7b$var$pg], $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg] = null;
}
var $23bcd42a245f9d7b$var$xg = null, $23bcd42a245f9d7b$var$yg = null, $23bcd42a245f9d7b$var$I = !1, $23bcd42a245f9d7b$var$zg = null;
function $23bcd42a245f9d7b$var$Ag(a, b) {
    var c = $23bcd42a245f9d7b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $23bcd42a245f9d7b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $23bcd42a245f9d7b$var$xg = a, $23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $23bcd42a245f9d7b$var$xg = a, $23bcd42a245f9d7b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $23bcd42a245f9d7b$var$qg ? {
                id: $23bcd42a245f9d7b$var$rg,
                overflow: $23bcd42a245f9d7b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $23bcd42a245f9d7b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $23bcd42a245f9d7b$var$xg = a, $23bcd42a245f9d7b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $23bcd42a245f9d7b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $23bcd42a245f9d7b$var$Eg(a) {
    if ($23bcd42a245f9d7b$var$I) {
        var b = $23bcd42a245f9d7b$var$yg;
        if (b) {
            var c = b;
            if (!$23bcd42a245f9d7b$var$Cg(a, b)) {
                if ($23bcd42a245f9d7b$var$Dg(a)) throw Error($23bcd42a245f9d7b$var$p(418));
                b = $23bcd42a245f9d7b$var$Lf(c.nextSibling);
                var d = $23bcd42a245f9d7b$var$xg;
                b && $23bcd42a245f9d7b$var$Cg(a, b) ? $23bcd42a245f9d7b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $23bcd42a245f9d7b$var$I = !1, $23bcd42a245f9d7b$var$xg = a);
            }
        } else {
            if ($23bcd42a245f9d7b$var$Dg(a)) throw Error($23bcd42a245f9d7b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $23bcd42a245f9d7b$var$I = !1;
            $23bcd42a245f9d7b$var$xg = a;
        }
    }
}
function $23bcd42a245f9d7b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $23bcd42a245f9d7b$var$xg = a;
}
function $23bcd42a245f9d7b$var$Gg(a) {
    if (a !== $23bcd42a245f9d7b$var$xg) return !1;
    if (!$23bcd42a245f9d7b$var$I) return $23bcd42a245f9d7b$var$Fg(a), $23bcd42a245f9d7b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$23bcd42a245f9d7b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $23bcd42a245f9d7b$var$yg)) {
        if ($23bcd42a245f9d7b$var$Dg(a)) throw $23bcd42a245f9d7b$var$Hg(), Error($23bcd42a245f9d7b$var$p(418));
        for(; b;)$23bcd42a245f9d7b$var$Ag(a, b), b = $23bcd42a245f9d7b$var$Lf(b.nextSibling);
    }
    $23bcd42a245f9d7b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($23bcd42a245f9d7b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $23bcd42a245f9d7b$var$yg = null;
        }
    } else $23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$xg ? $23bcd42a245f9d7b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $23bcd42a245f9d7b$var$Hg() {
    for(var a = $23bcd42a245f9d7b$var$yg; a;)a = $23bcd42a245f9d7b$var$Lf(a.nextSibling);
}
function $23bcd42a245f9d7b$var$Ig() {
    $23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$xg = null;
    $23bcd42a245f9d7b$var$I = !1;
}
function $23bcd42a245f9d7b$var$Jg(a) {
    null === $23bcd42a245f9d7b$var$zg ? $23bcd42a245f9d7b$var$zg = [
        a
    ] : $23bcd42a245f9d7b$var$zg.push(a);
}
var $23bcd42a245f9d7b$var$Kg = $23bcd42a245f9d7b$var$ua.ReactCurrentBatchConfig;
function $23bcd42a245f9d7b$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $23bcd42a245f9d7b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $23bcd42a245f9d7b$var$Mg = $23bcd42a245f9d7b$var$Uf(null), $23bcd42a245f9d7b$var$Ng = null, $23bcd42a245f9d7b$var$Og = null, $23bcd42a245f9d7b$var$Pg = null;
function $23bcd42a245f9d7b$var$Qg() {
    $23bcd42a245f9d7b$var$Pg = $23bcd42a245f9d7b$var$Og = $23bcd42a245f9d7b$var$Ng = null;
}
function $23bcd42a245f9d7b$var$Rg(a) {
    var b = $23bcd42a245f9d7b$var$Mg.current;
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Mg);
    a._currentValue = b;
}
function $23bcd42a245f9d7b$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $23bcd42a245f9d7b$var$Tg(a, b) {
    $23bcd42a245f9d7b$var$Ng = a;
    $23bcd42a245f9d7b$var$Pg = $23bcd42a245f9d7b$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($23bcd42a245f9d7b$var$Ug = !0), a.firstContext = null);
}
function $23bcd42a245f9d7b$var$Vg(a) {
    var b = a._currentValue;
    if ($23bcd42a245f9d7b$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $23bcd42a245f9d7b$var$Og) {
            if (null === $23bcd42a245f9d7b$var$Ng) throw Error($23bcd42a245f9d7b$var$p(308));
            $23bcd42a245f9d7b$var$Og = a;
            $23bcd42a245f9d7b$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $23bcd42a245f9d7b$var$Og = $23bcd42a245f9d7b$var$Og.next = a;
    }
    return b;
}
var $23bcd42a245f9d7b$var$Wg = null;
function $23bcd42a245f9d7b$var$Xg(a) {
    null === $23bcd42a245f9d7b$var$Wg ? $23bcd42a245f9d7b$var$Wg = [
        a
    ] : $23bcd42a245f9d7b$var$Wg.push(a);
}
function $23bcd42a245f9d7b$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $23bcd42a245f9d7b$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $23bcd42a245f9d7b$var$Zg(a, d);
}
function $23bcd42a245f9d7b$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $23bcd42a245f9d7b$var$$g = !1;
function $23bcd42a245f9d7b$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $23bcd42a245f9d7b$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $23bcd42a245f9d7b$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $23bcd42a245f9d7b$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($23bcd42a245f9d7b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $23bcd42a245f9d7b$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $23bcd42a245f9d7b$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $23bcd42a245f9d7b$var$Zg(a, c);
}
function $23bcd42a245f9d7b$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $23bcd42a245f9d7b$var$Cc(a, c);
    }
}
function $23bcd42a245f9d7b$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $23bcd42a245f9d7b$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $23bcd42a245f9d7b$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $23bcd42a245f9d7b$var$A({}, q, r);
                            break a;
                        case 2:
                            $23bcd42a245f9d7b$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $23bcd42a245f9d7b$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $23bcd42a245f9d7b$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($23bcd42a245f9d7b$var$p(191, e));
            e.call(d);
        }
    }
}
var $23bcd42a245f9d7b$var$jh = (new $bnENU.Component).refs;
function $23bcd42a245f9d7b$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $23bcd42a245f9d7b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $23bcd42a245f9d7b$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $23bcd42a245f9d7b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $23bcd42a245f9d7b$var$L(), e = $23bcd42a245f9d7b$var$lh(a), f = $23bcd42a245f9d7b$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $23bcd42a245f9d7b$var$dh(a, f, e);
        null !== b && ($23bcd42a245f9d7b$var$mh(b, a, e, d), $23bcd42a245f9d7b$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $23bcd42a245f9d7b$var$L(), e = $23bcd42a245f9d7b$var$lh(a), f = $23bcd42a245f9d7b$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $23bcd42a245f9d7b$var$dh(a, f, e);
        null !== b && ($23bcd42a245f9d7b$var$mh(b, a, e, d), $23bcd42a245f9d7b$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $23bcd42a245f9d7b$var$L(), d = $23bcd42a245f9d7b$var$lh(a), e = $23bcd42a245f9d7b$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $23bcd42a245f9d7b$var$dh(a, e, d);
        null !== b && ($23bcd42a245f9d7b$var$mh(b, a, d, c), $23bcd42a245f9d7b$var$eh(b, a, d));
    }
};
function $23bcd42a245f9d7b$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$23bcd42a245f9d7b$var$Ie(c, d) || !$23bcd42a245f9d7b$var$Ie(e, f) : !0;
}
function $23bcd42a245f9d7b$var$ph(a, b, c) {
    var d = !1, e = $23bcd42a245f9d7b$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $23bcd42a245f9d7b$var$Vg(f) : (e = $23bcd42a245f9d7b$var$Zf(b) ? $23bcd42a245f9d7b$var$Xf : $23bcd42a245f9d7b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $23bcd42a245f9d7b$var$Yf(a, e) : $23bcd42a245f9d7b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $23bcd42a245f9d7b$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $23bcd42a245f9d7b$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $23bcd42a245f9d7b$var$nh.enqueueReplaceState(b, b.state, null);
}
function $23bcd42a245f9d7b$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $23bcd42a245f9d7b$var$jh;
    $23bcd42a245f9d7b$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $23bcd42a245f9d7b$var$Vg(f) : (f = $23bcd42a245f9d7b$var$Zf(b) ? $23bcd42a245f9d7b$var$Xf : $23bcd42a245f9d7b$var$H.current, e.context = $23bcd42a245f9d7b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($23bcd42a245f9d7b$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $23bcd42a245f9d7b$var$nh.enqueueReplaceState(e, e.state, null), $23bcd42a245f9d7b$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $23bcd42a245f9d7b$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($23bcd42a245f9d7b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($23bcd42a245f9d7b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $23bcd42a245f9d7b$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($23bcd42a245f9d7b$var$p(284));
        if (!c._owner) throw Error($23bcd42a245f9d7b$var$p(290, a));
    }
    return a;
}
function $23bcd42a245f9d7b$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($23bcd42a245f9d7b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $23bcd42a245f9d7b$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $23bcd42a245f9d7b$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $23bcd42a245f9d7b$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $23bcd42a245f9d7b$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $23bcd42a245f9d7b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $23bcd42a245f9d7b$var$Ha && $23bcd42a245f9d7b$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $23bcd42a245f9d7b$var$sh(a, b, c), d.return = a, d;
        d = $23bcd42a245f9d7b$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $23bcd42a245f9d7b$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $23bcd42a245f9d7b$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $23bcd42a245f9d7b$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $23bcd42a245f9d7b$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $23bcd42a245f9d7b$var$va:
                    return c = $23bcd42a245f9d7b$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $23bcd42a245f9d7b$var$sh(a, null, b), c.return = a, c;
                case $23bcd42a245f9d7b$var$wa:
                    return b = $23bcd42a245f9d7b$var$zh(b, a.mode, c), b.return = a, b;
                case $23bcd42a245f9d7b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($23bcd42a245f9d7b$var$eb(b) || $23bcd42a245f9d7b$var$Ka(b)) return b = $23bcd42a245f9d7b$var$Ah(b, a.mode, c, null), b.return = a, b;
            $23bcd42a245f9d7b$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $23bcd42a245f9d7b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $23bcd42a245f9d7b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $23bcd42a245f9d7b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($23bcd42a245f9d7b$var$eb(c) || $23bcd42a245f9d7b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $23bcd42a245f9d7b$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $23bcd42a245f9d7b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $23bcd42a245f9d7b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $23bcd42a245f9d7b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($23bcd42a245f9d7b$var$eb(d) || $23bcd42a245f9d7b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $23bcd42a245f9d7b$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $23bcd42a245f9d7b$var$Ka(h);
        if ("function" !== typeof l) throw Error($23bcd42a245f9d7b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($23bcd42a245f9d7b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $23bcd42a245f9d7b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $23bcd42a245f9d7b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $23bcd42a245f9d7b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $23bcd42a245f9d7b$var$Ha && $23bcd42a245f9d7b$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $23bcd42a245f9d7b$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $23bcd42a245f9d7b$var$ya ? (d = $23bcd42a245f9d7b$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $23bcd42a245f9d7b$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $23bcd42a245f9d7b$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $23bcd42a245f9d7b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $23bcd42a245f9d7b$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $23bcd42a245f9d7b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($23bcd42a245f9d7b$var$eb(f)) return n(a, d, f, h);
            if ($23bcd42a245f9d7b$var$Ka(f)) return t(a, d, f, h);
            $23bcd42a245f9d7b$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $23bcd42a245f9d7b$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $23bcd42a245f9d7b$var$Bh = $23bcd42a245f9d7b$var$vh(!0), $23bcd42a245f9d7b$var$Ch = $23bcd42a245f9d7b$var$vh(!1), $23bcd42a245f9d7b$var$Dh = {}, $23bcd42a245f9d7b$var$Eh = $23bcd42a245f9d7b$var$Uf($23bcd42a245f9d7b$var$Dh), $23bcd42a245f9d7b$var$Fh = $23bcd42a245f9d7b$var$Uf($23bcd42a245f9d7b$var$Dh), $23bcd42a245f9d7b$var$Gh = $23bcd42a245f9d7b$var$Uf($23bcd42a245f9d7b$var$Dh);
function $23bcd42a245f9d7b$var$Hh(a) {
    if (a === $23bcd42a245f9d7b$var$Dh) throw Error($23bcd42a245f9d7b$var$p(174));
    return a;
}
function $23bcd42a245f9d7b$var$Ih(a, b) {
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Gh, b);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Fh, a);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Eh, $23bcd42a245f9d7b$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $23bcd42a245f9d7b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $23bcd42a245f9d7b$var$lb(b, a);
    }
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Eh);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Eh, b);
}
function $23bcd42a245f9d7b$var$Jh() {
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Eh);
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Fh);
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Gh);
}
function $23bcd42a245f9d7b$var$Kh(a) {
    $23bcd42a245f9d7b$var$Hh($23bcd42a245f9d7b$var$Gh.current);
    var b = $23bcd42a245f9d7b$var$Hh($23bcd42a245f9d7b$var$Eh.current);
    var c = $23bcd42a245f9d7b$var$lb(b, a.type);
    b !== c && ($23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Fh, a), $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Eh, c));
}
function $23bcd42a245f9d7b$var$Lh(a) {
    $23bcd42a245f9d7b$var$Fh.current === a && ($23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Eh), $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Fh));
}
var $23bcd42a245f9d7b$var$M = $23bcd42a245f9d7b$var$Uf(0);
function $23bcd42a245f9d7b$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $23bcd42a245f9d7b$var$Nh = [];
function $23bcd42a245f9d7b$var$Oh() {
    for(var a = 0; a < $23bcd42a245f9d7b$var$Nh.length; a++)$23bcd42a245f9d7b$var$Nh[a]._workInProgressVersionPrimary = null;
    $23bcd42a245f9d7b$var$Nh.length = 0;
}
var $23bcd42a245f9d7b$var$Ph = $23bcd42a245f9d7b$var$ua.ReactCurrentDispatcher, $23bcd42a245f9d7b$var$Qh = $23bcd42a245f9d7b$var$ua.ReactCurrentBatchConfig, $23bcd42a245f9d7b$var$Rh = 0, $23bcd42a245f9d7b$var$N = null, $23bcd42a245f9d7b$var$O = null, $23bcd42a245f9d7b$var$P = null, $23bcd42a245f9d7b$var$Sh = !1, $23bcd42a245f9d7b$var$Th = !1, $23bcd42a245f9d7b$var$Uh = 0, $23bcd42a245f9d7b$var$Vh = 0;
function $23bcd42a245f9d7b$var$Q() {
    throw Error($23bcd42a245f9d7b$var$p(321));
}
function $23bcd42a245f9d7b$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$23bcd42a245f9d7b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $23bcd42a245f9d7b$var$Xh(a, b, c, d, e, f) {
    $23bcd42a245f9d7b$var$Rh = f;
    $23bcd42a245f9d7b$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $23bcd42a245f9d7b$var$Ph.current = null === a || null === a.memoizedState ? $23bcd42a245f9d7b$var$Yh : $23bcd42a245f9d7b$var$Zh;
    a = c(d, e);
    if ($23bcd42a245f9d7b$var$Th) {
        f = 0;
        do {
            $23bcd42a245f9d7b$var$Th = !1;
            $23bcd42a245f9d7b$var$Uh = 0;
            if (25 <= f) throw Error($23bcd42a245f9d7b$var$p(301));
            f += 1;
            $23bcd42a245f9d7b$var$P = $23bcd42a245f9d7b$var$O = null;
            b.updateQueue = null;
            $23bcd42a245f9d7b$var$Ph.current = $23bcd42a245f9d7b$var$$h;
            a = c(d, e);
        }while ($23bcd42a245f9d7b$var$Th);
    }
    $23bcd42a245f9d7b$var$Ph.current = $23bcd42a245f9d7b$var$ai;
    b = null !== $23bcd42a245f9d7b$var$O && null !== $23bcd42a245f9d7b$var$O.next;
    $23bcd42a245f9d7b$var$Rh = 0;
    $23bcd42a245f9d7b$var$P = $23bcd42a245f9d7b$var$O = $23bcd42a245f9d7b$var$N = null;
    $23bcd42a245f9d7b$var$Sh = !1;
    if (b) throw Error($23bcd42a245f9d7b$var$p(300));
    return a;
}
function $23bcd42a245f9d7b$var$bi() {
    var a = 0 !== $23bcd42a245f9d7b$var$Uh;
    $23bcd42a245f9d7b$var$Uh = 0;
    return a;
}
function $23bcd42a245f9d7b$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $23bcd42a245f9d7b$var$P ? $23bcd42a245f9d7b$var$N.memoizedState = $23bcd42a245f9d7b$var$P = a : $23bcd42a245f9d7b$var$P = $23bcd42a245f9d7b$var$P.next = a;
    return $23bcd42a245f9d7b$var$P;
}
function $23bcd42a245f9d7b$var$di() {
    if (null === $23bcd42a245f9d7b$var$O) {
        var a = $23bcd42a245f9d7b$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $23bcd42a245f9d7b$var$O.next;
    var b = null === $23bcd42a245f9d7b$var$P ? $23bcd42a245f9d7b$var$N.memoizedState : $23bcd42a245f9d7b$var$P.next;
    if (null !== b) $23bcd42a245f9d7b$var$P = b, $23bcd42a245f9d7b$var$O = a;
    else {
        if (null === a) throw Error($23bcd42a245f9d7b$var$p(310));
        $23bcd42a245f9d7b$var$O = a;
        a = {
            memoizedState: $23bcd42a245f9d7b$var$O.memoizedState,
            baseState: $23bcd42a245f9d7b$var$O.baseState,
            baseQueue: $23bcd42a245f9d7b$var$O.baseQueue,
            queue: $23bcd42a245f9d7b$var$O.queue,
            next: null
        };
        null === $23bcd42a245f9d7b$var$P ? $23bcd42a245f9d7b$var$N.memoizedState = $23bcd42a245f9d7b$var$P = a : $23bcd42a245f9d7b$var$P = $23bcd42a245f9d7b$var$P.next = a;
    }
    return $23bcd42a245f9d7b$var$P;
}
function $23bcd42a245f9d7b$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $23bcd42a245f9d7b$var$fi(a) {
    var b = $23bcd42a245f9d7b$var$di(), c = b.queue;
    if (null === c) throw Error($23bcd42a245f9d7b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $23bcd42a245f9d7b$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($23bcd42a245f9d7b$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $23bcd42a245f9d7b$var$N.lanes |= m;
                $23bcd42a245f9d7b$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $23bcd42a245f9d7b$var$He(d, b.memoizedState) || ($23bcd42a245f9d7b$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $23bcd42a245f9d7b$var$N.lanes |= f, $23bcd42a245f9d7b$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $23bcd42a245f9d7b$var$gi(a) {
    var b = $23bcd42a245f9d7b$var$di(), c = b.queue;
    if (null === c) throw Error($23bcd42a245f9d7b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $23bcd42a245f9d7b$var$He(f, b.memoizedState) || ($23bcd42a245f9d7b$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $23bcd42a245f9d7b$var$hi() {}
function $23bcd42a245f9d7b$var$ii(a, b) {
    var c = $23bcd42a245f9d7b$var$N, d = $23bcd42a245f9d7b$var$di(), e = b(), f = !$23bcd42a245f9d7b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $23bcd42a245f9d7b$var$Ug = !0);
    d = d.queue;
    $23bcd42a245f9d7b$var$ji($23bcd42a245f9d7b$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $23bcd42a245f9d7b$var$P && $23bcd42a245f9d7b$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $23bcd42a245f9d7b$var$li(9, $23bcd42a245f9d7b$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $23bcd42a245f9d7b$var$R) throw Error($23bcd42a245f9d7b$var$p(349));
        0 !== ($23bcd42a245f9d7b$var$Rh & 30) || $23bcd42a245f9d7b$var$ni(c, b, e);
    }
    return e;
}
function $23bcd42a245f9d7b$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $23bcd42a245f9d7b$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $23bcd42a245f9d7b$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $23bcd42a245f9d7b$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $23bcd42a245f9d7b$var$oi(b) && $23bcd42a245f9d7b$var$pi(a);
}
function $23bcd42a245f9d7b$var$ki(a, b, c) {
    return c(function() {
        $23bcd42a245f9d7b$var$oi(b) && $23bcd42a245f9d7b$var$pi(a);
    });
}
function $23bcd42a245f9d7b$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$23bcd42a245f9d7b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $23bcd42a245f9d7b$var$pi(a) {
    var b = $23bcd42a245f9d7b$var$Zg(a, 1);
    null !== b && $23bcd42a245f9d7b$var$mh(b, a, 1, -1);
}
function $23bcd42a245f9d7b$var$qi(a) {
    var b = $23bcd42a245f9d7b$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $23bcd42a245f9d7b$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $23bcd42a245f9d7b$var$ri.bind(null, $23bcd42a245f9d7b$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $23bcd42a245f9d7b$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $23bcd42a245f9d7b$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $23bcd42a245f9d7b$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $23bcd42a245f9d7b$var$si() {
    return $23bcd42a245f9d7b$var$di().memoizedState;
}
function $23bcd42a245f9d7b$var$ti(a, b, c, d) {
    var e = $23bcd42a245f9d7b$var$ci();
    $23bcd42a245f9d7b$var$N.flags |= a;
    e.memoizedState = $23bcd42a245f9d7b$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $23bcd42a245f9d7b$var$ui(a, b, c, d) {
    var e = $23bcd42a245f9d7b$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $23bcd42a245f9d7b$var$O) {
        var g = $23bcd42a245f9d7b$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $23bcd42a245f9d7b$var$Wh(d, g.deps)) {
            e.memoizedState = $23bcd42a245f9d7b$var$li(b, c, f, d);
            return;
        }
    }
    $23bcd42a245f9d7b$var$N.flags |= a;
    e.memoizedState = $23bcd42a245f9d7b$var$li(1 | b, c, f, d);
}
function $23bcd42a245f9d7b$var$vi(a, b) {
    return $23bcd42a245f9d7b$var$ti(8390656, 8, a, b);
}
function $23bcd42a245f9d7b$var$ji(a, b) {
    return $23bcd42a245f9d7b$var$ui(2048, 8, a, b);
}
function $23bcd42a245f9d7b$var$wi(a, b) {
    return $23bcd42a245f9d7b$var$ui(4, 2, a, b);
}
function $23bcd42a245f9d7b$var$xi(a, b) {
    return $23bcd42a245f9d7b$var$ui(4, 4, a, b);
}
function $23bcd42a245f9d7b$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $23bcd42a245f9d7b$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $23bcd42a245f9d7b$var$ui(4, 4, $23bcd42a245f9d7b$var$yi.bind(null, b, a), c);
}
function $23bcd42a245f9d7b$var$Ai() {}
function $23bcd42a245f9d7b$var$Bi(a, b) {
    var c = $23bcd42a245f9d7b$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $23bcd42a245f9d7b$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $23bcd42a245f9d7b$var$Ci(a, b) {
    var c = $23bcd42a245f9d7b$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $23bcd42a245f9d7b$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $23bcd42a245f9d7b$var$Di(a, b, c) {
    if (0 === ($23bcd42a245f9d7b$var$Rh & 21)) return a.baseState && (a.baseState = !1, $23bcd42a245f9d7b$var$Ug = !0), a.memoizedState = c;
    $23bcd42a245f9d7b$var$He(c, b) || (c = $23bcd42a245f9d7b$var$yc(), $23bcd42a245f9d7b$var$N.lanes |= c, $23bcd42a245f9d7b$var$hh |= c, a.baseState = !0);
    return b;
}
function $23bcd42a245f9d7b$var$Ei(a, b) {
    var c = $23bcd42a245f9d7b$var$C;
    $23bcd42a245f9d7b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $23bcd42a245f9d7b$var$Qh.transition;
    $23bcd42a245f9d7b$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $23bcd42a245f9d7b$var$C = c, $23bcd42a245f9d7b$var$Qh.transition = d;
    }
}
function $23bcd42a245f9d7b$var$Fi() {
    return $23bcd42a245f9d7b$var$di().memoizedState;
}
function $23bcd42a245f9d7b$var$Gi(a, b, c) {
    var d = $23bcd42a245f9d7b$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($23bcd42a245f9d7b$var$Hi(a)) $23bcd42a245f9d7b$var$Ii(b, c);
    else if (c = $23bcd42a245f9d7b$var$Yg(a, b, c, d), null !== c) {
        var e = $23bcd42a245f9d7b$var$L();
        $23bcd42a245f9d7b$var$mh(c, a, d, e);
        $23bcd42a245f9d7b$var$Ji(c, b, d);
    }
}
function $23bcd42a245f9d7b$var$ri(a, b, c) {
    var d = $23bcd42a245f9d7b$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($23bcd42a245f9d7b$var$Hi(a)) $23bcd42a245f9d7b$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($23bcd42a245f9d7b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $23bcd42a245f9d7b$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $23bcd42a245f9d7b$var$Yg(a, b, e, d);
        null !== c && (e = $23bcd42a245f9d7b$var$L(), $23bcd42a245f9d7b$var$mh(c, a, d, e), $23bcd42a245f9d7b$var$Ji(c, b, d));
    }
}
function $23bcd42a245f9d7b$var$Hi(a) {
    var b = a.alternate;
    return a === $23bcd42a245f9d7b$var$N || null !== b && b === $23bcd42a245f9d7b$var$N;
}
function $23bcd42a245f9d7b$var$Ii(a, b) {
    $23bcd42a245f9d7b$var$Th = $23bcd42a245f9d7b$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $23bcd42a245f9d7b$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $23bcd42a245f9d7b$var$Cc(a, c);
    }
}
var $23bcd42a245f9d7b$var$ai = {
    readContext: $23bcd42a245f9d7b$var$Vg,
    useCallback: $23bcd42a245f9d7b$var$Q,
    useContext: $23bcd42a245f9d7b$var$Q,
    useEffect: $23bcd42a245f9d7b$var$Q,
    useImperativeHandle: $23bcd42a245f9d7b$var$Q,
    useInsertionEffect: $23bcd42a245f9d7b$var$Q,
    useLayoutEffect: $23bcd42a245f9d7b$var$Q,
    useMemo: $23bcd42a245f9d7b$var$Q,
    useReducer: $23bcd42a245f9d7b$var$Q,
    useRef: $23bcd42a245f9d7b$var$Q,
    useState: $23bcd42a245f9d7b$var$Q,
    useDebugValue: $23bcd42a245f9d7b$var$Q,
    useDeferredValue: $23bcd42a245f9d7b$var$Q,
    useTransition: $23bcd42a245f9d7b$var$Q,
    useMutableSource: $23bcd42a245f9d7b$var$Q,
    useSyncExternalStore: $23bcd42a245f9d7b$var$Q,
    useId: $23bcd42a245f9d7b$var$Q,
    unstable_isNewReconciler: !1
}, $23bcd42a245f9d7b$var$Yh = {
    readContext: $23bcd42a245f9d7b$var$Vg,
    useCallback: function(a, b) {
        $23bcd42a245f9d7b$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $23bcd42a245f9d7b$var$Vg,
    useEffect: $23bcd42a245f9d7b$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $23bcd42a245f9d7b$var$ti(4194308, 4, $23bcd42a245f9d7b$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $23bcd42a245f9d7b$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $23bcd42a245f9d7b$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $23bcd42a245f9d7b$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $23bcd42a245f9d7b$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $23bcd42a245f9d7b$var$Gi.bind(null, $23bcd42a245f9d7b$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $23bcd42a245f9d7b$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $23bcd42a245f9d7b$var$qi,
    useDebugValue: $23bcd42a245f9d7b$var$Ai,
    useDeferredValue: function(a) {
        return $23bcd42a245f9d7b$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $23bcd42a245f9d7b$var$qi(!1), b = a[0];
        a = $23bcd42a245f9d7b$var$Ei.bind(null, a[1]);
        $23bcd42a245f9d7b$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $23bcd42a245f9d7b$var$N, e = $23bcd42a245f9d7b$var$ci();
        if ($23bcd42a245f9d7b$var$I) {
            if (void 0 === c) throw Error($23bcd42a245f9d7b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $23bcd42a245f9d7b$var$R) throw Error($23bcd42a245f9d7b$var$p(349));
            0 !== ($23bcd42a245f9d7b$var$Rh & 30) || $23bcd42a245f9d7b$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $23bcd42a245f9d7b$var$vi($23bcd42a245f9d7b$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $23bcd42a245f9d7b$var$li(9, $23bcd42a245f9d7b$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $23bcd42a245f9d7b$var$ci(), b = $23bcd42a245f9d7b$var$R.identifierPrefix;
        if ($23bcd42a245f9d7b$var$I) {
            var c = $23bcd42a245f9d7b$var$sg;
            var d = $23bcd42a245f9d7b$var$rg;
            c = (d & ~(1 << 32 - $23bcd42a245f9d7b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $23bcd42a245f9d7b$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $23bcd42a245f9d7b$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $23bcd42a245f9d7b$var$Zh = {
    readContext: $23bcd42a245f9d7b$var$Vg,
    useCallback: $23bcd42a245f9d7b$var$Bi,
    useContext: $23bcd42a245f9d7b$var$Vg,
    useEffect: $23bcd42a245f9d7b$var$ji,
    useImperativeHandle: $23bcd42a245f9d7b$var$zi,
    useInsertionEffect: $23bcd42a245f9d7b$var$wi,
    useLayoutEffect: $23bcd42a245f9d7b$var$xi,
    useMemo: $23bcd42a245f9d7b$var$Ci,
    useReducer: $23bcd42a245f9d7b$var$fi,
    useRef: $23bcd42a245f9d7b$var$si,
    useState: function() {
        return $23bcd42a245f9d7b$var$fi($23bcd42a245f9d7b$var$ei);
    },
    useDebugValue: $23bcd42a245f9d7b$var$Ai,
    useDeferredValue: function(a) {
        var b = $23bcd42a245f9d7b$var$di();
        return $23bcd42a245f9d7b$var$Di(b, $23bcd42a245f9d7b$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $23bcd42a245f9d7b$var$fi($23bcd42a245f9d7b$var$ei)[0], b = $23bcd42a245f9d7b$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $23bcd42a245f9d7b$var$hi,
    useSyncExternalStore: $23bcd42a245f9d7b$var$ii,
    useId: $23bcd42a245f9d7b$var$Fi,
    unstable_isNewReconciler: !1
}, $23bcd42a245f9d7b$var$$h = {
    readContext: $23bcd42a245f9d7b$var$Vg,
    useCallback: $23bcd42a245f9d7b$var$Bi,
    useContext: $23bcd42a245f9d7b$var$Vg,
    useEffect: $23bcd42a245f9d7b$var$ji,
    useImperativeHandle: $23bcd42a245f9d7b$var$zi,
    useInsertionEffect: $23bcd42a245f9d7b$var$wi,
    useLayoutEffect: $23bcd42a245f9d7b$var$xi,
    useMemo: $23bcd42a245f9d7b$var$Ci,
    useReducer: $23bcd42a245f9d7b$var$gi,
    useRef: $23bcd42a245f9d7b$var$si,
    useState: function() {
        return $23bcd42a245f9d7b$var$gi($23bcd42a245f9d7b$var$ei);
    },
    useDebugValue: $23bcd42a245f9d7b$var$Ai,
    useDeferredValue: function(a) {
        var b = $23bcd42a245f9d7b$var$di();
        return null === $23bcd42a245f9d7b$var$O ? b.memoizedState = a : $23bcd42a245f9d7b$var$Di(b, $23bcd42a245f9d7b$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $23bcd42a245f9d7b$var$gi($23bcd42a245f9d7b$var$ei)[0], b = $23bcd42a245f9d7b$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $23bcd42a245f9d7b$var$hi,
    useSyncExternalStore: $23bcd42a245f9d7b$var$ii,
    useId: $23bcd42a245f9d7b$var$Fi,
    unstable_isNewReconciler: !1
};
function $23bcd42a245f9d7b$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $23bcd42a245f9d7b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $23bcd42a245f9d7b$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $23bcd42a245f9d7b$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $23bcd42a245f9d7b$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $23bcd42a245f9d7b$var$Oi(a, b, c) {
    c = $23bcd42a245f9d7b$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $23bcd42a245f9d7b$var$Pi || ($23bcd42a245f9d7b$var$Pi = !0, $23bcd42a245f9d7b$var$Qi = d);
        $23bcd42a245f9d7b$var$Mi(a, b);
    };
    return c;
}
function $23bcd42a245f9d7b$var$Ri(a, b, c) {
    c = $23bcd42a245f9d7b$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $23bcd42a245f9d7b$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $23bcd42a245f9d7b$var$Mi(a, b);
        "function" !== typeof d && (null === $23bcd42a245f9d7b$var$Si ? $23bcd42a245f9d7b$var$Si = new Set([
            this
        ]) : $23bcd42a245f9d7b$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $23bcd42a245f9d7b$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $23bcd42a245f9d7b$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $23bcd42a245f9d7b$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $23bcd42a245f9d7b$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $23bcd42a245f9d7b$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $23bcd42a245f9d7b$var$ch(-1, 1), b.tag = 2, $23bcd42a245f9d7b$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $23bcd42a245f9d7b$var$Xi = $23bcd42a245f9d7b$var$ua.ReactCurrentOwner, $23bcd42a245f9d7b$var$Ug = !1;
function $23bcd42a245f9d7b$var$Yi(a, b, c, d) {
    b.child = null === a ? $23bcd42a245f9d7b$var$Ch(b, null, c, d) : $23bcd42a245f9d7b$var$Bh(b, a.child, c, d);
}
function $23bcd42a245f9d7b$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $23bcd42a245f9d7b$var$Tg(b, e);
    d = $23bcd42a245f9d7b$var$Xh(a, b, c, d, f, e);
    c = $23bcd42a245f9d7b$var$bi();
    if (null !== a && !$23bcd42a245f9d7b$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $23bcd42a245f9d7b$var$$i(a, b, e);
    $23bcd42a245f9d7b$var$I && c && $23bcd42a245f9d7b$var$vg(b);
    b.flags |= 1;
    $23bcd42a245f9d7b$var$Yi(a, b, d, e);
    return b.child;
}
function $23bcd42a245f9d7b$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$23bcd42a245f9d7b$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $23bcd42a245f9d7b$var$cj(a, b, f, d, e);
        a = $23bcd42a245f9d7b$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $23bcd42a245f9d7b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $23bcd42a245f9d7b$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $23bcd42a245f9d7b$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $23bcd42a245f9d7b$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($23bcd42a245f9d7b$var$Ie(f, d) && a.ref === b.ref) {
            if ($23bcd42a245f9d7b$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($23bcd42a245f9d7b$var$Ug = !0);
            else return b.lanes = a.lanes, $23bcd42a245f9d7b$var$$i(a, b, e);
        }
    }
    return $23bcd42a245f9d7b$var$dj(a, b, c, d, e);
}
function $23bcd42a245f9d7b$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$fj, $23bcd42a245f9d7b$var$gj), $23bcd42a245f9d7b$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$fj, $23bcd42a245f9d7b$var$gj), $23bcd42a245f9d7b$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$fj, $23bcd42a245f9d7b$var$gj);
            $23bcd42a245f9d7b$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$fj, $23bcd42a245f9d7b$var$gj), $23bcd42a245f9d7b$var$gj |= d;
    $23bcd42a245f9d7b$var$Yi(a, b, e, c);
    return b.child;
}
function $23bcd42a245f9d7b$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $23bcd42a245f9d7b$var$dj(a, b, c, d, e) {
    var f = $23bcd42a245f9d7b$var$Zf(c) ? $23bcd42a245f9d7b$var$Xf : $23bcd42a245f9d7b$var$H.current;
    f = $23bcd42a245f9d7b$var$Yf(b, f);
    $23bcd42a245f9d7b$var$Tg(b, e);
    c = $23bcd42a245f9d7b$var$Xh(a, b, c, d, f, e);
    d = $23bcd42a245f9d7b$var$bi();
    if (null !== a && !$23bcd42a245f9d7b$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $23bcd42a245f9d7b$var$$i(a, b, e);
    $23bcd42a245f9d7b$var$I && d && $23bcd42a245f9d7b$var$vg(b);
    b.flags |= 1;
    $23bcd42a245f9d7b$var$Yi(a, b, c, e);
    return b.child;
}
function $23bcd42a245f9d7b$var$ij(a, b, c, d, e) {
    if ($23bcd42a245f9d7b$var$Zf(c)) {
        var f = !0;
        $23bcd42a245f9d7b$var$cg(b);
    } else f = !1;
    $23bcd42a245f9d7b$var$Tg(b, e);
    if (null === b.stateNode) $23bcd42a245f9d7b$var$jj(a, b), $23bcd42a245f9d7b$var$ph(b, c, d), $23bcd42a245f9d7b$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $23bcd42a245f9d7b$var$Vg(l) : (l = $23bcd42a245f9d7b$var$Zf(c) ? $23bcd42a245f9d7b$var$Xf : $23bcd42a245f9d7b$var$H.current, l = $23bcd42a245f9d7b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $23bcd42a245f9d7b$var$qh(b, g, d, l);
        $23bcd42a245f9d7b$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $23bcd42a245f9d7b$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $23bcd42a245f9d7b$var$Wf.current || $23bcd42a245f9d7b$var$$g ? ("function" === typeof m && ($23bcd42a245f9d7b$var$kh(b, c, m, d), k = b.memoizedState), (h = $23bcd42a245f9d7b$var$$g || $23bcd42a245f9d7b$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $23bcd42a245f9d7b$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $23bcd42a245f9d7b$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $23bcd42a245f9d7b$var$Vg(k) : (k = $23bcd42a245f9d7b$var$Zf(c) ? $23bcd42a245f9d7b$var$Xf : $23bcd42a245f9d7b$var$H.current, k = $23bcd42a245f9d7b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $23bcd42a245f9d7b$var$qh(b, g, d, k);
        $23bcd42a245f9d7b$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $23bcd42a245f9d7b$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $23bcd42a245f9d7b$var$Wf.current || $23bcd42a245f9d7b$var$$g ? ("function" === typeof y && ($23bcd42a245f9d7b$var$kh(b, c, y, d), n = b.memoizedState), (l = $23bcd42a245f9d7b$var$$g || $23bcd42a245f9d7b$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $23bcd42a245f9d7b$var$kj(a, b, c, d, f, e);
}
function $23bcd42a245f9d7b$var$kj(a, b, c, d, e, f) {
    $23bcd42a245f9d7b$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $23bcd42a245f9d7b$var$dg(b, c, !1), $23bcd42a245f9d7b$var$$i(a, b, f);
    d = b.stateNode;
    $23bcd42a245f9d7b$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $23bcd42a245f9d7b$var$Bh(b, a.child, null, f), b.child = $23bcd42a245f9d7b$var$Bh(b, null, h, f)) : $23bcd42a245f9d7b$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $23bcd42a245f9d7b$var$dg(b, c, !0);
    return b.child;
}
function $23bcd42a245f9d7b$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $23bcd42a245f9d7b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $23bcd42a245f9d7b$var$ag(a, b.context, !1);
    $23bcd42a245f9d7b$var$Ih(a, b.containerInfo);
}
function $23bcd42a245f9d7b$var$mj(a, b, c, d, e) {
    $23bcd42a245f9d7b$var$Ig();
    $23bcd42a245f9d7b$var$Jg(e);
    b.flags |= 256;
    $23bcd42a245f9d7b$var$Yi(a, b, c, d);
    return b.child;
}
var $23bcd42a245f9d7b$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $23bcd42a245f9d7b$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $23bcd42a245f9d7b$var$pj(a, b, c) {
    var d = b.pendingProps, e = $23bcd42a245f9d7b$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$M, e & 1);
    if (null === a) {
        $23bcd42a245f9d7b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $23bcd42a245f9d7b$var$qj(g, d, 0, null), a = $23bcd42a245f9d7b$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $23bcd42a245f9d7b$var$oj(c), b.memoizedState = $23bcd42a245f9d7b$var$nj, a) : $23bcd42a245f9d7b$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $23bcd42a245f9d7b$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $23bcd42a245f9d7b$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $23bcd42a245f9d7b$var$wh(h, f) : (f = $23bcd42a245f9d7b$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $23bcd42a245f9d7b$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $23bcd42a245f9d7b$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $23bcd42a245f9d7b$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $23bcd42a245f9d7b$var$rj(a, b) {
    b = $23bcd42a245f9d7b$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $23bcd42a245f9d7b$var$tj(a, b, c, d) {
    null !== d && $23bcd42a245f9d7b$var$Jg(d);
    $23bcd42a245f9d7b$var$Bh(b, a.child, null, c);
    a = $23bcd42a245f9d7b$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $23bcd42a245f9d7b$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $23bcd42a245f9d7b$var$Li(Error($23bcd42a245f9d7b$var$p(422))), $23bcd42a245f9d7b$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $23bcd42a245f9d7b$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $23bcd42a245f9d7b$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $23bcd42a245f9d7b$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $23bcd42a245f9d7b$var$oj(g);
        b.memoizedState = $23bcd42a245f9d7b$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $23bcd42a245f9d7b$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($23bcd42a245f9d7b$var$p(419));
        d = $23bcd42a245f9d7b$var$Li(f, d, void 0);
        return $23bcd42a245f9d7b$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($23bcd42a245f9d7b$var$Ug || h) {
        d = $23bcd42a245f9d7b$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $23bcd42a245f9d7b$var$Zg(a, e), $23bcd42a245f9d7b$var$mh(d, a, e, -1));
        }
        $23bcd42a245f9d7b$var$uj();
        d = $23bcd42a245f9d7b$var$Li(Error($23bcd42a245f9d7b$var$p(421)));
        return $23bcd42a245f9d7b$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $23bcd42a245f9d7b$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$Lf(e.nextSibling);
    $23bcd42a245f9d7b$var$xg = b;
    $23bcd42a245f9d7b$var$I = !0;
    $23bcd42a245f9d7b$var$zg = null;
    null !== a && ($23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$rg, $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$sg, $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$qg, $23bcd42a245f9d7b$var$rg = a.id, $23bcd42a245f9d7b$var$sg = a.overflow, $23bcd42a245f9d7b$var$qg = b);
    b = $23bcd42a245f9d7b$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $23bcd42a245f9d7b$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $23bcd42a245f9d7b$var$Sg(a.return, b, c);
}
function $23bcd42a245f9d7b$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $23bcd42a245f9d7b$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $23bcd42a245f9d7b$var$Yi(a, b, d.children, c);
    d = $23bcd42a245f9d7b$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $23bcd42a245f9d7b$var$wj(a, c, b);
            else if (19 === a.tag) $23bcd42a245f9d7b$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $23bcd42a245f9d7b$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $23bcd42a245f9d7b$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $23bcd42a245f9d7b$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $23bcd42a245f9d7b$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $23bcd42a245f9d7b$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $23bcd42a245f9d7b$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $23bcd42a245f9d7b$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $23bcd42a245f9d7b$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($23bcd42a245f9d7b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $23bcd42a245f9d7b$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $23bcd42a245f9d7b$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $23bcd42a245f9d7b$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $23bcd42a245f9d7b$var$lj(b);
            $23bcd42a245f9d7b$var$Ig();
            break;
        case 5:
            $23bcd42a245f9d7b$var$Kh(b);
            break;
        case 1:
            $23bcd42a245f9d7b$var$Zf(b.type) && $23bcd42a245f9d7b$var$cg(b);
            break;
        case 4:
            $23bcd42a245f9d7b$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$M, $23bcd42a245f9d7b$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $23bcd42a245f9d7b$var$pj(a, b, c);
                $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$M, $23bcd42a245f9d7b$var$M.current & 1);
                a = $23bcd42a245f9d7b$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$M, $23bcd42a245f9d7b$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $23bcd42a245f9d7b$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$M, $23bcd42a245f9d7b$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $23bcd42a245f9d7b$var$ej(a, b, c);
    }
    return $23bcd42a245f9d7b$var$$i(a, b, c);
}
var $23bcd42a245f9d7b$var$Aj, $23bcd42a245f9d7b$var$Bj, $23bcd42a245f9d7b$var$Cj, $23bcd42a245f9d7b$var$Dj;
$23bcd42a245f9d7b$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$23bcd42a245f9d7b$var$Bj = function() {};
$23bcd42a245f9d7b$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $23bcd42a245f9d7b$var$Hh($23bcd42a245f9d7b$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $23bcd42a245f9d7b$var$Ya(a, e);
                d = $23bcd42a245f9d7b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $23bcd42a245f9d7b$var$A({}, e, {
                    value: void 0
                });
                d = $23bcd42a245f9d7b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $23bcd42a245f9d7b$var$gb(a, e);
                d = $23bcd42a245f9d7b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $23bcd42a245f9d7b$var$Bf);
        }
        $23bcd42a245f9d7b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($23bcd42a245f9d7b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($23bcd42a245f9d7b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $23bcd42a245f9d7b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$23bcd42a245f9d7b$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $23bcd42a245f9d7b$var$Ej(a, b) {
    if (!$23bcd42a245f9d7b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $23bcd42a245f9d7b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $23bcd42a245f9d7b$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $23bcd42a245f9d7b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $23bcd42a245f9d7b$var$S(b), null;
        case 1:
            return $23bcd42a245f9d7b$var$Zf(b.type) && $23bcd42a245f9d7b$var$$f(), $23bcd42a245f9d7b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $23bcd42a245f9d7b$var$Jh();
            $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf);
            $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$H);
            $23bcd42a245f9d7b$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $23bcd42a245f9d7b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $23bcd42a245f9d7b$var$zg && ($23bcd42a245f9d7b$var$Gj($23bcd42a245f9d7b$var$zg), $23bcd42a245f9d7b$var$zg = null));
            $23bcd42a245f9d7b$var$Bj(a, b);
            $23bcd42a245f9d7b$var$S(b);
            return null;
        case 5:
            $23bcd42a245f9d7b$var$Lh(b);
            var e = $23bcd42a245f9d7b$var$Hh($23bcd42a245f9d7b$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $23bcd42a245f9d7b$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($23bcd42a245f9d7b$var$p(166));
                    $23bcd42a245f9d7b$var$S(b);
                    return null;
                }
                a = $23bcd42a245f9d7b$var$Hh($23bcd42a245f9d7b$var$Eh.current);
                if ($23bcd42a245f9d7b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$23bcd42a245f9d7b$var$Of] = b;
                    d[$23bcd42a245f9d7b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $23bcd42a245f9d7b$var$D("cancel", d);
                            $23bcd42a245f9d7b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $23bcd42a245f9d7b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $23bcd42a245f9d7b$var$lf.length; e++)$23bcd42a245f9d7b$var$D($23bcd42a245f9d7b$var$lf[e], d);
                            break;
                        case "source":
                            $23bcd42a245f9d7b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $23bcd42a245f9d7b$var$D("error", d);
                            $23bcd42a245f9d7b$var$D("load", d);
                            break;
                        case "details":
                            $23bcd42a245f9d7b$var$D("toggle", d);
                            break;
                        case "input":
                            $23bcd42a245f9d7b$var$Za(d, f);
                            $23bcd42a245f9d7b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $23bcd42a245f9d7b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $23bcd42a245f9d7b$var$hb(d, f), $23bcd42a245f9d7b$var$D("invalid", d);
                    }
                    $23bcd42a245f9d7b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $23bcd42a245f9d7b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $23bcd42a245f9d7b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $23bcd42a245f9d7b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $23bcd42a245f9d7b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $23bcd42a245f9d7b$var$Va(d);
                            $23bcd42a245f9d7b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $23bcd42a245f9d7b$var$Va(d);
                            $23bcd42a245f9d7b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $23bcd42a245f9d7b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $23bcd42a245f9d7b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$23bcd42a245f9d7b$var$Of] = b;
                    a[$23bcd42a245f9d7b$var$Pf] = d;
                    $23bcd42a245f9d7b$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $23bcd42a245f9d7b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $23bcd42a245f9d7b$var$D("cancel", a);
                                $23bcd42a245f9d7b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $23bcd42a245f9d7b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $23bcd42a245f9d7b$var$lf.length; e++)$23bcd42a245f9d7b$var$D($23bcd42a245f9d7b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $23bcd42a245f9d7b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $23bcd42a245f9d7b$var$D("error", a);
                                $23bcd42a245f9d7b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $23bcd42a245f9d7b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $23bcd42a245f9d7b$var$Za(a, d);
                                e = $23bcd42a245f9d7b$var$Ya(a, d);
                                $23bcd42a245f9d7b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $23bcd42a245f9d7b$var$A({}, d, {
                                    value: void 0
                                });
                                $23bcd42a245f9d7b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $23bcd42a245f9d7b$var$hb(a, d);
                                e = $23bcd42a245f9d7b$var$gb(a, d);
                                $23bcd42a245f9d7b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $23bcd42a245f9d7b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $23bcd42a245f9d7b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $23bcd42a245f9d7b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $23bcd42a245f9d7b$var$ob(a, k) : "number" === typeof k && $23bcd42a245f9d7b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($23bcd42a245f9d7b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $23bcd42a245f9d7b$var$D("scroll", a) : null != k && $23bcd42a245f9d7b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $23bcd42a245f9d7b$var$Va(a);
                                $23bcd42a245f9d7b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $23bcd42a245f9d7b$var$Va(a);
                                $23bcd42a245f9d7b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $23bcd42a245f9d7b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $23bcd42a245f9d7b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $23bcd42a245f9d7b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $23bcd42a245f9d7b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $23bcd42a245f9d7b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $23bcd42a245f9d7b$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($23bcd42a245f9d7b$var$p(166));
                c = $23bcd42a245f9d7b$var$Hh($23bcd42a245f9d7b$var$Gh.current);
                $23bcd42a245f9d7b$var$Hh($23bcd42a245f9d7b$var$Eh.current);
                if ($23bcd42a245f9d7b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$23bcd42a245f9d7b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $23bcd42a245f9d7b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $23bcd42a245f9d7b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $23bcd42a245f9d7b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$23bcd42a245f9d7b$var$Of] = b, b.stateNode = d;
            }
            $23bcd42a245f9d7b$var$S(b);
            return null;
        case 13:
            $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($23bcd42a245f9d7b$var$I && null !== $23bcd42a245f9d7b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $23bcd42a245f9d7b$var$Hg(), $23bcd42a245f9d7b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $23bcd42a245f9d7b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($23bcd42a245f9d7b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($23bcd42a245f9d7b$var$p(317));
                        f[$23bcd42a245f9d7b$var$Of] = b;
                    } else $23bcd42a245f9d7b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $23bcd42a245f9d7b$var$S(b);
                    f = !1;
                } else null !== $23bcd42a245f9d7b$var$zg && ($23bcd42a245f9d7b$var$Gj($23bcd42a245f9d7b$var$zg), $23bcd42a245f9d7b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($23bcd42a245f9d7b$var$M.current & 1) ? 0 === $23bcd42a245f9d7b$var$T && ($23bcd42a245f9d7b$var$T = 3) : $23bcd42a245f9d7b$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $23bcd42a245f9d7b$var$S(b);
            return null;
        case 4:
            return $23bcd42a245f9d7b$var$Jh(), $23bcd42a245f9d7b$var$Bj(a, b), null === a && $23bcd42a245f9d7b$var$sf(b.stateNode.containerInfo), $23bcd42a245f9d7b$var$S(b), null;
        case 10:
            return $23bcd42a245f9d7b$var$Rg(b.type._context), $23bcd42a245f9d7b$var$S(b), null;
        case 17:
            return $23bcd42a245f9d7b$var$Zf(b.type) && $23bcd42a245f9d7b$var$$f(), $23bcd42a245f9d7b$var$S(b), null;
        case 19:
            $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$M);
            f = b.memoizedState;
            if (null === f) return $23bcd42a245f9d7b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $23bcd42a245f9d7b$var$Ej(f, !1);
                else {
                    if (0 !== $23bcd42a245f9d7b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $23bcd42a245f9d7b$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $23bcd42a245f9d7b$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$M, $23bcd42a245f9d7b$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $23bcd42a245f9d7b$var$B() > $23bcd42a245f9d7b$var$Hj && (b.flags |= 128, d = !0, $23bcd42a245f9d7b$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $23bcd42a245f9d7b$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $23bcd42a245f9d7b$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$23bcd42a245f9d7b$var$I) return $23bcd42a245f9d7b$var$S(b), null;
                    } else 2 * $23bcd42a245f9d7b$var$B() - f.renderingStartTime > $23bcd42a245f9d7b$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $23bcd42a245f9d7b$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $23bcd42a245f9d7b$var$B(), b.sibling = null, c = $23bcd42a245f9d7b$var$M.current, $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$M, d ? c & 1 | 2 : c & 1), b;
            $23bcd42a245f9d7b$var$S(b);
            return null;
        case 22:
        case 23:
            return $23bcd42a245f9d7b$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($23bcd42a245f9d7b$var$gj & 1073741824) && ($23bcd42a245f9d7b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $23bcd42a245f9d7b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($23bcd42a245f9d7b$var$p(156, b.tag));
}
function $23bcd42a245f9d7b$var$Jj(a, b) {
    $23bcd42a245f9d7b$var$wg(b);
    switch(b.tag){
        case 1:
            return $23bcd42a245f9d7b$var$Zf(b.type) && $23bcd42a245f9d7b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $23bcd42a245f9d7b$var$Jh(), $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf), $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$H), $23bcd42a245f9d7b$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $23bcd42a245f9d7b$var$Lh(b), null;
        case 13:
            $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($23bcd42a245f9d7b$var$p(340));
                $23bcd42a245f9d7b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$M), null;
        case 4:
            return $23bcd42a245f9d7b$var$Jh(), null;
        case 10:
            return $23bcd42a245f9d7b$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $23bcd42a245f9d7b$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $23bcd42a245f9d7b$var$Kj = !1, $23bcd42a245f9d7b$var$U = !1, $23bcd42a245f9d7b$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $23bcd42a245f9d7b$var$V = null;
function $23bcd42a245f9d7b$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $23bcd42a245f9d7b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $23bcd42a245f9d7b$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $23bcd42a245f9d7b$var$W(a, b, d);
    }
}
var $23bcd42a245f9d7b$var$Oj = !1;
function $23bcd42a245f9d7b$var$Pj(a, b) {
    $23bcd42a245f9d7b$var$Cf = $23bcd42a245f9d7b$var$dd;
    a = $23bcd42a245f9d7b$var$Me();
    if ($23bcd42a245f9d7b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $23bcd42a245f9d7b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $23bcd42a245f9d7b$var$dd = !1;
    for($23bcd42a245f9d7b$var$V = b; null !== $23bcd42a245f9d7b$var$V;)if (b = $23bcd42a245f9d7b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $23bcd42a245f9d7b$var$V = a;
    else for(; null !== $23bcd42a245f9d7b$var$V;){
        b = $23bcd42a245f9d7b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $23bcd42a245f9d7b$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($23bcd42a245f9d7b$var$p(163));
            }
        } catch (F) {
            $23bcd42a245f9d7b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $23bcd42a245f9d7b$var$V = a;
            break;
        }
        $23bcd42a245f9d7b$var$V = b.return;
    }
    n = $23bcd42a245f9d7b$var$Oj;
    $23bcd42a245f9d7b$var$Oj = !1;
    return n;
}
function $23bcd42a245f9d7b$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $23bcd42a245f9d7b$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $23bcd42a245f9d7b$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $23bcd42a245f9d7b$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $23bcd42a245f9d7b$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $23bcd42a245f9d7b$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$23bcd42a245f9d7b$var$Of], delete b[$23bcd42a245f9d7b$var$Pf], delete b[$23bcd42a245f9d7b$var$of], delete b[$23bcd42a245f9d7b$var$Qf], delete b[$23bcd42a245f9d7b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $23bcd42a245f9d7b$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $23bcd42a245f9d7b$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $23bcd42a245f9d7b$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $23bcd42a245f9d7b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $23bcd42a245f9d7b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($23bcd42a245f9d7b$var$Wj(a, b, c), a = a.sibling; null !== a;)$23bcd42a245f9d7b$var$Wj(a, b, c), a = a.sibling;
}
function $23bcd42a245f9d7b$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($23bcd42a245f9d7b$var$Xj(a, b, c), a = a.sibling; null !== a;)$23bcd42a245f9d7b$var$Xj(a, b, c), a = a.sibling;
}
var $23bcd42a245f9d7b$var$X = null, $23bcd42a245f9d7b$var$Yj = !1;
function $23bcd42a245f9d7b$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$23bcd42a245f9d7b$var$ak(a, b, c), c = c.sibling;
}
function $23bcd42a245f9d7b$var$ak(a, b, c) {
    if ($23bcd42a245f9d7b$var$lc && "function" === typeof $23bcd42a245f9d7b$var$lc.onCommitFiberUnmount) try {
        $23bcd42a245f9d7b$var$lc.onCommitFiberUnmount($23bcd42a245f9d7b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $23bcd42a245f9d7b$var$U || $23bcd42a245f9d7b$var$Mj(c, b);
        case 6:
            var d = $23bcd42a245f9d7b$var$X, e = $23bcd42a245f9d7b$var$Yj;
            $23bcd42a245f9d7b$var$X = null;
            $23bcd42a245f9d7b$var$Zj(a, b, c);
            $23bcd42a245f9d7b$var$X = d;
            $23bcd42a245f9d7b$var$Yj = e;
            null !== $23bcd42a245f9d7b$var$X && ($23bcd42a245f9d7b$var$Yj ? (a = $23bcd42a245f9d7b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $23bcd42a245f9d7b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $23bcd42a245f9d7b$var$X && ($23bcd42a245f9d7b$var$Yj ? (a = $23bcd42a245f9d7b$var$X, c = c.stateNode, 8 === a.nodeType ? $23bcd42a245f9d7b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $23bcd42a245f9d7b$var$Kf(a, c), $23bcd42a245f9d7b$var$bd(a)) : $23bcd42a245f9d7b$var$Kf($23bcd42a245f9d7b$var$X, c.stateNode));
            break;
        case 4:
            d = $23bcd42a245f9d7b$var$X;
            e = $23bcd42a245f9d7b$var$Yj;
            $23bcd42a245f9d7b$var$X = c.stateNode.containerInfo;
            $23bcd42a245f9d7b$var$Yj = !0;
            $23bcd42a245f9d7b$var$Zj(a, b, c);
            $23bcd42a245f9d7b$var$X = d;
            $23bcd42a245f9d7b$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$23bcd42a245f9d7b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $23bcd42a245f9d7b$var$Nj(c, b, g) : 0 !== (f & 4) && $23bcd42a245f9d7b$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $23bcd42a245f9d7b$var$Zj(a, b, c);
            break;
        case 1:
            if (!$23bcd42a245f9d7b$var$U && ($23bcd42a245f9d7b$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $23bcd42a245f9d7b$var$W(c, b, h);
            }
            $23bcd42a245f9d7b$var$Zj(a, b, c);
            break;
        case 21:
            $23bcd42a245f9d7b$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($23bcd42a245f9d7b$var$U = (d = $23bcd42a245f9d7b$var$U) || null !== c.memoizedState, $23bcd42a245f9d7b$var$Zj(a, b, c), $23bcd42a245f9d7b$var$U = d) : $23bcd42a245f9d7b$var$Zj(a, b, c);
            break;
        default:
            $23bcd42a245f9d7b$var$Zj(a, b, c);
    }
}
function $23bcd42a245f9d7b$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $23bcd42a245f9d7b$var$Lj);
        b.forEach(function(b) {
            var d = $23bcd42a245f9d7b$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $23bcd42a245f9d7b$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $23bcd42a245f9d7b$var$X = h.stateNode;
                        $23bcd42a245f9d7b$var$Yj = !1;
                        break a;
                    case 3:
                        $23bcd42a245f9d7b$var$X = h.stateNode.containerInfo;
                        $23bcd42a245f9d7b$var$Yj = !0;
                        break a;
                    case 4:
                        $23bcd42a245f9d7b$var$X = h.stateNode.containerInfo;
                        $23bcd42a245f9d7b$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $23bcd42a245f9d7b$var$X) throw Error($23bcd42a245f9d7b$var$p(160));
            $23bcd42a245f9d7b$var$ak(f, g, e);
            $23bcd42a245f9d7b$var$X = null;
            $23bcd42a245f9d7b$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $23bcd42a245f9d7b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$23bcd42a245f9d7b$var$ek(b, a), b = b.sibling;
}
function $23bcd42a245f9d7b$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $23bcd42a245f9d7b$var$dk(b, a);
            $23bcd42a245f9d7b$var$fk(a);
            if (d & 4) {
                try {
                    $23bcd42a245f9d7b$var$Qj(3, a, a.return), $23bcd42a245f9d7b$var$Rj(3, a);
                } catch (t) {
                    $23bcd42a245f9d7b$var$W(a, a.return, t);
                }
                try {
                    $23bcd42a245f9d7b$var$Qj(5, a, a.return);
                } catch (t) {
                    $23bcd42a245f9d7b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $23bcd42a245f9d7b$var$dk(b, a);
            $23bcd42a245f9d7b$var$fk(a);
            d & 512 && null !== c && $23bcd42a245f9d7b$var$Mj(c, c.return);
            break;
        case 5:
            $23bcd42a245f9d7b$var$dk(b, a);
            $23bcd42a245f9d7b$var$fk(a);
            d & 512 && null !== c && $23bcd42a245f9d7b$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $23bcd42a245f9d7b$var$ob(e, "");
                } catch (t) {
                    $23bcd42a245f9d7b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $23bcd42a245f9d7b$var$ab(e, f);
                    $23bcd42a245f9d7b$var$vb(h, g);
                    var l = $23bcd42a245f9d7b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $23bcd42a245f9d7b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $23bcd42a245f9d7b$var$nb(e, q) : "children" === m ? $23bcd42a245f9d7b$var$ob(e, q) : $23bcd42a245f9d7b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $23bcd42a245f9d7b$var$bb(e, f);
                            break;
                        case "textarea":
                            $23bcd42a245f9d7b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $23bcd42a245f9d7b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $23bcd42a245f9d7b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $23bcd42a245f9d7b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$23bcd42a245f9d7b$var$Pf] = f;
                } catch (t) {
                    $23bcd42a245f9d7b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $23bcd42a245f9d7b$var$dk(b, a);
            $23bcd42a245f9d7b$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($23bcd42a245f9d7b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $23bcd42a245f9d7b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $23bcd42a245f9d7b$var$dk(b, a);
            $23bcd42a245f9d7b$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $23bcd42a245f9d7b$var$bd(b.containerInfo);
            } catch (t) {
                $23bcd42a245f9d7b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $23bcd42a245f9d7b$var$dk(b, a);
            $23bcd42a245f9d7b$var$fk(a);
            break;
        case 13:
            $23bcd42a245f9d7b$var$dk(b, a);
            $23bcd42a245f9d7b$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($23bcd42a245f9d7b$var$gk = $23bcd42a245f9d7b$var$B()));
            d & 4 && $23bcd42a245f9d7b$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($23bcd42a245f9d7b$var$U = (l = $23bcd42a245f9d7b$var$U) || m, $23bcd42a245f9d7b$var$dk(b, a), $23bcd42a245f9d7b$var$U = l) : $23bcd42a245f9d7b$var$dk(b, a);
            $23bcd42a245f9d7b$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($23bcd42a245f9d7b$var$V = a, m = a.child; null !== m;){
                    for(q = $23bcd42a245f9d7b$var$V = m; null !== $23bcd42a245f9d7b$var$V;){
                        r = $23bcd42a245f9d7b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $23bcd42a245f9d7b$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $23bcd42a245f9d7b$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $23bcd42a245f9d7b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $23bcd42a245f9d7b$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $23bcd42a245f9d7b$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $23bcd42a245f9d7b$var$V = y) : $23bcd42a245f9d7b$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $23bcd42a245f9d7b$var$rb("display", g));
                            } catch (t) {
                                $23bcd42a245f9d7b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $23bcd42a245f9d7b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $23bcd42a245f9d7b$var$dk(b, a);
            $23bcd42a245f9d7b$var$fk(a);
            d & 4 && $23bcd42a245f9d7b$var$bk(a);
            break;
        case 21:
            break;
        default:
            $23bcd42a245f9d7b$var$dk(b, a), $23bcd42a245f9d7b$var$fk(a);
    }
}
function $23bcd42a245f9d7b$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($23bcd42a245f9d7b$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($23bcd42a245f9d7b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($23bcd42a245f9d7b$var$ob(e, ""), d.flags &= -33);
                    var f = $23bcd42a245f9d7b$var$Vj(a);
                    $23bcd42a245f9d7b$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $23bcd42a245f9d7b$var$Vj(a);
                    $23bcd42a245f9d7b$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($23bcd42a245f9d7b$var$p(161));
            }
        } catch (k) {
            $23bcd42a245f9d7b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $23bcd42a245f9d7b$var$ik(a, b, c) {
    $23bcd42a245f9d7b$var$V = a;
    $23bcd42a245f9d7b$var$jk(a, b, c);
}
function $23bcd42a245f9d7b$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $23bcd42a245f9d7b$var$V;){
        var e = $23bcd42a245f9d7b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $23bcd42a245f9d7b$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $23bcd42a245f9d7b$var$U;
                h = $23bcd42a245f9d7b$var$Kj;
                var l = $23bcd42a245f9d7b$var$U;
                $23bcd42a245f9d7b$var$Kj = g;
                if (($23bcd42a245f9d7b$var$U = k) && !l) for($23bcd42a245f9d7b$var$V = e; null !== $23bcd42a245f9d7b$var$V;)g = $23bcd42a245f9d7b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $23bcd42a245f9d7b$var$kk(e) : null !== k ? (k.return = g, $23bcd42a245f9d7b$var$V = k) : $23bcd42a245f9d7b$var$kk(e);
                for(; null !== f;)$23bcd42a245f9d7b$var$V = f, $23bcd42a245f9d7b$var$jk(f, b, c), f = f.sibling;
                $23bcd42a245f9d7b$var$V = e;
                $23bcd42a245f9d7b$var$Kj = h;
                $23bcd42a245f9d7b$var$U = l;
            }
            $23bcd42a245f9d7b$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $23bcd42a245f9d7b$var$V = f) : $23bcd42a245f9d7b$var$lk(a, b, c);
    }
}
function $23bcd42a245f9d7b$var$lk(a) {
    for(; null !== $23bcd42a245f9d7b$var$V;){
        var b = $23bcd42a245f9d7b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $23bcd42a245f9d7b$var$U || $23bcd42a245f9d7b$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$23bcd42a245f9d7b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $23bcd42a245f9d7b$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $23bcd42a245f9d7b$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $23bcd42a245f9d7b$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $23bcd42a245f9d7b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($23bcd42a245f9d7b$var$p(163));
                }
                $23bcd42a245f9d7b$var$U || b.flags & 512 && $23bcd42a245f9d7b$var$Sj(b);
            } catch (r) {
                $23bcd42a245f9d7b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $23bcd42a245f9d7b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $23bcd42a245f9d7b$var$V = c;
            break;
        }
        $23bcd42a245f9d7b$var$V = b.return;
    }
}
function $23bcd42a245f9d7b$var$hk(a) {
    for(; null !== $23bcd42a245f9d7b$var$V;){
        var b = $23bcd42a245f9d7b$var$V;
        if (b === a) {
            $23bcd42a245f9d7b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $23bcd42a245f9d7b$var$V = c;
            break;
        }
        $23bcd42a245f9d7b$var$V = b.return;
    }
}
function $23bcd42a245f9d7b$var$kk(a) {
    for(; null !== $23bcd42a245f9d7b$var$V;){
        var b = $23bcd42a245f9d7b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $23bcd42a245f9d7b$var$Rj(4, b);
                    } catch (k) {
                        $23bcd42a245f9d7b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $23bcd42a245f9d7b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $23bcd42a245f9d7b$var$Sj(b);
                    } catch (k) {
                        $23bcd42a245f9d7b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $23bcd42a245f9d7b$var$Sj(b);
                    } catch (k) {
                        $23bcd42a245f9d7b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $23bcd42a245f9d7b$var$W(b, b.return, k);
        }
        if (b === a) {
            $23bcd42a245f9d7b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $23bcd42a245f9d7b$var$V = h;
            break;
        }
        $23bcd42a245f9d7b$var$V = b.return;
    }
}
var $23bcd42a245f9d7b$var$mk = Math.ceil, $23bcd42a245f9d7b$var$nk = $23bcd42a245f9d7b$var$ua.ReactCurrentDispatcher, $23bcd42a245f9d7b$var$ok = $23bcd42a245f9d7b$var$ua.ReactCurrentOwner, $23bcd42a245f9d7b$var$pk = $23bcd42a245f9d7b$var$ua.ReactCurrentBatchConfig, $23bcd42a245f9d7b$var$K = 0, $23bcd42a245f9d7b$var$R = null, $23bcd42a245f9d7b$var$Y = null, $23bcd42a245f9d7b$var$Z = 0, $23bcd42a245f9d7b$var$gj = 0, $23bcd42a245f9d7b$var$fj = $23bcd42a245f9d7b$var$Uf(0), $23bcd42a245f9d7b$var$T = 0, $23bcd42a245f9d7b$var$qk = null, $23bcd42a245f9d7b$var$hh = 0, $23bcd42a245f9d7b$var$rk = 0, $23bcd42a245f9d7b$var$sk = 0, $23bcd42a245f9d7b$var$tk = null, $23bcd42a245f9d7b$var$uk = null, $23bcd42a245f9d7b$var$gk = 0, $23bcd42a245f9d7b$var$Hj = Infinity, $23bcd42a245f9d7b$var$vk = null, $23bcd42a245f9d7b$var$Pi = !1, $23bcd42a245f9d7b$var$Qi = null, $23bcd42a245f9d7b$var$Si = null, $23bcd42a245f9d7b$var$wk = !1, $23bcd42a245f9d7b$var$xk = null, $23bcd42a245f9d7b$var$yk = 0, $23bcd42a245f9d7b$var$zk = 0, $23bcd42a245f9d7b$var$Ak = null, $23bcd42a245f9d7b$var$Bk = -1, $23bcd42a245f9d7b$var$Ck = 0;
function $23bcd42a245f9d7b$var$L() {
    return 0 !== ($23bcd42a245f9d7b$var$K & 6) ? $23bcd42a245f9d7b$var$B() : -1 !== $23bcd42a245f9d7b$var$Bk ? $23bcd42a245f9d7b$var$Bk : $23bcd42a245f9d7b$var$Bk = $23bcd42a245f9d7b$var$B();
}
function $23bcd42a245f9d7b$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($23bcd42a245f9d7b$var$K & 2) && 0 !== $23bcd42a245f9d7b$var$Z) return $23bcd42a245f9d7b$var$Z & -$23bcd42a245f9d7b$var$Z;
    if (null !== $23bcd42a245f9d7b$var$Kg.transition) return 0 === $23bcd42a245f9d7b$var$Ck && ($23bcd42a245f9d7b$var$Ck = $23bcd42a245f9d7b$var$yc()), $23bcd42a245f9d7b$var$Ck;
    a = $23bcd42a245f9d7b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $23bcd42a245f9d7b$var$jd(a.type);
    return a;
}
function $23bcd42a245f9d7b$var$mh(a, b, c, d) {
    if (50 < $23bcd42a245f9d7b$var$zk) throw $23bcd42a245f9d7b$var$zk = 0, $23bcd42a245f9d7b$var$Ak = null, Error($23bcd42a245f9d7b$var$p(185));
    $23bcd42a245f9d7b$var$Ac(a, c, d);
    if (0 === ($23bcd42a245f9d7b$var$K & 2) || a !== $23bcd42a245f9d7b$var$R) a === $23bcd42a245f9d7b$var$R && (0 === ($23bcd42a245f9d7b$var$K & 2) && ($23bcd42a245f9d7b$var$rk |= c), 4 === $23bcd42a245f9d7b$var$T && $23bcd42a245f9d7b$var$Dk(a, $23bcd42a245f9d7b$var$Z)), $23bcd42a245f9d7b$var$Ek(a, d), 1 === c && 0 === $23bcd42a245f9d7b$var$K && 0 === (b.mode & 1) && ($23bcd42a245f9d7b$var$Hj = $23bcd42a245f9d7b$var$B() + 500, $23bcd42a245f9d7b$var$fg && $23bcd42a245f9d7b$var$jg());
}
function $23bcd42a245f9d7b$var$Ek(a, b) {
    var c = a.callbackNode;
    $23bcd42a245f9d7b$var$wc(a, b);
    var d = $23bcd42a245f9d7b$var$uc(a, a === $23bcd42a245f9d7b$var$R ? $23bcd42a245f9d7b$var$Z : 0);
    if (0 === d) null !== c && $23bcd42a245f9d7b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $23bcd42a245f9d7b$var$bc(c);
        if (1 === b) 0 === a.tag ? $23bcd42a245f9d7b$var$ig($23bcd42a245f9d7b$var$Fk.bind(null, a)) : $23bcd42a245f9d7b$var$hg($23bcd42a245f9d7b$var$Fk.bind(null, a)), $23bcd42a245f9d7b$var$Jf(function() {
            0 === ($23bcd42a245f9d7b$var$K & 6) && $23bcd42a245f9d7b$var$jg();
        }), c = null;
        else {
            switch($23bcd42a245f9d7b$var$Dc(d)){
                case 1:
                    c = $23bcd42a245f9d7b$var$fc;
                    break;
                case 4:
                    c = $23bcd42a245f9d7b$var$gc;
                    break;
                case 16:
                    c = $23bcd42a245f9d7b$var$hc;
                    break;
                case 536870912:
                    c = $23bcd42a245f9d7b$var$jc;
                    break;
                default:
                    c = $23bcd42a245f9d7b$var$hc;
            }
            c = $23bcd42a245f9d7b$var$Gk(c, $23bcd42a245f9d7b$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $23bcd42a245f9d7b$var$Hk(a, b) {
    $23bcd42a245f9d7b$var$Bk = -1;
    $23bcd42a245f9d7b$var$Ck = 0;
    if (0 !== ($23bcd42a245f9d7b$var$K & 6)) throw Error($23bcd42a245f9d7b$var$p(327));
    var c = a.callbackNode;
    if ($23bcd42a245f9d7b$var$Ik() && a.callbackNode !== c) return null;
    var d = $23bcd42a245f9d7b$var$uc(a, a === $23bcd42a245f9d7b$var$R ? $23bcd42a245f9d7b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $23bcd42a245f9d7b$var$Jk(a, d);
    else {
        b = d;
        var e = $23bcd42a245f9d7b$var$K;
        $23bcd42a245f9d7b$var$K |= 2;
        var f = $23bcd42a245f9d7b$var$Kk();
        if ($23bcd42a245f9d7b$var$R !== a || $23bcd42a245f9d7b$var$Z !== b) $23bcd42a245f9d7b$var$vk = null, $23bcd42a245f9d7b$var$Hj = $23bcd42a245f9d7b$var$B() + 500, $23bcd42a245f9d7b$var$Lk(a, b);
        for(;;)try {
            $23bcd42a245f9d7b$var$Mk();
            break;
        } catch (h) {
            $23bcd42a245f9d7b$var$Nk(a, h);
        }
        $23bcd42a245f9d7b$var$Qg();
        $23bcd42a245f9d7b$var$nk.current = f;
        $23bcd42a245f9d7b$var$K = e;
        null !== $23bcd42a245f9d7b$var$Y ? b = 0 : ($23bcd42a245f9d7b$var$R = null, $23bcd42a245f9d7b$var$Z = 0, b = $23bcd42a245f9d7b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $23bcd42a245f9d7b$var$xc(a), 0 !== e && (d = e, b = $23bcd42a245f9d7b$var$Ok(a, e)));
        if (1 === b) throw c = $23bcd42a245f9d7b$var$qk, $23bcd42a245f9d7b$var$Lk(a, 0), $23bcd42a245f9d7b$var$Dk(a, d), $23bcd42a245f9d7b$var$Ek(a, $23bcd42a245f9d7b$var$B()), c;
        if (6 === b) $23bcd42a245f9d7b$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$23bcd42a245f9d7b$var$Pk(e) && (b = $23bcd42a245f9d7b$var$Jk(a, d), 2 === b && (f = $23bcd42a245f9d7b$var$xc(a), 0 !== f && (d = f, b = $23bcd42a245f9d7b$var$Ok(a, f))), 1 === b)) throw c = $23bcd42a245f9d7b$var$qk, $23bcd42a245f9d7b$var$Lk(a, 0), $23bcd42a245f9d7b$var$Dk(a, d), $23bcd42a245f9d7b$var$Ek(a, $23bcd42a245f9d7b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($23bcd42a245f9d7b$var$p(345));
                case 2:
                    $23bcd42a245f9d7b$var$Qk(a, $23bcd42a245f9d7b$var$uk, $23bcd42a245f9d7b$var$vk);
                    break;
                case 3:
                    $23bcd42a245f9d7b$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $23bcd42a245f9d7b$var$gk + 500 - $23bcd42a245f9d7b$var$B(), 10 < b)) {
                        if (0 !== $23bcd42a245f9d7b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $23bcd42a245f9d7b$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $23bcd42a245f9d7b$var$Ff($23bcd42a245f9d7b$var$Qk.bind(null, a, $23bcd42a245f9d7b$var$uk, $23bcd42a245f9d7b$var$vk), b);
                        break;
                    }
                    $23bcd42a245f9d7b$var$Qk(a, $23bcd42a245f9d7b$var$uk, $23bcd42a245f9d7b$var$vk);
                    break;
                case 4:
                    $23bcd42a245f9d7b$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $23bcd42a245f9d7b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $23bcd42a245f9d7b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $23bcd42a245f9d7b$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $23bcd42a245f9d7b$var$Ff($23bcd42a245f9d7b$var$Qk.bind(null, a, $23bcd42a245f9d7b$var$uk, $23bcd42a245f9d7b$var$vk), d);
                        break;
                    }
                    $23bcd42a245f9d7b$var$Qk(a, $23bcd42a245f9d7b$var$uk, $23bcd42a245f9d7b$var$vk);
                    break;
                case 5:
                    $23bcd42a245f9d7b$var$Qk(a, $23bcd42a245f9d7b$var$uk, $23bcd42a245f9d7b$var$vk);
                    break;
                default:
                    throw Error($23bcd42a245f9d7b$var$p(329));
            }
        }
    }
    $23bcd42a245f9d7b$var$Ek(a, $23bcd42a245f9d7b$var$B());
    return a.callbackNode === c ? $23bcd42a245f9d7b$var$Hk.bind(null, a) : null;
}
function $23bcd42a245f9d7b$var$Ok(a, b) {
    var c = $23bcd42a245f9d7b$var$tk;
    a.current.memoizedState.isDehydrated && ($23bcd42a245f9d7b$var$Lk(a, b).flags |= 256);
    a = $23bcd42a245f9d7b$var$Jk(a, b);
    2 !== a && (b = $23bcd42a245f9d7b$var$uk, $23bcd42a245f9d7b$var$uk = c, null !== b && $23bcd42a245f9d7b$var$Gj(b));
    return a;
}
function $23bcd42a245f9d7b$var$Gj(a) {
    null === $23bcd42a245f9d7b$var$uk ? $23bcd42a245f9d7b$var$uk = a : $23bcd42a245f9d7b$var$uk.push.apply($23bcd42a245f9d7b$var$uk, a);
}
function $23bcd42a245f9d7b$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$23bcd42a245f9d7b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $23bcd42a245f9d7b$var$Dk(a, b) {
    b &= ~$23bcd42a245f9d7b$var$sk;
    b &= ~$23bcd42a245f9d7b$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $23bcd42a245f9d7b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $23bcd42a245f9d7b$var$Fk(a) {
    if (0 !== ($23bcd42a245f9d7b$var$K & 6)) throw Error($23bcd42a245f9d7b$var$p(327));
    $23bcd42a245f9d7b$var$Ik();
    var b = $23bcd42a245f9d7b$var$uc(a, 0);
    if (0 === (b & 1)) return $23bcd42a245f9d7b$var$Ek(a, $23bcd42a245f9d7b$var$B()), null;
    var c = $23bcd42a245f9d7b$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $23bcd42a245f9d7b$var$xc(a);
        0 !== d && (b = d, c = $23bcd42a245f9d7b$var$Ok(a, d));
    }
    if (1 === c) throw c = $23bcd42a245f9d7b$var$qk, $23bcd42a245f9d7b$var$Lk(a, 0), $23bcd42a245f9d7b$var$Dk(a, b), $23bcd42a245f9d7b$var$Ek(a, $23bcd42a245f9d7b$var$B()), c;
    if (6 === c) throw Error($23bcd42a245f9d7b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $23bcd42a245f9d7b$var$Qk(a, $23bcd42a245f9d7b$var$uk, $23bcd42a245f9d7b$var$vk);
    $23bcd42a245f9d7b$var$Ek(a, $23bcd42a245f9d7b$var$B());
    return null;
}
function $23bcd42a245f9d7b$var$Rk(a, b) {
    var c = $23bcd42a245f9d7b$var$K;
    $23bcd42a245f9d7b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $23bcd42a245f9d7b$var$K = c, 0 === $23bcd42a245f9d7b$var$K && ($23bcd42a245f9d7b$var$Hj = $23bcd42a245f9d7b$var$B() + 500, $23bcd42a245f9d7b$var$fg && $23bcd42a245f9d7b$var$jg());
    }
}
function $23bcd42a245f9d7b$var$Sk(a) {
    null !== $23bcd42a245f9d7b$var$xk && 0 === $23bcd42a245f9d7b$var$xk.tag && 0 === ($23bcd42a245f9d7b$var$K & 6) && $23bcd42a245f9d7b$var$Ik();
    var b = $23bcd42a245f9d7b$var$K;
    $23bcd42a245f9d7b$var$K |= 1;
    var c = $23bcd42a245f9d7b$var$pk.transition, d = $23bcd42a245f9d7b$var$C;
    try {
        if ($23bcd42a245f9d7b$var$pk.transition = null, $23bcd42a245f9d7b$var$C = 1, a) return a();
    } finally{
        $23bcd42a245f9d7b$var$C = d, $23bcd42a245f9d7b$var$pk.transition = c, $23bcd42a245f9d7b$var$K = b, 0 === ($23bcd42a245f9d7b$var$K & 6) && $23bcd42a245f9d7b$var$jg();
    }
}
function $23bcd42a245f9d7b$var$Ij() {
    $23bcd42a245f9d7b$var$gj = $23bcd42a245f9d7b$var$fj.current;
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$fj);
}
function $23bcd42a245f9d7b$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $23bcd42a245f9d7b$var$Gf(c));
    if (null !== $23bcd42a245f9d7b$var$Y) for(c = $23bcd42a245f9d7b$var$Y.return; null !== c;){
        var d = c;
        $23bcd42a245f9d7b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $23bcd42a245f9d7b$var$$f();
                break;
            case 3:
                $23bcd42a245f9d7b$var$Jh();
                $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf);
                $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$H);
                $23bcd42a245f9d7b$var$Oh();
                break;
            case 5:
                $23bcd42a245f9d7b$var$Lh(d);
                break;
            case 4:
                $23bcd42a245f9d7b$var$Jh();
                break;
            case 13:
                $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$M);
                break;
            case 19:
                $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$M);
                break;
            case 10:
                $23bcd42a245f9d7b$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $23bcd42a245f9d7b$var$Ij();
        }
        c = c.return;
    }
    $23bcd42a245f9d7b$var$R = a;
    $23bcd42a245f9d7b$var$Y = a = $23bcd42a245f9d7b$var$wh(a.current, null);
    $23bcd42a245f9d7b$var$Z = $23bcd42a245f9d7b$var$gj = b;
    $23bcd42a245f9d7b$var$T = 0;
    $23bcd42a245f9d7b$var$qk = null;
    $23bcd42a245f9d7b$var$sk = $23bcd42a245f9d7b$var$rk = $23bcd42a245f9d7b$var$hh = 0;
    $23bcd42a245f9d7b$var$uk = $23bcd42a245f9d7b$var$tk = null;
    if (null !== $23bcd42a245f9d7b$var$Wg) {
        for(b = 0; b < $23bcd42a245f9d7b$var$Wg.length; b++)if (c = $23bcd42a245f9d7b$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $23bcd42a245f9d7b$var$Wg = null;
    }
    return a;
}
function $23bcd42a245f9d7b$var$Nk(a, b) {
    do {
        var c = $23bcd42a245f9d7b$var$Y;
        try {
            $23bcd42a245f9d7b$var$Qg();
            $23bcd42a245f9d7b$var$Ph.current = $23bcd42a245f9d7b$var$ai;
            if ($23bcd42a245f9d7b$var$Sh) {
                for(var d = $23bcd42a245f9d7b$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $23bcd42a245f9d7b$var$Sh = !1;
            }
            $23bcd42a245f9d7b$var$Rh = 0;
            $23bcd42a245f9d7b$var$P = $23bcd42a245f9d7b$var$O = $23bcd42a245f9d7b$var$N = null;
            $23bcd42a245f9d7b$var$Th = !1;
            $23bcd42a245f9d7b$var$Uh = 0;
            $23bcd42a245f9d7b$var$ok.current = null;
            if (null === c || null === c.return) {
                $23bcd42a245f9d7b$var$T = 1;
                $23bcd42a245f9d7b$var$qk = b;
                $23bcd42a245f9d7b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $23bcd42a245f9d7b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $23bcd42a245f9d7b$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $23bcd42a245f9d7b$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $23bcd42a245f9d7b$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $23bcd42a245f9d7b$var$Ti(f, l, b);
                            $23bcd42a245f9d7b$var$uj();
                            break a;
                        }
                        k = Error($23bcd42a245f9d7b$var$p(426));
                    }
                } else if ($23bcd42a245f9d7b$var$I && h.mode & 1) {
                    var J = $23bcd42a245f9d7b$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $23bcd42a245f9d7b$var$Wi(J, g, h, f, b);
                        $23bcd42a245f9d7b$var$Jg($23bcd42a245f9d7b$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $23bcd42a245f9d7b$var$Ki(k, h);
                4 !== $23bcd42a245f9d7b$var$T && ($23bcd42a245f9d7b$var$T = 2);
                null === $23bcd42a245f9d7b$var$tk ? $23bcd42a245f9d7b$var$tk = [
                    f
                ] : $23bcd42a245f9d7b$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $23bcd42a245f9d7b$var$Oi(f, k, b);
                            $23bcd42a245f9d7b$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $23bcd42a245f9d7b$var$Si || !$23bcd42a245f9d7b$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $23bcd42a245f9d7b$var$Ri(f, h, b);
                                $23bcd42a245f9d7b$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $23bcd42a245f9d7b$var$Tk(c);
        } catch (na) {
            b = na;
            $23bcd42a245f9d7b$var$Y === c && null !== c && ($23bcd42a245f9d7b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $23bcd42a245f9d7b$var$Kk() {
    var a = $23bcd42a245f9d7b$var$nk.current;
    $23bcd42a245f9d7b$var$nk.current = $23bcd42a245f9d7b$var$ai;
    return null === a ? $23bcd42a245f9d7b$var$ai : a;
}
function $23bcd42a245f9d7b$var$uj() {
    if (0 === $23bcd42a245f9d7b$var$T || 3 === $23bcd42a245f9d7b$var$T || 2 === $23bcd42a245f9d7b$var$T) $23bcd42a245f9d7b$var$T = 4;
    null === $23bcd42a245f9d7b$var$R || 0 === ($23bcd42a245f9d7b$var$hh & 268435455) && 0 === ($23bcd42a245f9d7b$var$rk & 268435455) || $23bcd42a245f9d7b$var$Dk($23bcd42a245f9d7b$var$R, $23bcd42a245f9d7b$var$Z);
}
function $23bcd42a245f9d7b$var$Jk(a, b) {
    var c = $23bcd42a245f9d7b$var$K;
    $23bcd42a245f9d7b$var$K |= 2;
    var d = $23bcd42a245f9d7b$var$Kk();
    if ($23bcd42a245f9d7b$var$R !== a || $23bcd42a245f9d7b$var$Z !== b) $23bcd42a245f9d7b$var$vk = null, $23bcd42a245f9d7b$var$Lk(a, b);
    for(;;)try {
        $23bcd42a245f9d7b$var$Uk();
        break;
    } catch (e) {
        $23bcd42a245f9d7b$var$Nk(a, e);
    }
    $23bcd42a245f9d7b$var$Qg();
    $23bcd42a245f9d7b$var$K = c;
    $23bcd42a245f9d7b$var$nk.current = d;
    if (null !== $23bcd42a245f9d7b$var$Y) throw Error($23bcd42a245f9d7b$var$p(261));
    $23bcd42a245f9d7b$var$R = null;
    $23bcd42a245f9d7b$var$Z = 0;
    return $23bcd42a245f9d7b$var$T;
}
function $23bcd42a245f9d7b$var$Uk() {
    for(; null !== $23bcd42a245f9d7b$var$Y;)$23bcd42a245f9d7b$var$Vk($23bcd42a245f9d7b$var$Y);
}
function $23bcd42a245f9d7b$var$Mk() {
    for(; null !== $23bcd42a245f9d7b$var$Y && !$23bcd42a245f9d7b$var$cc();)$23bcd42a245f9d7b$var$Vk($23bcd42a245f9d7b$var$Y);
}
function $23bcd42a245f9d7b$var$Vk(a) {
    var b = $23bcd42a245f9d7b$var$Wk(a.alternate, a, $23bcd42a245f9d7b$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $23bcd42a245f9d7b$var$Tk(a) : $23bcd42a245f9d7b$var$Y = b;
    $23bcd42a245f9d7b$var$ok.current = null;
}
function $23bcd42a245f9d7b$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $23bcd42a245f9d7b$var$Fj(c, b, $23bcd42a245f9d7b$var$gj), null !== c) {
                $23bcd42a245f9d7b$var$Y = c;
                return;
            }
        } else {
            c = $23bcd42a245f9d7b$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $23bcd42a245f9d7b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $23bcd42a245f9d7b$var$T = 6;
                $23bcd42a245f9d7b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $23bcd42a245f9d7b$var$Y = b;
            return;
        }
        $23bcd42a245f9d7b$var$Y = b = a;
    }while (null !== b);
    0 === $23bcd42a245f9d7b$var$T && ($23bcd42a245f9d7b$var$T = 5);
}
function $23bcd42a245f9d7b$var$Qk(a, b, c) {
    var d = $23bcd42a245f9d7b$var$C, e = $23bcd42a245f9d7b$var$pk.transition;
    try {
        $23bcd42a245f9d7b$var$pk.transition = null, $23bcd42a245f9d7b$var$C = 1, $23bcd42a245f9d7b$var$Xk(a, b, c, d);
    } finally{
        $23bcd42a245f9d7b$var$pk.transition = e, $23bcd42a245f9d7b$var$C = d;
    }
    return null;
}
function $23bcd42a245f9d7b$var$Xk(a, b, c, d) {
    do $23bcd42a245f9d7b$var$Ik();
    while (null !== $23bcd42a245f9d7b$var$xk);
    if (0 !== ($23bcd42a245f9d7b$var$K & 6)) throw Error($23bcd42a245f9d7b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($23bcd42a245f9d7b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $23bcd42a245f9d7b$var$Bc(a, f);
    a === $23bcd42a245f9d7b$var$R && ($23bcd42a245f9d7b$var$Y = $23bcd42a245f9d7b$var$R = null, $23bcd42a245f9d7b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $23bcd42a245f9d7b$var$wk || ($23bcd42a245f9d7b$var$wk = !0, $23bcd42a245f9d7b$var$Gk($23bcd42a245f9d7b$var$hc, function() {
        $23bcd42a245f9d7b$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $23bcd42a245f9d7b$var$pk.transition;
        $23bcd42a245f9d7b$var$pk.transition = null;
        var g = $23bcd42a245f9d7b$var$C;
        $23bcd42a245f9d7b$var$C = 1;
        var h = $23bcd42a245f9d7b$var$K;
        $23bcd42a245f9d7b$var$K |= 4;
        $23bcd42a245f9d7b$var$ok.current = null;
        $23bcd42a245f9d7b$var$Pj(a, c);
        $23bcd42a245f9d7b$var$ek(c, a);
        $23bcd42a245f9d7b$var$Oe($23bcd42a245f9d7b$var$Df);
        $23bcd42a245f9d7b$var$dd = !!$23bcd42a245f9d7b$var$Cf;
        $23bcd42a245f9d7b$var$Df = $23bcd42a245f9d7b$var$Cf = null;
        a.current = c;
        $23bcd42a245f9d7b$var$ik(c, a, e);
        $23bcd42a245f9d7b$var$dc();
        $23bcd42a245f9d7b$var$K = h;
        $23bcd42a245f9d7b$var$C = g;
        $23bcd42a245f9d7b$var$pk.transition = f;
    } else a.current = c;
    $23bcd42a245f9d7b$var$wk && ($23bcd42a245f9d7b$var$wk = !1, $23bcd42a245f9d7b$var$xk = a, $23bcd42a245f9d7b$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($23bcd42a245f9d7b$var$Si = null);
    $23bcd42a245f9d7b$var$mc(c.stateNode, d);
    $23bcd42a245f9d7b$var$Ek(a, $23bcd42a245f9d7b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($23bcd42a245f9d7b$var$Pi) throw $23bcd42a245f9d7b$var$Pi = !1, a = $23bcd42a245f9d7b$var$Qi, $23bcd42a245f9d7b$var$Qi = null, a;
    0 !== ($23bcd42a245f9d7b$var$yk & 1) && 0 !== a.tag && $23bcd42a245f9d7b$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $23bcd42a245f9d7b$var$Ak ? $23bcd42a245f9d7b$var$zk++ : ($23bcd42a245f9d7b$var$zk = 0, $23bcd42a245f9d7b$var$Ak = a) : $23bcd42a245f9d7b$var$zk = 0;
    $23bcd42a245f9d7b$var$jg();
    return null;
}
function $23bcd42a245f9d7b$var$Ik() {
    if (null !== $23bcd42a245f9d7b$var$xk) {
        var a = $23bcd42a245f9d7b$var$Dc($23bcd42a245f9d7b$var$yk), b = $23bcd42a245f9d7b$var$pk.transition, c = $23bcd42a245f9d7b$var$C;
        try {
            $23bcd42a245f9d7b$var$pk.transition = null;
            $23bcd42a245f9d7b$var$C = 16 > a ? 16 : a;
            if (null === $23bcd42a245f9d7b$var$xk) var d = !1;
            else {
                a = $23bcd42a245f9d7b$var$xk;
                $23bcd42a245f9d7b$var$xk = null;
                $23bcd42a245f9d7b$var$yk = 0;
                if (0 !== ($23bcd42a245f9d7b$var$K & 6)) throw Error($23bcd42a245f9d7b$var$p(331));
                var e = $23bcd42a245f9d7b$var$K;
                $23bcd42a245f9d7b$var$K |= 4;
                for($23bcd42a245f9d7b$var$V = a.current; null !== $23bcd42a245f9d7b$var$V;){
                    var f = $23bcd42a245f9d7b$var$V, g = f.child;
                    if (0 !== ($23bcd42a245f9d7b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($23bcd42a245f9d7b$var$V = l; null !== $23bcd42a245f9d7b$var$V;){
                                    var m = $23bcd42a245f9d7b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $23bcd42a245f9d7b$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $23bcd42a245f9d7b$var$V = q;
                                    else for(; null !== $23bcd42a245f9d7b$var$V;){
                                        m = $23bcd42a245f9d7b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $23bcd42a245f9d7b$var$Tj(m);
                                        if (m === l) {
                                            $23bcd42a245f9d7b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $23bcd42a245f9d7b$var$V = r;
                                            break;
                                        }
                                        $23bcd42a245f9d7b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $23bcd42a245f9d7b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $23bcd42a245f9d7b$var$V = g;
                    else b: for(; null !== $23bcd42a245f9d7b$var$V;){
                        f = $23bcd42a245f9d7b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $23bcd42a245f9d7b$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $23bcd42a245f9d7b$var$V = x;
                            break b;
                        }
                        $23bcd42a245f9d7b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($23bcd42a245f9d7b$var$V = w; null !== $23bcd42a245f9d7b$var$V;){
                    g = $23bcd42a245f9d7b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $23bcd42a245f9d7b$var$V = u;
                    else b: for(g = w; null !== $23bcd42a245f9d7b$var$V;){
                        h = $23bcd42a245f9d7b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $23bcd42a245f9d7b$var$Rj(9, h);
                            }
                        } catch (na) {
                            $23bcd42a245f9d7b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $23bcd42a245f9d7b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $23bcd42a245f9d7b$var$V = F;
                            break b;
                        }
                        $23bcd42a245f9d7b$var$V = h.return;
                    }
                }
                $23bcd42a245f9d7b$var$K = e;
                $23bcd42a245f9d7b$var$jg();
                if ($23bcd42a245f9d7b$var$lc && "function" === typeof $23bcd42a245f9d7b$var$lc.onPostCommitFiberRoot) try {
                    $23bcd42a245f9d7b$var$lc.onPostCommitFiberRoot($23bcd42a245f9d7b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $23bcd42a245f9d7b$var$C = c, $23bcd42a245f9d7b$var$pk.transition = b;
        }
    }
    return !1;
}
function $23bcd42a245f9d7b$var$Yk(a, b, c) {
    b = $23bcd42a245f9d7b$var$Ki(c, b);
    b = $23bcd42a245f9d7b$var$Oi(a, b, 1);
    a = $23bcd42a245f9d7b$var$dh(a, b, 1);
    b = $23bcd42a245f9d7b$var$L();
    null !== a && ($23bcd42a245f9d7b$var$Ac(a, 1, b), $23bcd42a245f9d7b$var$Ek(a, b));
}
function $23bcd42a245f9d7b$var$W(a, b, c) {
    if (3 === a.tag) $23bcd42a245f9d7b$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $23bcd42a245f9d7b$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $23bcd42a245f9d7b$var$Si || !$23bcd42a245f9d7b$var$Si.has(d))) {
                a = $23bcd42a245f9d7b$var$Ki(c, a);
                a = $23bcd42a245f9d7b$var$Ri(b, a, 1);
                b = $23bcd42a245f9d7b$var$dh(b, a, 1);
                a = $23bcd42a245f9d7b$var$L();
                null !== b && ($23bcd42a245f9d7b$var$Ac(b, 1, a), $23bcd42a245f9d7b$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $23bcd42a245f9d7b$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $23bcd42a245f9d7b$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $23bcd42a245f9d7b$var$R === a && ($23bcd42a245f9d7b$var$Z & c) === c && (4 === $23bcd42a245f9d7b$var$T || 3 === $23bcd42a245f9d7b$var$T && ($23bcd42a245f9d7b$var$Z & 130023424) === $23bcd42a245f9d7b$var$Z && 500 > $23bcd42a245f9d7b$var$B() - $23bcd42a245f9d7b$var$gk ? $23bcd42a245f9d7b$var$Lk(a, 0) : $23bcd42a245f9d7b$var$sk |= c);
    $23bcd42a245f9d7b$var$Ek(a, b);
}
function $23bcd42a245f9d7b$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $23bcd42a245f9d7b$var$sc, $23bcd42a245f9d7b$var$sc <<= 1, 0 === ($23bcd42a245f9d7b$var$sc & 130023424) && ($23bcd42a245f9d7b$var$sc = 4194304)));
    var c = $23bcd42a245f9d7b$var$L();
    a = $23bcd42a245f9d7b$var$Zg(a, b);
    null !== a && ($23bcd42a245f9d7b$var$Ac(a, b, c), $23bcd42a245f9d7b$var$Ek(a, c));
}
function $23bcd42a245f9d7b$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $23bcd42a245f9d7b$var$Zk(a, c);
}
function $23bcd42a245f9d7b$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($23bcd42a245f9d7b$var$p(314));
    }
    null !== d && d.delete(b);
    $23bcd42a245f9d7b$var$Zk(a, c);
}
var $23bcd42a245f9d7b$var$Wk;
$23bcd42a245f9d7b$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $23bcd42a245f9d7b$var$Wf.current) $23bcd42a245f9d7b$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $23bcd42a245f9d7b$var$Ug = !1, $23bcd42a245f9d7b$var$zj(a, b, c);
            $23bcd42a245f9d7b$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $23bcd42a245f9d7b$var$Ug = !1, $23bcd42a245f9d7b$var$I && 0 !== (b.flags & 1048576) && $23bcd42a245f9d7b$var$ug(b, $23bcd42a245f9d7b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $23bcd42a245f9d7b$var$jj(a, b);
            a = b.pendingProps;
            var e = $23bcd42a245f9d7b$var$Yf(b, $23bcd42a245f9d7b$var$H.current);
            $23bcd42a245f9d7b$var$Tg(b, c);
            e = $23bcd42a245f9d7b$var$Xh(null, b, d, a, e, c);
            var f = $23bcd42a245f9d7b$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $23bcd42a245f9d7b$var$Zf(d) ? (f = !0, $23bcd42a245f9d7b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $23bcd42a245f9d7b$var$ah(b), e.updater = $23bcd42a245f9d7b$var$nh, b.stateNode = e, e._reactInternals = b, $23bcd42a245f9d7b$var$rh(b, d, a, c), b = $23bcd42a245f9d7b$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $23bcd42a245f9d7b$var$I && f && $23bcd42a245f9d7b$var$vg(b), $23bcd42a245f9d7b$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $23bcd42a245f9d7b$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $23bcd42a245f9d7b$var$$k(d);
                a = $23bcd42a245f9d7b$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $23bcd42a245f9d7b$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $23bcd42a245f9d7b$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $23bcd42a245f9d7b$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $23bcd42a245f9d7b$var$aj(null, b, d, $23bcd42a245f9d7b$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($23bcd42a245f9d7b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $23bcd42a245f9d7b$var$Lg(d, e), $23bcd42a245f9d7b$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $23bcd42a245f9d7b$var$Lg(d, e), $23bcd42a245f9d7b$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $23bcd42a245f9d7b$var$lj(b);
                if (null === a) throw Error($23bcd42a245f9d7b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $23bcd42a245f9d7b$var$bh(a, b);
                $23bcd42a245f9d7b$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $23bcd42a245f9d7b$var$Ki(Error($23bcd42a245f9d7b$var$p(423)), b);
                        b = $23bcd42a245f9d7b$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $23bcd42a245f9d7b$var$Ki(Error($23bcd42a245f9d7b$var$p(424)), b);
                        b = $23bcd42a245f9d7b$var$mj(a, b, d, c, e);
                        break a;
                    } else for($23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$Lf(b.stateNode.containerInfo.firstChild), $23bcd42a245f9d7b$var$xg = b, $23bcd42a245f9d7b$var$I = !0, $23bcd42a245f9d7b$var$zg = null, c = $23bcd42a245f9d7b$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $23bcd42a245f9d7b$var$Ig();
                    if (d === e) {
                        b = $23bcd42a245f9d7b$var$$i(a, b, c);
                        break a;
                    }
                    $23bcd42a245f9d7b$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $23bcd42a245f9d7b$var$Kh(b), null === a && $23bcd42a245f9d7b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $23bcd42a245f9d7b$var$Ef(d, e) ? g = null : null !== f && $23bcd42a245f9d7b$var$Ef(d, f) && (b.flags |= 32), $23bcd42a245f9d7b$var$hj(a, b), $23bcd42a245f9d7b$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $23bcd42a245f9d7b$var$Eg(b), null;
        case 13:
            return $23bcd42a245f9d7b$var$pj(a, b, c);
        case 4:
            return $23bcd42a245f9d7b$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $23bcd42a245f9d7b$var$Bh(b, null, d, c) : $23bcd42a245f9d7b$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $23bcd42a245f9d7b$var$Lg(d, e), $23bcd42a245f9d7b$var$Zi(a, b, d, e, c);
        case 7:
            return $23bcd42a245f9d7b$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $23bcd42a245f9d7b$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $23bcd42a245f9d7b$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($23bcd42a245f9d7b$var$He(f.value, g)) {
                        if (f.children === e.children && !$23bcd42a245f9d7b$var$Wf.current) {
                            b = $23bcd42a245f9d7b$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $23bcd42a245f9d7b$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $23bcd42a245f9d7b$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($23bcd42a245f9d7b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $23bcd42a245f9d7b$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $23bcd42a245f9d7b$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $23bcd42a245f9d7b$var$Tg(b, c), e = $23bcd42a245f9d7b$var$Vg(e), d = d(e), b.flags |= 1, $23bcd42a245f9d7b$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $23bcd42a245f9d7b$var$Lg(d, b.pendingProps), e = $23bcd42a245f9d7b$var$Lg(d.type, e), $23bcd42a245f9d7b$var$aj(a, b, d, e, c);
        case 15:
            return $23bcd42a245f9d7b$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $23bcd42a245f9d7b$var$Lg(d, e), $23bcd42a245f9d7b$var$jj(a, b), b.tag = 1, $23bcd42a245f9d7b$var$Zf(d) ? (a = !0, $23bcd42a245f9d7b$var$cg(b)) : a = !1, $23bcd42a245f9d7b$var$Tg(b, c), $23bcd42a245f9d7b$var$ph(b, d, e), $23bcd42a245f9d7b$var$rh(b, d, e, c), $23bcd42a245f9d7b$var$kj(null, b, d, !0, a, c);
        case 19:
            return $23bcd42a245f9d7b$var$yj(a, b, c);
        case 22:
            return $23bcd42a245f9d7b$var$ej(a, b, c);
    }
    throw Error($23bcd42a245f9d7b$var$p(156, b.tag));
};
function $23bcd42a245f9d7b$var$Gk(a, b) {
    return $23bcd42a245f9d7b$var$ac(a, b);
}
function $23bcd42a245f9d7b$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $23bcd42a245f9d7b$var$Bg(a, b, c, d) {
    return new $23bcd42a245f9d7b$var$al(a, b, c, d);
}
function $23bcd42a245f9d7b$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $23bcd42a245f9d7b$var$$k(a) {
    if ("function" === typeof a) return $23bcd42a245f9d7b$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $23bcd42a245f9d7b$var$Da) return 11;
        if (a === $23bcd42a245f9d7b$var$Ga) return 14;
    }
    return 2;
}
function $23bcd42a245f9d7b$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $23bcd42a245f9d7b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $23bcd42a245f9d7b$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $23bcd42a245f9d7b$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $23bcd42a245f9d7b$var$ya:
            return $23bcd42a245f9d7b$var$Ah(c.children, e, f, b);
        case $23bcd42a245f9d7b$var$za:
            g = 8;
            e |= 8;
            break;
        case $23bcd42a245f9d7b$var$Aa:
            return a = $23bcd42a245f9d7b$var$Bg(12, c, b, e | 2), a.elementType = $23bcd42a245f9d7b$var$Aa, a.lanes = f, a;
        case $23bcd42a245f9d7b$var$Ea:
            return a = $23bcd42a245f9d7b$var$Bg(13, c, b, e), a.elementType = $23bcd42a245f9d7b$var$Ea, a.lanes = f, a;
        case $23bcd42a245f9d7b$var$Fa:
            return a = $23bcd42a245f9d7b$var$Bg(19, c, b, e), a.elementType = $23bcd42a245f9d7b$var$Fa, a.lanes = f, a;
        case $23bcd42a245f9d7b$var$Ia:
            return $23bcd42a245f9d7b$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $23bcd42a245f9d7b$var$Ba:
                    g = 10;
                    break a;
                case $23bcd42a245f9d7b$var$Ca:
                    g = 9;
                    break a;
                case $23bcd42a245f9d7b$var$Da:
                    g = 11;
                    break a;
                case $23bcd42a245f9d7b$var$Ga:
                    g = 14;
                    break a;
                case $23bcd42a245f9d7b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($23bcd42a245f9d7b$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $23bcd42a245f9d7b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $23bcd42a245f9d7b$var$Ah(a, b, c, d) {
    a = $23bcd42a245f9d7b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $23bcd42a245f9d7b$var$qj(a, b, c, d) {
    a = $23bcd42a245f9d7b$var$Bg(22, a, d, b);
    a.elementType = $23bcd42a245f9d7b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $23bcd42a245f9d7b$var$xh(a, b, c) {
    a = $23bcd42a245f9d7b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $23bcd42a245f9d7b$var$zh(a, b, c) {
    b = $23bcd42a245f9d7b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $23bcd42a245f9d7b$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $23bcd42a245f9d7b$var$zc(0);
    this.expirationTimes = $23bcd42a245f9d7b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $23bcd42a245f9d7b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $23bcd42a245f9d7b$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $23bcd42a245f9d7b$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $23bcd42a245f9d7b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $23bcd42a245f9d7b$var$ah(f);
    return a;
}
function $23bcd42a245f9d7b$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $23bcd42a245f9d7b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $23bcd42a245f9d7b$var$el(a) {
    if (!a) return $23bcd42a245f9d7b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($23bcd42a245f9d7b$var$Vb(a) !== a || 1 !== a.tag) throw Error($23bcd42a245f9d7b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($23bcd42a245f9d7b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($23bcd42a245f9d7b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($23bcd42a245f9d7b$var$Zf(c)) return $23bcd42a245f9d7b$var$bg(a, c, b);
    }
    return b;
}
function $23bcd42a245f9d7b$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $23bcd42a245f9d7b$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $23bcd42a245f9d7b$var$el(null);
    c = a.current;
    d = $23bcd42a245f9d7b$var$L();
    e = $23bcd42a245f9d7b$var$lh(c);
    f = $23bcd42a245f9d7b$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $23bcd42a245f9d7b$var$dh(c, f, e);
    a.current.lanes = e;
    $23bcd42a245f9d7b$var$Ac(a, e, d);
    $23bcd42a245f9d7b$var$Ek(a, d);
    return a;
}
function $23bcd42a245f9d7b$var$gl(a, b, c, d) {
    var e = b.current, f = $23bcd42a245f9d7b$var$L(), g = $23bcd42a245f9d7b$var$lh(e);
    c = $23bcd42a245f9d7b$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $23bcd42a245f9d7b$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $23bcd42a245f9d7b$var$dh(e, b, g);
    null !== a && ($23bcd42a245f9d7b$var$mh(a, e, g, f), $23bcd42a245f9d7b$var$eh(a, e, g));
    return g;
}
function $23bcd42a245f9d7b$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $23bcd42a245f9d7b$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $23bcd42a245f9d7b$var$jl(a, b) {
    $23bcd42a245f9d7b$var$il(a, b);
    (a = a.alternate) && $23bcd42a245f9d7b$var$il(a, b);
}
function $23bcd42a245f9d7b$var$kl() {
    return null;
}
var $23bcd42a245f9d7b$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $23bcd42a245f9d7b$var$ml(a) {
    this._internalRoot = a;
}
$23bcd42a245f9d7b$var$nl.prototype.render = $23bcd42a245f9d7b$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($23bcd42a245f9d7b$var$p(409));
    $23bcd42a245f9d7b$var$gl(a, b, null, null);
};
$23bcd42a245f9d7b$var$nl.prototype.unmount = $23bcd42a245f9d7b$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $23bcd42a245f9d7b$var$Sk(function() {
            $23bcd42a245f9d7b$var$gl(null, a, null, null);
        });
        b[$23bcd42a245f9d7b$var$uf] = null;
    }
};
function $23bcd42a245f9d7b$var$nl(a) {
    this._internalRoot = a;
}
$23bcd42a245f9d7b$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $23bcd42a245f9d7b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $23bcd42a245f9d7b$var$Qc.length && 0 !== b && b < $23bcd42a245f9d7b$var$Qc[c].priority; c++);
        $23bcd42a245f9d7b$var$Qc.splice(c, 0, a);
        0 === c && $23bcd42a245f9d7b$var$Vc(a);
    }
};
function $23bcd42a245f9d7b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $23bcd42a245f9d7b$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $23bcd42a245f9d7b$var$ql() {}
function $23bcd42a245f9d7b$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $23bcd42a245f9d7b$var$hl(g);
                f.call(a);
            };
        }
        var g = $23bcd42a245f9d7b$var$fl(b, d, a, 0, null, !1, !1, "", $23bcd42a245f9d7b$var$ql);
        a._reactRootContainer = g;
        a[$23bcd42a245f9d7b$var$uf] = g.current;
        $23bcd42a245f9d7b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $23bcd42a245f9d7b$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $23bcd42a245f9d7b$var$hl(k);
            h.call(a);
        };
    }
    var k = $23bcd42a245f9d7b$var$cl(a, 0, !1, null, null, !1, !1, "", $23bcd42a245f9d7b$var$ql);
    a._reactRootContainer = k;
    a[$23bcd42a245f9d7b$var$uf] = k.current;
    $23bcd42a245f9d7b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $23bcd42a245f9d7b$var$Sk(function() {
        $23bcd42a245f9d7b$var$gl(b, k, c, d);
    });
    return k;
}
function $23bcd42a245f9d7b$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $23bcd42a245f9d7b$var$hl(g);
                h.call(a);
            };
        }
        $23bcd42a245f9d7b$var$gl(b, g, a, e);
    } else g = $23bcd42a245f9d7b$var$rl(c, b, a, e, d);
    return $23bcd42a245f9d7b$var$hl(g);
}
$23bcd42a245f9d7b$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $23bcd42a245f9d7b$var$tc(b.pendingLanes);
                0 !== c && ($23bcd42a245f9d7b$var$Cc(b, c | 1), $23bcd42a245f9d7b$var$Ek(b, $23bcd42a245f9d7b$var$B()), 0 === ($23bcd42a245f9d7b$var$K & 6) && ($23bcd42a245f9d7b$var$Hj = $23bcd42a245f9d7b$var$B() + 500, $23bcd42a245f9d7b$var$jg()));
            }
            break;
        case 13:
            $23bcd42a245f9d7b$var$Sk(function() {
                var b = $23bcd42a245f9d7b$var$Zg(a, 1);
                if (null !== b) {
                    var c = $23bcd42a245f9d7b$var$L();
                    $23bcd42a245f9d7b$var$mh(b, a, 1, c);
                }
            }), $23bcd42a245f9d7b$var$jl(a, 1);
    }
};
$23bcd42a245f9d7b$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $23bcd42a245f9d7b$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $23bcd42a245f9d7b$var$L();
            $23bcd42a245f9d7b$var$mh(b, a, 134217728, c);
        }
        $23bcd42a245f9d7b$var$jl(a, 134217728);
    }
};
$23bcd42a245f9d7b$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $23bcd42a245f9d7b$var$lh(a), c = $23bcd42a245f9d7b$var$Zg(a, b);
        if (null !== c) {
            var d = $23bcd42a245f9d7b$var$L();
            $23bcd42a245f9d7b$var$mh(c, a, b, d);
        }
        $23bcd42a245f9d7b$var$jl(a, b);
    }
};
$23bcd42a245f9d7b$var$Hc = function() {
    return $23bcd42a245f9d7b$var$C;
};
$23bcd42a245f9d7b$var$Ic = function(a, b) {
    var c = $23bcd42a245f9d7b$var$C;
    try {
        return $23bcd42a245f9d7b$var$C = a, b();
    } finally{
        $23bcd42a245f9d7b$var$C = c;
    }
};
$23bcd42a245f9d7b$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $23bcd42a245f9d7b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $23bcd42a245f9d7b$var$Db(d);
                        if (!e) throw Error($23bcd42a245f9d7b$var$p(90));
                        $23bcd42a245f9d7b$var$Wa(d);
                        $23bcd42a245f9d7b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $23bcd42a245f9d7b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $23bcd42a245f9d7b$var$fb(a, !!c.multiple, b, !1);
    }
};
$23bcd42a245f9d7b$var$Gb = $23bcd42a245f9d7b$var$Rk;
$23bcd42a245f9d7b$var$Hb = $23bcd42a245f9d7b$var$Sk;
var $23bcd42a245f9d7b$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $23bcd42a245f9d7b$var$Cb,
        $23bcd42a245f9d7b$var$ue,
        $23bcd42a245f9d7b$var$Db,
        $23bcd42a245f9d7b$var$Eb,
        $23bcd42a245f9d7b$var$Fb,
        $23bcd42a245f9d7b$var$Rk
    ]
}, $23bcd42a245f9d7b$var$ul = {
    findFiberByHostInstance: $23bcd42a245f9d7b$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $23bcd42a245f9d7b$var$vl = {
    bundleType: $23bcd42a245f9d7b$var$ul.bundleType,
    version: $23bcd42a245f9d7b$var$ul.version,
    rendererPackageName: $23bcd42a245f9d7b$var$ul.rendererPackageName,
    rendererConfig: $23bcd42a245f9d7b$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $23bcd42a245f9d7b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $23bcd42a245f9d7b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $23bcd42a245f9d7b$var$ul.findFiberByHostInstance || $23bcd42a245f9d7b$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $23bcd42a245f9d7b$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$23bcd42a245f9d7b$var$wl.isDisabled && $23bcd42a245f9d7b$var$wl.supportsFiber) try {
        $23bcd42a245f9d7b$var$kc = $23bcd42a245f9d7b$var$wl.inject($23bcd42a245f9d7b$var$vl), $23bcd42a245f9d7b$var$lc = $23bcd42a245f9d7b$var$wl;
    } catch (a) {}
}
$23bcd42a245f9d7b$export$ae55be85d98224ed = $23bcd42a245f9d7b$var$tl;
$23bcd42a245f9d7b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$23bcd42a245f9d7b$var$ol(b)) throw Error($23bcd42a245f9d7b$var$p(200));
    return $23bcd42a245f9d7b$var$dl(a, b, null, c);
};
$23bcd42a245f9d7b$export$882461b6382ed46c = function(a, b) {
    if (!$23bcd42a245f9d7b$var$ol(a)) throw Error($23bcd42a245f9d7b$var$p(299));
    var c = !1, d = "", e = $23bcd42a245f9d7b$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $23bcd42a245f9d7b$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$23bcd42a245f9d7b$var$uf] = b.current;
    $23bcd42a245f9d7b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $23bcd42a245f9d7b$var$ml(b);
};
$23bcd42a245f9d7b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($23bcd42a245f9d7b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($23bcd42a245f9d7b$var$p(268, a));
    }
    a = $23bcd42a245f9d7b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$23bcd42a245f9d7b$export$cd75ccfd720a3cd4 = function(a) {
    return $23bcd42a245f9d7b$var$Sk(a);
};
$23bcd42a245f9d7b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$23bcd42a245f9d7b$var$pl(b)) throw Error($23bcd42a245f9d7b$var$p(200));
    return $23bcd42a245f9d7b$var$sl(null, a, b, !0, c);
};
$23bcd42a245f9d7b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$23bcd42a245f9d7b$var$ol(a)) throw Error($23bcd42a245f9d7b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $23bcd42a245f9d7b$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $23bcd42a245f9d7b$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$23bcd42a245f9d7b$var$uf] = b.current;
    $23bcd42a245f9d7b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $23bcd42a245f9d7b$var$nl(b);
};
$23bcd42a245f9d7b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$23bcd42a245f9d7b$var$pl(b)) throw Error($23bcd42a245f9d7b$var$p(200));
    return $23bcd42a245f9d7b$var$sl(null, a, b, !1, c);
};
$23bcd42a245f9d7b$export$502457920280e6be = function(a) {
    if (!$23bcd42a245f9d7b$var$pl(a)) throw Error($23bcd42a245f9d7b$var$p(40));
    return a._reactRootContainer ? ($23bcd42a245f9d7b$var$Sk(function() {
        $23bcd42a245f9d7b$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$23bcd42a245f9d7b$var$uf] = null;
        });
    }), !0) : !1;
};
$23bcd42a245f9d7b$export$c78a37762a8d58e1 = $23bcd42a245f9d7b$var$Rk;
$23bcd42a245f9d7b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$23bcd42a245f9d7b$var$pl(c)) throw Error($23bcd42a245f9d7b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($23bcd42a245f9d7b$var$p(38));
    return $23bcd42a245f9d7b$var$sl(a, b, c, !1, d);
};
$23bcd42a245f9d7b$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fOxuK", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ks7lO"));

});
parcelRegister("ks7lO", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $ee3c1fdfe8a0ae81$export$c4744153514ff05d; }, function (v) { return $ee3c1fdfe8a0ae81$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $ee3c1fdfe8a0ae81$export$3e506c1ccc9cc1a7; }, function (v) { return $ee3c1fdfe8a0ae81$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $ee3c1fdfe8a0ae81$export$e26fe2ed2fa76875; }, function (v) { return $ee3c1fdfe8a0ae81$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $ee3c1fdfe8a0ae81$export$502329bbf4b505b1; }, function (v) { return $ee3c1fdfe8a0ae81$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $ee3c1fdfe8a0ae81$export$6e3807111c4874c4; }, function (v) { return $ee3c1fdfe8a0ae81$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $ee3c1fdfe8a0ae81$export$c27134553091fb3a; }, function (v) { return $ee3c1fdfe8a0ae81$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $ee3c1fdfe8a0ae81$export$33ee1acdc04fd2a2; }, function (v) { return $ee3c1fdfe8a0ae81$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $ee3c1fdfe8a0ae81$export$b00a404bbd5edef2; }, function (v) { return $ee3c1fdfe8a0ae81$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $ee3c1fdfe8a0ae81$export$8352ce38b91d0c62; }, function (v) { return $ee3c1fdfe8a0ae81$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $ee3c1fdfe8a0ae81$export$d66a1c1c77bd778b; }, function (v) { return $ee3c1fdfe8a0ae81$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $ee3c1fdfe8a0ae81$export$d3dfb8e4810cb555; }, function (v) { return $ee3c1fdfe8a0ae81$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $ee3c1fdfe8a0ae81$export$839f9183b0465a69; }, function (v) { return $ee3c1fdfe8a0ae81$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $ee3c1fdfe8a0ae81$export$72fdf0e06517287b; }, function (v) { return $ee3c1fdfe8a0ae81$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $ee3c1fdfe8a0ae81$export$4b844e58a3e414b4; }, function (v) { return $ee3c1fdfe8a0ae81$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $ee3c1fdfe8a0ae81$export$816d2913ae6b83b1; }, function (v) { return $ee3c1fdfe8a0ae81$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $ee3c1fdfe8a0ae81$export$61bcfe829111a1d0; }, function (v) { return $ee3c1fdfe8a0ae81$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $ee3c1fdfe8a0ae81$export$7ee8c9beb337bc3f; }, function (v) { return $ee3c1fdfe8a0ae81$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $ee3c1fdfe8a0ae81$export$b5836b71941fa3ed; }, function (v) { return $ee3c1fdfe8a0ae81$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $ee3c1fdfe8a0ae81$export$cf845f2c119da08a; }, function (v) { return $ee3c1fdfe8a0ae81$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ee3c1fdfe8a0ae81$export$c4744153514ff05d;
var $ee3c1fdfe8a0ae81$export$3e506c1ccc9cc1a7;
var $ee3c1fdfe8a0ae81$export$e26fe2ed2fa76875;
var $ee3c1fdfe8a0ae81$export$502329bbf4b505b1;
var $ee3c1fdfe8a0ae81$export$6e3807111c4874c4;
var $ee3c1fdfe8a0ae81$export$c27134553091fb3a;
var $ee3c1fdfe8a0ae81$export$33ee1acdc04fd2a2;
var $ee3c1fdfe8a0ae81$export$b00a404bbd5edef2;
var $ee3c1fdfe8a0ae81$export$8352ce38b91d0c62;
var $ee3c1fdfe8a0ae81$export$d66a1c1c77bd778b;
var $ee3c1fdfe8a0ae81$export$d3dfb8e4810cb555;
var $ee3c1fdfe8a0ae81$export$839f9183b0465a69;
var $ee3c1fdfe8a0ae81$export$72fdf0e06517287b;
var $ee3c1fdfe8a0ae81$export$4b844e58a3e414b4;
var $ee3c1fdfe8a0ae81$export$816d2913ae6b83b1;
var $ee3c1fdfe8a0ae81$export$61bcfe829111a1d0;
var $ee3c1fdfe8a0ae81$export$7ee8c9beb337bc3f;
var $ee3c1fdfe8a0ae81$export$b5836b71941fa3ed;
var $ee3c1fdfe8a0ae81$export$cf845f2c119da08a;
"use strict";
function $ee3c1fdfe8a0ae81$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $ee3c1fdfe8a0ae81$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ee3c1fdfe8a0ae81$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $ee3c1fdfe8a0ae81$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $ee3c1fdfe8a0ae81$var$g(C, c)) n < e && 0 > $ee3c1fdfe8a0ae81$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $ee3c1fdfe8a0ae81$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $ee3c1fdfe8a0ae81$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ee3c1fdfe8a0ae81$var$l = performance;
    $ee3c1fdfe8a0ae81$export$c4744153514ff05d = function() {
        return $ee3c1fdfe8a0ae81$var$l.now();
    };
} else {
    var $ee3c1fdfe8a0ae81$var$p = Date, $ee3c1fdfe8a0ae81$var$q = $ee3c1fdfe8a0ae81$var$p.now();
    $ee3c1fdfe8a0ae81$export$c4744153514ff05d = function() {
        return $ee3c1fdfe8a0ae81$var$p.now() - $ee3c1fdfe8a0ae81$var$q;
    };
}
var $ee3c1fdfe8a0ae81$var$r = [], $ee3c1fdfe8a0ae81$var$t = [], $ee3c1fdfe8a0ae81$var$u = 1, $ee3c1fdfe8a0ae81$var$v = null, $ee3c1fdfe8a0ae81$var$y = 3, $ee3c1fdfe8a0ae81$var$z = !1, $ee3c1fdfe8a0ae81$var$A = !1, $ee3c1fdfe8a0ae81$var$B = !1, $ee3c1fdfe8a0ae81$var$D = "function" === typeof setTimeout ? setTimeout : null, $ee3c1fdfe8a0ae81$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $ee3c1fdfe8a0ae81$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $ee3c1fdfe8a0ae81$var$G(a) {
    for(var b = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$t); null !== b;){
        if (null === b.callback) $ee3c1fdfe8a0ae81$var$k($ee3c1fdfe8a0ae81$var$t);
        else if (b.startTime <= a) $ee3c1fdfe8a0ae81$var$k($ee3c1fdfe8a0ae81$var$t), b.sortIndex = b.expirationTime, $ee3c1fdfe8a0ae81$var$f($ee3c1fdfe8a0ae81$var$r, b);
        else break;
        b = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$t);
    }
}
function $ee3c1fdfe8a0ae81$var$H(a) {
    $ee3c1fdfe8a0ae81$var$B = !1;
    $ee3c1fdfe8a0ae81$var$G(a);
    if (!$ee3c1fdfe8a0ae81$var$A) {
        if (null !== $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r)) $ee3c1fdfe8a0ae81$var$A = !0, $ee3c1fdfe8a0ae81$var$I($ee3c1fdfe8a0ae81$var$J);
        else {
            var b = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$t);
            null !== b && $ee3c1fdfe8a0ae81$var$K($ee3c1fdfe8a0ae81$var$H, b.startTime - a);
        }
    }
}
function $ee3c1fdfe8a0ae81$var$J(a, b) {
    $ee3c1fdfe8a0ae81$var$A = !1;
    $ee3c1fdfe8a0ae81$var$B && ($ee3c1fdfe8a0ae81$var$B = !1, $ee3c1fdfe8a0ae81$var$E($ee3c1fdfe8a0ae81$var$L), $ee3c1fdfe8a0ae81$var$L = -1);
    $ee3c1fdfe8a0ae81$var$z = !0;
    var c = $ee3c1fdfe8a0ae81$var$y;
    try {
        $ee3c1fdfe8a0ae81$var$G(b);
        for($ee3c1fdfe8a0ae81$var$v = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r); null !== $ee3c1fdfe8a0ae81$var$v && (!($ee3c1fdfe8a0ae81$var$v.expirationTime > b) || a && !$ee3c1fdfe8a0ae81$var$M());){
            var d = $ee3c1fdfe8a0ae81$var$v.callback;
            if ("function" === typeof d) {
                $ee3c1fdfe8a0ae81$var$v.callback = null;
                $ee3c1fdfe8a0ae81$var$y = $ee3c1fdfe8a0ae81$var$v.priorityLevel;
                var e = d($ee3c1fdfe8a0ae81$var$v.expirationTime <= b);
                b = $ee3c1fdfe8a0ae81$export$c4744153514ff05d();
                "function" === typeof e ? $ee3c1fdfe8a0ae81$var$v.callback = e : $ee3c1fdfe8a0ae81$var$v === $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r) && $ee3c1fdfe8a0ae81$var$k($ee3c1fdfe8a0ae81$var$r);
                $ee3c1fdfe8a0ae81$var$G(b);
            } else $ee3c1fdfe8a0ae81$var$k($ee3c1fdfe8a0ae81$var$r);
            $ee3c1fdfe8a0ae81$var$v = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r);
        }
        if (null !== $ee3c1fdfe8a0ae81$var$v) var w = !0;
        else {
            var m = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$t);
            null !== m && $ee3c1fdfe8a0ae81$var$K($ee3c1fdfe8a0ae81$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $ee3c1fdfe8a0ae81$var$v = null, $ee3c1fdfe8a0ae81$var$y = c, $ee3c1fdfe8a0ae81$var$z = !1;
    }
}
var $ee3c1fdfe8a0ae81$var$N = !1, $ee3c1fdfe8a0ae81$var$O = null, $ee3c1fdfe8a0ae81$var$L = -1, $ee3c1fdfe8a0ae81$var$P = 5, $ee3c1fdfe8a0ae81$var$Q = -1;
function $ee3c1fdfe8a0ae81$var$M() {
    return $ee3c1fdfe8a0ae81$export$c4744153514ff05d() - $ee3c1fdfe8a0ae81$var$Q < $ee3c1fdfe8a0ae81$var$P ? !1 : !0;
}
function $ee3c1fdfe8a0ae81$var$R() {
    if (null !== $ee3c1fdfe8a0ae81$var$O) {
        var a = $ee3c1fdfe8a0ae81$export$c4744153514ff05d();
        $ee3c1fdfe8a0ae81$var$Q = a;
        var b = !0;
        try {
            b = $ee3c1fdfe8a0ae81$var$O(!0, a);
        } finally{
            b ? $ee3c1fdfe8a0ae81$var$S() : ($ee3c1fdfe8a0ae81$var$N = !1, $ee3c1fdfe8a0ae81$var$O = null);
        }
    } else $ee3c1fdfe8a0ae81$var$N = !1;
}
var $ee3c1fdfe8a0ae81$var$S;
if ("function" === typeof $ee3c1fdfe8a0ae81$var$F) $ee3c1fdfe8a0ae81$var$S = function() {
    $ee3c1fdfe8a0ae81$var$F($ee3c1fdfe8a0ae81$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ee3c1fdfe8a0ae81$var$T = new MessageChannel, $ee3c1fdfe8a0ae81$var$U = $ee3c1fdfe8a0ae81$var$T.port2;
    $ee3c1fdfe8a0ae81$var$T.port1.onmessage = $ee3c1fdfe8a0ae81$var$R;
    $ee3c1fdfe8a0ae81$var$S = function() {
        $ee3c1fdfe8a0ae81$var$U.postMessage(null);
    };
} else $ee3c1fdfe8a0ae81$var$S = function() {
    $ee3c1fdfe8a0ae81$var$D($ee3c1fdfe8a0ae81$var$R, 0);
};
function $ee3c1fdfe8a0ae81$var$I(a) {
    $ee3c1fdfe8a0ae81$var$O = a;
    $ee3c1fdfe8a0ae81$var$N || ($ee3c1fdfe8a0ae81$var$N = !0, $ee3c1fdfe8a0ae81$var$S());
}
function $ee3c1fdfe8a0ae81$var$K(a, b) {
    $ee3c1fdfe8a0ae81$var$L = $ee3c1fdfe8a0ae81$var$D(function() {
        a($ee3c1fdfe8a0ae81$export$c4744153514ff05d());
    }, b);
}
$ee3c1fdfe8a0ae81$export$3e506c1ccc9cc1a7 = 5;
$ee3c1fdfe8a0ae81$export$e26fe2ed2fa76875 = 1;
$ee3c1fdfe8a0ae81$export$502329bbf4b505b1 = 4;
$ee3c1fdfe8a0ae81$export$6e3807111c4874c4 = 3;
$ee3c1fdfe8a0ae81$export$c27134553091fb3a = null;
$ee3c1fdfe8a0ae81$export$33ee1acdc04fd2a2 = 2;
$ee3c1fdfe8a0ae81$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ee3c1fdfe8a0ae81$export$8352ce38b91d0c62 = function() {
    $ee3c1fdfe8a0ae81$var$A || $ee3c1fdfe8a0ae81$var$z || ($ee3c1fdfe8a0ae81$var$A = !0, $ee3c1fdfe8a0ae81$var$I($ee3c1fdfe8a0ae81$var$J));
};
$ee3c1fdfe8a0ae81$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ee3c1fdfe8a0ae81$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$ee3c1fdfe8a0ae81$export$d3dfb8e4810cb555 = function() {
    return $ee3c1fdfe8a0ae81$var$y;
};
$ee3c1fdfe8a0ae81$export$839f9183b0465a69 = function() {
    return $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r);
};
$ee3c1fdfe8a0ae81$export$72fdf0e06517287b = function(a) {
    switch($ee3c1fdfe8a0ae81$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ee3c1fdfe8a0ae81$var$y;
    }
    var c = $ee3c1fdfe8a0ae81$var$y;
    $ee3c1fdfe8a0ae81$var$y = b;
    try {
        return a();
    } finally{
        $ee3c1fdfe8a0ae81$var$y = c;
    }
};
$ee3c1fdfe8a0ae81$export$4b844e58a3e414b4 = function() {};
$ee3c1fdfe8a0ae81$export$816d2913ae6b83b1 = function() {};
$ee3c1fdfe8a0ae81$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ee3c1fdfe8a0ae81$var$y;
    $ee3c1fdfe8a0ae81$var$y = a;
    try {
        return b();
    } finally{
        $ee3c1fdfe8a0ae81$var$y = c;
    }
};
$ee3c1fdfe8a0ae81$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ee3c1fdfe8a0ae81$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $ee3c1fdfe8a0ae81$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $ee3c1fdfe8a0ae81$var$f($ee3c1fdfe8a0ae81$var$t, a), null === $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r) && a === $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$t) && ($ee3c1fdfe8a0ae81$var$B ? ($ee3c1fdfe8a0ae81$var$E($ee3c1fdfe8a0ae81$var$L), $ee3c1fdfe8a0ae81$var$L = -1) : $ee3c1fdfe8a0ae81$var$B = !0, $ee3c1fdfe8a0ae81$var$K($ee3c1fdfe8a0ae81$var$H, c - d))) : (a.sortIndex = e, $ee3c1fdfe8a0ae81$var$f($ee3c1fdfe8a0ae81$var$r, a), $ee3c1fdfe8a0ae81$var$A || $ee3c1fdfe8a0ae81$var$z || ($ee3c1fdfe8a0ae81$var$A = !0, $ee3c1fdfe8a0ae81$var$I($ee3c1fdfe8a0ae81$var$J)));
    return a;
};
$ee3c1fdfe8a0ae81$export$b5836b71941fa3ed = $ee3c1fdfe8a0ae81$var$M;
$ee3c1fdfe8a0ae81$export$cf845f2c119da08a = function(a) {
    var b = $ee3c1fdfe8a0ae81$var$y;
    return function() {
        var c = $ee3c1fdfe8a0ae81$var$y;
        $ee3c1fdfe8a0ae81$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ee3c1fdfe8a0ae81$var$y = c;
        }
    };
};

});



parcelRegister("2pWWv", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});


var $7476e21157772a88$exports = {};
"use strict";

$7476e21157772a88$exports = (parcelRequire("8f2hE"));


parcelRequire("bnENU");
var $a818400b9257b505$export$882461b6382ed46c;
var $a818400b9257b505$export$757ceba2d55c277e;
"use strict";
var $93b772b00f04f226$exports = {};
"use strict";
function $93b772b00f04f226$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($93b772b00f04f226$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$93b772b00f04f226$var$checkDCE();

$93b772b00f04f226$exports = (parcelRequire("34ehV"));


var $a818400b9257b505$var$i;
$a818400b9257b505$export$882461b6382ed46c = $93b772b00f04f226$exports.createRoot;
$a818400b9257b505$export$757ceba2d55c277e = $93b772b00f04f226$exports.hydrateRoot;




var $bnENU = parcelRequire("bnENU");
// Older browsers don't support event options, feature detect it.
let $b73088ac51b12d07$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    const passiveTestOptions = {
        get passive () {
            $b73088ac51b12d07$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, passiveTestOptions);
    window.removeEventListener("testPassive", null, passiveTestOptions);
}
const $b73088ac51b12d07$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
let $b73088ac51b12d07$var$locks = [];
const $b73088ac51b12d07$var$locksIndex = new Map();
let $b73088ac51b12d07$var$documentListenerAdded = false;
let $b73088ac51b12d07$var$initialClientY = -1;
let $b73088ac51b12d07$var$previousBodyOverflowSetting;
let $b73088ac51b12d07$var$htmlStyle;
let $b73088ac51b12d07$var$bodyStyle;
let $b73088ac51b12d07$var$previousBodyPaddingRight;
// returns true if `el` should be allowed to receive touchmove events.
const $b73088ac51b12d07$var$allowTouchMove = (el)=>$b73088ac51b12d07$var$locks.some((lock)=>{
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
const $b73088ac51b12d07$var$preventDefault = (rawEvent)=>{
    const e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($b73088ac51b12d07$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
const $b73088ac51b12d07$var$setOverflowHidden = (options)=>{
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($b73088ac51b12d07$var$previousBodyPaddingRight === undefined) {
        const reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        const scrollBarGap = window.innerWidth - document.documentElement.getBoundingClientRect().width;
        if (reserveScrollBarGap && scrollBarGap > 0) {
            const computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
            $b73088ac51b12d07$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = `${computedBodyPaddingRight + scrollBarGap}px`;
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($b73088ac51b12d07$var$previousBodyOverflowSetting === undefined) {
        $b73088ac51b12d07$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
const $b73088ac51b12d07$var$restoreOverflowSetting = ()=>{
    if ($b73088ac51b12d07$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $b73088ac51b12d07$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $b73088ac51b12d07$var$previousBodyPaddingRight = undefined;
    }
    if ($b73088ac51b12d07$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $b73088ac51b12d07$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $b73088ac51b12d07$var$previousBodyOverflowSetting = undefined;
    }
};
const $b73088ac51b12d07$var$setPositionFixed = ()=>window.requestAnimationFrame(()=>{
        const $html = document.documentElement;
        const $body = document.body;
        // If bodyStyle is already set, don't set it again.
        if ($b73088ac51b12d07$var$bodyStyle === undefined) {
            $b73088ac51b12d07$var$htmlStyle = {
                ...$html.style
            };
            $b73088ac51b12d07$var$bodyStyle = {
                ...$body.style
            };
            // Update the dom inside an animation frame
            const { scrollY: scrollY, scrollX: scrollX, innerHeight: innerHeight } = window;
            $html.style.height = "100%";
            $html.style.overflow = "hidden";
            $body.style.position = "fixed";
            $body.style.top = `0px`;
            // $body.style.top = `${-scrollY}px`;
            $body.style.left = `${-scrollX}px`;
            $body.style.width = "100%";
            $body.style.height = "auto";
            $body.style.overflow = "hidden";
            setTimeout(()=>window.requestAnimationFrame(()=>{
                    // Attempt to check if the bottom bar appeared due to the position change
                    const bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    // $body.style.top = -(scrollY + bottomBarHeight) + 'px';
                    $body.style.top = `0px`;
                }), 300);
        }
    });
const $b73088ac51b12d07$var$restorePositionSetting = ()=>{
    if ($b73088ac51b12d07$var$bodyStyle !== undefined) {
        // Convert the position from "px" to Int
        const y = -parseInt(document.body.style.top, 10);
        const x = -parseInt(document.body.style.left, 10);
        // Restore styles
        const $html = document.documentElement;
        const $body = document.body;
        $html.style.height = $b73088ac51b12d07$var$htmlStyle?.height || "";
        $html.style.overflow = $b73088ac51b12d07$var$htmlStyle?.overflow || "";
        $body.style.position = $b73088ac51b12d07$var$bodyStyle.position || "";
        $body.style.top = $b73088ac51b12d07$var$bodyStyle.top || "";
        $body.style.left = $b73088ac51b12d07$var$bodyStyle.left || "";
        $body.style.width = $b73088ac51b12d07$var$bodyStyle.width || "";
        $body.style.height = $b73088ac51b12d07$var$bodyStyle.height || "";
        $body.style.overflow = $b73088ac51b12d07$var$bodyStyle.overflow || "";
        // Restore scroll
        window.scrollTo(x, y);
        $b73088ac51b12d07$var$bodyStyle = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
const $b73088ac51b12d07$var$isTargetElementTotallyScrolled = (targetElement)=>targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
const $b73088ac51b12d07$var$handleScroll = (event, targetElement)=>{
    const clientY = event.targetTouches[0].clientY - $b73088ac51b12d07$var$initialClientY;
    if ($b73088ac51b12d07$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $b73088ac51b12d07$var$preventDefault(event);
    if ($b73088ac51b12d07$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $b73088ac51b12d07$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
const $b73088ac51b12d07$export$24fdf68abf432c44 = (targetElement, options)=>{
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    $b73088ac51b12d07$var$locksIndex.set(targetElement, $b73088ac51b12d07$var$locksIndex?.get(targetElement) ? $b73088ac51b12d07$var$locksIndex?.get(targetElement) + 1 : 1);
    // disableBodyScroll must not have been called on this targetElement before
    if ($b73088ac51b12d07$var$locks.some((lock)=>lock.targetElement === targetElement)) return;
    const lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $b73088ac51b12d07$var$locks = [
        ...$b73088ac51b12d07$var$locks,
        lock
    ];
    if ($b73088ac51b12d07$var$isIosDevice) $b73088ac51b12d07$var$setPositionFixed();
    else $b73088ac51b12d07$var$setOverflowHidden(options);
    if ($b73088ac51b12d07$var$isIosDevice) {
        targetElement.ontouchstart = (event)=>{
            if (event.targetTouches.length === 1) // detect single touch.
            $b73088ac51b12d07$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = (event)=>{
            if (event.targetTouches.length === 1) // detect single touch.
            $b73088ac51b12d07$var$handleScroll(event, targetElement);
        };
        if (!$b73088ac51b12d07$var$documentListenerAdded) {
            document.addEventListener("touchmove", $b73088ac51b12d07$var$preventDefault, $b73088ac51b12d07$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $b73088ac51b12d07$var$documentListenerAdded = true;
        }
    }
};
const $b73088ac51b12d07$export$45a3ef215b2a5866 = ()=>{
    if ($b73088ac51b12d07$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $b73088ac51b12d07$var$locks.forEach((lock)=>{
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($b73088ac51b12d07$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $b73088ac51b12d07$var$preventDefault, $b73088ac51b12d07$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $b73088ac51b12d07$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $b73088ac51b12d07$var$initialClientY = -1;
    }
    if ($b73088ac51b12d07$var$isIosDevice) $b73088ac51b12d07$var$restorePositionSetting();
    else $b73088ac51b12d07$var$restoreOverflowSetting();
    $b73088ac51b12d07$var$locks = [];
    $b73088ac51b12d07$var$locksIndex.clear();
};
const $b73088ac51b12d07$export$e5d0524c3725571e = (targetElement)=>{
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $b73088ac51b12d07$var$locksIndex.set(targetElement, $b73088ac51b12d07$var$locksIndex?.get(targetElement) ? $b73088ac51b12d07$var$locksIndex?.get(targetElement) - 1 : 0);
    if ($b73088ac51b12d07$var$locksIndex?.get(targetElement) === 0) {
        $b73088ac51b12d07$var$locks = $b73088ac51b12d07$var$locks.filter((lock)=>lock.targetElement !== targetElement);
        $b73088ac51b12d07$var$locksIndex?.delete(targetElement);
    }
    if ($b73088ac51b12d07$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($b73088ac51b12d07$var$documentListenerAdded && $b73088ac51b12d07$var$locks.length === 0) {
            document.removeEventListener("touchmove", $b73088ac51b12d07$var$preventDefault, $b73088ac51b12d07$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $b73088ac51b12d07$var$documentListenerAdded = false;
        }
    }
    if ($b73088ac51b12d07$var$locks.length === 0) {
        if ($b73088ac51b12d07$var$isIosDevice) $b73088ac51b12d07$var$restorePositionSetting();
        else $b73088ac51b12d07$var$restoreOverflowSetting();
    }
};



parcelRequire("bnENU");
function $ba7ab6802e0962e7$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        children: "Loading..."
    });
}




var $bnENU = parcelRequire("bnENU");
var $e77d19bda74ac681$var$V3_URL = "https://js.stripe.com/v3";
var $e77d19bda74ac681$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $e77d19bda74ac681$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $e77d19bda74ac681$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($e77d19bda74ac681$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$e77d19bda74ac681$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $e77d19bda74ac681$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($e77d19bda74ac681$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $e77d19bda74ac681$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "1.54.2",
        startTime: startTime
    });
};
var $e77d19bda74ac681$var$stripePromise = null;
var $e77d19bda74ac681$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($e77d19bda74ac681$var$stripePromise !== null) return $e77d19bda74ac681$var$stripePromise;
    $e77d19bda74ac681$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined" || typeof document === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($e77d19bda74ac681$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $e77d19bda74ac681$var$findScript();
            if (script && params) console.warn($e77d19bda74ac681$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $e77d19bda74ac681$var$injectScript(params);
            script.addEventListener("load", function() {
                if (window.Stripe) resolve(window.Stripe);
                else reject(new Error("Stripe.js not available"));
            });
            script.addEventListener("error", function() {
                reject(new Error("Failed to load Stripe.js"));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });
    return $e77d19bda74ac681$var$stripePromise;
};
var $e77d19bda74ac681$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $e77d19bda74ac681$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// own script injection.
var $e77d19bda74ac681$var$stripePromise$1 = Promise.resolve().then(function() {
    return $e77d19bda74ac681$var$loadScript(null);
});
var $e77d19bda74ac681$var$loadCalled = false;
$e77d19bda74ac681$var$stripePromise$1["catch"](function(err) {
    if (!$e77d19bda74ac681$var$loadCalled) console.warn(err);
});
var $e77d19bda74ac681$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $e77d19bda74ac681$var$loadCalled = true;
    var startTime = Date.now();
    return $e77d19bda74ac681$var$stripePromise$1.then(function(maybeStripe) {
        return $e77d19bda74ac681$var$initStripe(maybeStripe, args, startTime);
    });
};


var $6323bf82a322056a$exports = {};

(function(global, factory) {
    factory($6323bf82a322056a$exports, (parcelRequire("bnENU")));
})($6323bf82a322056a$exports, function(exports1, React) {
    "use strict";
    React = React && Object.prototype.hasOwnProperty.call(React, "default") ? React["default"] : React;
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function createCommonjsModule(fn, module) {
        return module = {
            exports: {}
        }, fn(module, module.exports), module.exports;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    var ReactPropTypesSecret_1 = ReactPropTypesSecret;
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    var factoryWithThrowingShims = function() {
        function shim(props, propName, componentName, location, propFullName, secret) {
            if (secret === ReactPropTypesSecret_1) // It is still safe when called from React.
            return;
            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            err.name = "Invariant Violation";
            throw err;
        }
        shim.isRequired = shim;
        function getShim() {
            return shim;
        }
        // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
        var ReactPropTypes = {
            array: shim,
            bool: shim,
            func: shim,
            number: shim,
            object: shim,
            string: shim,
            symbol: shim,
            any: shim,
            arrayOf: getShim,
            element: shim,
            elementType: shim,
            instanceOf: getShim,
            node: shim,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim,
            checkPropTypes: emptyFunctionWithReset,
            resetWarningCache: emptyFunction
        };
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
    };
    var propTypes = createCommonjsModule(function(module) {
        // By explicitly using `prop-types` you are opting into new production behavior.
        // http://fb.me/prop-types-in-prod
        module.exports = factoryWithThrowingShims();
    });
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === "object";
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === "function";
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === "function" && typeof raw.createToken === "function" && typeof raw.createPaymentMethod === "function" && typeof raw.confirmCardPayment === "function";
    };
    var PLAIN_OBJECT_STR = "[object Object]";
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details."; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(INVALID_STRIPE_ERROR);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        if (isPromise(raw)) return {
            tag: "async",
            stripePromise: Promise.resolve(raw).then(validateStripe)
        };
        var stripe = validateStripe(raw);
        if (stripe === null) return {
            tag: "empty"
        };
        return {
            tag: "sync",
            stripe: stripe
        };
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = "ElementsContext";
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    var CartElementContext = /*#__PURE__*/ React.createContext(null);
    CartElementContext.displayName = "CartElementContext";
    var parseCartElementContext = function parseCartElementContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), cart = _React$useState2[0], setCart = _React$useState2[1];
        var _React$useState3 = React.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), cartState = _React$useState4[0], setCartState = _React$useState4[1]; // For a sync stripe instance, initialize into context
        var _React$useState5 = React.useState(function() {
            return {
                stripe: parsed.tag === "sync" ? parsed.stripe : null,
                elements: parsed.tag === "sync" ? parsed.stripe.elements(options) : null
            };
        }), _React$useState6 = _slicedToArray(_React$useState5, 2), ctx = _React$useState6[0], setContext = _React$useState6[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === "async" && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === "sync" && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                "clientSecret",
                "fonts"
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            var anyStripe = ctx.stripe;
            if (!anyStripe || !anyStripe._registerWrapper || !anyStripe.registerAppInfo) return;
            anyStripe._registerWrapper({
                name: "react-stripe-js",
                version: "1.16.5"
            });
            anyStripe.registerAppInfo({
                name: "react-stripe-js",
                version: "1.16.5",
                url: "https://stripe.com/docs/stripe-js/react"
            });
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CartElementContext.Provider, {
            value: {
                cart: cart,
                setCart: setCart,
                cartState: cartState,
                setCartState: setCartState
            }
        }, children));
    };
    Elements.propTypes = {
        stripe: propTypes.any,
        options: propTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    var useCartElementContextWithUseCase = function useCartElementContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(CartElementContext);
        return parseCartElementContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase("calls useElements()"), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsContextWi2 = useElementsContextWithUseCase("calls useStripe()"), stripe = _useElementsContextWi2.stripe;
        return stripe;
    };
    /**
   * @docs https://stripe.com/docs/payments/checkout/cart-element
   */ var useCartElement = function useCartElement() {
        var _useCartElementContex = useCartElementContextWithUseCase("calls useCartElement()"), cart = _useCartElementContex.cart;
        return cart;
    };
    /**
   * @docs https://stripe.com/docs/payments/checkout/cart-element
   */ var useCartElementState = function useCartElementState() {
        var _useCartElementContex2 = useCartElementContextWithUseCase("calls useCartElementState()"), cartState = _useCartElementContex2.cartState;
        return cartState;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase("mounts <ElementsConsumer>"); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: propTypes.func.isRequired
    };
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onCheckout = _ref.onCheckout, onLineItemClick = _ref.onLineItemClick, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var _useElementsContextWi = useElementsContextWithUseCase("mounts <".concat(displayName, ">")), elements = _useElementsContextWi.elements;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null);
            var _useCartElementContex = useCartElementContextWithUseCase("mounts <".concat(displayName, ">")), setCart = _useCartElementContex.setCart, setCartState = _useCartElementContex.setCartState; // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, "blur", onBlur);
            useAttachEvent(element, "focus", onFocus);
            useAttachEvent(element, "escape", onEscape);
            useAttachEvent(element, "click", onClick);
            useAttachEvent(element, "loaderror", onLoadError);
            useAttachEvent(element, "loaderstart", onLoaderStart);
            useAttachEvent(element, "networkschange", onNetworksChange);
            useAttachEvent(element, "lineitemclick", onLineItemClick);
            useAttachEvent(element, "confirm", onConfirm);
            useAttachEvent(element, "cancel", onCancel);
            useAttachEvent(element, "shippingaddresschange", onShippingAddressChange);
            useAttachEvent(element, "shippingratechange", onShippingRateChange);
            var readyCallback;
            if (type === "cart") readyCallback = function readyCallback(event) {
                setCartState(event);
                onReady && onReady(event);
            };
            else if (onReady) {
                if (type === "payButton") // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, "ready", readyCallback);
            var changeCallback = type === "cart" ? function(event) {
                setCartState(event);
                onChange && onChange(event);
            } : onChange;
            useAttachEvent(element, "change", changeCallback);
            var checkoutCallback = type === "cart" ? function(event) {
                setCartState(event);
                onCheckout && onCheckout(event);
            } : onCheckout;
            useAttachEvent(element, "checkout", checkoutCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && elements && domNode.current !== null) {
                    var newElement = elements.create(type, options);
                    if (type === "cart" && setCart) // we know that elements.create return value must be of type StripeCartElement if type is 'cart',
                    // we need to cast because typescript is not able to infer which overloaded method is used based off param type
                    setCart(newElement);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    newElement.mount(domNode.current);
                }
            }, [
                elements,
                options,
                setCart
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    "paymentRequest"
                ]);
                if (updates) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current) {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    }
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            // Validate that we are in the right context by calling useElementsContextWithUseCase.
            useElementsContextWithUseCase("mounts <".concat(displayName, ">"));
            useCartElementContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: propTypes.string,
            className: propTypes.string,
            onChange: propTypes.func,
            onBlur: propTypes.func,
            onFocus: propTypes.func,
            onReady: propTypes.func,
            onEscape: propTypes.func,
            onClick: propTypes.func,
            onLoadError: propTypes.func,
            onLoaderStart: propTypes.func,
            onNetworksChange: propTypes.func,
            onCheckout: propTypes.func,
            onLineItemClick: propTypes.func,
            onConfirm: propTypes.func,
            onCancel: propTypes.func,
            onShippingAddressChange: propTypes.func,
            onShippingRateChange: propTypes.func,
            options: propTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === "undefined";
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent("auBankAccount", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent("card", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent("cardNumber", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent("cardExpiry", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent("cardCvc", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent("fpxBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent("iban", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent("idealBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent("p24Bank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent("epsBank", isServer);
    var PaymentElement = createElementComponent("payment", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PayButtonElement = createElementComponent("payButton", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent("paymentRequestButton", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent("linkAuthentication", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent("address", isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent("shippingAddress", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/elements/cart-element
   */ var CartElement = createElementComponent("cart", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent("paymentMethodMessaging", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent("affirmMessage", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent("afterpayClearpayMessage", isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CartElement = CartElement;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EpsBankElement = EpsBankElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PayButtonElement = PayButtonElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCartElement = useCartElement;
    exports1.useCartElementState = useCartElementState;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});





var $bnENU = parcelRequire("bnENU");


function $24501165cf5f80f8$export$2e2bcd8739ae039({ amount: amount, onPaymentMethod: onPaymentMethod, onPaymentSubmit: onPaymentSubmit, submitting: submitting, validated: validated, message: message }) {
    const stripe = (0, $6323bf82a322056a$exports.useStripe)();
    const elements = (0, $6323bf82a322056a$exports.useElements)();
    const [paymentRequest, setPaymentRequest] = (0, $bnENU.useState)(null);
    const [canPayWithPaymentRequest, setCanPayWithPaymentRequest] = (0, $bnENU.useState)(false);
    const [showCredit, setShowCredit] = (0, $bnENU.useState)(false);
    const [isPaymentComplete, setIsPaymentComplete] = (0, $bnENU.useState)(false);
    const [extra, setExtra] = (0, $bnENU.useState)({
        email: "",
        first_name: "",
        last_name: ""
    });
    const [isLoading, setIsLoading] = (0, $bnENU.useState)(true);
    (0, $bnENU.useEffect)(()=>{
        if (paymentRequest) paymentRequest.update({
            total: {
                label: "Megaphone",
                amount: Math.round(amount)
            }
        });
    }, [
        amount
    ]);
    const finalize = (e)=>{
        if (stripe) onPaymentMethod(e, stripe, extra);
        else console.log("Stripe was not loaded in the payment finalize function.");
    };
    // Lots of help from here: https://stackoverflow.com/questions/60865022/stripe-payment-request-button-with-subscriptions
    (0, $bnENU.useEffect)(()=>{
        if (stripe && !paymentRequest) {
            const pr = stripe.paymentRequest({
                country: "CA",
                currency: "cad",
                total: {
                    label: "Megaphone",
                    amount: Math.round(amount)
                },
                disableWallets: [
                    "link"
                ],
                requestPayerEmail: true
            });
            setPaymentRequest(pr);
        }
    }, [
        stripe
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (paymentRequest) // Check the availability of the Payment Request API.
        paymentRequest.canMakePayment().then((result)=>{
            setIsLoading(false);
            if (result) {
                setCanPayWithPaymentRequest(true);
                paymentRequest.on("paymentmethod", finalize);
            }
        });
        return ()=>{
            if (paymentRequest) // @ts-ignore
            paymentRequest.removeAllListeners(); // Not officially supported, but helpful in the meantime.
        };
    }, [
        paymentRequest,
        amount
    ]);
    if (isLoading || !stripe || !elements) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        className: "mt-4",
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $ba7ab6802e0962e7$export$2e2bcd8739ae039), {})
    });
    const readyToSubmit = validated && isPaymentComplete && extra.email.includes("@");
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("form", {
        onSubmit: (e)=>!submitting && readyToSubmit && onPaymentSubmit(e, stripe, elements, extra),
        children: [
            canPayWithPaymentRequest && paymentRequest && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h2", {
                        children: "Pay by"
                    }),
                    message && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        className: "payment-error",
                        children: message
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        className: "payment-methods",
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6323bf82a322056a$exports.PaymentRequestButtonElement), {
                                // key={Math.random()}
                                options: {
                                    paymentRequest: paymentRequest,
                                    style: {
                                        paymentRequestButton: {
                                        }
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                className: "payment-methods-or",
                                children: "- or -"
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("button", {
                                type: "button",
                                className: "button" + (showCredit ? " button--outline" : ""),
                                onClick: (e)=>setShowCredit(!showCredit),
                                children: "Credit Card"
                            })
                        ]
                    })
                ]
            }),
            !canPayWithPaymentRequest && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h2", {
                children: "Pay by Credit Card"
            }),
            (!canPayWithPaymentRequest || showCredit) && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("label", {
                                className: "",
                                htmlFor: "field-email",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("input", {
                                    required: true,
                                    type: "email",
                                    id: "field-email",
                                    name: "name",
                                    className: "",
                                    placeholder: "email@example.com",
                                    value: extra.email,
                                    onChange: (e)=>setExtra({
                                            ...extra,
                                            email: e.target.value
                                        })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6323bf82a322056a$exports.PaymentElement), {
                        className: "mv-2",
                        id: "payment-element",
                        onChange: (event)=>{
                            setIsPaymentComplete(event.complete);
                        },
                        options: {
                            layout: "tabs",
                            // billingDetails: 'never',
                            wallets: {
                                applePay: "never",
                                googlePay: "never"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        "aria-hidden": "true",
                        className: "donate-secure big-secure",
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                            children: "Your payment details are secure and not stored by Megaphone."
                        })
                    }),
                    message && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        className: "payment-error",
                        children: message
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("button", {
                        className: "button button-donation-submit",
                        type: "submit",
                        disabled: submitting || !readyToSubmit,
                        children: "Complete Payment"
                    })
                ]
            })
        ]
    });
}




var $bnENU = parcelRequire("bnENU");
function $e45ddf9e80c073cb$export$2e2bcd8739ae039({ setVendors: setVendors, vendors: vendors, modalRef: modalRef }) {
    const [search, setSearch] = (0, $bnENU.useState)("");
    const vendorPickerRef = (0, $bnENU.useRef)(null);
    const vendorFormRef = (0, $bnENU.useRef)(null);
    (0, $bnENU.useEffect)(()=>{
        const selectedVendor = vendors.find((v)=>v.selected);
        modalRef.current?.classList.toggle("long-bottom", !selectedVendor);
        return ()=>{
            modalRef.current?.classList.remove("long-bottom");
        };
    }, [
        vendors
    ]);
    const selectedVendor = vendors.find((v)=>v.selected);
    const q = search.toLowerCase().trim();
    const results = selectedVendor ? [
        selectedVendor
    ] : vendors.filter((vendor)=>{
        return vendor.name.toLowerCase().includes(q) || vendor.badge_id && vendor.badge_id.toString() === q;
    });
    // .sort((a, b) => {
    // 	if (a.name < b.name) return -1
    // 	if (a.name > b.name) return 1
    // 	return 0
    // })
    const chooseVendor = (vendor)=>{
        setVendors(vendors.map((v)=>{
            v.selected = v.id === vendor.id;
            return v;
        }));
        setSearch("");
        modalRef.current?.scrollTo(0, vendorPickerRef.current?.offsetTop || 0);
    // modalRef.current?.scrollTo({
    // 	top: vendorPickerRef.current?.offsetTop || 0,
    // 	behavior: 'smooth',
    // })
    };
    const clearVendor = (vendor)=>{
        setVendors(vendors.map((v)=>{
            v.selected = false;
            return v;
        }));
    };
    const clickVendor = (vendor)=>{
        return (e)=>{
            vendor.selected ? clearVendor(vendor) : chooseVendor(vendor);
        };
    };
    const query = new URLSearchParams(window.location.search);
    const queryVendor = parseInt(query.get("badge") || "", 10);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        className: "vendor-picker",
        ref: vendorPickerRef,
        children: [
            !selectedVendor && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                className: "vendor-form",
                ref: vendorFormRef,
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("label", {
                        htmlFor: "search",
                        children: "Search Vendors or Choose from List"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("input", {
                        id: "search",
                        placeholder: "Find by Name or Badge Number...",
                        type: "search",
                        value: search,
                        autoComplete: "off",
                        autoCorrect: "off",
                        autoCapitalize: "off",
                        onFocus: (e)=>{
                            modalRef.current?.scrollTo(0, vendorFormRef.current?.offsetTop || 0);
                        },
                        onChange: (e)=>{
                            setSearch(e.target.value);
                            modalRef.current?.scrollTo(0, vendorFormRef.current?.offsetTop || 0);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                className: "vendor-list",
                children: [
                    results.map((vendor)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            className: "vendor" + (vendor.selected ? " vendor-selected" : ""),
                            children: [
                                vendor.image.cover.url !== "" ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                    src: vendor.image.cover.url
                                }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                    className: "vendor-image-placeholder"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    className: "info",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h3", {
                                            children: vendor.name
                                        }),
                                        vendor.badge_id && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("p", {
                                            children: [
                                                "Badge ",
                                                vendor.badge_id
                                            ]
                                        })
                                    ]
                                }),
                                vendor.selected && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("button", {
                                    type: "button",
                                    onClick: clickVendor(vendor),
                                    className: "button button--outline button--on-black",
                                    children: "Change"
                                }),
                                !vendor.selected && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("button", {
                                    type: "button",
                                    onClick: clickVendor(vendor),
                                    className: "button",
                                    children: "Pay"
                                })
                            ]
                        }, vendor.id)),
                    results.length === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("p", {
                        className: "no-result",
                        children: [
                            "No vendors found with ",
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("br", {}),
                            "that name or badge number."
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("bnENU");
function $8174b139c52c69e5$export$2e2bcd8739ae039({ setProducts: setProducts, products: products }) {
    const setQuantity = (product, quantity)=>{
        setProducts(products.map((p)=>{
            return p.id === product.id ? {
                ...p,
                quantity: quantity
            } : p;
        }));
    };
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        className: "product-picker",
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h2", {
                className: "title",
                children: "Choose Products"
            }),
            products.map((product)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    className: "product",
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                            src: product.image.cover.url
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h3", {
                                    className: "title",
                                    children: product.title
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    className: "quantity",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h4", {
                                            className: "add",
                                            onClick: ()=>setQuantity(product, product.quantity ? product.quantity + 1 : 1),
                                            children: "+"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h4", {
                                            children: typeof product.quantity !== "undefined" ? product.quantity : 0
                                        }),
                                        typeof product.quantity !== "undefined" && product.quantity > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            className: "subtotal",
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("h4", {
                                                    children: [
                                                        "$",
                                                        (product.quantity * product.price / 100).toFixed(2)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h4", {
                                                    className: "clear",
                                                    onClick: ()=>setQuantity(product, 0),
                                                    children: "\xd7"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, product.id))
        ]
    });
}



parcelRequire("bnENU");
function $f928753afe27af23$export$2e2bcd8739ae039({ tip: tip, setTip: setTip, vendors: vendors }) {
    const selectedVendor = vendors.find((v)=>v.selected);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        className: "tip-picker",
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("h3", {
                children: [
                    "Add a Tip for ",
                    selectedVendor ? selectedVendor.name : "Vendor"
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                className: "defaults",
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        className: "presets",
                        children: [
                            100,
                            200,
                            500,
                            1000
                        ].map((i)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                className: "tip",
                                onClick: ()=>setTip(tip + i),
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("h5", {
                                    children: [
                                        "+",
                                        i / 100
                                    ]
                                })
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        className: "subtotal",
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("input", {
                                    type: "number",
                                    value: tip / 100,
                                    min: 0,
                                    onChange: (e)=>setTip(parseFloat(e.target.value) * 100)
                                })
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h4", {
                                className: "clear",
                                onClick: ()=>setTip(0),
                                children: "\xd7"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $bnENU = parcelRequire("bnENU");
function $4054d1a1ec34a271$export$2e2bcd8739ae039({ onDone: onDone, children: children, className: className, style: style }) {
    const [holding, setHolding] = (0, $bnENU.useState)(false);
    const timer = (0, $bnENU.useRef)(null);
    const startHold = (e)=>{
        e.preventDefault();
        setHolding(true);
        timer.current = window.setTimeout(()=>{
            onDone();
            setHolding(false);
        }, 1000);
    };
    const endHold = (e)=>{
        e.preventDefault();
        setHolding(false);
        if (timer.current) clearTimeout(timer.current);
    };
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("button", {
        style: style,
        className: (className ? className : "") + " hold-button" + (holding ? " holding" : ""),
        onPointerDown: startHold,
        onPointerUp: endHold,
        children: children
    });
}


// const stripePromise = loadStripe('pk_test_QKrWL0MMndVLL9P3AhlIN8Oh') // Stripe Publishable Key
const $802842f95b224ed2$var$stripePromise = (0, $e77d19bda74ac681$export$de80f7562c3fd6b1)("pk_live_0FW0ag4jzudLThcCw7TQ4b4j"); // Stripe Publishable Key
function $802842f95b224ed2$export$2e2bcd8739ae039({ closeModal: closeModal, openModal: openModal, isModalOpen: isModalOpen, baseUrl: baseUrl, vendorsInitial: vendorsInitial, productsInitial: productsInitial, purchase: purchase, setPurchase: setPurchase, modalRef: modalRef }) {
    // Form info
    const [vendors, setVendors] = (0, $bnENU.useState)(vendorsInitial.map((vendor)=>({
            ...vendor,
            selected: false
        })));
    const [products, setProducts] = (0, $bnENU.useState)(productsInitial.map((product)=>({
            ...product,
            quantity: 0
        })));
    const [tip, setTip] = (0, $bnENU.useState)(0);
    // Stripe info
    // const [email, setEmail] = useState<string>('')
    const [message, setMessage] = (0, $bnENU.useState)();
    const [hasNoVendor, setHasNoVendor] = (0, $bnENU.useState)(false);
    const [isLoading, setIsLoading] = (0, $bnENU.useState)(true);
    const [isSubmitting, setIsSubmitting] = (0, $bnENU.useState)(false);
    const [paymentIntent, setPaymentIntent] = (0, $bnENU.useState)(undefined);
    const [paymentComplete, setPaymentComplete] = (0, $bnENU.useState)(false);
    const [done, setDone] = (0, $bnENU.useState)(false);
    const [formId, setFormId] = (0, $bnENU.useState)((Math.random() + 1).toString(36).substring(5));
    const formatPrice = (amount)=>(amount / 100).toFixed(2);
    const pushAnalytics = (action, label)=>{
        // @ts-ignore
        if (typeof window.dataLayer !== "undefined") // @ts-ignore
        window.dataLayer.push({
            event: "interaction",
            eventCategory: "payments",
            eventAction: action,
            eventLabel: label
        });
        console.log("pushAnalytics", action, label);
    };
    (0, $bnENU.useEffect)(()=>{
        if (isModalOpen) pushAnalytics("open", "payments");
    }, [
        isModalOpen
    ]);
    (0, $bnENU.useEffect)(()=>{
        const subtotal = products.reduce((acc, product)=>{
            return acc + (product.quantity || 0) * product.price;
        }, 0) + tip;
        const total = subtotal > 0 ? Math.round(subtotal + 30) / 0.971 : 0; // https://support.stripe.com/questions/passing-the-stripe-fee-on-to-customers
        if (total > 0 && !paymentComplete) {
            const product_ids = [];
            products.forEach((p)=>{
                if (p.quantity && p.quantity > 0) for(let i = 0; i < p.quantity; i++)product_ids.push(p.id);
            });
            const intent = {
                amount: Math.round(total),
                vendor_id: vendors.find((v)=>v.selected)?.id,
                product_ids: product_ids,
                tips: tip
            };
            fetch(baseUrl + "/purchases/payment_intent", {
                method: paymentIntent ? "PATCH" : "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(paymentIntent ? {
                    ...intent,
                    intent_id: paymentIntent.id
                } : intent)
            }).then((res)=>res.json()).then((data)=>setPaymentIntent(data));
        }
    }, [
        products,
        tip
    ]);
    // SUCCESS HANDLING !
    // http://uwbc.localhost/donation-test-page/?payment_intent=pi_3Mip6iFLDDJq2OeF0X4fnaxr&payment_intent_client_secret=pi_3Mip6iFLDDJq2OeF0X4fnaxr_secret_xX0huhRAIzkefZxkmqRY2A6Ui&redirect_status=succeeded
    (0, $bnENU.useEffect)(()=>{
        const params = new URLSearchParams(window.location.search);
        const clientSecret = params.get("payment_intent_client_secret");
        if (!clientSecret) {
            setIsLoading(false);
            return;
        } else setIsLoading(true);
        const extra = {
            email: params.get("email") || "",
            first_name: params.get("first_name") || "",
            last_name: params.get("last_name") || ""
        };
        $802842f95b224ed2$var$stripePromise.then((stripe)=>{
            if (stripe) stripe.retrievePaymentIntent(clientSecret).then((result)=>handlePaymentAttempt(result, undefined, extra, "creditcard"));
        });
    }, []);
    // Check for query params, set fields and open modal if they exist.
    // Otherwise, set fields from cookie.
    (0, $bnENU.useEffect)(()=>{
        const query = new URLSearchParams(window.location.search);
        const queryVendor = parseInt(query.get("badge") || "", 10);
        if (queryVendor) {
            let hasVendor = false;
            setVendors(vendors.map((v, i)=>{
                v.selected = v.badge_id === queryVendor;
                if (!hasVendor && v.selected) hasVendor = true;
                return v;
            }));
            if (!hasVendor) setHasNoVendor(true);
            openModal();
        }
    }, []);
    // Apple Pay / Payment Request
    const handlePaymentMethod = async (e, stripe, extra)=>{
        setIsSubmitting(true);
        setMessage(undefined);
        if (paymentIntent && !!paymentIntent.client_secret) {
            const result = await stripe.confirmCardPayment(paymentIntent.client_secret, {
                payment_method: e.paymentMethod.id
            }, {
                handleActions: false
            });
            handlePaymentAttempt(result, e, extra, "applepay");
        }
    };
    // Stripe Form submit
    const handlePaymentSubmit = async (e, stripe, elements, extra)=>{
        e.preventDefault();
        setIsSubmitting(true);
        setMessage(undefined);
        const result = await stripe.confirmPayment({
            elements: elements,
            confirmParams: {
                // Can get redirected elsewhere to handle payment
                // return_url: "https://denimandsteel.ngrok.io",
                return_url: window.location.href,
                payment_method_data: {
                    billing_details: {
                        email: extra.email
                    }
                }
            },
            redirect: "if_required"
        });
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        handlePaymentAttempt(result, undefined, extra, "creditcard");
    };
    const handlePaymentAttempt = async ({ error: error, paymentIntent: paymentIntent }, e, { email: email, first_name: first_name, last_name: last_name }, method)=>{
        setIsSubmitting(false);
        if (error) {
            if (error.type === "card_error" || error.type === "validation_error") setMessage(error.message);
            else setMessage("There was a problem processing your payment. Please check your name, address, and payment information and try again. If the problem persists please contact your credit card issuer.");
            if (e) e.complete("fail");
        } else if (paymentIntent) switch(paymentIntent.status){
            case "succeeded":
                setPaymentIntent(paymentIntent);
                setPaymentComplete(true);
                break;
            case "processing":
                setMessage("Your payment is processing.");
                break;
            case "requires_payment_method":
                setMessage("Your payment was not successful, please try again.");
                break;
            default:
                setMessage("There was a problem processing your payment. Please check your name, address, and payment information and try again. If the problem persists please contact your credit card issuer.");
                break;
        }
        else setMessage("There was a problem processing your payment. Please check your name, address, and payment information and try again. If the problem persists please contact your credit card issuer.");
        if (paymentIntent && paymentIntent.status === "succeeded") {
            const res = await fetch(baseUrl + "/purchases", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    purchase: {
                        payment_id: paymentIntent.id,
                        payment_method: method
                    }
                })
            });
            const data = await res.json();
            setPurchase(data);
            setIsLoading(false);
            setIsSubmitting(false);
            pushAnalytics("purchase", "payments");
            if (e) e.complete("success");
        }
    };
    // Reset everything
    const handleComplete = (e)=>{
        setTip(0);
        setProducts(productsInitial);
        setVendors(vendorsInitial);
        setMessage(undefined);
        setPaymentIntent(undefined);
        setPurchase(undefined);
        setPaymentComplete(false);
        setDone(false);
    };
    if (isLoading) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $ba7ab6802e0962e7$export$2e2bcd8739ae039), {});
    else if (paymentComplete || done) {
        const subtotal = products.reduce((acc, product)=>{
            return acc + (product.quantity || 0) * product.price;
        }, 0) + tip;
        const total = subtotal > 0 ? Math.round(subtotal + 30) / 0.971 : 0; // https://support.stripe.com/questions/passing-the-stripe-fee-on-to-customers
        const transactionFee = total - subtotal;
        const vendor = vendors.find((v)=>v.selected);
        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
            children: [
                !purchase && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    className: "finishing",
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h2", {
                            children: "Finishing Payment"
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $ba7ab6802e0962e7$export$2e2bcd8739ae039), {})
                    ]
                }),
                purchase && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    className: "paid",
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            className: "checkmark",
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("polyline", {
                                            points: "17 8 10 16 7 12"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("circle", {
                                            cx: "12",
                                            cy: "12",
                                            r: "10"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("h4", {
                                            children: [
                                                "Payment complete: $",
                                                formatPrice(total)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("h2", {
                                            className: "",
                                            children: [
                                                "Show this to ",
                                                vendor?.name
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("h1", {
                            className: "font-size-xxl subtotal",
                            children: [
                                "$",
                                formatPrice(subtotal)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                            className: "arrow-down",
                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "0",
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("rect", {
                                        x: "8",
                                        y: "0",
                                        width: "8",
                                        height: "12"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("polyline", {
                                        points: "2 11 22 11 12 24 2 11"
                                    })
                                ]
                            })
                        }),
                        vendor && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            className: "vendor",
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                    src: vendor?.image.cover.url
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h2", {
                                            children: vendor?.name
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("p", {
                                            children: [
                                                "Badge ",
                                                vendor?.badge_id
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            className: "bottom-and-button",
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4054d1a1ec34a271$export$2e2bcd8739ae039), {
                                    className: "button",
                                    onDone: ()=>{
                                        closeModal();
                                        setDone(true);
                                    },
                                    children: "Press and Hold to Close"
                                }),
                                done && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("button", {
                                        className: "button button--outline",
                                        onClick: handleComplete,
                                        children: "Start New Transaction"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("p", {
                                    className: "receipt",
                                    children: [
                                        "Receipt sent to ",
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("strong", {
                                            children: purchase.email
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    } else {
        const subtotal = products.reduce((acc, product)=>{
            return acc + (product.quantity || 0) * product.price;
        }, 0) + tip;
        const total = subtotal > 0 ? Math.round(subtotal + 30) / 0.971 : 0; // https://support.stripe.com/questions/passing-the-stripe-fee-on-to-customers
        const transactionFee = total - subtotal;
        const selectedVendor = vendors.find((v)=>v.selected);
        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
            className: "payments-form",
            children: [
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h1", {
                    className: "modal-title",
                    children: "Pay Vendor"
                }),
                hasNoVendor && !selectedVendor && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                    className: "payment-error",
                    children: "The vendor you were looking for is not able to receive payments. The vendor should contact Megaphone to resolve."
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $e45ddf9e80c073cb$export$2e2bcd8739ae039), {
                    vendors: vendors,
                    setVendors: setVendors,
                    modalRef: modalRef
                }),
                selectedVendor && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $8174b139c52c69e5$export$2e2bcd8739ae039), {
                            products: products,
                            setProducts: setProducts
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $f928753afe27af23$export$2e2bcd8739ae039), {
                            tip: tip,
                            setTip: setTip,
                            vendors: vendors
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    className: "",
                    children: [
                        total > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("hr", {}),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    className: "donate-total",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("h4", {
                                            className: "price-subtotal",
                                            children: [
                                                "$",
                                                formatPrice(subtotal)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("h4", {
                                            className: "price-fee",
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    children: "Transaction Fee"
                                                }),
                                                " $",
                                                formatPrice(transactionFee)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h4", {
                                            className: "price-total",
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("strong", {
                                                children: [
                                                    "$",
                                                    formatPrice(total)
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        total > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                            className: "payment",
                            children: paymentIntent && paymentIntent.client_secret ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6323bf82a322056a$exports.Elements), {
                                stripe: $802842f95b224ed2$var$stripePromise,
                                options: {
                                    clientSecret: paymentIntent.client_secret,
                                    fonts: [],
                                    appearance: {
                                        theme: "stripe",
                                        variables: {
                                            // spacingUnit: '5px',
                                            // @ts-ignore
                                            gridRowSpacing: "18px",
                                            // colorPrimary: '#ff0000',
                                            fontWeightNormal: "bold",
                                            fontFamily: "Lato, sans-serif"
                                        }
                                    }
                                },
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $24501165cf5f80f8$export$2e2bcd8739ae039), {
                                    amount: total,
                                    onPaymentMethod: handlePaymentMethod,
                                    onPaymentSubmit: handlePaymentSubmit,
                                    submitting: isSubmitting,
                                    validated: true,
                                    message: message
                                })
                            }, paymentIntent.id) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $ba7ab6802e0962e7$export$2e2bcd8739ae039), {})
                            })
                        })
                    ]
                })
            ]
        });
    }
}


function $b86f1e09b00a1c2e$export$2e2bcd8739ae039() {
    // const baseUrl = window.location.host === "dev-megaphone-wordpress.pantheonsite.io" ? "https://megaphone-magazine-staging-d857d30ff8e7.herokuapp.com" : "http://localhost:3000"
    const baseUrl = "https://app.megaphonemagazine.com";
    const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");
    const [loading, setLoading] = (0, $bnENU.useState)(true);
    const [open, setOpen] = (0, $bnENU.useState)(!!clientSecret || window.location.hash === "#buy");
    const [error, setError] = (0, $bnENU.useState)(null);
    const modalRef = (0, $bnENU.useRef)(null);
    const [purchase, setPurchase] = (0, $bnENU.useState)(undefined);
    const [vendors, setVendors] = (0, $bnENU.useState)([]);
    const [products, setProducts] = (0, $bnENU.useState)([]);
    (0, $bnENU.useEffect)(()=>{
        Promise.all([
            fetch(baseUrl + "/vendors.json"),
            fetch(baseUrl + "/products.json?web=true")
        ]).then((responses)=>{
            const errors = responses.filter((response)=>!response.ok);
            if (errors.length > 0) throw errors.map((response)=>Error(response.statusText));
            const json = responses.map((response)=>response.json());
            return Promise.all(json);
        }).then((data)=>{
            setLoading(false);
            setVendors(data[0]);
            setProducts(data[1]);
        }).catch((errors)=>{
            setLoading(false);
            setError("Something went wrong fetching the vendors or products.");
        });
    }, []);
    (0, $bnENU.useEffect)(()=>{
        if (modalRef && modalRef.current) {
            if (open) (0, $b73088ac51b12d07$export$24fdf68abf432c44)(modalRef.current);
            else (0, $b73088ac51b12d07$export$e5d0524c3725571e)(modalRef.current);
        }
    }, [
        modalRef,
        open
    ]);
    (0, $bnENU.useEffect)(()=>{
        window.addEventListener("keydown", downHandler);
        return ()=>{
            window.removeEventListener("keydown", downHandler);
        };
    }, []);
    const openModal = ()=>{
        setOpen(true);
    };
    const closeModal = ()=>{
        setOpen(false);
    };
    const downHandler = (e)=>{
        if (e.code === "Escape") closeModal();
    };
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("button", {
                className: "button button--rounded",
                onClick: openModal,
                "aria-haspopup": "dialog",
                "aria-expanded": open,
                children: "Pay a Vendor"
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                ref: modalRef,
                className: `modal modal-donate modal-donate-next ${open ? "show" : ""}`,
                tabIndex: -1,
                role: "dialog",
                "aria-hidden": !open,
                "aria-labelledby": "modal-title",
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        className: "modal-backdrop",
                        "aria-hidden": "true",
                        onClick: closeModal
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        className: "modal-contents",
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("button", {
                                type: "button",
                                className: "modal-close",
                                onClick: closeModal,
                                "aria-label": "Close",
                                children: "Close"
                            }),
                            !loading ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: open ? "block" : "none"
                                },
                                children: [
                                    error && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        className: "error",
                                        children: error
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $802842f95b224ed2$export$2e2bcd8739ae039), {
                                        vendorsInitial: vendors,
                                        productsInitial: products,
                                        closeModal: closeModal,
                                        openModal: openModal,
                                        isModalOpen: open,
                                        baseUrl: baseUrl,
                                        purchase: purchase,
                                        setPurchase: setPurchase,
                                        modalRef: modalRef
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $ba7ab6802e0962e7$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            }),
            !open && purchase && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                className: "purchase-alert",
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    className: "purchase-alert-inner",
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            children: [
                                "You paid ",
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("strong", {
                                    children: purchase.vendor.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("button", {
                            className: "",
                            onClick: openModal,
                            "aria-haspopup": "dialog",
                            "aria-expanded": open,
                            children: "Show"
                        })
                    ]
                })
            })
        ]
    });
}


document.addEventListener("DOMContentLoaded", function() {
    // Array.from(document.querySelectorAll('[data-donation]')).forEach((donationElement) => {
    //   const container = document.createElement('div')
    //   container.classList.add('donation-wrapper');
    //   donationElement.after(container)
    //   const root = createRoot(container);
    //   root.render(<App campaignId={donationElement.getAttribute('data-campaign') || (window as any).UWBC_DEFAULT_DONATION_CAMPAIGN} donationTileId={donationElement.getAttribute('data-tile-id') || undefined} useCookies={donationElement.getAttribute('data-use-cookies') == "true" || false} baseUrl={baseUrl} />);
    //   donationElement.remove();
    // })
    Array.from(document.querySelectorAll("[data-payments]")).forEach((element)=>{
        const root = (0, $a818400b9257b505$export$882461b6382ed46c)(element);
        root.render(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $b86f1e09b00a1c2e$export$2e2bcd8739ae039), {}));
    });
});


var $63d75d7c39bb2245$exports = {};
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $63d75d7c39bb2245$exports = factory();
})($63d75d7c39bb2245$exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 686: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                /**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */ function command(type) {
                    try {
                        return document.execCommand(type);
                    } catch (err) {
                        return false;
                    }
                }
                /**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */ var ClipboardActionCut = function ClipboardActionCut(target) {
                    var selectedText = select_default()(target);
                    command("cut");
                    return selectedText;
                };
                /* harmony default export */ var actions_cut = ClipboardActionCut;
                /**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */ function createFakeElement(value) {
                    var isRTL = document.documentElement.getAttribute("dir") === "rtl";
                    var fakeElement = document.createElement("textarea"); // Prevent zooming on iOS
                    fakeElement.style.fontSize = "12pt"; // Reset box model
                    fakeElement.style.border = "0";
                    fakeElement.style.padding = "0";
                    fakeElement.style.margin = "0"; // Move element out of screen horizontally
                    fakeElement.style.position = "absolute";
                    fakeElement.style[isRTL ? "right" : "left"] = "-9999px"; // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    fakeElement.style.top = "".concat(yPosition, "px");
                    fakeElement.setAttribute("readonly", "");
                    fakeElement.value = value;
                    return fakeElement;
                }
                /**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */ var fakeCopyAction = function fakeCopyAction(value, options) {
                    var fakeElement = createFakeElement(value);
                    options.container.appendChild(fakeElement);
                    var selectedText = select_default()(fakeElement);
                    command("copy");
                    fakeElement.remove();
                    return selectedText;
                };
                /**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */ var ClipboardActionCopy = function ClipboardActionCopy(target) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        container: document.body
                    };
                    var selectedText = "";
                    if (typeof target === "string") selectedText = fakeCopyAction(target, options);
                    else if (target instanceof HTMLInputElement && ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "password"
                    ].includes(target === null || target === void 0 ? void 0 : target.type)) // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                    selectedText = fakeCopyAction(target.value, options);
                    else {
                        selectedText = select_default()(target);
                        command("copy");
                    }
                    return selectedText;
                };
                /* harmony default export */ var actions_copy = ClipboardActionCopy;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                /**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */ var ClipboardActionDefault = function ClipboardActionDefault() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    // Defines base properties passed from constructor.
                    var _options$action = options.action, action = _options$action === void 0 ? "copy" : _options$action, container = options.container, target = options.target, text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.
                    if (action !== "copy" && action !== "cut") throw new Error('Invalid "action" value, use either "copy" or "cut"');
                     // Sets the `target` property using an element that will be have its content copied.
                    if (target !== undefined) {
                        if (target && _typeof(target) === "object" && target.nodeType === 1) {
                            if (action === "copy" && target.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (action === "cut" && (target.hasAttribute("readonly") || target.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    } // Define selection strategy based on `text` property.
                    if (text) return actions_copy(text, {
                        container: container
                    });
                     // Defines which selection strategy based on `target` property.
                    if (target) return action === "cut" ? actions_cut(target) : actions_copy(target, {
                        container: container
                    });
                };
                /* harmony default export */ var actions_default = ClipboardActionDefault;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        _classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ _createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === "function" ? options.action : this.defaultAction;
                                this.target = typeof options.target === "function" ? options.target : this.defaultTarget;
                                this.text = typeof options.text === "function" ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === "object" ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, "click", function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                var action = this.action(trigger) || "copy";
                                var text = actions_default({
                                    action: action,
                                    container: this.container,
                                    target: this.target(trigger),
                                    text: this.text(trigger)
                                }); // Fires an event based on the copy operation result.
                                this.emit(text ? "success" : "error", {
                                    action: action,
                                    text: text,
                                    trigger: trigger,
                                    clearSelection: function clearSelection() {
                                        if (trigger) trigger.focus();
                                        window.getSelection().removeAllRanges();
                                    }
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue("action", trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue("target", trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue("text", trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                            }
                        }
                    ], [
                        {
                            key: "copy",
                            value: function copy(target) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    container: document.body
                                };
                                return actions_copy(target, options);
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(target) {
                                return actions_cut(target);
                            }
                        },
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    "copy",
                                    "cut"
                                ];
                                var actions = typeof action === "string" ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== "undefined" && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === "function" && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === "function") return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === "function") // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === "string") elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === "[object NodeList]" || type === "[object HTMLCollection]") && "length" in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === "string" || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === "[object Function]";
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error("Missing required arguments");
                    if (!is.string(type)) throw new TypeError("Second argument must be a String");
                    if (!is.fn(callback)) throw new TypeError("Third argument must be a Function");
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === "SELECT") {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
                        var isReadOnly = element.hasAttribute("readonly");
                        if (!isReadOnly) element.setAttribute("readonly", "");
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute("readonly");
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute("contenteditable")) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(686);
    /******/ }().default;
});


const $097bf9dc71f72fe2$var$shareBtns = document.querySelectorAll("[data-clipboard-text]");
if ($097bf9dc71f72fe2$var$shareBtns) $097bf9dc71f72fe2$var$shareBtns.forEach((btn)=>{
    const button = new (0, (/*@__PURE__*/$parcel$interopDefault($63d75d7c39bb2245$exports)))(btn);
    button.on("success", function(e) {
        e.clearSelection();
        btn.textContent = "Link copied!";
        setTimeout(()=>{
            btn.textContent = "Copy link to this story";
        }, 2000);
    });
});



parcelRequire("bnENU");



var $bnENU = parcelRequire("bnENU");


var $bnENU = parcelRequire("bnENU");


var $bnENU = parcelRequire("bnENU");

var $2pWWv = parcelRequire("2pWWv");
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $2pWWv = parcelRequire("2pWWv");
var $d0ac70d5134d086b$var$_win, $d0ac70d5134d086b$var$_doc, $d0ac70d5134d086b$var$_docElement, $d0ac70d5134d086b$var$_pluginInitted, $d0ac70d5134d086b$var$_tempDiv, $d0ac70d5134d086b$var$_tempDivStyler, $d0ac70d5134d086b$var$_recentSetterPlugin, $d0ac70d5134d086b$var$_reverting, $d0ac70d5134d086b$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $d0ac70d5134d086b$var$_transformProps = {}, $d0ac70d5134d086b$var$_RAD2DEG = 180 / Math.PI, $d0ac70d5134d086b$var$_DEG2RAD = Math.PI / 180, $d0ac70d5134d086b$var$_atan2 = Math.atan2, $d0ac70d5134d086b$var$_bigNum = 1e8, $d0ac70d5134d086b$var$_capsExp = /([A-Z])/g, $d0ac70d5134d086b$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $d0ac70d5134d086b$var$_complexExp = /[\s,\(]\S/, $d0ac70d5134d086b$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $d0ac70d5134d086b$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $d0ac70d5134d086b$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $d0ac70d5134d086b$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$d0ac70d5134d086b$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $d0ac70d5134d086b$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $d0ac70d5134d086b$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $d0ac70d5134d086b$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $d0ac70d5134d086b$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $d0ac70d5134d086b$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $d0ac70d5134d086b$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $d0ac70d5134d086b$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $d0ac70d5134d086b$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $d0ac70d5134d086b$var$_transformProp = "transform", $d0ac70d5134d086b$var$_transformOriginProp = $d0ac70d5134d086b$var$_transformProp + "Origin", $d0ac70d5134d086b$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $d0ac70d5134d086b$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $d0ac70d5134d086b$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $d0ac70d5134d086b$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $d0ac70d5134d086b$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $d0ac70d5134d086b$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $d0ac70d5134d086b$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($d0ac70d5134d086b$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($d0ac70d5134d086b$var$_transformOriginProp, isNotCSS, "");
        }
        property = $d0ac70d5134d086b$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $d0ac70d5134d086b$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $d0ac70d5134d086b$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($d0ac70d5134d086b$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $d0ac70d5134d086b$var$_reverting();
        if ((!i || !i.isStart) && !style[$d0ac70d5134d086b$var$_transformProp]) {
            $d0ac70d5134d086b$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$d0ac70d5134d086b$var$_transformOriginProp]) {
                style[$d0ac70d5134d086b$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $d0ac70d5134d086b$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $d0ac70d5134d086b$var$_revertStyle,
        save: $d0ac70d5134d086b$var$_saveStyle
    };
    target._gsap || (0, $2pWWv.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $d0ac70d5134d086b$var$_supports3D, $d0ac70d5134d086b$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $d0ac70d5134d086b$var$_doc.createElementNS ? $d0ac70d5134d086b$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $d0ac70d5134d086b$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $d0ac70d5134d086b$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $d0ac70d5134d086b$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($d0ac70d5134d086b$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $d0ac70d5134d086b$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $d0ac70d5134d086b$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $d0ac70d5134d086b$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $d0ac70d5134d086b$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($d0ac70d5134d086b$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $d0ac70d5134d086b$var$_prefixes[i] : "") + property;
}, $d0ac70d5134d086b$var$_initCore = function _initCore() {
    if ($d0ac70d5134d086b$var$_windowExists() && window.document) {
        $d0ac70d5134d086b$var$_win = window;
        $d0ac70d5134d086b$var$_doc = $d0ac70d5134d086b$var$_win.document;
        $d0ac70d5134d086b$var$_docElement = $d0ac70d5134d086b$var$_doc.documentElement;
        $d0ac70d5134d086b$var$_tempDiv = $d0ac70d5134d086b$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $d0ac70d5134d086b$var$_tempDivStyler = $d0ac70d5134d086b$export$a232bb0480ae674a("div");
        $d0ac70d5134d086b$var$_transformProp = $d0ac70d5134d086b$export$8cbef5dd49a09c8b($d0ac70d5134d086b$var$_transformProp);
        $d0ac70d5134d086b$var$_transformOriginProp = $d0ac70d5134d086b$var$_transformProp + "Origin";
        $d0ac70d5134d086b$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $d0ac70d5134d086b$var$_supports3D = !!$d0ac70d5134d086b$export$8cbef5dd49a09c8b("perspective");
        $d0ac70d5134d086b$var$_reverting = (0, $2pWWv.gsap).core.reverting;
        $d0ac70d5134d086b$var$_pluginInitted = 1;
    }
}, $d0ac70d5134d086b$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $d0ac70d5134d086b$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $d0ac70d5134d086b$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $d0ac70d5134d086b$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $d0ac70d5134d086b$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $d0ac70d5134d086b$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $d0ac70d5134d086b$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $d0ac70d5134d086b$var$_getBBoxHack || (bounds = $d0ac70d5134d086b$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$d0ac70d5134d086b$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$d0ac70d5134d086b$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $d0ac70d5134d086b$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $d0ac70d5134d086b$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$d0ac70d5134d086b$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $d0ac70d5134d086b$var$_transformProps && property !== $d0ac70d5134d086b$var$_transformOriginProp) property = $d0ac70d5134d086b$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($d0ac70d5134d086b$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $d0ac70d5134d086b$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $2pWWv.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $d0ac70d5134d086b$var$_renderNonTweeningValueOnlyAtEnd : $d0ac70d5134d086b$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $d0ac70d5134d086b$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $d0ac70d5134d086b$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$d0ac70d5134d086b$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $d0ac70d5134d086b$var$_tempDiv.style, horizontal = $d0ac70d5134d086b$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $d0ac70d5134d086b$var$_nonConvertibleUnits[unit] || $d0ac70d5134d086b$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $d0ac70d5134d086b$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($d0ac70d5134d086b$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $2pWWv._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $d0ac70d5134d086b$var$_doc || !parent.appendChild) parent = $d0ac70d5134d086b$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $2pWWv._ticker).time && !cache.uncache) return (0, $2pWWv._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $d0ac70d5134d086b$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$d0ac70d5134d086b$var$_nonStandardLayouts[$d0ac70d5134d086b$var$_getComputedProperty(parent, "display")] && (style.position = $d0ac70d5134d086b$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($d0ac70d5134d086b$var$_tempDiv);
            px = $d0ac70d5134d086b$var$_tempDiv[measureProperty];
            parent.removeChild($d0ac70d5134d086b$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $2pWWv._getCache)(parent);
            cache.time = (0, $2pWWv._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $2pWWv._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $d0ac70d5134d086b$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $d0ac70d5134d086b$var$_pluginInitted || $d0ac70d5134d086b$var$_initCore();
    if (property in $d0ac70d5134d086b$var$_propertyAliases && property !== "transform") {
        property = $d0ac70d5134d086b$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($d0ac70d5134d086b$var$_transformProps[property] && property !== "transform") {
        value = $d0ac70d5134d086b$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $d0ac70d5134d086b$var$_firstTwoOnly($d0ac70d5134d086b$var$_getComputedProperty(target, $d0ac70d5134d086b$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $d0ac70d5134d086b$var$_specialProps[property] && $d0ac70d5134d086b$var$_specialProps[property](target, property, unit) || $d0ac70d5134d086b$var$_getComputedProperty(target, property) || (0, $2pWWv._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $d0ac70d5134d086b$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $d0ac70d5134d086b$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $d0ac70d5134d086b$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $d0ac70d5134d086b$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $d0ac70d5134d086b$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $2pWWv.PropTween)(this._pt, target.style, prop, 0, 1, (0, $2pWWv._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $d0ac70d5134d086b$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $d0ac70d5134d086b$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $2pWWv._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $2pWWv._numWithUnitExp)) || [];
    endValues = end.match((0, $2pWWv._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $2pWWv._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $2pWWv._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $2pWWv._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $2pWWv._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $d0ac70d5134d086b$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $d0ac70d5134d086b$var$_renderNonTweeningValueOnlyAtEnd : $d0ac70d5134d086b$var$_renderNonTweeningValue;
    (0, $2pWWv._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $d0ac70d5134d086b$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $d0ac70d5134d086b$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $d0ac70d5134d086b$var$_keywordToPercent[x] || x;
    split[1] = $d0ac70d5134d086b$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $d0ac70d5134d086b$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($d0ac70d5134d086b$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $d0ac70d5134d086b$var$_transformOriginProp : $d0ac70d5134d086b$var$_transformProp;
                }
                $d0ac70d5134d086b$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $d0ac70d5134d086b$var$_removeProperty(target, $d0ac70d5134d086b$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $d0ac70d5134d086b$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $d0ac70d5134d086b$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$d0ac70d5134d086b$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $2pWWv.PropTween)(plugin._pt, target, property, 0, 0, $d0ac70d5134d086b$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $d0ac70d5134d086b$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $d0ac70d5134d086b$var$_rotationalProperties = {}, $d0ac70d5134d086b$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $d0ac70d5134d086b$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $d0ac70d5134d086b$var$_getComputedProperty(target, $d0ac70d5134d086b$var$_transformProp);
    return $d0ac70d5134d086b$var$_isNullTransform(matrixString) ? $d0ac70d5134d086b$var$_identity2DMatrix : matrixString.substr(7).match((0, $2pWWv._numExp)).map((0, $2pWWv._round));
}, $d0ac70d5134d086b$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $2pWWv._getCache)(target), style = target.style, matrix = $d0ac70d5134d086b$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $d0ac70d5134d086b$var$_identity2DMatrix : matrix;
    } else if (matrix === $d0ac70d5134d086b$var$_identity2DMatrix && !target.offsetParent && target !== $d0ac70d5134d086b$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $d0ac70d5134d086b$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $d0ac70d5134d086b$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $d0ac70d5134d086b$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $d0ac70d5134d086b$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $d0ac70d5134d086b$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $d0ac70d5134d086b$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $d0ac70d5134d086b$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $d0ac70d5134d086b$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$d0ac70d5134d086b$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $d0ac70d5134d086b$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $d0ac70d5134d086b$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $d0ac70d5134d086b$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $d0ac70d5134d086b$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $d0ac70d5134d086b$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $2pWWv.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $d0ac70d5134d086b$var$_getComputedProperty(target, $d0ac70d5134d086b$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $d0ac70d5134d086b$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$d0ac70d5134d086b$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$d0ac70d5134d086b$var$_transformProp] !== "none" ? cs[$d0ac70d5134d086b$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $d0ac70d5134d086b$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $d0ac70d5134d086b$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $d0ac70d5134d086b$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $d0ac70d5134d086b$var$_atan2(b, a) * $d0ac70d5134d086b$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $d0ac70d5134d086b$var$_atan2(c, d) * $d0ac70d5134d086b$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $d0ac70d5134d086b$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $d0ac70d5134d086b$var$_atan2(a32, a33);
            rotationX = angle * $d0ac70d5134d086b$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $d0ac70d5134d086b$var$_atan2(-c, a33);
            rotationY = angle * $d0ac70d5134d086b$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $d0ac70d5134d086b$var$_atan2(b, a);
            rotation = angle * $d0ac70d5134d086b$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $2pWWv._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $2pWWv._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $d0ac70d5134d086b$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $d0ac70d5134d086b$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$d0ac70d5134d086b$var$_isNullTransform($d0ac70d5134d086b$var$_getComputedProperty(target, $d0ac70d5134d086b$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $2pWWv._round)(scaleX);
    cache.scaleY = (0, $2pWWv._round)(scaleY);
    cache.rotation = (0, $2pWWv._round)(rotation) + deg;
    cache.rotationX = (0, $2pWWv._round)(rotationX) + deg;
    cache.rotationY = (0, $2pWWv._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$d0ac70d5134d086b$var$_transformOriginProp] = $d0ac70d5134d086b$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $2pWWv._config).force3D;
    cache.renderTransform = cache.svg ? $d0ac70d5134d086b$var$_renderSVGTransforms : $d0ac70d5134d086b$var$_supports3D ? $d0ac70d5134d086b$var$_renderCSSTransforms : $d0ac70d5134d086b$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $d0ac70d5134d086b$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$d0ac70d5134d086b$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $2pWWv.getUnit)(start);
    return (0, $2pWWv._round)(parseFloat(start) + parseFloat($d0ac70d5134d086b$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $d0ac70d5134d086b$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $d0ac70d5134d086b$var$_renderCSSTransforms(ratio, cache);
}, $d0ac70d5134d086b$var$_zeroDeg = "0deg", $d0ac70d5134d086b$var$_zeroPx = "0px", $d0ac70d5134d086b$var$_endParenthesis = ") ", $d0ac70d5134d086b$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $d0ac70d5134d086b$var$_zeroDeg || rotationY !== $d0ac70d5134d086b$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $d0ac70d5134d086b$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $d0ac70d5134d086b$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $d0ac70d5134d086b$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $d0ac70d5134d086b$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $d0ac70d5134d086b$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $d0ac70d5134d086b$var$_zeroPx) transforms += "perspective(" + transformPerspective + $d0ac70d5134d086b$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $d0ac70d5134d086b$var$_zeroPx || y !== $d0ac70d5134d086b$var$_zeroPx || z !== $d0ac70d5134d086b$var$_zeroPx) transforms += z !== $d0ac70d5134d086b$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $d0ac70d5134d086b$var$_endParenthesis;
    if (rotation !== $d0ac70d5134d086b$var$_zeroDeg) transforms += "rotate(" + rotation + $d0ac70d5134d086b$var$_endParenthesis;
    if (rotationY !== $d0ac70d5134d086b$var$_zeroDeg) transforms += "rotateY(" + rotationY + $d0ac70d5134d086b$var$_endParenthesis;
    if (rotationX !== $d0ac70d5134d086b$var$_zeroDeg) transforms += "rotateX(" + rotationX + $d0ac70d5134d086b$var$_endParenthesis;
    if (skewX !== $d0ac70d5134d086b$var$_zeroDeg || skewY !== $d0ac70d5134d086b$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $d0ac70d5134d086b$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $d0ac70d5134d086b$var$_endParenthesis;
    target.style[$d0ac70d5134d086b$var$_transformProp] = transforms || "translate(0, 0)";
}, $d0ac70d5134d086b$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $d0ac70d5134d086b$var$_DEG2RAD;
        skewX *= $d0ac70d5134d086b$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $d0ac70d5134d086b$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $2pWWv._round)(a11);
        a21 = (0, $2pWWv._round)(a21);
        a12 = (0, $2pWWv._round)(a12);
        a22 = (0, $2pWWv._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $d0ac70d5134d086b$var$_convertToUnit(target, "x", x, "px");
        ty = $d0ac70d5134d086b$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $2pWWv._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $2pWWv._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $2pWWv._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $2pWWv._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$d0ac70d5134d086b$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $d0ac70d5134d086b$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $2pWWv._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $d0ac70d5134d086b$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $d0ac70d5134d086b$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $d0ac70d5134d086b$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $2pWWv.PropTween)(plugin._pt, target, property, startNum, change, $d0ac70d5134d086b$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $d0ac70d5134d086b$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $d0ac70d5134d086b$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $d0ac70d5134d086b$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$d0ac70d5134d086b$var$_transformProp] = transforms;
        endCache = $d0ac70d5134d086b$var$_parseTransform(target, 1);
        $d0ac70d5134d086b$var$_removeProperty(target, $d0ac70d5134d086b$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$d0ac70d5134d086b$var$_transformProp];
        style[$d0ac70d5134d086b$var$_transformProp] = transforms;
        endCache = $d0ac70d5134d086b$var$_parseTransform(target, 1);
        style[$d0ac70d5134d086b$var$_transformProp] = startValue;
    }
    for(p in $d0ac70d5134d086b$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $2pWWv.getUnit)(startValue);
            endUnit = (0, $2pWWv.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $d0ac70d5134d086b$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $2pWWv.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $d0ac70d5134d086b$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $d0ac70d5134d086b$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $2pWWv._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $d0ac70d5134d086b$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $d0ac70d5134d086b$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $d0ac70d5134d086b$export$855822f522f18eef = {
    name: "css",
    register: $d0ac70d5134d086b$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $d0ac70d5134d086b$var$_pluginInitted || $d0ac70d5134d086b$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $d0ac70d5134d086b$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $2pWWv._plugins)[p] && (0, $2pWWv._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $d0ac70d5134d086b$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $2pWWv._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $2pWWv._colorExp).lastIndex = 0;
                if (!(0, $2pWWv._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $2pWWv.getUnit)(startValue);
                    endUnit = (0, $2pWWv.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $d0ac70d5134d086b$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $2pWWv._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $2pWWv._replaceRandom)(startValue));
                    (0, $2pWWv.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $2pWWv._config).units[p] || (0, $2pWWv.getUnit)($d0ac70d5134d086b$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $d0ac70d5134d086b$var$_get(target, p)); // can't work with relative values
                } else startValue = $d0ac70d5134d086b$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $d0ac70d5134d086b$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $d0ac70d5134d086b$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $d0ac70d5134d086b$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $d0ac70d5134d086b$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $d0ac70d5134d086b$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $d0ac70d5134d086b$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $2pWWv.PropTween)(this._pt, style, $d0ac70d5134d086b$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $2pWWv.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $2pWWv._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $d0ac70d5134d086b$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($d0ac70d5134d086b$var$_transformOriginProp, 0, style[$d0ac70d5134d086b$var$_transformOriginProp]);
                        endValue = $d0ac70d5134d086b$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $d0ac70d5134d086b$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $d0ac70d5134d086b$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $d0ac70d5134d086b$var$_addNonTweeningPT(this, style, p, $d0ac70d5134d086b$var$_firstTwoOnly(startValue), $d0ac70d5134d086b$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $d0ac70d5134d086b$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $d0ac70d5134d086b$var$_rotationalProperties) {
                        $d0ac70d5134d086b$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $2pWWv._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $d0ac70d5134d086b$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $d0ac70d5134d086b$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $d0ac70d5134d086b$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$d0ac70d5134d086b$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $2pWWv.getUnit)(endValue) || (p in (0, $2pWWv._config).units ? (0, $2pWWv._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $d0ac70d5134d086b$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $2pWWv.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $2pWWv._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $d0ac70d5134d086b$var$_renderRoundedCSSProp : $d0ac70d5134d086b$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $d0ac70d5134d086b$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $2pWWv._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $d0ac70d5134d086b$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $2pWWv._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$d0ac70d5134d086b$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $d0ac70d5134d086b$var$_get,
    aliases: $d0ac70d5134d086b$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $d0ac70d5134d086b$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $d0ac70d5134d086b$var$_transformProps && property !== $d0ac70d5134d086b$var$_transformOriginProp && (target._gsap.x || $d0ac70d5134d086b$var$_get(target, "x")) ? plugin && $d0ac70d5134d086b$var$_recentSetterPlugin === plugin ? property === "scale" ? $d0ac70d5134d086b$var$_setterScale : $d0ac70d5134d086b$var$_setterTransform : ($d0ac70d5134d086b$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $d0ac70d5134d086b$var$_setterScaleWithRender : $d0ac70d5134d086b$var$_setterTransformWithRender) : target.style && !(0, $2pWWv._isUndefined)(target.style[property]) ? $d0ac70d5134d086b$var$_setterCSSStyle : ~property.indexOf("-") ? $d0ac70d5134d086b$var$_setterCSSProp : (0, $2pWWv._getSetter)(target, property);
    },
    core: {
        _removeProperty: $d0ac70d5134d086b$var$_removeProperty,
        _getMatrix: $d0ac70d5134d086b$var$_getMatrix
    }
};
(0, $2pWWv.gsap).utils.checkPrefix = $d0ac70d5134d086b$export$8cbef5dd49a09c8b;
(0, $2pWWv.gsap).core.getStyleSaver = $d0ac70d5134d086b$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $2pWWv._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $d0ac70d5134d086b$var$_transformProps[name] = 1;
    });
    (0, $2pWWv._forEachName)(rotation, function(name) {
        (0, $2pWWv._config).units[name] = "deg";
        $d0ac70d5134d086b$var$_rotationalProperties[name] = 1;
    });
    $d0ac70d5134d086b$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $2pWWv._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $d0ac70d5134d086b$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $2pWWv._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $2pWWv._config).units[name] = "px";
});
(0, $2pWWv.gsap).registerPlugin($d0ac70d5134d086b$export$855822f522f18eef);


var $15b5f22af2a86faa$export$99ee26438460406a = (0, $2pWWv.gsap).registerPlugin((0, $d0ac70d5134d086b$export$855822f522f18eef)) || (0, $2pWWv.gsap), // to protect from tree shaking
$15b5f22af2a86faa$export$7b23975ad686bf91 = $15b5f22af2a86faa$export$99ee26438460406a.core.Tween;


function $474f6de71d24b8f5$export$2e2bcd8739ae039({ vendor: vendor, area: area }) {
    const [accordionState, setAccordionState] = (0, $bnENU.useState)({});
    const accordionContentRefs = (0, $bnENU.useRef)({});
    const accordionBodyRefs = (0, $bnENU.useRef)({});
    const vendorLocation = vendor.locations.length > 1 ? vendor.locations.find((location)=>location.neighbourhood === area) || area : vendor.locations[0];
    (0, $bnENU.useEffect)(()=>{
        for(const vendorId in accordionState){
            const isOpen = accordionState[vendorId];
            const accordionBody = accordionBodyRefs.current[vendorId];
            const accordionContent = accordionContentRefs.current[vendorId];
            const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            if (accordionContent && accordionBody) {
                if (isOpen) {
                    (0, $15b5f22af2a86faa$export$99ee26438460406a).set(accordionContent, {
                        height: "auto"
                    });
                    (0, $15b5f22af2a86faa$export$99ee26438460406a).from(accordionContent, {
                        duration: reduceMotion ? 0 : 0.25,
                        height: 0
                    });
                    accordionContent.removeAttribute("hidden");
                    accordionBody.removeAttribute("hidden");
                } else (0, $15b5f22af2a86faa$export$99ee26438460406a).to(accordionContent, {
                    duration: reduceMotion ? 0 : 0.25,
                    height: 0
                }).then(()=>{
                    accordionContent.setAttribute("hidden", "true");
                    accordionBody.setAttribute("hidden", "true");
                });
            }
        }
    }, [
        accordionState
    ]);
    const handleAccordionClick = (vendorId)=>{
        setAccordionState((prevState)=>({
                ...prevState,
                [vendorId]: prevState[vendorId] === undefined ? true : !prevState[vendorId]
            }));
    };
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        className: "vendor accordion",
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h3", {
                className: "accordion-header font-family-lato font-size-m",
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("button", {
                    className: "accordion-toggle bold",
                    "aria-controls": `vendor-${vendor.id}`,
                    "aria-expanded": accordionState[vendor.id] ? "true" : "false",
                    onClick: ()=>handleAccordionClick(vendor.id),
                    id: `vendor-${vendor.id}-heading`,
                    children: [
                        vendor.name,
                        vendorLocation.name && ` at ${vendorLocation.name}`
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                hidden: true,
                className: "accordion-body",
                "aria-hidden": !accordionState[vendor.id],
                ref: (el)=>accordionBodyRefs.current[vendor.id] = el,
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    hidden: true,
                    id: `vendor-${vendor.id}`,
                    className: "accordion-body-content vendor-info",
                    "aria-hidden": !accordionState[vendor.id],
                    "aria-labelledby": `vendor-${vendor.id}-heading`,
                    role: "region",
                    ref: (el)=>accordionContentRefs.current[vendor.id] = el,
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            className: "vendor-detail",
                            children: [
                                vendor.image.cover.url ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                    className: "vendor-photo",
                                    alt: "",
                                    src: vendor.image.cover.url
                                }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                    className: "vendor-photo placeholder"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    className: "vendor-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("a", {
                                            href: `/?badge=${vendor.badge_id}`,
                                            className: "button font-size-s",
                                            children: "Pay Vendor"
                                        }),
                                        vendorLocation.name || vendorLocation.cross_street ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("a", {
                                            className: "button button--outline font-size-s",
                                            href: `https://www.google.com/maps/search/?api=1&query=${vendorLocation.cross_street} ${vendorLocation.name ? vendorLocation.name : ""}`,
                                            target: "_blank",
                                            children: "Open in Google Maps"
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        vendorLocation.description || vendorLocation.hours !== "<p></p>" ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            className: "vendor-location",
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("h4", {
                                    className: "font-size-m bold",
                                    children: [
                                        vendorLocation.name,
                                        " ",
                                        vendorLocation.cross_street && `(${vendorLocation.cross_street})`
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("p", {
                                    className: "font-size-s",
                                    children: vendorLocation.description
                                }),
                                vendorLocation.hours !== "<p></p>" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("p", {
                                    className: "font-size-s",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("strong", {
                                            children: "Usual hours"
                                        }),
                                        ":",
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: vendorLocation.hours.replace(/<p>/g, "").replace(/<\/p>/g, "<br>")
                                            }
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    ]
                })
            })
        ]
    }, vendor.id);
}


const $a008cc9275029c4f$export$3ceb184d70dbd166 = [
    {
        city: "Vancouver",
        name: "arbutus-ridge",
        dPath: "M266.747,288.365l34.768,1.098l0.118,29.438l16.774,36.138 l-0.06,6.731l-1.476,3.158l-2.768,2.145l-16.054-0.752l-3.096,2.836l-1.61,25.357l-45.278-0.812l0.202-61.214l-5.738-9.492 l1.956,0.376l5.506,4.288l-26.044-37.94l0.488-2.888L266.747,288.365L266.747,288.365z"
    },
    {
        city: "Vancouver",
        name: "shaughnessy",
        dPath: "M293.339,394.507l1.668-25.485l3.754-3.003l15.69,0.883 l2.648-2.292l1.164-10.356l-16.832-35.972l0.084-28.83l42.858,0.934l2.746-2.582l9.958-1.22l7.212,3.618l13.874,0.346 l-2.562,106.811L293.339,394.507L293.339,394.507L293.339,394.507z"
    },
    {
        city: "Vancouver",
        name: "riley-park",
        dPath: "M443.399,401.025l-31.862-1.776l0.021-23.2l-6.544-9.308 l0.559-12.244l7.487-8.172l1.816-55.294l43.6,1.541l0.211-0.105l32.436,0.788l-2.092,109.024L443.399,401.025L443.399,401.025z"
    },
    {
        city: "Vancouver",
        name: "south-cambie",
        dPath: "M411.539,399.251l-35.932-1.894l2.578-107.418l36.718,1.105 l-1.822,55.298l-7.486,8.17l-0.554,12.248l7.012,10.792L411.539,399.251L411.539,399.251z"
    },
    {
        city: "Vancouver",
        name: "kensington-cedar-cottage",
        dPath: "M591.721,270.829l-0.84,84.462l-5.052,8.16l-0.752,29.548h-0.183 l-0.058,9.42l-95.802-0.147l2.092-109.021l36.45,0.854l0.048-2.024l0.55,0.04l0.349-26.438l63.191,1.068v4.078H591.721 L591.721,270.829z"
    },
    {
        city: "Vancouver",
        name: "renfrew-collingwood",
        dPath: "M691.361,404.965l-23.076,1.234l-13.902-9.771l-3.322,4.418 l-1.646,0.906l-64.556,0.7l0.058-9.418h0.176l0.658-29.141l5.734-9.92l0.268-87.226l76.492,0.588l23.1-16.376l0.036,154.004 H691.361L691.361,404.965z"
    },
    {
        city: "Vancouver",
        name: "oakridge",
        dPath: "M443.399,401.025l-1.612,66.037l-102.696-2.104l1.692-69.354 L443.399,401.025L443.399,401.025z"
    },
    {
        city: "Vancouver",
        name: "killarney",
        dPath: "M691.891,548.427l-1.63-0.31l-0.021-0.026l-0.424-0.191 l-0.07-0.131v-0.084l-0.024-0.031l-0.119-0.046l-0.175,0.065l-0.204-0.042l-0.033-0.038v-0.142l-0.013-0.024l-1.552-0.328 l-0.152-0.235l-1.124-0.381l-0.01-0.014l-1.706-0.372l-0.12-0.14l-1.577-0.184l-0.15-0.156l-1.022-0.128l-0.166-0.238l-0.424-0.098 l-0.012-0.015l-0.846-0.107l-0.04,0.016l-1.028-0.364l-0.022-0.027l-0.941-0.19l-0.164-0.144l-0.084-0.024l-0.088,0.057h-0.15 l-0.05,0.037l-1.928-0.504l-0.076,0.351l-0.143-0.046l0.078-0.353l-0.985-0.27l-0.154-0.389l-3.122-0.624l0.012-0.01l-3.5-1.064 l-0.144,0.089l-1.061-0.194l-0.054,0.33l-2.852-0.45l-0.546,1.014l-2.376-1.142l-0.051,0.116l-0.384-0.178l-0.023,0.05 l-0.482-0.223l-0.12,0.183l-0.446-0.218l-0.195,0.386l-1.322-0.672l0.624-1.282l-1.808-0.964l0.132-0.26l-1.012-0.505l-0.126,0.223 l-1.104-0.555l-0.036,0.022l-0.128,0.236l-2.189-1.059l0.014-0.038l-0.038-0.01l0.012-0.034l-0.067-0.042l-0.038,0.068 l-0.059-0.044h-0.01l-0.242-0.236h-0.025l-0.131-0.334v0.116l-0.638-0.192l0.021-0.13l-7.07-2.59l-1.006-1.378l-6.446-1.806 l-1.317-1.404l-0.116,0.012v-0.023l-0.376,0.563l-0.076,2.114l-5.22-1.136l-0.038-0.053h-0.013l-0.172-0.64l-0.279-0.273h-0.4 l-3.598,2.056l-5.687-1.11l-0.042,0.05v0.061l-0.128,0.189l-0.244,0.131l-0.504-0.097l-0.136-0.168l-0.044-0.216l-0.026-0.026 l-0.058,0.166l-6.344,0.166l-0.024,0.051l-0.072,0.062l-0.828,0.166l-0.046,0.038l-2.018,0.229l-0.656-0.377l-3.684-0.277 l-0.278,0.202l-1.744-0.298l-0.09,0.151l-3.622-0.036v-0.128l-2.576,0.164l-0.036,0.042l-0.14,0.021l-0.07,0.048l-4.8-0.508 l20.402-111.046l3.857,0.069l0.128-15.958l3.146-0.178l-0.156,0.024l0.298-0.04l-0.142,0.016l31.308-1.019l4.528-5.151 l12.031,9.144l24.948-0.613L691.891,548.427L691.891,548.427z"
    },
    {
        city: "Vancouver",
        name: "victoria-fraserview",
        dPath: "M529.633,511.159l0.324-108.064l36.764-0.657l-0.17,0.046 l48.828,0.27l-0.136,15.958l-3.853-0.072l-4.197,63.44l-10.962,14.47l-5.24,33.139l-0.022-0.013l-3.588-0.142l-0.036-0.024 l-2.828-0.216l-0.012-0.012l-10.706-1.122l-0.054,0.354l-0.04,0.024l-7.896-2.448l-0.056-0.05l-2.324-0.227l-0.14-0.082 l0.042-2.352l-0.248-0.222l-0.936-0.061l-0.223,0.2l-0.552,1.258l-0.166,0.026l-1.284-0.552l-0.28-0.376l-0.111,0.023l-7.562-3.926 l-0.964-1.518l-1.194-0.643l-0.035-0.06l-2.091-1.013l-0.976,0.015v0.454l-0.984-0.324l0.011,0.012l-0.101-0.026l-0.012,0.082 l-0.098-0.05l-0.011-0.104l-0.609-0.181l0.012-0.119l-0.11-0.021l0.017-0.07l-1.061-0.378l-0.01,0.04l-2.388-0.868l-0.046,0.036 l-0.095-0.048l0.015-0.044l-0.015-0.014l-1.151-0.349l-0.046,0.11l-3.988-0.614l-0.058,0.13l-0.906-0.079l0.038-0.469l-0.166-0.144 l-1.072-0.29l-4.072,1.412L529.633,511.159L529.633,511.159z"
    },
    {
        city: "Vancouver",
        name: "sunset",
        dPath: "M439.777,524.033l3.64-123.008l86.556,2.073l-0.164,111.637 l-2.783,0.939l-0.034-0.012l-3.164,1.19l-0.636,0.766l-0.128,0.042l-0.347-0.068l-0.248,0.148l0.097,0.53l-0.061,0.058l-1.588,0.33 l-0.094-0.504l-0.034-0.026v-0.072h-0.214l-0.01,0.013l-5.517,0.746l-0.084-0.11l-2.611-0.672l-0.454,0.472l-0.288,1.308 l-0.114,0.072l-1.408,0.05l-0.084,0.103l-0.166,0.04l-0.01-0.01l-0.414-0.137l-1.32,0.336l-0.281,0.261l-1.36,0.048l-0.048-0.024 l-1.656,0.311l-0.063-0.042l-0.072,0.023l-0.092,0.154l-0.456,0.048l-0.256,0.23l-0.345,0.077l-0.034-0.01l-0.062,0.01 l-0.068,0.097l-1.634,0.382l-0.094-0.11l-3.57,0.977l-0.058-0.019l-2.468,0.376l-0.084,0.084l-0.057,0.771l0.101-0.024v0.26 l-0.12,0.034l-0.044,0.19l-1.637,0.355l-0.012,0.187l-1.002,0.324l-0.402,0.644l-0.117,0.038l0.182,0.624l-0.06,0.118l0.01,0.038 l-0.962,0.323l-0.258-0.788l-0.271,0.152h-0.284l-2.328,1.054h-1.241l-0.221,0.106l-0.266,0.382l-1.614,0.666l-0.298-0.1 l-0.748,0.3l-0.044,0.064l-0.108,0.033l-0.012,0.036l-2.815,0.632l-0.013-0.14h-0.118v-0.048l-0.672,0.122l-0.132,0.244 l-0.618,0.102l-0.038,0.414l-0.418,0.096l-0.126-0.096l-0.098-0.254l0.078-0.146l-0.046-0.324l-1.895-0.057l-0.01,0.034 l-0.024,0.024h-0.069l-0.013,0.012l-0.783-0.012l-0.013,0.012l-0.096-0.012l-0.044,0.027h-0.026l-0.014-0.027l-0.978-0.024 l-0.2,0.96l-0.064,0.044l-1.008-0.182l-0.164-0.606l-0.064-0.038l-0.117,0.215l-5.128,0.456l-0.152-0.101l0.026-0.868l-1.889,0.462 l-0.094,0.21l0.01,0.307l-0.069,0.109l-10.584,0.757l-0.078,0.081l-0.092,0.578l0.046,0.062l-0.013,0.202l-0.613-0.019 l-0.013,0.064l-0.815-0.164l-0.223-0.479l-0.542-0.418l-1.065,0.072l-0.132-0.086l-5.992,0.266v0.166l-0.13-0.012v-0.674 l-1.223-0.012v0.573l-0.044,0.051l-3.392-0.272l-0.09-0.376l-0.524-0.3l-0.626-0.061L439.777,524.033L439.777,524.033z"
    },
    {
        city: "Vancouver",
        name: "marpole",
        dPath: "M314.615,464.489l127.18,2.573l-2.228,63.406l-0.166-0.046 l-0.091-0.112l-0.126-0.062l-0.082,0.012l-0.035,0.05l-0.059,0.022l-0.044,0.05l-3.678-0.446l-0.012,0.202l-0.881-0.014 l-0.096-0.308l-0.386-0.024l0.038,0.444l-2.624-0.303l-0.038,0.87l-2.021-0.258l0.263,0.309l0.069,0.021l0.011,0.188l-3.696-0.388 l-0.11-0.96l-8.288,1.103l-0.021-0.024l-2.952,0.848l0.012,0.471h0.13v0.34l-0.224,0.012v-0.166h-0.128v-0.422h-0.128v-0.248 l-0.456,0.472l-0.024,0.068l-0.766-0.012l-0.07-0.528l-4.823,2.26l-0.395,1.29l-0.12,0.132l-4.91,1.504l0.026,0.271l-0.054,0.04 h-0.376l0.016,0.439l-4.458,2.114l-0.128-0.01l-0.216,0.222l-0.038,0.152l0.026,0.107l0.388,0.038l-0.024,0.765l-0.342-0.015 l-0.012-0.094l-0.304-0.012l-0.013,0.063h-0.132l-0.02-0.069l-0.366-0.026l-0.012-0.052h-0.055v-0.042l-1.432,0.288l-0.492,0.354 l-0.036-0.042h-0.024l-0.023,0.028l-0.07-0.016l-0.033,0.029l-0.041,0.013l-0.01,0.033h-0.199l-0.015-0.044l-0.044,0.013v-0.026 h-0.283v0.152l-0.654,0.256l-0.74-0.185l-0.021,0.038h-0.187l-0.106-0.084v-0.025l-0.104-0.04l-0.334,0.02l-0.348,0.4l-0.334,1.154 l-2.064,0.968l-0.042-0.013l-0.08,0.106l-1.046,0.232l-0.044-0.013l-0.108-0.096l-0.072-0.014l-3.797,2.16l-0.305,0.588l-1,0.216 l-2.152,1.628l-1.535,0.324l-0.324,0.407l-2.545,0.61l-0.705,0.744v0.32l-7.24,1.974l-0.188,0.194l-0.024,1.365l-2.83,0.261 l-0.097,0.088l-0.01,0.294l-1.151-0.026l-0.015,0.33h-0.047v0.187l-1.931-0.061l-0.048-0.036l-2.752-0.153v0.105l-1.906-0.107 v-0.122l-0.044-0.011l-0.015-0.168l-1.451-0.08l-0.12-0.124l-0.183-0.607l-0.047-0.017l-0.141,0.814l-0.012,0.012h-0.026 l-0.026-0.021l-0.021-0.064l-0.094,0.013l0.586-2.954l-0.072-0.036h-0.576l-0.54,2.834l-0.304-0.046l0.292-1.271l-0.146,0.15 l-0.293,0.102l-1.06-0.094l-0.015-0.014l-2.389-0.652l-0.097,0.448l-0.494-0.08l0.036-0.246l-0.012-0.012l-0.18-0.028l-0.103,0.554 l-1.574-0.315l0.013-0.034l-0.013-0.014l0.08-0.429l-1.147-0.869v-0.013l-0.262-0.156l-0.095,0.106l-4.704-1.436l0.105-0.46 l-5.245-1.007l-0.108,0.154l-1.15,0.456l-0.062-0.026l-0.13-0.172l-3.584-1.518l-0.062-0.108l-0.312-0.172l-0.036-0.05 l-4.624-2.608l-0.155-0.394l-12.106-8.234l-0.522-1.504l0.106-0.306l0.224-0.222l1.046,0.222l0.038,0.062l-0.012,0.066 l-0.048,0.038l-0.754-0.141l-0.328,0.095l-0.138,0.319l0.316,0.952l2.506,2.044l0.234,0.013l1.368-1.561l0.328-0.023l0.23,0.168 l0.102,0.277l3.778,2.424h0.034l12.95,8.67l1.74-1.964l0.146-0.754l-7.933-6.854l-0.186,0.271l-0.166-0.142l0.344-0.446 l-0.359-0.628l-2.648-1.846l0.034,0.058l-2.042-1.112l-0.035-0.046v-0.012l-5.611-3.422l-0.062-0.158l-0.884-0.73l-0.554-0.023 l-0.484-0.311l-0.012-0.037l-0.402-0.229l-0.004,0.058l-0.67-0.441l-0.024-0.048l-0.496-0.332l-0.11-0.536l-2.974-1.88l-0.79-1.479 l-0.218-0.109l-0.128,0.025l-0.612,1.232l2.152-12.244l1.908-1.269l-1.19-1.812L314.615,464.489L314.615,464.489z"
    },
    {
        city: "Vancouver",
        name: "kerrisdale",
        dPath: "M305.759,524.389l-3.122-5.844l1.222-1.764l-1.016-2.229 l-1.342-0.813h-0.72l-0.122-0.544l-0.084-0.047l-0.024-0.048l-0.392-0.266v-0.038l-0.024-0.032l-0.012-0.098l-0.048-0.05 l-0.128-0.024l-0.178,0.11l-0.254-0.024l-0.332,0.67l-0.106,0.015l-0.158-0.097l-0.01-0.155l0.024-0.036l0.012-0.267l-0.036-0.042 l-0.06-0.027l-0.202,0.088l-0.176-0.076l-0.06-0.36l-2.676-2.68l0.128-0.378l-2.968-3.316v-0.052l-0.082-0.094l-0.14-0.024 l-5.792-5.562h-0.026l-1.412-1.889l-0.66-0.228l-0.012-0.024l-0.188-0.138l-0.058-0.56l-0.728-0.467h-0.068l-0.156,0.072 l-0.024,0.036l-0.084,0.034l-0.01-0.022l-0.486-0.361l-0.022-0.064l-0.048-0.044l-0.07-0.023l-0.432-0.418l-0.022-0.104 l-0.472-0.306l-0.072-0.21l-1.006-0.648l-0.084-0.13l-0.068-0.024l-0.166-0.202l-0.292-0.062l-0.068-0.058l-0.024-0.118 l-0.038-0.048l-0.012-0.059l-0.414-0.306l-0.204,0.028l-0.474-0.48l-0.296-0.044l-0.036-0.06l0.012-0.024l-0.024-0.042v-0.022 l-0.108-0.13l-0.37-0.086l-0.12,0.048l-0.012,0.026h-0.162l-0.038-0.026l-0.096-0.228l-0.486-0.145l-0.122-0.105h-0.024 l-0.18-0.116l-0.022-0.042l-0.862-0.322l-0.026-0.052l-2.016-0.855l-0.026-0.036l-0.902-0.309l-0.06-0.098l-0.214-0.13 l-0.072-0.122l-0.274-0.082l-0.072,0.044l-0.06-0.012l-0.168-0.17l-0.384-0.095l-0.048-0.062l-0.096,0.014l-0.024-0.014h-0.012 l-0.048-0.024h-0.07l-0.022-0.012h-0.038l-0.07-0.063l-0.01-0.03l-0.29-0.143l-0.022-0.035l-0.16-0.074h-0.25l-0.12-0.061h-0.092 l-0.05-0.036h-0.012l-0.024-0.025v-0.026l-0.026-0.044l-0.068-0.023l-0.06,0.046h-0.024l-0.084-0.061v-0.025l-0.206-0.168 l-0.106-0.011l-0.19-0.191l-0.584-0.192v-0.084l-0.242-0.13h-0.048l-1.626-0.792l-0.036,0.036l0.012,0.034l-0.024,0.012 l-0.108-0.054l-0.012-0.038l0.012-0.022l-0.024-0.038h-0.022l-0.026-0.016h0.162l-0.106-0.048l-0.128-0.176l-0.46-0.108 l-0.094,0.164l-2.402-1.21l-0.01-0.024l-0.686-0.405l-0.036-0.053l-8.45-3.968l-0.108-0.178l0.012-0.024l-0.134-0.529h-0.022 l-0.01-0.103h-0.108l-0.01,0.103l-0.012,0.014l-0.036,0.196l-0.734,0.334l-0.862-0.28l0.05,0.11l-2.53-0.784l-0.022-0.036 l-4.246-0.854l-0.012-0.01l-3.51-0.16l-0.012-0.012l-1.538,0.084l-0.05,0.028h-0.152l-0.05,0.025l-1.738-0.025l-0.144,0.191 l-1.946-0.062l-0.022-0.015h-0.13l-0.026-0.012h-0.06l-0.01,0.012l-0.048,0.179l-0.708-0.068l-0.012-0.07h-0.258l-0.048,0.068 l-0.882-0.076l0.012-1.08l-1.198-0.044l-0.062-0.46h-0.198l0.024-0.848l-0.388-0.036l-0.01,0.012l-0.012,0.834l-0.048-0.012 l-0.098,0.024l-0.036,0.046l-0.92-0.059v-0.023l-0.142-0.013v0.036l-0.08-0.012v-0.012l-0.224,0.012v0.012l-0.092,0.013v-0.024 l-0.452,0.07l-0.036,0.134l-0.094,0.046h-0.154l-0.24,0.452l-0.036,0.01l-0.038,0.052v0.269l-2.972-0.561l0.048-0.262l-0.192-0.023 l-0.348-0.311l-0.222-0.012l-0.084-0.046l-0.022-0.046l-2.464-0.851l0.026-0.062l-0.014-0.074l-1.968-1.396v-0.062l-0.562-0.418 l1.188-81.802l118.33,1.972l-1.694,69.358l-24.482-0.473l-1.184,46.494l1.188,1.812l-1.904,1.271l-2.804,13.722l-0.072,0.068 l-0.012,0.048l0.024,0.106l0.204,0.144h0.038l0.024,0.026l1.89,0.254v0.023l-1.264-0.075l-0.008,0.016l-0.792-0.242l-0.18-0.198 h-0.012L305.759,524.389L305.759,524.389z"
    },
    {
        city: "Vancouver",
        name: "dunbar-southlands",
        dPath: "M97.881,371.445l34.248,20.208l7.962-10.305l27.572,11.971 l-0.122-7.628l-5.09-0.215l0.01-8.466l5.14-0.607l0.216-35.946l-6.376-0.246l-18.336-14.004l25.228-3.656l0.154-29.738 l-19.288-0.649l-0.752-7.108l75.976,1.791l-0.49,2.887l26.038,37.94l-5.672-4.35l-1.788-0.318l5.736,9.49l-0.202,61.218 l-25.592-0.06l-1.19,81.804l-3.634-2.974l-0.014-0.16l0.106-0.118l0.422-0.112l0.046,0.024l0.048,0.082l1.578-0.446l-0.024-0.05 l0.012-0.08l-0.024-0.038l-0.972,0.05l-0.012-0.025v-0.036l-0.034-0.04l-0.084-0.026l-0.048,0.026l-0.06,0.086l-0.832,0.196 l-0.118-0.042l-0.024-0.024l-0.306,0.024v-0.021l-0.214-0.023l-0.024-0.026l-0.994-0.158l-0.06-0.054l-0.19-0.04l-0.162,0.04 l-0.202-0.103l-0.048,0.017l-0.19-0.064l-0.06-0.069l-0.048-0.013l-0.048,0.013l-0.072-0.097v-0.012l-3.04-1.51l-0.076,0.012 l-0.06-0.08v-0.028l-2.474-0.819l-0.098,0.04l-0.08-0.028l-0.012-0.022v-0.01l-2.132-0.448l-0.012,0.026l-0.074,0.059l-0.096-0.013 l-0.036-0.023l-0.188,0.598l0.072,0.048l0.014,0.206l-0.058,0.106v0.107l0.072,0.106h0.06l0.048,0.084l2.68,1.388l0.024,0.038 l0.388,0.202l0.024,0.04l7.254,4.174l0.022,0.052l4.302,2.746l0.014-0.012l0.966,0.416l0.122,0.204l-0.154,0.502l-8.192-1.124 l0.012-0.012l-4.238-2.101l-0.01-0.036l-10.516-7.262l-0.06-0.306l0.106-0.225l1.86-0.54l0.154-0.208l-1.594-0.458l-0.13-0.13 l-0.012-0.296l-0.106-0.014l-0.31,0.17h-0.106l-0.034-0.036l-0.06-0.012l-0.024-0.072l-10.114-7.521l-0.154-0.025l-0.252-0.238 l-0.01-0.028l-0.062-0.056l-0.038-0.012l-0.034-0.036v-0.058l0.232-0.099l0.014-0.04l-0.014-0.118l0.396-1.161l-0.024-0.047 l-0.07-0.037l-0.332,0.411l-0.06,0.024l-0.01,0.118l-0.356,0.6l-0.15,0.094l-3.488-1.151l-0.024-0.046l-0.192-0.132l-0.166,0.035 l-0.036,0.04l-0.144,0.038h0.07l-2.544-0.025l-0.482-0.232l-0.16-0.191l-1.762-0.66l-0.024-0.028l-11.792-1.44l-0.048-0.04 l-2.774-0.529l-0.108,0.04l-1.36-0.437l-0.022,0.305l-0.24-0.095l-0.144-0.218l0.012-0.012l-0.074-0.084l-0.072-0.519l-0.118-0.086 l0.312-3.616l0.038-0.062l-0.012-0.224l2.082-3.71l0.012-0.511l-0.048-0.067l-0.576-0.086l-0.404,0.56l0.012,0.096l-0.602,1 l0.048,0.21l-1.106,1.324l0.026,0.198l-1.73,2.566l0.118,0.174l-0.708,1.914l-0.376-0.156l0.036-0.108l-0.07-0.046h-0.048 l-0.306-0.178l-0.07,0.021l-4.816-1.449l-0.01-0.038l-0.518-0.276l-0.07,0.048l-0.27-0.084l-0.06-0.122v-0.08l0.178-0.325v-0.08 l-0.142-0.166l-0.036-0.3l2.712-3.883l-0.176-0.248l-0.11-0.592l-0.79-0.313l-0.742-1.994l-0.26-0.222h-0.142l-0.198,0.13 l-0.308-0.106l-0.636-0.744l-0.66-0.153l-0.068-0.08l0.072-0.79l-0.06-0.118l-0.246-0.128l-0.07-0.152l0.046-0.21l0.06-0.08h0.084 l-0.026-0.288l-0.532-0.844v-0.456l0.104-0.212l-0.284-0.928l-1.122-0.796l-0.494-2.338l-0.352-0.028l-0.896-1.216l-0.598-0.236 l-0.178-0.528l-0.624-0.239l-0.918-1.372l-0.282,0.021l-0.06,0.108l0.252,1.069l-0.082,0.082l-0.352-0.012l-0.05,0.059l0.072,0.46 l-0.058,0.107l-0.166,0.059l-0.154-0.034l-0.092-0.12l0.012-0.475l0.176-0.283l0.012-0.398l-0.842-0.848v-0.178l-0.13-0.187 l0.012-0.186l0.21-0.181l-0.048-0.248l-0.162-0.197l-0.14-0.047l-0.284-0.426h-0.178l-0.13,0.179l-0.166,0.06l-0.492-0.272 l0.06-0.151l0.152-0.064l-0.152-0.31l0.06-0.07l-0.026-0.35l-0.186-0.19l-0.176,0.057l-0.282-0.221l0.06-0.562l-0.082-0.062 l-0.292,0.028l-0.202-0.246l0.084-0.768l-0.15-0.471l-0.248-0.188l0.036-0.082l-0.202-0.354l0.038-0.479l-0.188-0.272l-0.2-0.078 l-0.32-1l-0.624-0.354l-0.186-0.26v-0.738l-27.826-25.004l-0.072-0.318l-0.528-0.516l-3.486-0.738l-0.376-0.576l-0.532-0.186 l-0.364-0.4l-0.294-1.16l-10.162-8.374l-1.102-2.535l-1.348-0.587L97.881,371.445L97.881,371.445z"
    },
    {
        city: "Vancouver",
        name: "west-point-grey",
        dPath: "M148.441,285.039l-36.918-0.855l1.006-41.668l-13.628,0.802 l-0.124-8.14l-6.608,1.092l0.242-7.236l-8.434-11.022l2.354-23.414l4.844,1.034l0.154,0.186l16.108,3.654l0.542-0.328l6.174,1.534 l0.128,0.166v0.166l9.04,3.92l0.152,0.282l2.858,1.152l0.12,0.316l0.118,0.106l18.252-1.75l0.25-0.68l0.768-0.312l2.534,1.086 l0.542-0.062l0.104-0.092l-0.024-0.152l-0.19-0.24l0.084-0.128l0.144-0.07l0.646,0.128l0.07-0.034l0.01-0.07l0.776-0.524 l0.072-0.118l-0.19-0.59l-0.094-0.06l-0.186,0.012l-0.14-0.092l-0.048-0.154l-0.092-0.07l-0.06-0.154l0.072-0.21l1.232-0.36 l0.19-0.414l-0.014-0.096l0.06-0.132h0.062l0.092-0.116l0.202-0.014l0.092,0.048l0.356,0.95l0.834,0.506l0.316,0.026l0.038,0.034 l0.022,0.138l1.388,0.708l0.272,0.012l0.19,0.306l2.426,0.966l0.236,0.35l2.376,1.084l1.71-0.19l0.878-0.612l0.074-0.644 l0.036-0.026l0.096,0.046l0.228,0.502l-0.128,0.434l4.4,4.718l-0.718,0.564l0.424,3.306l7.602,5.416l0.21,0.014l1.302,1.034 l0.162-0.072l0.636,0.246l0.092,0.552l2.032,0.412l0.142-0.28l0.514-0.128l0.248,0.208l2.176,0.208l1.818-1.19l0.542-1.22 l10.908-4.784l0.024-0.174l0.128-0.06l0.286,0.038l0.166,0.256l0.092,0.06l0.118,0.012l0.13-0.118l3.34,0.318l0.198-0.096 l1.74,0.012l-1.706,70.992L148.441,285.039L148.441,285.039z"
    },
    {
        city: "Vancouver",
        name: "kitsilano",
        dPath: "M338.913,209.905l-15.748,7.704l-1.771,72.214l-121.208-3.597 l1.706-70.994l2.216,0.434l0.104-0.024l0.036-0.048l0.096-0.048l2.228,0.194l2.438,2.392l1.202,0.278v0.024l0.868,0.24l0.012-0.06 l2.806,0.346l0.436-0.146l0.25,0.096l0.034-0.026l0.482,0.118l-0.034,0.2l2.882,0.666l0.34-0.156l0.258,0.06l0.048-0.166 l0.282,0.06l-0.024,0.106l0.822,0.44l0.356,0.484l4.166,0.372l0.06-0.022l0.036-0.038l1.36-0.036l0.014-0.026l3.27,0.29l0.18,0.296 l0.198,0.104l0.036,0.048l2.164,0.298l0.036-0.012l0.07,0.012l0.116-0.072l0.672,0.192l0.208-0.118l0.54,0.25h0.06l0.224,0.11 l0.434,0.01l0.258,0.142l0.026-0.026l0.166,0.026l0.024-0.026l0.13,0.026l0.012-0.036l0.142,0.024l0.012-0.05l0.246,0.038 l0.014-0.038l0.386,0.062l0.082,0.068l0.048-0.024l0.388,0.074l0.08,0.06l2.824,0.092l0.062,0.036l1.152,0.072l0.012-0.082 l0.996,0.062l0.024,0.024l0.39,0.084l0.036-0.106l2.408,0.022l0.026-0.104h0.14v0.09l0.248-0.01l0.036-0.048l0.248,0.01l0.05-0.104 l3.082-0.016l0.118-0.094l0.412-0.048l0.036-0.21l3.418-1.536l0.15,0.07l2.48-0.884l0.024-0.128l0.8-0.222l0.01-0.06l8.856-4.824 v-0.048l0.576-0.83l0.21-0.06l0.084-0.128l0.012-0.156l2.822-1.834l6.84-0.518l0.024-0.108l0.536-0.132l0.012-0.038l2.244-0.292 l0.176-0.436l0.414,0.152l-0.118,0.352l0.366,0.154l0.034,0.06l-0.034,0.082l0.034,0.07l0.636,0.192l1.692,1.798l13.066,0.43 l9.476-14.646l-0.284-0.94l0.974-2.496l5.508-1.056l1.204,0.356l1.58-0.226l3.458-6.302l1.678-0.192l0.106,0.122l0.014,0.046 l-0.014,0.07l-0.058,0.082l-1.072,0.37l-0.364,0.422l-0.144,0.824l0.08,0.012l-0.022,0.176l-0.062,0.014l0.048,0.718l0.726,0.798 l2.142,0.75l1.07,1.572l1.618,0.072l1.141-0.524l1.746-3.506l1.911-0.574l5.304,1.5l2.769,2.408l0.071,0.2l0.068,0.068l0.014,0.082 l3.23,2.838l0.632,0.048v0.046l-0.329,0.096l-0.356,0.966l1.161,2.226l0.568,0.06l0.229,0.224l0.248,0.722l-0.118,0.048 l-0.048,0.128h-0.012l-0.095,0.062l-0.024,0.166l-0.403,0.242l0.038,0.484l0.05-0.022l0.022-0.026h0.014l0.01-0.01l0.014,0.024 l-0.014,0.296l1.61,3.052h0.014l0.418,0.946l0.038,0.024l0.01,0.038l0.061,0.07l0.021,0.084l-0.035,0.13l0.025,0.048l0.466-0.222 l0.263,0.552l-0.424,0.2l0.06,0.048h0.274l0.213,0.12h0.412l0.146-0.072l-0.051-0.094l0.521-0.284l0.198,0.376l-0.034,0.584 L338.913,209.905L338.913,209.905z"
    },
    {
        city: "Vancouver",
        name: "fairview",
        dPath: "M415.387,244.261l-0.508,46.771l-36.716-1.11l-0.021,0.614 l-31.319-2.54l-2.45,2.386l-22.973-0.568l1.776-72.206l20.044-9.796l-0.025,0.566l0.262,0.416v0.128l0.096,0.108v0.048l0.492,1.062 l-0.036,0.326l-0.78,0.224l-0.035,0.06l-1.379,0.206l-0.084,0.098h-0.107l-0.01,0.012l-0.18,0.058l-0.039,0.036l-0.045,0.31 l0.045,0.06l-0.134,0.626l-0.506,0.518l-0.206,0.06l-0.031-0.022l0.123,9.564l1.353-0.116l0.166,0.412l-1.246,0.422l0.502,1.506 l0.069-0.012l0.039,0.012l0.074,0.152l-0.039,0.084l-0.05,0.024l0.933,1.412l1.324-0.084l0.383,0.284l0.396,0.796l1.184,0.132 l0.996,0.834l0.096,1.348l0.931,0.856l1.821-1.832l-0.631-2.516l-0.236-0.014l-0.08-0.048l-0.13-0.224l-0.015-0.186l0.25-0.644 l-0.104-0.352l-0.096,0.048l-0.059-0.162l0.059-0.036l-0.715-1.328l-0.047,0.024l-0.119-0.178l0.091-0.034l-0.08-0.424 l-0.058-0.012l-0.028-0.424l0.084-0.01l0.792-1.838l-0.129-0.348l-0.285-0.026l0.178-1.034l0.764,0.07l0.291-1.176l-0.192-0.048 l-0.356-0.504l1.532-1.236l0.284,0.328h1.138l-0.034-0.338l0.078-0.012l-0.008-0.118l1.975-0.036l0.037,0.752l1.094-0.022 l0.623,0.776l0.481-0.446l0.521,0.622l-0.873,0.734l1.119,1.318l0.459-0.364l0.066,0.07l0.08-0.07l1.943,2.4l0.074,0.502 l0.73,0.612l0.061-0.094l-0.015-0.034l0.233-0.118l2.402,2.906l-0.211,0.166l0.045,0.06l0.131-0.06l0.869,1.022l0.473-0.376 l0.82,1.07l-0.031-0.006l-0.023,0.234l-0.354,0.272l0.01,0.122l3.744,4.516l-0.049,1.81l-0.551,0.664l-0.049,2.58l0.176,0.094 l0.053,0.14l-0.015,0.162l-0.084,0.14l-0.612,0.012l-1.754-0.874l-0.012,0.024l-0.082-0.024v-0.024l-2.396-0.134v0.036h-0.197 v-0.026l-4.538-1.79l-0.06,0.176l0.067,0.026l-0.026,0.068l-0.149-0.036l0.058-0.246l-0.22-0.014l-0.06,0.036l-0.328,1.194 l0.027,0.084l-0.012,0.048l-0.06,0.048l-0.058,0.13h-0.015l-0.134,0.262l0.154,0.578l1.109,0.792l0.714-0.492l0.19-0.012 l0.082,0.048l1.316,2.404l0.104-0.072l1.248,0.024l0.012-0.186l0.656,0.024l0.32,0.564v0.024l-0.068,0.05v0.068l-0.387,0.214 l1.141,2.01l1.376,0.616l0.832-0.224l1.763-1.726l0.071-1.27l0.252-0.272h2.231l1.23-1.19l1.026,0.026l0.292,0.328l2.951,0.082 l0.061-0.07v-0.128l0.068-0.062l0.072,0.026l0.105-0.07l6.84,0.422l1.686,1.876l1.559,0.336l1.334-0.59l0.964-1.868l-0.012-0.494 l0.042-0.06l0.036-0.012l1.036,0.6l1.457,0.074l2.824-2.006l1.267-0.008l0.804,0.708l0.67,2.258l0.683,0.672l5.199,0.306 l0.904-0.566l0.336-3.62l-0.12-0.094l-0.046-0.468l0.046-0.012l-0.034-0.234h-0.054l-0.034-0.308l0.21-0.06l0.013-0.138h0.046 l-0.024-0.06h0.046v-0.038l-0.078-0.08l-0.012-0.068l-0.14-0.07l0.038-0.07l0.021-0.882l0.106-0.012l0.027-0.53h0.152l0.022-0.552 l0.035-0.012l0.952,1.094l-0.042,0.648l1.242-0.952l0.072-0.238l-0.234-0.524v-0.048l0.13-0.106l0.128-0.268l0.322-0.268 l0.76-0.144l0.792-1.56l1.292-0.702l-0.021-0.11l0.056-0.118l0.296-0.224l0.126-0.01l0.061,0.034l4.025-3.22l0.23-0.024 l0.164-0.134l0.036-0.224l-0.104-0.048l0.068-0.236l0.048,0.038l0.056-0.168l0.046-0.05l0.042-0.01l0.022-0.024l0.234-0.012 l0.104,0.074l0.074,0.128v0.048l0.766-0.684L415.387,244.261L415.387,244.261z"
    },
    {
        city: "Vancouver",
        name: "mount-pleasant",
        dPath: "M460.405,217.503l-2.028,16.726l14.088,10.738l56.218,7.724 l-0.518,39.434l-0.55-0.034l-0.052,2.021l-68.879-1.643l-0.208,0.106l-43.6-1.542l0.766-65.846l0.729-0.614v-0.036l0.742-0.206 l0.01-0.012l0.76-0.036l0.112,0.306l1.03,0.372l0.088-0.06l0.105,0.038v0.022l0.256,0.272h0.034l0.015-0.024l-0.059-0.4 l-0.027-0.036l0.027-0.096l-0.054-0.096h-0.026l-0.044-0.226l0.013-0.036l0.359-0.134l0.034-0.036h0.072l0.025-0.024l5.646-1.59 l-0.208-0.858l0.916-0.236l0.088,0.498l0.096,0.072l0.292,0.012l0.218-0.19l0.416-1.302l1.148-0.588l-0.012-0.388l0.458-0.092 l0.033,0.752l0.284,0.096l2.114-0.99l1.226,0.098l0.038,0.024l4.475,0.084l0.136,0.214h0.286l-0.054,2.74l0.622,0.084v-0.14 l0.023-0.026l0.024-0.386h0.199l-0.012-0.048h0.022v-0.2l-0.034-0.022l0.058-0.542h-0.036l0.036-0.154h0.034l-0.021-0.28 l0.235-0.012l-0.176-0.084l-0.016-0.098l0.04-0.144l0.128-0.14l0.012-0.036l0.034-0.034l0.012-0.048l0.29-0.252l1.006-0.148 l0.036,0.038l7.366,0.156l-0.04-0.294h2.754v-0.35h0.328v0.338l0.764-0.024l0.389-0.274l0.151-0.314l0.042-2.586L460.405,217.503 L460.405,217.503z"
    },
    {
        city: "Vancouver",
        name: "downtown",
        dPath: "M380.291,180.139l16.362-16.596l-47.116-46.76l3.338-3.248 l0.292,0.238l0.972,0.024l1.84-0.848l2.871,2.672l0.035,0.364l-0.107,0.234l-0.039,0.024l-0.105,0.204l-0.094,0.07l-0.053,0.348 l0.279,0.514l1.102,0.758l0.008,0.024l3.254,3.382l0.458-0.474l0.038-0.012l1.998,1.996l0.273-0.272l0.008-0.036l0.029-0.024 l0.012,0.012h0.023l1.624,1.646l0.166-0.186l0.024,0.022l0.014-0.022l0.256,0.248l0.014,0.048l2.834-2.908l-0.174-0.2l-0.025,0.01 l-0.446-0.456l0.624-0.636l0.964,0.538l-0.168,0.154l-0.286-0.284l-0.142,0.144l0.132,0.14l0.01-0.012l0.062,0.048l0.042-0.036 l0.01,0.012l0.022-0.012l5.646,4.1l-0.012,0.06l0.366-0.364l0.447,0.3l0.258,0.428l-0.012,0.048l-3.352,3.422l3.486,3.2l0.14,0.392 l2.319,2.056l0.174-0.084l1.793,0.672l0.035,0.152l4.194-1.032l2.544-2.494l-0.117-0.21v-0.288l0.14-0.212l0.212-0.128l0.283,0.01 l10.427,7l4.605,0.362l0.036-0.026l1.024-0.012l0.428,0.568l-0.023,0.036l0.132,0.118l1.534-0.432l0.006-0.19l0.328-0.06 l0.058,0.024l0.682,1.586l0.2,0.142l2.718-0.962l1.15,1.166l1.03,0.216l2.184-0.602l0.128,0.06l0.106,0.142l-0.057,0.47l-4.55,2.8 h-0.235l-0.173,0.096l0.013,0.048l-0.124,0.128l-0.162,0.036l-0.596,0.664l0.779,0.364l0.034-0.058l4.88,1.954l23.416-8.162 l0.012-0.012l0.064-0.012l0.13,0.108l0.019,0.094l-0.118,0.19l-0.053-0.06l-16.43,8.94l-0.078,0.234l-0.342,0.178l-0.024,0.062 l-0.233,0.128l-0.026,0.07l-0.846,0.468l-0.188,0.388l0.013,0.082l3.494,2.036v0.094l-0.143,0.27l1.094,0.558l0.059-0.012 l0.554,0.152l2.256-1.18l0.036-0.068l-0.416-1.254l0.059-0.058l0.052-0.012l0.784,1.174l0.54-0.368l0.071,0.14l-0.04,0.094 l0.061,0.142l0.038-0.01l0.021,0.01l0.286-0.166l-0.12-0.222l0.376-0.2l0.176,0.33l1.29-0.694l0.219,0.354l-0.024,0.128 l-0.06,0.036v0.07l-1.011,0.542l0.141,0.258l2.25-0.942l0.065,0.012l0.095,0.2l-0.059,0.068l0.13,0.214l0.08-0.012l0.094,0.152 l-0.021,0.154l-2.076,1.2l0.152,0.26l0.988-0.542l0.271,0.094l0.182,0.386l-0.054,0.024l-0.012,0.106l-1.206,0.646l0.06,0.038 l0.188,0.366l-0.366,0.21l-0.152-0.272l-0.315,0.188l0.126,0.246l-0.044,0.024l0.01,0.048l-0.612,0.338l1.712,0.48l4.584-1.636 l5.097,1.046l0.132,0.2l5.624,1.156l0.696-1.054l0.357-0.144l0.508,0.072l0.08,0.094l0.072,0.024l0.536-0.73l0.308,0.198 l-0.55,0.79l0.132,2.956l0.248,0.494l2.172,0.9l8.254-1.18l0.246-1.186l-0.363-0.038l0.224-6.364l0.021-0.036l0.038-0.022 l0.658,0.046l-1.903,66.738l-8.774-0.952l-0.014-0.4h-1.469l-1.222,0.602l-0.884-0.108l-0.932-0.708l0.31-0.232l-0.218-0.422 l-0.022-0.85l0.562-0.836l-0.225-0.316l0.99-0.364l0.708,0.084l0.09-2.834l0.078-0.092l0.106-0.012l-0.036-2.294h-0.082v-0.062 l-0.059,0.014v-0.154h0.166l0.059-0.54l0.926,0.014l-0.034-0.588l-0.067-0.108l-0.061-1.292l-0.02-0.012l-0.088-0.354l-0.419-0.29 l-7.89-0.194l-0.036,0.026l-1.176-0.084l-0.526-0.49l-0.226-0.066l-0.046-0.072l-2.893,0.168l-0.016-0.012l-0.126-0.238 l-0.186-0.144l-0.41,0.034l-0.034,0.026l-0.6,0.01l-0.038-0.068l-0.416-0.098l-0.21,0.058l-0.097,0.104l-0.104,0.55l-0.042,0.01 l-0.176,1.036l-0.026,0.026l0.048,0.846l0.212,0.27l-0.17,1.084l0.334,0.424l-0.12,0.082l-0.072-0.07l-0.548,0.426l0.187,0.528 l-0.08,0.506l-0.678,0.614l-0.154,1.082l-0.798-0.118l-0.466,0.424l-0.263-0.352l0.013-0.154l-0.519-0.696l-0.2-0.036l-0.025,0.14 l-1.796-0.272l0.014,0.026l-0.326,1.546l-0.07,0.05l-0.953-0.134l-0.013-0.04l-1.069-0.106l-2.893,1.896l-0.208,0.87l-5.132,2.646 v0.024l-0.068,0.012v-0.012l-2.231,1.658l-5.132-0.026l-3.952-2.97v0.036l-0.853-0.142l-0.071-0.048v-0.036l-2.223,0.164v0.038 l-0.584,0.176l-0.016-0.036l-1.312,0.71l0.015,0.022l-0.059,0.038l-0.033-0.014l-0.391,1.166l-0.899,0.71l-0.047,0.178h0.036 l-0.012,0.07h-0.023l-0.011,3.96l-0.368,0.376l-0.023,0.306l-0.229,0.254l0.179,0.186l-0.296,0.32l-0.051,0.788l-0.506,0.842 l-1.448,0.466l-0.329,0.316l-0.322-0.316v0.01l-0.042-0.01l-0.28,0.27l0.01,0.012l-0.048,0.048l-0.012-0.012l-0.446,0.398 l-1.224,0.048v-0.012l-1.944-1.694l-0.716,0.716l-0.718-0.706l0.058-0.068l-2.906-2.872l-0.252-0.024l-0.252,0.254l-2.098,0.012 l-0.34-0.376l-0.012,0.07l-0.141,0.138l-0.224,0.018l-0.164-0.096l-0.032-0.068l-3.584,3.544l0.064,0.304l1.107,1.164l0.021,0.174 l-0.352,0.468l-4.518-0.024l-0.416-0.286l-0.026-0.062l-0.094-0.06l-0.022-0.06l-2.293-2.048v-0.026l-0.194-0.108l-0.101,0.014 l-0.021-0.07l-0.166-0.096l-0.049,0.048l-0.053,0.01l-2.765-2.688l-0.476,0.504l-0.012,0.168l-0.156,0.012l-0.543,0.542v0.21 l-0.197-0.012l-0.471,0.292l-0.562-0.094l-0.317-0.398l-0.041-0.366l0.349-0.528l-1-0.986l-1.364,1.35h-0.061l-0.067-0.048 l-0.015-0.084l1.32-1.426l-1.472-1.468l0.862-0.894l-0.87-0.846l-0.362,0.272l-0.818,0.176l-1.045-0.46l0.151-0.14l-1.012-1.012 l-0.446,0.446l-1.456-1.47h-0.04l-0.35-0.352l-0.1-0.036l-0.236,0.236h-0.09l-0.379-0.28l-0.037-0.398l0.07-0.152l0.352-0.262 h0.107l0.282,0.284l0.284,0.012l0.023-0.024l-1.224-1.228l-0.168-1.172l0.351-0.56l-1.015-0.976l-1.272,1.27l-1.465-1.468 l-0.586,0.612l-0.146,0.046l-0.084-0.084l-0.016-0.096l1.041-1.06l-0.416-0.39l-0.291,0.26l-0.28,0.086l-0.472-0.11l-0.334-0.454 l0.067-0.558l0.088-0.106v-0.036l0.224-0.214l-0.823-0.918l1.198-1.224l-1.914-1.894l-1.646,0.826l-0.904-0.944l-0.023,0.026 l-0.458,0.036l-0.272-0.516L380.291,180.139L380.291,180.139z"
    },
    {
        city: "Vancouver",
        name: "west-end",
        dPath: "M350.896,203.297l0.668-1.752l-3.957-6.928l-0.723-0.084 l-0.748,0.358l-0.05,0.28l0.269,0.36l0.01,0.06l0.074,0.092v0.024l-0.024,0.024l-0.05,0.012l-0.066-0.036l-0.527-1.054l0.012-0.062 l-1.038-0.562v-0.036l-0.052-0.048l-0.008,0.024l-0.181-0.12l-0.062,0.012l-0.022-0.038l0.013-0.024l0.071-0.036h0.026l0.068-0.038 h0.033l0.038,0.038h0.022l0.084-0.068l0.021-3.656l-0.584-0.784l-0.622-0.11l-0.1,0.062l0.1,0.072l-0.016,0.074l-0.652,0.278 l-1.69-0.338l-0.014-0.074l0.024-0.046l0.159-0.084l0.109-2.716l-0.365-0.824l-0.529-0.272l-0.023,0.012l-0.072,0.19l-0.334,0.222 l-1.535-0.446l-0.012-0.036l0.012-0.048h0.599l0.12-0.06l0.12-4.154l-1.952-2.178l-0.25-0.096l-1.132,0.278v0.118l0.036,0.082 l-0.133,0.456l0.049,0.26l-0.061,0.108l-0.048,0.026h-0.036l-0.023-0.012l-0.096-1.056l0.071-0.144l-0.01-0.096l0.407-1.01 l-0.762-0.67l-0.016,0.006h-0.05l-0.358,0.194l-0.012-0.022l0.096-0.086h0.024l0.048-0.036l0.025-0.06l0.049-0.024h0.023v-0.036 l0.036-0.048v-0.022l-0.42-0.526h-0.015l-0.129,0.156l-0.104,0.048l-0.078,0.132l-0.13,0.072l-0.025-0.024l0.258-0.274v-0.01 l0.109-0.17l-0.518-1.726l0.06-0.022l-4.888-9.356l-2.227-1.022l-0.071-0.234l0.071-0.336l0.049-0.062l1.804-0.646l0.368-17.762 l-4.824-4.964l-0.186-0.06l-0.633,0.348l-0.373-0.024l-1.353-1.258l-0.013-0.074l-0.25-0.144l-0.084-0.144v-0.026l-0.047-0.06 h-0.013l-0.012-0.084l-0.048-0.06l-0.094-0.01l-0.072-0.048l-0.012-0.036l0.012-0.094l-0.07-0.024l-0.012-0.06l-0.676-0.568h-0.07 l-0.023,0.022h-0.195l-0.07-0.038l14.319-13.912l10.443-2.61l4.35-4.424l47.118,46.762l-45.448,40.33L350.896,203.297 L350.896,203.297z"
    },
    {
        city: "Vancouver",
        name: "strathcona",
        dPath: "M460.703,207.553l1.609-56.782l-0.657-0.048l0.958,0.062 l-0.074,0.998l1.598,0.418l1.646,4.766l-0.034,0.106l0.822,1.36l0.2,0.092l0.294,0.496l0.344,0.178l0.126-0.306l-0.364-4.092 l1.632-0.166l0.013-0.01l1.6-0.154l-0.012-0.13l0.47-0.048l0.658,1.352l0.062,0.026l0.132,0.202l-0.164-1.704l-0.096-0.094h-0.025 l-0.244-0.24v-0.01l-0.296-0.376l-0.011,0.01l-0.046-0.068l-0.012-0.084l-1.842-2.376l-1.48-0.612l-0.06-0.074l-2.462-1.056 l-0.013-0.024l-4.542-2.124l-0.004-9.184l-0.025-0.048l-0.562-0.214l0.236-0.574l0.067-0.024l24.923,10.444l0.216-7.446 l0.182-0.092l15.326,6.572l-0.408,15.126l0.408,0.094l0.065-0.068l2.692,0.422l-0.03,0.482l-0.033,0.038v0.116l0.056,0.076 l1.1,0.156l0.376-7.794l0.612,0.024l0.012-0.024l1.576-0.348l0.834,0.336l0.1,0.19l0.637,0.034l-0.183,5.844h-0.128l-0.038,0.026 l0.208,5.244l1.345,0.18l0.031-0.13l3.03-0.308l0.166-0.306l-0.012-0.048l0.198-0.166l0.17-1.914l0.038-0.048v-0.026h-0.026v-0.438 h0.19l0.023-0.372l0.078-0.046l0.25-1.284l0.189-0.214l0.566-0.036l0.122-0.884h0.046v-0.092l0.178,0.012l0.013-0.038l-0.024-0.048 l0.024-0.06l-0.152-0.012l0.012-0.528l0.106,0.01l0.023-0.034l-0.178-1.108h-0.012l-0.122-0.288h-0.048l0.014-0.07l-0.014-0.048 l-0.104-0.116l-0.302-1.464l-0.014-0.01l-0.012-0.142l-0.021-0.024v-0.024l-0.042-0.036l0.158-1.036l0.47-0.448l0.754-0.014 l0.074-0.036l0.038,0.024l0.34-0.084l0.19-0.706l0.113-0.11l0.044-0.012l0.748-2.05l0.645-0.146l0.012-0.024l0.59-0.3l0.876,0.096 l0.259,0.224l1.012,8.482l0.611,0.084l0.095-0.096l0.062-0.226l0.132-0.06l0.082-0.104l0.046-0.41l-0.025-0.024l-0.044-0.104 l0.094-2.57l-0.024-0.048l0.024-1.252l0.012-0.024l-0.06-3.3l-0.044-0.016l0.07-1.032l0.275-0.226l0.572,0.01l0.034,0.024 l0.764,0.046l0.124,0.122l0.024,0.07l0.021,0.01h0.014l0.013-0.01l-0.013-0.294l0.166-0.118v-0.568l-0.084-0.024l-0.01-0.294h0.082 v-0.038h-0.048v-0.128l-0.21-0.012l0.012-9.032l0.849-0.012v3.106h0.08v0.104h0.04v-0.036h0.021v0.104h-0.021v-0.036l-0.04,0.012 v0.722h0.04v-0.022h0.021v0.092h-0.021v-0.022h-0.04v0.714h0.008v-0.024h0.036v0.092h-0.026v-0.018h-0.034v0.716h0.034v-0.024 h0.026v0.096h-0.026v-0.026h-0.034v0.716h0.034v-0.012h0.026v0.082h-0.026v-0.026h-0.034v0.716h0.034v-0.022h0.026l-0.015,0.092 h-0.021l0.01-0.026h-0.034v0.716h0.024v-0.01h0.036v0.08h-0.026v-0.02h-0.034l-0.012,1.128l0.065,0.012v0.198l-0.084,0.012 l0.026,1.83l0.094,0.13l0.836,0.206l4.086-2.348l-0.075-1.116l0.094-0.07l0.054-5.188l-1.042-0.316l-0.025,0.024l-0.929-0.234 l0.015-0.048l-0.07-0.034l0.01-0.026l-0.094-0.036l0.021-0.08l-0.09-0.142l0.057-2.962l0.14-0.14l2.518,0.716l-1.306,112.844 l-57.979-8.29l-12.326-10.174L460.703,207.553L460.703,207.553z"
    },
    {
        city: "Vancouver",
        name: "grandview-woodland",
        dPath: "M592.063,128.969l-0.351,137.792l-63.191-1.07l1.476-125.842 l21.854,7.034l0.079-7.516l0.072-0.086l3.688,0.062l0.046,0.024l0.082,0.132l-0.038,2.824l0.023,0.012v0.118l-0.023,0.012 l-0.01,0.646l0.033,0.012l-0.012,0.13h-0.021l-0.024,0.87h0.024v0.128h-0.024l-0.038,1.8h0.038v0.13h-0.038l-0.021,1.858h0.021 v0.13h-0.021l-0.013,0.858h0.034l-0.012,0.118h-0.022l-0.071,4.092l0.241,0.036v-0.024h0.116v0.082h0.977l0.012,0.07h0.844v-0.036 h0.042v-0.136h0.046v-0.118l0.176-0.038l0.015-0.34l0.83,0.012v0.482h0.132v0.024l0.082,0.012v0.178l0.08-0.012l0.023-0.062 l0.038-0.01l0.024-0.038l0.023-2.998l-0.023-0.012h-0.154l0.012-0.22l0.133-0.014l0.246-2.222l-0.036-0.022l0.092-0.708 l-0.082-0.104l0.012-0.624l0.082-0.118l-0.046-1.484l0.07-0.094l0.012-0.752l-0.07-0.094l0.032-0.684l0.066-0.06l-0.013-0.822 l-0.071-0.07l0.042-0.67l0.67,0.024l0.058,0.074l0.012,0.542l-0.084,0.104l-0.012,0.822l0.072,0.048v0.648l-0.084,0.092v0.802 l0.06,0.068v0.612l-0.063,0.092l-0.013,0.822l0.059,0.06l0.012,0.588l-0.082,0.128l-0.012,0.882l0.036,0.036l-0.061,1.528 l0.095,0.046l1.319-0.046l0.03-0.014l0.632,0.026l0.026-0.012l0.151,0.022l0.048-0.022l0.896,0.046l0.082-0.062l0.212,0.012 l0.038,0.026l0.012,0.024l0.729,0.024l0.044-0.024l0.12,0.036l0.052,0.048l0.036,0.096h0.458v0.328l1.558,0.014l0.024,1.938 l0.229-0.048l0.032-0.026l1.15,0.048l0.014-1.68l1.02,0.038l0.015,0.352l-0.082,0.012v0.092l0.27-0.022l0.219-0.19l-0.042-0.046 l0.264-1.414l0.14-0.084l0.45,0.048l0.176,0.234l0.202,0.108l0.042-0.024l0.042-0.058l0.012-0.28l-0.128,0.022l-0.023-0.038 l0.231-0.48l-0.08-0.048l-0.063,0.142l-0.13-0.05l0.025-0.092l-0.178-0.106l0.236-0.458l-0.044-0.038l0.126-0.27l-0.389-0.176 l-0.012,0.104h-0.034l0.034-0.74l-0.056-0.036l0.962-1.8l2.058,1.118l0.517-0.026l-0.022-0.01l-0.021-0.048l-0.055-0.024h-0.036 l-0.304-0.44l-0.082-0.038l-0.025-0.104l-0.646-0.314l1.284-3.456l1.094,0.54l0.164-0.334l-0.614-0.87l0.45-0.34l0.55,0.776 l0.234,0.108l0.932-2.012l0.425,0.21l0.01-0.06l-0.01-0.024l0.985-1.612l0.265-0.108l1.123,0.214l0.318-0.226l0.214-0.52 l2.433-1.828l0.02,0.012l0.236-0.144l-0.141-0.198l0.895-0.672l-1.788-2.364l2.598-1.87l0.284,0.4l-0.313,0.2l1.086,1.48 l2.397-1.822l0.305,0.39l0.478-0.622l-0.038-0.012l2.234-1.816l0.729,0.204l0.216,0.192L592.063,128.969L592.063,128.969z"
    },
    {
        city: "Vancouver",
        name: "hastings-sunrise",
        dPath: "M591.721,266.747l0.347-137.784l0.073-0.048l0.032-0.06 l0.061-0.036l0.229,0.12l0.044-0.012l0.108-0.156l0.1,0.012l0.034-0.038l0.048-0.01l0.046,0.01l0.046-0.01l0.051-0.448l0.042-0.036 v-0.012l0.848-0.71l0.021-0.102l0.143-0.048l0.01-0.036l4.402-2.21l0.012-0.038l1.208-0.418l0.096-0.118l0.834-0.392l0.059-0.072 l2.613-1.316l0.013-0.022l0.193-0.098h0.062l5.442-2.532l0.031-0.048l0.305-0.06l0.035-0.036l1.91-0.662l0.024-0.024l0.918-0.072 l0.504,0.3l0.108,2.642l0.315,0.384l0.12,0.012l0.271,0.214l0.206,0.022l0.153-0.06l0.198,0.11l0.178-0.118l0.564,0.072 l-0.013-0.012l-0.035,0.142l1.062,0.238l0.122-0.106l0.166-0.56l-0.014-0.048l0.136-0.448l1.574-0.218l0.664-0.912l3.646-0.356 l0.36,0.24l0.264,0.552l0.024,1.194l1.153,2.12l-0.09,0.122l-0.023,0.128l0.178,0.482l1.008,0.444l0.072-0.012l0.658-1.28 l2.728,1.258l-0.6,1.266l2.006,1.59l0.47-0.012l1.702-1.89l1.104-0.224l0.345,0.166l1.126-0.06l0.01-0.012l7.124,1.712l0.876,0.926 l0.474,2.614l1.42,1.094l5.452,0.782l0.044,0.048l0.036,0.012l0.524,1.02v0.082l-0.024,0.048l0.354,0.628l1.518,0.422l0.282-0.048 l0.355-0.296l0.212-0.724l0.084-0.048l0.101,0.012l0.458,1.242l0.8,0.06l1.394-0.562l0.141-0.41l0.044-0.034h0.065l0.299,0.454 l-0.013,0.048l0.236,0.222l0.012,0.07l1.5,0.708l0.101,0.246l0.281,0.036l0.166,0.204l0.381,0.166l0.438-0.024l1.128-1l0.008-0.238 l-1.262-2.718l0.038-0.062l3.556-0.614l2.282,0.778l0.804,0.872l0.679,0.206l0.058,0.084v0.092l0.036,0.038l0.932-0.792 l-0.34-0.436l1.024-0.932l0.313,0.316l0.188-0.144l0.146-0.52l0.454-0.216l0.07-0.146l0.214-0.118l0.191-0.334v-0.07l0.022-0.012 l0.026-0.038l0.336-0.166l0.033-0.06v-0.094h-0.033l-0.07-0.048l0.042-0.046l-0.218-0.142l0.144-0.222l0.143,0.092l0.075-0.104 l0.106,0.082l0.042-0.068l0.24,0.166l-0.022-0.174l0.246-0.086l0.082,0.298l0.048,0.022l2.055-1.876l0.084-0.314l0.14-0.072h0.196 l1.275-1.02l-0.203-0.602l-0.353,0.116l0.26,0.822l-2.212,0.708l-0.023-0.048l-0.752,0.234l-0.097-0.258l-0.021,0.012l-0.082-0.296 l0.05-0.012l-0.067-0.186l-0.038,0.012l-0.013-0.05l-0.317,0.094l-0.162-0.566l0.282-0.084l0.025-0.024l0.013-0.038l0.128-0.022 l0.016,0.01l0.31-0.082l-0.012-0.036v0.04l0.012-0.012l0.08,0.012v0.024l0.174-0.046v-0.024l-0.021-0.024l0.012-0.012l0.034-0.012 l0.04,0.012l0.012,0.012l0.009,0.024l0.119-0.038v-0.036l0.118-0.036l0.036,0.024l0.366-0.106v-0.08l0.058-0.024l0.053,0.06 l0.178-0.048v-0.012h-0.015l0.015-0.074l0.021-0.012h0.062l0.01,0.048h0.01l-0.01-0.024l0.022-0.024l0.111-0.024l0.04,0.024 l0.42-0.128l-0.023-0.086l0.012-0.01h0.05l0.022,0.01v0.012l0.023,0.036l0.024-0.012v-0.024l0.114-0.038v-0.024l0.033-0.022h0.046 l0.022,0.01l0.014-0.01h0.048l0.04-0.026h0.036l0.024,0.026l0.224-0.1l-0.012-0.026v-0.024l0.021-0.024h0.062l0.021,0.048 l0.172-0.048l-0.023-0.06l0.056-0.038h0.036l0.061,0.048l0.067-0.01l0.015-0.048l0.119-0.038l0.188,0.6l-0.038,0.01l0.1,0.296 l2.452-1.384l0.032,0.012l1.816-0.848l0.989,0.336l0.774,0.832l0.036,0.188l0.378-0.072l2.228-1.844l0.128-0.014l0.036-0.022 l0.322-0.572l0.106-0.038l0.048,0.012l0.046-0.012l0.494-0.952l0.076-0.012l0.023-0.022l0.012-0.038l-0.023-0.07v0.008l0.012-0.168 l0.116-0.12l0.654,0.038l0.012-0.014l0.616,0.872l2.766-0.612l0.024-0.06l2.63-0.528l-0.912,128.93l-24.382,16.718L591.721,266.747 L591.721,266.747z"
    },
    {
        city: "Victoria",
        name: "james-bay",
        dPath: "M299.641,476.604 c-5.327-1.512-9.601,1.834-12.932,5.127c-1.274,1.258-0.711,2.441-3.136,2.831c-1.641,0.265-2.646,0.365-3.826-1.288 c-1.78-2.496,0.642-3.496,1.071-5.639c0.599-2.986-2.148-7.065-5.485-4.73c-1.441,1.008,1.334,2.968-1.441,2.627 c-1.432-0.175-3.168-4.252-4.299-5.216c-0.594-0.507-0.337-1.423-1.364-1.812c-1.318-0.499-2.377,0.864-3.29,0.677 c-2.307-0.475-3.775-2.182-6.211-3.048c-0.532-0.19-4.643-1.97-4.936-1.964c-2.128,0.05-1.915,2.333-3.597,2.626 c-1.337,0.232-1.48-1.112-2.588-1.287c-1.633-0.258-3.295-0.039-4.923-0.396c-2.206-0.484-4.853-2.408-6.491-3.736 c-3.149-2.553-3.679-3.135-8.274-3.519c-3.615-0.303-7.254-0.451-10.875-0.678c-3.242-0.205-11.008,0.831-13.795-0.866 c-1.372-0.838-1.603-2.56-2.843-3.803c-3.101-3.104-7.191-5.431-9.657-9.627c-2.774-4.721,1.031-3.265,1.532-7.54 c0.282-2.402-3.758-7.91-5-9.832c-4.067-6.305-13.488-10.51-19.463-14.735c-5.293-3.739-9.606-9.511-15.061-12.724 c-3.496-2.061-5.106-0.937-8.444-0.689c-1.691,0.126-3.475-0.521-5.126-0.024c-3.54,1.062-6.516,4.941-10.318,5.65l-0.892-2.78 l-28.262,2.257l-0.791-8.775l22.282-1.734l0.434-7.051l-22,1.938l0.434-8.967l22.306-1.658l-0.395-3.178 c2.143,1.072,9.602-3.522,7.014-5.38c-1.728-1.239-3.52,1.726-5.292,0.878c-8.5-4.052,11.581-6.819,11.44-6.695 c1.995-1.774,0.781-4.179-0.867-6.097c-1.695-1.974-4.921-1.693-5.982-3.53c-0.63-1.093,0.957-3.096,0.103-4.489 c-0.936-1.526-2.674-1.517-4.247-1.595c-2.69-0.134-4.089,1.393-6.849-1.505c-0.253-0.267-0.487-0.545-0.702-0.842l15.929-14.359 c-3.589-3.71-13.502-12.599-7.55-18.928c5.625-5.979,15.03,1.153,20.074,3.865c6.961,3.745,11.578,5.252,18.849,5.955 c1.266,0.122,1.125-2.143,2.129,0.013c0.514,1.102-2.004,1.792-1.236,3.087c1.037,1.751,3.341,0.483,4.501-0.651 c1.267-1.235,2.269-7.264,5.434-6.057c1.835,0.699-0.206,4.283,2.271,5.038c1.866,0.567,1.34-1.343,1.862-1.543 c0.499-0.191,0.85-0.731,2.155-1.07c1.833-0.476,2.914,1.011,5.075-0.191c2.338-1.302,4.13-4.729,4.834-7.142 c0.949-3.252,1.199-4.521,3.481-7.641c2.945-4.025,11.134-6.142,12.6,0.497c0.665,3.009-1.328,3.091-1.67,5.751 c-0.462,3.589,3.378,4.602,5.904,5.944c2.088,1.111,1.538,3.378,4.936,0.484l-3.316-4.118l2.347-1.43 c2.523,3.242,5.204,6.41,7.588,9.757c3.149,4.419,4.787,5.675,9.615,8.433c1.55,0.885,3.448,2.473,5.18,2.957 c1.682,0.471,3.501-0.163,5.152,0.542c2.486,1.062,11.732,3.381,11.492,6.154c10.012,1.345,19.94,5.259,29.639,8.01 c-1.708,2.625-10.152,10.763-6.683,14.118c0.904,0.877,4.583,0.833,6.109,2.066c2.084,1.683,3.078,4.289,5.547,5.587 c3.986,2.089,7.214-0.291,7.257,3.685c0.022,2.11-2.827,5.855-3.418,8.111c-0.76,2.903-0.771,5.494-0.427,8.449 c0.535,4.597-5.086,16.908-1.078,19.288h0.013v0.039h0.013c0,0.05-0.002,0.062-0.013,0.101h-0.013v0.027h-0.013v0.013h-0.012v0.012 h-0.013v0.015h-0.024v0.013h-0.051v0.012c-3.07,0.13-4.481,5.319-4.897,7.934c-1.869,11.729,8.192,12.45,15.292,20.547 c4.387,5.003,7.339,12.221,5.37,18.964c-0.839,2.869-3.214,3.973-4.541,6.21C300.029,466.156,300.346,472.279,299.641,476.604z"
    },
    {
        city: "Victoria",
        name: "rockland",
        dPath: "M471.916,278.897 c14.893,0.497,29.775,0.829,44.676,0.942c0.271,7.723,0.527,15.45,0.811,23.172c0.156,4.306,0.316,8.611,0.475,12.918 c0.1,2.666-2.98,6.261-4.209,8.509c-4.223,7.713-8.27,14.355-10.371,22.852c-1.928,7.789,2.537,15.76,4.902,23.293 c-12.811,5.745-25.189,13.009-39.389,14.085c-15.52,1.176-33.178-0.09-48.189-4.52c-9.482-2.797-8.395-12.595-14.363-18.889 c-2.217-2.339-4.881-3.061-7.947-3.556c-8.777-1.416-17.557-2.833-26.334-4.25c2.061-12.803,4.137-25.607,6.264-38.401 c14.895,3.3,29.879-3.574,42.609-10.406c9.201-4.938,18.965-9.387,28.676-13.231C457.67,288.192,464.062,282.428,471.916,278.897z"
    },
    {
        city: "Victoria",
        name: "jubilee",
        dPath: "M523.822,205.271l7.297-51.577l-31.02-2.27 c0.463-23.871,0.922-47.741,1.379-71.611c-1.59,0.913-5.664,2.053-5.705,4.073c-0.055,2.886-0.113,5.772-0.17,8.659 c-0.227,11.191-0.451,22.38-0.676,33.572c-0.371,18.521-0.742,37.044-1.111,55.565c-0.203,10.022-3.584,24.768,1.561,34.13 c3.666,6.668,5.58,16.167,0.543,22.899c-4.781,6.394-14.986,9.418-21.826,13.029c-1.834,0.967-14.979,6.857-14.771,7.979 c1.184,6.428,2.369,12.854,3.553,19.282c34.805-0.395,69.742,0.884,104.566,0.981c0.742-23.71,1.441-47.422,2.283-71.128 L523.822,205.271z"
    },
    {
        city: "Victoria",
        name: "fernwood",
        dPath: "M468.422,280.888 c-9.641,6.663-19.805,10.388-30.25,15.432c-9.705,4.684-19.258,10.518-29.143,14.716c-18.244,7.755-35.584,3.228-54.152,0.165 c7.148-43.989,9.828-88.785,12.994-133.336c41.846,3.329,84.195-0.093,125.943,3.852c-0.223,9.495-2.979,22.643,0.459,31.858 c2.764,7.413,5.75,10.89,3.977,19.628c-1.809,8.911-11.564,11.862-18.684,15.638c-6.316,3.349-12.641,6.686-18.961,10.027 c-3.275,1.731,1.576,16.378,2.27,20.134l9.041-0.104C470.693,279.448,469.52,280.116,468.422,280.888z"
    },
    {
        city: "Victoria",
        name: "victoria-west",
        dPath: "M82.243,186.956 c1.514-7.995,2.93-16.009,4.389-24.014c0.889-4.881,1.778-9.762,2.667-14.644c0.609-3.34-3.121-3.673-5.894-5.114l9.145-25.635 c3.168,1.443,5.032,3.552,7.806,5.254c4.362,2.679,6.396,6.305,9.833,9.693c1.659,1.636,2.033,3.119,3.354,4.858 c2.32,3.055,6.115,2.462,8.685,4.909c1.708,1.628,1.693,3.85,2.066,6.008c0.021,0.122,0.575,3.335,0.522,3.278 c1.317,1.394,4.149,0.026,5.063,1.62c1.026,1.786-1.988,3.651-1.67,5.689c0.695,4.482,8.246,4.991,11.612,4.661 c5.053-0.496,4.123-5.27,7.557-7.072c4.857-2.551,4.189,3.692,7.002,4.528c2.699,0.802,2.739-6.536,4.667-1.786 c0.603,1.484-0.96,4.071,0.076,6.134c1.062,2.112,3.899,4.732,6.313,5.19c1.714,0.325,4.627-2.103,5.752-1.25 c1.347,1.02-0.747,2.279-0.434,3.482c1.137,4.356,6.765,5.244,9.03,9.311c2.908,5.223,1.018,8.583,0.829,14.067 c-0.177,5.122,1.865,3.761,4.4,6.76c0.908,1.075,0.565,2.55,1.365,3.521c1.087,1.32,2.306,1.055,3.507,2.079 c2.944,2.51,1.805,17.123,7.206,12.497c2.786,4.45,5.797,12.647,9.961,15.778c0.887,0.667,2.179,0.091,3.137,0.522 c0.663,0.298,0.155,2.039,1.071,1.964c2.152-0.174,1.502-2.068,3.202-2.705c4.61-1.728,6.852,3.124,5.967,6.714 c-0.825,3.355-3.103,5.935,0.384,8.284c3.129,2.112,3.973-0.287,5.356,4.908c0.676,2.539,1.824,8.381,0.408,10.805 c-0.897,1.534-1.629,1.043-2.716,1.953c-5.648,4.714-9.171,12.879-14.935,17.764c-1.777,1.506-0.716,3.151-5.038,1.456 c-1.941-0.763-1.455-1.911-3.941-1.99c-1.495-0.047-3.085,1.146-4.999,0.979c-1.875-0.16-5.721-0.513-7.436-1.235 c-1.85-0.779-2.367-2.068-4.298-2.488c-1.304-0.281-4.562,1.039-5.943,0.422c-2.591-1.158-5.021-3.897-8.021-5.528 c-1.944-1.061-3.842-2.274-4.809-4.267c-0.458-0.947,0.557-2.183-0.191-3.073c-1.818-2.161-2.774,0.208-3.622-0.024 c-1.475-0.408-1.344-1.176-2.946-2.359c-1.995-1.473-4.798-1.145-6.721-1.976c-4.178-1.814-1.865-3.459-1.696-7.296 c0.1-2.259-0.869-6.564-3.738-4.731c-3.118,1.99-1.805,9.045-7.384,8.989c-2.569-0.024-2.029-2.182-5.127-0.546 c-1.782,0.938-3.303,4.293-5.994,3.71c-0.516-0.111-1.453-2.059-2.398-2.485c-0.62-0.28-5.952-0.759-6.734-0.458 c-1.896,0.722-2.322,4.908-4.922,3.531c-4.636-2.45,5.989-8.95,0.536-10.649c-0.771-0.239-1.195,1.917-2.538,1.62 c-4.233-0.942-1.762-6.766-2.844-9.259c-1.4-3.225-2.96-1.386-4.195-2.079c-2.468-1.387-1.049-2.181-2.768-4.782 c-1.947-2.949-7.855-2.85-10.126-0.204c-1.838,2.138-0.664,4.058-3.163,5.496c-2.343,1.349-2.562-1.679-3.8,2.642 c-0.651,2.275,1.501,7.239-2.271,7.678c-0.208,0.024-0.395-0.011-0.6-0.027C81.547,234.339,81.884,210.647,82.243,186.956z"
    },
    {
        city: "Victoria",
        name: "oaklands",
        dPath: "M377.387,127.524 c4.037-5.001,10.316-10.631,12.627-16.771c1.797-4.778-0.033-10.269-0.836-15.051c-3.328-19.839-6.809-39.569-10.717-59.301 l17.943-2.946l-0.844,21.299c35.484,1.12,70.971,2.247,106.455,3.366c-0.145,5.798-0.285,11.596-0.428,17.393 c-0.025,0.87,0.428,3.994-0.424,4.481c-0.795,0.457-5.357,2.414-5.373,3.216c-0.186,9.268-0.371,18.535-0.557,27.802 c-0.473,23.567-0.945,47.134-1.418,70.702c-41.746-3.945-84.098-0.523-125.943-3.852c0.641-9.491,1.279-18.983,1.918-28.475 c0.289-4.292,0.58-8.585,0.867-12.877C370.832,133.929,375.768,129.621,377.387,127.524z"
    },
    {
        city: "Victoria",
        name: "downtown-victoria",
        dPath: "M360.004,272.507l-48.668-4.411 l0.944-10.395l-11.274-1.021l1.709-24.753l-19.08,0.407l-0.153-8.608l-4.808,0.102l0.127,5.153l-8.405,0.177v-0.279l-1.121,0.024 l0.025,1.136l-3.507,0.075l0.076,2.615l-17.23,0.383l-0.077-3.036l-10.661,0.269c-0.064,3.243,0.36,3.155,1.378,5.699 c1.377,3.438-0.327,5.232-0.768,8.737c-0.428,3.412,0.154,5.359,1.263,7.945c0.722,1.685,3,4.1,1.482,6.016 c-4.668,5.89-0.779,11.435-0.752,17.741c0.027,6.579,2.5,12.634,2.536,19.146c0.812,0.002,1.625-0.003,2.436-0.013 c0.369,2.489,0.846,3.888-0.26,6.133c-0.792,1.61-3.975,0.276-3.975,2.487c0,1.883,2.453,1.192,3.06,2.438 c0.765,1.562,0.451,3.196,0.025,4.896c2.387,0.621,4.582,3.187,6.423,4.839c2.082,1.866,5.254,1.846,6.266,4.306 c0.784,1.907-1.139,7.36-1.45,9.366c-0.466,3.012-1.023,6.018-1.331,9.052c6.618,0.887,13.096,3.316,19.497,5.133 c3.344,0.946,6.688,1.896,10.03,2.844c0.784,0.221,4.486-6.517,5.267-7.391c2.224-2.489,5.132-3.19,4.929-6.68 c-0.165-2.838-0.723-5.865-0.258-8.685c1.245-7.535,2.488-15.068,3.733-22.604l8.021,1.313c0.219-1.388,0.453-2.773,0.702-4.157 l-0.702,4.157l10.905,1.799l-0.854,5.088l38.529,6.352C356.369,302.162,361.145,286.792,360.004,272.507z"
    },
    {
        city: "Victoria",
        name: "hillside-quadra",
        dPath: "M295.776,186.421 c-0.001,0.028-0.021,0.036-0.051,0.025c1.676-10.111-1.01-19.879-2.905-29.778c-2.018-10.544-2.989-21.783-6.24-32.02 c-2.998-9.443-8.31-18.458-11.772-27.839c-4.944-13.395-9.889-26.788-14.833-40.183c39.465-6.956,78.942-13.71,118.481-20.227 c2.828,14.273,5.555,28.51,7.961,42.858c1.398,8.333,2.797,16.667,4.195,25c0.494,2.957-0.082,5.769-1.508,8.381 c-2.91,5.346-7.973,10.132-11.719,14.883c-5.119,6.487-6.697,8.483-7.229,16.402c-1.094,16.219-2.18,32.438-3.332,48.653 C343.139,190.611,319.419,188.887,295.776,186.421z"
    },
    {
        city: "Victoria",
        name: "burnside",
        dPath: "M203.172,158.491 c2.109,1.721,3.781,0.652,4.248-1.505c0.46-2.127-1.959-6.041-3.89-7.091c-3.337-1.813-7.928,0.471-10.858,1.984 c-3.448,1.78-9.791,6.704-11.639,0.35c-0.96-3.305,1.264-5.537-0.057-9.4c-0.782-2.288-2.115-15.165-7.278-13.339 c-1.512,0.535-1.376,4.219-3.213,3.66c-3.04-0.924,3.542-7.857,3.501-7.799c1.868-2.657,2.225-5.639,3.896-8.258 c0.614-0.962,2.666-1.749,2.755-2.997c0.161-2.243-4.229,0.244-5.114,0.753c-0.502,0.289-0.668,1.467-1.007,1.569 c-0.767,0.228-2.754-0.11-3.163,0.127c-3.304,1.923-2.26,5.36-6.25,7.218c-2.927,1.364-4.221,2.207-6.657,3.865 c-1.532,1.042-2.077,1.656-4.119,1.44c-5.144-0.541-1.351-3.185-4.018-4.298c-1.167-0.487-0.922,0.159-1.646,0.574 c-0.19,0.109,0.35,1.434,0.013,1.785c-1.973,2.066-4.827,3.784-7.487,4.809c-4.63,1.785-13.131,2.839-17.893,1.491 c-2.647-0.75-6.691-2.667-8.418-4.974c-1.199-1.604-1.173-3.588-2.397-5.165c-1.703-2.192-4.586-4.065-6.518-6.211 c-1.309-1.454-5.601-4.198-5.726-6.122c-0.191-2.957,8.826-12.432,11.114-15.691c6.789-9.669,13.579-19.338,20.366-29.007 c5.138-7.318,10.276-14.635,15.414-21.952c7.032,5.3,14.065,10.6,21.097,15.9c3.923,2.957,7.845,5.913,11.768,8.869 c2.845,2.144,4.934,0.924,8.518,0.294c12.81-2.247,25.623-4.497,38.442-6.686l-0.025-0.039c11.037-1.87,22.033-4.006,33.044-6.02 c4.833,13.096,9.667,26.191,14.502,39.287c3.543,9.599,8.625,18.751,11.975,28.332c3.481,9.957,4.237,21.292,6.215,31.63 c1.94,10.134,4.772,20.212,3.056,30.57c0.031,0.009,0.049,0.001,0.051-0.025l11.861,1.237l-2.755,31.068l-3.724-0.333 c1.429,4.46,1.467,8.88,1.582,13.532l-19.104,0.407l-0.153-8.609l-4.809,0.102l0.127,5.153l-8.404,0.177v-0.279l-1.122,0.024 l0.025,1.136l-3.507,0.075l0.076,2.615l-17.23,0.383l-0.077-3.036l-10.662,0.269c-0.248-5.375,0.409-6.888-1.48-11.581 c-2.217-5.514-3.067-12.178-1.747-17.983c3.388-14.894,14.613,12.692,21.591,4.706c3.409-3.899-1.204-5.84-3.94-7.091 c-4.279-1.953-6.521-6.233-9.438-9.897c-2.593-3.254-4.594-4.733-8.825-2.205c-0.876,0.522-3.36,0.251-2.066,2.334 c0.61,0.981,4.806-1.674,3.214,1.53c-0.662,1.332-3.823,1.946-4.999,2.959c-1.841,1.586-2.923,3.744-4.999,5.185 c-2.435,1.687-4.518,1.418-7.078,2.263c-1.94,0.641-2.582,1.582-4.286,2.59c-3.883,2.297-12.317,2.881-16.184,0.038 c-4.833-3.554,0.083-11.128-2.372-16.056c-0.639-1.285-2.115-0.894-2.5-2.002c-0.406-1.174,0.752-3.731,0.574-5.229 c-0.294-2.478-0.777-4.865-0.982-7.359c-0.308-3.725-4.129-7.757-0.995-11.301C193.333,159.048,200.222,157.616,203.172,158.491z"
    },
    {
        city: "Victoria",
        name: "north-park",
        dPath: "M307.611,187.658 c19.742,1.6,39.477,3.28,59.217,4.922l-6.824,79.927l-48.668-4.413l0.944-10.393l-11.274-1.021 c0.836-12.131,3.949-26.368,0.127-38.287l3.724,0.333L307.611,187.658z"
    },
    {
        city: "Victoria",
        name: "fairfield",
        dPath: "M289.031,339.72 c2.391-2.174,5.121-3.376,4.929-6.682c-0.165-2.838-0.723-5.863-0.258-8.683c1.245-7.535,2.489-15.07,3.733-22.604 c6.31,1.031,12.617,2.071,18.927,3.11l-0.854,5.088l38.53,6.354l0.84-5.103l23.365,3.853c-2.127,12.794-4.203,25.595-6.264,38.401 c9.553,1.54,21.191,1.491,30.215,5.075c6.396,2.541,7.695,9.957,10.547,15.485c3.24,6.282,9.982,6.503,16.193,7.521 c12.934,2.122,24.988,4.178,38.102,3.267c1.525,21.223,3.25,42.032,3.174,63.27c-15.092-4.044-26.029,0.347-39.486,7.422 c-7.496,3.945-13.209,8.501-19.488,14.053c-5.891,5.211-15.424,10.885-19.715,17.537c-1.926,2.982-0.561,5.57-0.65,8.878 c-0.074,2.662-1.773,5.358-1.137,8.123c1.146,4.958,7.342,8.586,3.674,14.283c-2.66,4.135-6.758,4.279-9.273,0.51 c-3.408-5.114-0.326-10.677-4.498-15.993c-13.207-16.821-36.982-28.474-58.688-27.215c-6.553,0.381-14.945,2.499-21.304,0.93 c0.694-4.252,0.404-10.295,2.526-14.105c0.987-1.771,3.129-2.671,4.081-4.783c2.285-5.068,0.963-12.247-1.875-16.797 c-2.699-4.322-6.744-7.878-10.801-10.878c-1.785-1.318-5.716-2.78-6.887-4.745c-0.917-1.537-0.81-5.229-0.688-6.987 c0.198-2.873,1.501-9.48,5.076-9.629v-0.014h0.051v-0.013h0.026v-0.015h0.012v-0.013h0.012v-0.012h0.013v-0.025h0.012 c0.01-0.039,0.014-0.054,0.012-0.103H291.2v-0.037h-0.012c-4.28-2.543,1.154-11.59,1.314-15.648 c0.245-6.232-0.424-10.557,1.829-16.672c0.958-2.596,2.867-3.681,1.193-5.623c-1.106-1.283-5.083-0.734-6.836-1.693 c-1.13-0.623-1.838-1.464-2.729-2.361c-2.389-2.402-3.514-3.667-6.555-5.075c-1.896-0.879-2.274,0.579-3.112-1.402 c-0.522-1.237,1.609-3.64,2.039-4.3C281.826,350.297,285.373,344.988,289.031,339.72z"
    },
    {
        city: "Victoria",
        name: "gonzales",
        dPath: "M470.182,425.959 c-3.178-12.885-2.197-27.904-3.146-41.154c15.084-1.145,27.482-8.086,41.166-14.222c-2.072-6.593-6.93-15.114-5.234-21.957 c2.141-8.648,5.678-15.009,9.988-22.885c1.439-2.625,4.301-6.09,4.951-9.041c0.852-3.87-0.336-9.146-0.482-13.12 c-0.291-7.912-0.555-15.825-0.832-23.738l50.85,0.141c-1.477,45.25-2.961,90.5-4.4,135.75l-27.152-0.256 c3.273,7.051,5.566,11.588,5.549,19.27c-9.146-2.098-17.193-4.104-24.613,2.947c-5.018,4.766-1.406,9.121,1.758,13.367 c3.723,4.99,0.178,9.562-4.525,13.184c-6.75,5.201-13.158,3.539-20.459,1.24c-4.482-1.413-14.723,1.336-17.293-4.465 c-0.928-2.098,0.885-4.307,0.523-6.542c-0.527-3.26-3.453-5.853-6.619-6.403C470.234,440.786,470.902,433.199,470.182,425.959z"
    }
];
const $a008cc9275029c4f$export$ad3b1d218268814f = [
    "640,0 345.868,0 347.516,10.411 347.033,11.553 348.197,12.989 349.598,13.295 350.621,13.073 351.445,12.461 377.473,30.377 377.579,30.909 376.905,32.177 377.375,32.377 378.209,30.859 398.499,43.795 399.227,42.655 397.817,41.773 397.511,42.209 397.191,41.987 397.981,40.587 398.699,40.611 399.355,40.165 399.661,40.659 400.131,40.741 400.285,40.295 400.203,39.883 400.471,39.835 402.649,43.951 410.283,48.337 410.129,49.065 414.879,51.769 416.797,51.817 417.775,50.465 415.967,32.121 419.271,29.171 419.767,38.943 420.307,39.307 419.789,39.601 419.919,40.661 420.635,41.237 428.267,41.933 428.845,41.287 429.489,41.675 429.877,42.403 429.725,45.027 431.289,46.673 430.613,44.087 432.939,42.195 435.021,42.405 435.281,42.017 435.563,33.369 435.841,41.839 436.936,42.239 437.993,41.981 438.102,36.219 438.431,35.817 438.499,31.689 440.075,31.759 440.297,30.253 441.169,30.241 441.183,31.333 442.475,31.333 442.431,27.371 443.547,27.371 443.489,33.369 443.985,33.357 443.887,27.021 445.149,26.315 451.709,26.655 451.521,31.499 449.755,31.675 449.499,41.729 451.909,41.857 453.027,28.849 454.181,27.403 453.919,26.887 453.415,27.369 452.745,26.825 453.213,15.417 453.919,14.769 454.307,13.723 453.965,12.309 454.825,13.593 454.825,30.069 475.72,30.569 475.846,30.179 482.688,29.779 482.739,29.519 483.363,29.519 483.354,29.791 485.903,29.673 489.573,21.043 490.065,21.489 486.447,31.051 486.659,31.451 486.85,31.451 490.029,22.611 490.501,22.871 490.642,22.755 497.957,27.543 497.835,27.727 498.153,27.963 498.249,27.809 498.463,27.985 498.911,30.183 499.325,30.749 499.325,31.375 500.335,32.917 498.065,35.785 498.523,36.069 499.348,34.825 499.896,35.785 499.827,36.749 503.921,39.619 503.131,40.761 503.495,41.019 504.331,39.725 504.461,39.817 504.661,39.759 505.319,38.819 505.401,38.793 506.644,39.479 506.825,40.219 508.39,41.313 507.319,43.089 508.896,44.263 508.68,44.583 508.797,44.675 508.743,44.723 508.463,44.547 508.333,44.783 508.605,44.923 507.757,46.207 507.885,46.311 507.871,46.359 508.107,46.501 508.191,46.431 508.355,46.393 509.001,45.419 509.237,45.595 508.06,47.863 508.189,47.981 508.257,47.921 508.505,48.087 508.493,48.145 508.686,48.299 510.229,46.253 510.474,46.419 509.841,47.381 509.899,47.697 510.058,47.851 510.093,47.791 510.247,47.897 511.043,46.731 511.409,46.953 511.633,46.647 511.409,46.481 511.646,46.095 511.93,46.293 512.201,45.897 512.117,45.803 512.211,45.685 512.469,45.855 512.105,46.409 513.327,47.241 514.221,46.007 514.537,46.231 516.352,43.535 516.655,43.701 515.865,44.889 516.726,45.477 517.523,44.349 517.447,44.269 517.663,43.939 518.64,44.599 518.367,45.035 519.485,45.727 519.661,45.421 519.941,45.575 519.107,47.283 519.233,47.531 520.352,48.281 520.848,47.763 521.009,47.715 522.315,48.483 522.411,48.329 522.797,48.529 522.983,48.469 525.113,50.003 525.325,49.979 525.701,49.577 526.726,50.141 526.571,50.401 526.619,50.461 526.427,50.745 526.341,50.685 525.85,51.461 526.141,51.603 526.201,51.779 526.457,51.923 526.469,52.027 526.541,52.145 526.775,52.205 526.976,52.145 527.159,51.967 527.277,52.037 526.913,52.567 526.815,53.485 529.385,55.177 524.587,62.589 525.237,63.001 529.224,57.145 529.039,57.027 529.976,55.603 533.375,57.215 532.854,58.027 533.151,58.215 532.903,58.581 533.717,59.123 533.943,58.807 534.766,59.313 536.047,58.795 531.885,65.183 532.308,65.441 533.241,64.087 533.631,64.323 536.795,59.499 537.18,59.629 537.239,59.851 538.827,60.943 538.381,62.097 538.64,62.721 547.801,68.921 559.479,68.531 559.867,69.823 560.102,70.009 567.213,69.231 567.995,68.293 575.415,67.669 576.403,66.679 577.545,66.315 578.169,66.551 591.591,63.513 591.651,63.797 593.432,63.619 593.808,63.853 593.394,69.863 605.184,75.447 605.245,76.493 606.083,76.951 606.969,76.223 610.667,77.967 619.335,71.531 623.781,73.581 621.51,76.155 620.841,75.531 615.465,81.189 630.203,88.163 630.766,87.305 635.507,89.727 634.201,92.207 634.461,92.417 635.037,91.537 635.346,91.665 634.955,92.417 635.167,92.711 635.943,93.149 635.731,93.667 636.483,94.137 636.801,93.749 637.529,94.033 637.917,93.985 640,86.758 ",
    "640,127.883 631.589,126.733 630.601,128.343 628.061,127.381 628.449,125.357 625.803,124.321 625.075,125.931 623.781,125.367 622.475,120.801 619.023,120.297 617.857,122.123 616.095,121.909 615.731,123.099 612.999,122.767 612.897,119.603 595.391,126.683 595.341,127.307 594.153,127.307 592.001,128.765 591.001,128.649 588.969,129.987 588.335,131.141 587.903,130.649 585.439,132.517 584.357,130.999 584.617,130.777 584.315,130.459 581.801,132.245 583.575,134.565 582.693,135.235 582.759,135.415 581.981,136.227 581.757,136.029 581.059,136.687 581.105,136.841 579.307,138.183 578.565,137.819 578.259,137.889 577.123,139.207 577.371,139.819 576.767,139.573 575.897,141.533 575.101,140.701 574.665,141.017 575.395,141.993 575.241,142.345 573.983,141.759 573.115,143.559 573.325,143.665 573.089,144.087 572.899,144.007 572.503,144.783 573.479,145.333 573.761,145.981 574.207,146.229 574.231,146.357 573.607,146.487 573.455,146.747 571.925,145.851 571.057,145.887 570.553,146.431 570.691,146.899 570.563,147.183 570.609,147.771 570.481,148.053 570.501,148.865 569.739,148.983 569.421,149.373 569.239,150.253 567.371,151.713 566.889,151.629 566.703,151.383 566.691,150.161 564.705,150.197 564.723,149.689 564.671,149.597 559.777,149.609 559.713,154.045 556.243,154.081 555.549,153.599 555.795,139.485 555.667,139.367 552.125,139.331 551.855,139.509 551.785,146.999 527.463,139.143 527.251,139.343 527.205,142.167 527.451,142.519 529.369,143.105 529.355,149.703 524.863,152.065 524.263,151.443 524.137,140.553 523.317,140.529 523.465,150.927 521.854,150.963 521.665,151.103 521.583,159.925 521.051,160.101 520.511,160.021 520.467,158.845 520.265,158.561 519.809,151.609 517.479,151.727 517.525,146.643 517.297,146.643 516.031,154.559 514.513,154.689 514.127,154.419 514.055,147.469 513.419,147.445 513.419,147.561 513.597,147.785 513.529,154.925 513.949,154.913 514.891,159.191 514.385,161.509 513.997,161.483 512.837,165.827 512.837,162.333 511.495,162.383 511.519,163.029 512.235,163.017 512.287,166.041 512.027,166.099 512.005,166.537 509.321,166.339 508.535,165.845 508.593,155.427 507.135,155.167 507.157,153.651 506.475,153.651 506.463,155.217 504.817,155.393 504.713,162.379 504.311,162.933 503.793,163.049 503.383,162.697 503.277,162.125 500.239,161.665 500.575,146.433 485.459,139.859 485.271,147.125 460.359,136.543 459.801,137.719 460.309,137.955 459.647,145.883 460.565,147.633 468.909,151.021 471.673,154.469 467.241,154.939 467.577,159.043 467.303,159.291 464.377,151.901 462.623,151.407 462.659,150.853 461.613,150.829 461.507,157.815 461.153,158.271 453.003,159.167 451.343,158.073 451.097,155.581 450.661,154.851 449.663,154.663 448.169,155.781 439.197,153.099 433.197,155.171 431.615,154.665 432.179,154.405 432.041,154.111 432.351,153.945 432.249,153.747 433.921,152.829 433.711,152.463 433.439,152.417 432.469,152.911 432.383,152.687 434.319,151.287 434.001,150.687 431.827,151.569 431.651,151.383 432.627,150.807 432.745,150.587 432.497,150.221 430.465,151.221 430.217,150.915 427.062,152.511 426.595,152.347 426.521,152.569 425.261,151.679 425.389,151.383 421.965,149.303 422.431,148.457 440.107,138.683 439.991,138.517 417.245,146.499 415.373,145.783 415.303,145.079 418.183,140.355 406.903,135.145 405.121,137.311 402.753,138.277 390.041,130.913 389.484,131.005 389.359,131.265 389.359,131.525 389.475,131.747 385.607,134.933 382.707,135.241 382.643,135.065 380.995,134.461 380.759,134.545 374.893,129.005 378.654,125.135 378.643,124.791 378.434,124.497 378.139,124.399 377.747,124.517 377.167,125.059 371.829,121.297 371.709,121.011 371.863,120.849 370.889,120.271 370.107,121.049 370.663,121.733 367.936,124.533 367.751,124.335 367.682,124.395 365.859,122.593 365.577,122.865 358.809,117.263 358.625,116.711 358.988,115.933 355.896,112.955 353.887,113.635 353.119,113.531 352.383,112.839 353.507,108.851 356.289,106.013 358.396,105.565 358.541,105.929 362.503,106.353 364.003,105.495 364.105,105.093 364.447,104.917 364.801,104.281 367.715,102.307 369.171,102.355 373.585,109.281 375.421,110.223 376.701,110.095 378.831,108.847 378.561,107.781 382.23,102.697 387.491,101.687 388.459,101.945 388.275,104.111 388.395,104.427 388.581,104.463 388.581,104.769 388.323,104.979 388.169,114.889 386.839,116.055 386.371,117.985 387.675,119.077 390.641,119.227 393.098,117.499 396.355,111.101 396.015,110.267 393.723,109.477 392.814,108.443 390.029,108.087 389.465,105.217 389.177,104.997 389.348,104.303 389.652,104.243 389.689,103.407 390.439,102.445 391.273,102.703 392.135,102.597 396.239,98.903 399.885,101.125 408.089,100.467 411.035,90.223 410.009,87.991 409.527,87.577 409.493,87.281 409.247,87.071 408.941,87.011 408.497,87.177 408.453,87.319 407.135,87.955 406.465,89.023 406.217,89.117 404.397,91.881 402.783,92.755 380.9,79.291 380.93,79.105 380.673,78.659 380.165,78.565 379.736,78.825 379.675,78.967 372.457,78.709 363.932,68.633 364.223,68.409 364.355,68.057 364.329,67.751 364.131,67.467 363.823,67.327 363.48,67.337 361.381,63.879 352.991,58.411 340.005,29.969 337.137,28.969 335.715,26.063 320.823,29.719 317.905,29.175 309.521,32.081 307.921,33.773 304.663,34.749 301.053,38.241 300.077,42.745 300.911,43.863 300.417,45.109 293.955,51.243 290.873,51.373 290.707,51.679 290.861,52.455 290.719,52.985 290.497,53.231 290.661,53.645 288.829,64.147 289.321,64.617 288.311,72.117 287.923,72.327 288.251,72.525 286.959,82.007 281.513,85.063 280.173,86.957 280.607,87.605 282.817,87.781 283.607,90.877 280.505,91.925 280.573,92.231 282.041,92.115 282.289,93.209 282.973,94.041 282.961,94.981 281.949,95.523 283.171,97.193 283.925,97.157 284.231,98.029 283.387,99.557 283.701,100.711 289.383,104.389 291.827,103.485 292.767,103.565 293.333,103.093 295.697,103.003 297.603,104.675 299.719,111.703 298.601,111.655 298.683,111.821 300.647,112.383 303.013,114.747 305.907,115.217 307.035,114.631 307.919,115.347 308.831,120.991 307.809,121.733 307.729,122.849 310.325,129.493 317.125,136.127 317.465,136.079 317.947,136.633 318.169,137.751 317.711,138.787 318.909,137.609 319.861,137.819 321.121,139.067 321.182,139.535 321.625,139.325 328.449,145.041 326.805,164.555 328.755,165.109 336.105,180.385 336.493,179.445 337.057,179.185 337.469,179.185 338.221,179.679 338.646,185.429 340.221,185.981 340.879,185.767 341.184,186.003 341.066,189.529 343.264,190.049 343.697,189.753 343.895,189.753 344.495,190.317 344.329,193.797 344.381,193.925 346.543,195.995 346.823,195.291 347.566,195.019 351.404,201.123 351.117,202.943 350.691,203.261 351.279,204.577 352.068,204.509 352.857,205.273 354.491,204.453 356.447,206.359 355.236,207.569 356.027,208.509 355.697,208.909 355.791,209.613 356.137,209.969 356.759,209.875 357.033,209.593 357.451,210.017 356.413,211.077 356.441,211.229 356.559,211.265 357.207,210.595 358.711,212.079 359.98,210.797 360.993,211.821 360.641,212.467 360.711,213.313 362.051,214.807 361.852,214.795 361.557,214.535 361.4,214.547 360.943,215.043 360.967,215.381 361.167,215.559 361.461,215.641 361.757,215.455 363.559,217.145 363.936,216.829 364.98,217.767 364.9,217.875 365.066,218.061 366.089,218.357 366.831,218.121 367.016,217.955 367.889,218.825 367.159,219.627 369.771,222.299 369.499,222.661 369.511,223.343 369.887,223.685 370.509,223.663 372.146,222.017 378.721,227.921 382.823,227.713 383.604,226.981 382.365,225.735 385.398,222.207 389.305,222.115 392.27,224.699 392.161,224.897 392.891,225.533 393.609,224.769 395.257,226.461 396.573,226.541 397.515,225.731 397.867,226.119 398.231,225.705 398.619,225.859 399.797,225.189 400.207,224.539 400.207,223.787 400.725,223.505 401.143,218.155 402.107,216.969 402.261,216.333 404.967,215.147 406.553,215.171 406.801,215.381 407.165,215.475 407.477,215.407 409.735,216.521 411.395,218.723 415.939,218.887 426.661,211.783 426.487,211.559 426.757,211.265 428.899,211.523 429.193,211.431 429.533,209.715 431.171,209.973 431.181,209.845 431.379,209.857 431.367,210.023 431.833,210.681 431.773,210.869 431.997,211.351 432.681,210.779 433.443,210.791 433.597,209.709 434.263,209.121 434.319,208.417 434.155,208.031 434.825,207.545 434.579,207.195 434.743,206.127 434.495,205.713 434.897,203.395 436.377,203.475 436.777,204.053 438.639,203.441 449.871,204.627 450.245,207.095 449.717,207.105 449.573,207.177 449.555,210.131 449.363,210.235 449.293,213.021 448.163,212.995 447.601,213.301 447.812,213.617 447.441,213.969 447.193,214.759 447.485,215.749 447.171,215.971 448.191,216.665 449.609,216.511 450.151,216.097 451.635,216.203 451.587,219.319 451.339,219.635 447.289,219.741 447.289,219.977 441.561,220.153 441.539,220.399 441.157,220.331 441.087,220.097 438.829,219.685 438.361,220.017 438.325,220.393 438.759,221.095 438.713,221.485 438.409,221.745 438.341,221.965 438.425,222.165 437.027,222.139 437.107,219.353 436.697,219.305 436.697,219.575 431.015,219.647 430.051,221.023 428.087,222.063 427.711,222.087 427.533,221.945 427.441,221.545 427.781,221.109 429.275,220.531 430.027,219.735 430.027,219.347 428.275,219.063 427.699,219.359 427.239,219.347 425.087,220.275 425.003,220.501 426.169,220.619 426.511,220.877 426.605,221.253 426.405,221.605 426.193,221.699 426.169,221.475 425.277,221.735 425.395,222.593 419.291,224.333 419.383,224.709 418.915,224.709 418.695,225.025 418.049,223.965 416.133,224.411 415.017,225.587 414.603,225.317 414.073,225.517 414.133,225.893 409.781,229.489 409.557,229.527 409.205,229.785 409.139,230.093 407.327,231.281 406.871,232.313 406.187,232.409 405.573,233.219 405.837,233.761 404.823,234.629 404.812,234.205 403.999,233.101 403.719,233.063 403.685,233.545 403.531,233.535 403.219,240.423 402.819,240.787 397.125,240.469 396.737,240.079 395.797,237.163 395.375,236.809 393.787,236.693 391.715,238.255 389.848,238.643 388.232,237.959 388.081,238.077 387.93,239.489 387.047,240.995 385.575,241.359 384.271,240.771 382.925,239.163 376.045,238.729 375.657,239.045 372.893,238.917 372.518,238.525 371.339,238.513 370.081,239.785 368.105,239.749 367.646,240.063 367.48,241.335 365.516,243.135 364.511,243.135 363.973,242.809 362.631,240.759 362.984,240.573 362.675,240.007 362.007,239.971 361.991,240.171 360.734,240.145 359.309,237.571 358.943,237.621 358.484,238.045 358.137,238.033 357.311,237.223 357.264,236.809 357.957,235.105 367.717,237.825 367.801,237.659 367.801,237.471 367.673,237.307 367.505,237.247 367.573,234.693 368.089,234.143 368.159,232.191 364.727,227.995 364.943,227.323 359.57,221.111 359.923,220.547 359.232,220.039 358.999,220.169 357.789,219.557 357.764,219.557 357.057,218.829 356.73,219.135 355.896,218.101 356.673,217.349 356.177,216.783 355.969,216.933 355.475,216.337 353.957,216.173 353.934,215.717 351.721,215.679 351.734,216.445 350.807,216.397 350.499,216.055 349.203,217.135 349.461,217.677 347.791,222.971 348.803,224.655 348.591,225.643 348.865,226.217 349.146,226.345 349.473,228.051 347.699,229.711 347.123,229.111 346.877,227.851 345.827,226.935 345.018,226.829 344.759,226.651 344.449,226.005 343.123,225.545 342.654,225.699 342.443,225.631 340.48,213.001 341.145,212.579 341.521,211.275 344.295,210.425 339.133,201.743 339.661,201.403 339.909,200.685 338.379,197.769 338.343,196.449 332.283,191.135 325.417,189.325 324.029,189.653 321.629,193.429 319.783,193.571 315.809,191.303 315.457,190.807 315.681,188.913 317.105,188.291 316.833,187.771 315.785,187.679 315.139,187.937 310.305,194.053 302.697,194.749 292.113,213.303 280.333,212.609 279.401,211.645 279.333,211.201 277.839,210.387 277.709,210.079 267.217,210.701 257.513,218.297 229.053,221.097 228.615,220.627 209.695,218.087 207.105,215.511 188.513,215.677 187.773,216.677 173.931,218.243 169.061,215.279 168.109,213.131 168.249,211.893 168.547,211.469 169.731,211.479 169.813,211.361 169.721,211.069 169.463,210.843 168.327,210.751 168.189,210.855 168.189,211.035 167.975,211.211 167.637,210.989 167.975,210.693 163.659,206.131 163.869,205.483 162.789,204.115 163.035,204.973 161.461,205.653 158.183,204.995 157.713,204.219 154.385,202.923 152.577,200.805 152.539,200.653 152.963,199.877 152.883,199.667 152.963,199.511 153.033,199.559 153.563,198.643 153.503,198.489 153.727,198.087 154.077,197.995 154.245,197.685 153.669,197.391 151.813,200.449 128.453,204.693 125.607,203.237 124.573,200.295 120.117,199.683 118.797,197.189 110.789,197.333 108.659,195.135 101.181,196.251 99.533,194.499 96.709,194.393 95.733,193.241 93.287,192.993 92.253,192.075 54.575,185.947 51.269,188.255 50.331,188.183 49.153,186.985 15.531,186.317 0,200.05 0,318.914 52.259,353.587 52.609,354.565 52.881,354.705 52.671,354.905 52.683,355.241 81.475,374.011 82.309,373.855 82.367,374.797 83.943,375.689 85.231,378.177 85.985,377.991 86.313,378.885 106.297,396.659 107.203,396.635 109.461,397.973 109.767,398.623 115.345,401.841 182.5,393.567 640,182.692 ",
    "640,182.692 182.5,393.567 115.345,401.841 109.767,398.623 115.519,401.941 114.333,403.125 112.579,410.253 110.215,410.263 110.815,413.831 112.005,415.009 112.605,419.761 106.687,417.993 103.733,420.969 102.557,424.535 99.607,426.325 92.501,424.559 92.501,425.757 103.169,429.871 90.523,438.517 0,360.172 0,367.365 71.055,434.551 77.159,434.715 87.845,444.175 90.209,444.761 90.809,445.949 101.075,450.421 99.959,452.903 111.545,460.077 113.529,480.901 0,516.833 0,518.451 39.903,505.655 40.643,505.747 118.737,480.497 120.269,478.519 120.273,478.519 121.045,477.443 140.849,479.577 141.423,482.003 142.471,482.671 144.329,482.329 149.271,478.695 153.243,481.637 147.443,524.695 142.015,533.019 139.157,532.431 134.843,536.003 130.147,549.071 127.195,550.861 125.429,553.823 125.436,556 640,556 "
];
const $a008cc9275029c4f$export$c58a162a77a2ceb0 = [
    "M-5.894,48.915c4.205,1.166,8.998-0.088,13.447,0.693c2.977,0.522,5.879,0.89,8.221,3.131 c2.004,1.919,2.164,4.661,4.114,6.459c-0.484,0.623-0.332,1.304,0.254,1.914c-0.059,0.044-0.122,0.079-0.191,0.103 c-0.223,5.577,7.948,5.273,12.006,6.555c2.603,0.82,5.344,1.48,6.484,4.16c0.929,2.18,3.271,4.405,5.855,3.417 c0.365-2.018,3.041-3.972,5.166-3.807c3.746,0.292,2.69,6.139,5.835,6.375c6.714,0.508,18.824,2.39,21.74,9.075 c0.613,1.402,1.667,3.985,1.07,5.561c-0.645,1.7-2.567,0.123-3.079,2.417c-0.788,3.533,1.474,3.811,3.022,1.301 c2.08-3.372,2.32-2.313,5.029-0.825c3.883,2.133,6.883,2.903,9.554,6.623c-0.551,0.071-1.042,0.284-1.467,0.638 c3.959,3.819,7.766,8.174,11.849,11.261l-0.473,0.408c1.608,1.046,2.619,2.461,4.081,3.738c-0.35,2.628,6.172,5.017,7.588,7.052 c1.204,1.729,0.767,3.349,2.448,4.956c1.75,1.673,3.939,2.512,5.714,4.138l0.356-0.753c8.049,3.47,23.97-0.402,28.339-8.099 c-2.233,6.582,8.006,3.623,10.241,1.04c1.917-2.217,4.323-1.348,6.377-2.914c2.019-1.54,1.348-3.99,3.75-5.013l-0.356-0.587 c2.633-2.308,8.348-0.818,10.267-4.553c-0.447,2.579-3.111,4.102-4.26,6.364c-0.613,1.208-3.612,5.648-3.647,6.466 c-0.099,2.27-3.597,3.816-3.583,5.957c0.023,4.13,4.695-2.868,6.058-3.087c1.716,2.056,7.994,17.184,6.299,18.594 c0.059,0.214,0.118,0.427,0.179,0.638l-0.815,0.307c0.005,0.964,0.341,1.658,1.173,1.797c-0.451,1.7,0.08,7.146,2.882,6.211 c2.159-0.719,6.307-3.81,9.345-4.947c4.622-1.73,6.494-3.715,9.953,0.164c1.074,1.206,4.313,5.221,1.785,6.594 c-0.845,0.458-1.792,0.299-2.711,0.057c-2.301-0.609-2.777,0.333-4.813,0.619c-3.596,0.505-5.06,0.665-7.991,2.888 c-3.49,2.648,1.325,6.431,1.919,8.884c0.709,2.929-2.11,6.905,1.058,8.635c-1.083,0.881-1.09,1.514,0.293,1.758 c-1.304,1.426-2.722,3.269-2.129,5.217c1.896-1.111,3.563-0.31,2.539,1.772c2.634,3.819-0.344,7.686,0.229,11.301 c1.077,6.778,8.759,5.525,13.189,5.827c3.047,0.208,5.257-1.782,7.619-3.333c2.548-1.675,5.668-1.361,8.449-3.349 c2.693-1.924,12.471-8.668,10.573-11.95c5.397-2.401,7.315,0.903,10.33,4.884c2.556,3.375,4.037,4.819,7.524,6.594 c2.774,1.413,6.449,5.309,2.755,8.149c-3.417,2.627-7.664-3.7-9.986-5.522c-5.487-4.305-10.256-8.729-11.44,0.918 c-0.984,8.027,2.123,14.372,5.025,21.72c-2.928,1.044-1.5,7.608-1.518,10.432h-0.459l0.115,2.513 c3.543-0.638,2.196,1.151,2.231,3.048c0.071,3.768-2.02,3.217-1.677,7.973c0.066,0.912,0.023,1.978,0.211,2.879 c0.652,3.125,0.452,1.906,1.939,3.541c2.257,2.485-1.97,3.869,0.255,5.949c-3.246,0.827-2.693,12.78-0.804,14.485 c-0.335,0.753-0.745,1.308-1.429,1.776l0.905,8.288l0.841-0.089c0.692,4.884,2.308,7.564,2.844,12.512 c3.801-1.32,2.933,4.584-1.926,4.4c-0.378,1.357-1.289,2.607-0.458,4.023c0.746,1.275,3.147,1.229,3.572,1.881 c1.027,1.578,0.431,3.001-0.473,4.318c-0.761,1.109,2.036,2.04,2.882,2.646c-2.488,3.304-5.312,0.52-8.099-0.854l-0.484,0.97 c4.255,2.102,8.522,4.178,12.766,6.3c0.334-0.688,0.682-1.369,1.047-2.041c4.461,1.128,3.115,3.78,2.577,7.385l-0.28-0.024 c-0.216,1.49-0.441,2.978-0.676,4.462l0.242,0.04c-0.358,2.308,0.089,6.599-3.431,5.508l-0.127,0.972 c-13.808-1.489-25.483-12.485-34.358-23.454l-0.919,0.728l2.385,2.819l-4.336,2.411c0.032-5.193-8.695-3.556-6.503-10.269 c0.27-0.829,1.349-0.4,1.537-1.901c0.259-2.07,0.175-1.751-1.008-3.481c-1.549-2.268-2.513-2.87-5.363-2.932 c-2.652-0.059-4.069,0.234-6.033,1.989c-1,0.894-5.26,5.591-4.878,7.084c0.791,3.088-5.732,13.96-8.768,8.922 c-1.015-0.011-1.733-0.072-2.817-0.258l-0.536,2.959c-3.026-0.402-1.901-4.055-3.687-4.947c-1.046-0.523-1.922,1.608-2.346,1.963 c-2.823,2.37-3.022,5.208-7.232,5.409l-0.523-1.696c2.922-1.554,1.794-1.853,0.383-2.194c-0.347-0.083-2.937,1.113-4.591,0.612 l0.115-0.152c-0.297-0.221-0.596-0.443-0.893-0.664l-0.446,0.536c-5.374-1.662-10.284-4.147-15.419-6.672l0.229-0.344 c-0.486-0.326-0.966-0.662-1.441-1.007l-0.307,0.406c-3.921-2.221-10.797-6.179-15.388-3.174 c-9.459,6.19,3.407,15.333,6.435,19.995c-5.189,5.082-10.435,9.734-16.044,14.35c1.294,2.072,7.77,7.299,9.438,4.105l1.531,1.25 l-0.459,0.445c0.988,1.226-0.025,1.877,0.344,2.73c0.825,1.906,0.089,0.425,1.722,1.671c1.401,1.07,5.44,2.912,7.078,2.578 l0.256,1.414l-1.505,0.293c2.415,5.188-9.299,3.576-11.542,4.988c-5.631,3.55,5.142,8.349-0.701,9.54l0.394,4.17 c-5.431,0.46-10.864,0.92-16.295,1.38c-4.719,0.4-6.164-0.786-6.38,4.092c-0.222,5.013,1.144,3.477,5.931,3.056 c5.428-0.48,10.858-0.957,16.287-1.438c-0.187,2.836-0.389,5.672-0.587,8.507c-5.42,0.462-10.843,0.894-16.267,1.337 c-0.973,0.078-5.118-0.25-5.861,0.514c-0.534,0.544-0.164,6.22,0.32,6.682c1.759,1.693,10.781-0.532,13.142-0.736 c4.985-0.429,9.969-0.858,14.954-1.278l1.339,4.044c0.374-0.042,0.662-0.221,0.816-0.549l0.421,0.23 c0.93-2.416,4.468-3.603,6.906-4.654c2.948-1.272,3.46-0.435,6.039-0.511c3.569-0.105,6.962,1.173,10.496,1.325 c2.451,1.611,4.913,4.667,7.194,6.8l0.114-0.078c0.526,0.511,9.748,7.55,9.724,7.659c-0.534,2.592,6.982,6.646,9.074,7.984 c2.837,1.809,4.979,4.769,7.442,7.076c1.62,1.518,4.759,6.102,3.82,8.348c-1.253,2.996-4.442,6.108-0.445,8.559 c3.043,1.868,3.532,6.077,5.866,7.893c1.246,0.971,3.675-0.335,4.679,1.814c1.165,2.493,2.995,1.874,5.622,2.343 c6.639,1.188,14.126-0.178,20.768,0.347c4.24,0.334,6.06,3.219,9.221,5.386c1.938,1.331,8.989,3.185,11.21,2.815 c1.808-0.303,2.652-2.098,4.311-2.157c1.431-0.052,2.518,1.947,3.875,2.296c2.343,0.598,4.329,1.282,6.307,2.683 c1.667,1.184,4.312-1.178,6.742,0.66c1.143,0.863,2.179,6.391,4.885,5.867c2.915-0.563-0.126-4.878,4.501-2.603 c4.922,2.419,0.715,3.779-0.063,5.803c-1.135,2.949-0.601,5.602,2.641,6.626c3.423,1.081,3.457-3.157,5.165-5.007 c4.762-5.158,14.73-4.435,21.073-4.643c16.712-0.549,31.858,0.143,46.973,7.983c6.994,3.629,15.178,7.873,20.732,13.557 c2.475,2.533,4.877,5.83,6.096,9.184c1.312,3.604,0.156,7.93,1.695,11.326c3.926,8.646,13.328-1.441,8.1-7.515 c-2.594-3.012-4.127-5.824-3.762-9.92c0.381-4.279,0.643-5.727-0.186-9.852c-0.824-4.114,10.924-12,13.852-14.615 c6.557-5.847,12.529-11.379,19.832-16.285c11.229-7.54,29.566-18.841,43.734-13.415c3.168,1.213,6.098,3.421,7.814,6.399 c2.135,3.697,3.941,1.033,3.477,6.385c-0.215,2.454-2.217-0.188-0.727,2.499c0.203,0.367,4.285,1.693,4.742,1.907 c4.219,1.962,7.109,1.935,11.633,2.799c7.855,1.503,14.285,2.768,21.836-1.646c6.148-3.595,10.229-12.042,2.861-15.815 c-8.418-4.309,1.979-13.31,6.51-15.151c7.852-3.192,11.932,1.937,19.203,3.025c4.873,0.728,15.787,9.614,15.168,14.677 c-0.699,5.723-6.113,0.594-6.301,7.195c-0.033,1.223,1.242,2.66,1.213,4.143c-0.018,0.901-1.367,1.263-1.746,2.042 c0.164-0.342-0.5,2.205-0.436,1.924c-0.387,1.662-2.039,2.124-0.029,3.591c2.893,2.107,5.256,5.327,7.229,8.314 c1.598,2.422,4.787,4.3,5.781,6.891c2.033,5.312,11.844,11.916,14.938,4.302c1.205-2.968,0.781-5.147,3.488-7.651 c1.949-1.804,0.111-6.533,3.234-7.754c2.219-0.872,4.949,2.964,6.721,4.023c2.336,1.395,3.189-1.408,4.309-2.965 c0.994-1.382,3.006-1.819,3.277-4.426c0.357-3.385-2.111-4.259,2.551-5.088c2.164-0.384,5.287,1.113,7.717,0.241 c3.611-1.295,3.416-4.271,4.412-7.682c1.375-4.713-7.078-7.74-9.176-12.226c-3.258-6.97,0.885-8.476,6.279-12.972 c0.689-0.573,2.133,0.524,2.668-0.664c0.443-0.979-0.99-1.94-0.854-2.932c0.447-3.255,1.697-5.429,4.754-7.084 c6.009-3.255,18.074-7.035,28.441-6.99V-18.896H-5.894V48.915z",
    "M78.604,296.464C78.628,296.46,78.625,296.458,78.604,296.464L78.604,296.464z",
    "M225.611,249.838l-5.638,1.621l-0.153-0.548c-1.548-1.456-0.696-4.367,0.6-6.095 c-0.676-0.645-0.286-1.218,0.638-1.659c-2.267-2.887,1.546-5.25-4.387-6.479c-4.122-0.854-3.386,1.266-3.865,5.319l-1.964-0.216 l0.269-2.539l-0.178-0.011l0.268-2.309c-7.457,0.807-9.785-20.436-16.745-14.793c-2.127-2.806-1.171-4.297-1.275-6.836 c-0.195-4.741-2.407-6.263-6.199-8.774c0.763-1.729-4.083-6.661-4.833-9.45c-1.045-3.886,1.035-7.585-0.166-11.3 c-1.004-3.107-4.529-5.856-6.561-8.264c-0.895-1.06-1.885-1.9-2.92-2.826c-1.742-1.554-0.281-2.087-1.027-3.412 c-0.437-0.774,0.881-1.385-0.332-2.168c-1.139-0.733-3.775,1.215-5.216,1.071c-2.697-0.269-6.099-3.144-7.117-5.624 c-0.832-2.029,0.849-5.085,0.332-6.377c-1.522-3.807-2.885,2.497-3.138,3.367l-1.046-0.115c0.371-2.819-3.408-5.069-5.955-4.974 c-3.54,0.132-4.621,3.893-7.041,5.566c-3.325,2.3-18.097,0.071-13.188-5.478c2.433,0.715,1.736-1.309,1.287-3.019 c-0.635-2.414-3.798-1.39-5.395-2.019c1.291-2.297-1.411-1.942-1.989-3.902c-0.445-1.505,1.32-3.273,0.522-5.192 c-3.19-1.938-5.235-3.287-8.43-3.38l-0.587-1.977c0.833-0.001,1.486-0.289,1.517-1.059l-1.339,0.306 c0.087-0.875-0.286-1.339-1.161-1.351c0.259-2.599-2.046-3.399-4.259-4.541v0.868h-0.408c0.259-4.798-6.825-6.115-6.594-8.813 c-0.806-0.307-1.542-0.162-2.207,0.408c-2.39-2.318-4.926-4.931-7.294-5.944l-4.082-1.172l-0.229,1.058 c-0.909-1.359-2.637-4.145-4.207-4.22c-1.683-0.082-3.594,0.118-5.186-0.475c-2.167-0.805-1.216-1.765-2.539-2.39 c-0.49-0.231-2.474-5.67-4.616-2.512c-0.544,0.802-6.378-0.643-7.722-0.67l-0.229,0.817l-5.305-0.522l-0.127,0.574 c-4.385,0.082-7.884-4.659-6.7-8.63c0.887-2.973,1.331-4.942,1.229-7.695c-0.084-2.285-1.409-4.439-0.178-6.708 c-1.243-1.438-2.023-1.04-3.654-1.459c-1.211-0.311-0.959-2.506-1.919-2.506c-2.112,0-6.618,0.814-3.826-2.973 c-3.369-1.218-7.179,2.15-10.113-1.007c-0.568-2.317-6.329-4.963-8.979-5.981c-3.544-1.363-7.599-1.126-11.141-2.768 c-4.486-2.08-8.679-0.407-13.037,0.8c-2.318,0.642-1.926,2.877-4.271,3.49v293.908c0.295-0.185,0.562-0.351,0.756-0.458 c2.518-1.394,1.741,1.322,4.222-1.639c1.827-2.181,7.684-1.481,5.012,2.646c1.783-0.078,4.797-0.677,4.961,0.805 c2.981,1.136,8.863,0.744,8.71-3.455c-0.002-0.07-2.255,0.501-2.321-0.078c-0.16-1.4,1.16-2.313,1.212-3.811 c0.083-2.413-2.297-3.68-0.37-6.327c2.292-3.147,3.476-3.599,6.926-2.71c0.392,0.101,6.156-0.716,6.057-0.356 c1.077-3.919-0.284-3.448,4.482-3.481c2.97-0.021,6.607-0.398,8.821-2.642c6.979-7.074,2.359,1.569,5.559,4.326 c2.106,1.812,0.429,4.034,3.653,4.96c3.042,0.876,4.014,1.388,6.371,0.493c3.387-1.285,1.312-2.886,3.074-5.344 c0.495-0.688,4.994-0.113,2.506-2.213c-0.049-0.041,0.509-4.168,1.174-4.699c2.704-2.164,0.038-5.377-1.311-7.171 c-0.649-0.862-2.032-3.679-2.292-4.805c-0.476-2.062,0.644-4.003-0.676-6.429c3.23-1.48-4.149-6.118-3.902-8.824 c0.144-1.561,3.32-2.623,1.565-4.287c-2.181-2.073-4.399-3.56-3.352-6.018c1.953-4.589,4.484,0.163,7.512,0.037 c1.46-0.062,1.809-1.393,3.354-1.207c2.628,0.315,4.121,1.78,5.293,4.026c0.778,1.488-0.239,3.167,1.67,3.759 c0.541,0.167,5.301-2.215,6.147-2.703c0.801-0.462,3.173-0.276,2.66-1.99c-0.29-0.965-0.203-3.417-0.938-3.768 c-2.086-0.994-2.586-0.86-3.507-3.717c-0.649-2.014-0.14-2.306-0.033-2.334c-0.08,0.013-0.469,0.014-1.638-0.421 c-1.548-0.575-4.797,0.857-5.567-1.491c-0.609-1.857-0.437-4.395-0.083-6.325c3.088,0.964,5.489,2.712,7.87,0.46 c2.722-2.579,0.985-4.434-1.104-6.524c-3.562-3.565-8.794-1.161-11.937,1.549c-1.622,1.398-5.927-1.421-7.599-2.407 c-2.52-1.482-2.976-4.582-3.075-7.203c-0.06-1.553-1.243-1.592-1.448-3.244c-0.248-1.99,0.833-3.944,0.434-6.098l1.085,0.268 c0.227-0.954,0.461-1.907,0.701-2.855l0.205,0.037l0.09-0.471c0.915-0.031,1.603,0.328,1.951,1.135 c2.75-1.411,0.759,0.991,2.487,0.969c2.455-0.033,2.453-0.889,4.107-1.99c3.148-2.093,5.253-2.757,9.094-3.315l0.356,1.392 l2.155-0.523l-0.051-0.868c3.005,0.707,8.392,1.146,8.735-3.391c-2.77-1.139-0.617-4.929,0.759-6.117 c1.255-1.083,2.943,0.198,3.558-1.563c0.183-0.52,0.935-4.361,0.886-4.31c2.52-2.738,7.396-2.258,9.426,0.192 c1.173,1.417,0.876,5.063,3.036,5.044c2.689-0.023,3.978,0.076,4.833,3.118c0.693,2.464-0.53,3.553,1.04,6.529 c1.106,2.095,2.642,2.596,4.598,0.559c0.522,0.59,0.868,1.272,1.033,2.042c-4.333,1.051-2.285,4.71,1.607,2.92 c-0.466-0.363-0.58-0.784-0.256-1.263c2.221,0.13,2.74,1.768,4.478,2.768c0.274,0.159-0.098,1.042,0.498,1.302 c1.044,0.46,1.824-0.685,2.397-0.497c1.349,0.439,2.46-0.491,3.443,0.722c0.521,0.64,0.465,1.518,1.218,1.695 c1.64,0.388,2.438-2.1,3.425-3.003c1.985-1.823,1.702-2.111,4.081-2.015c2.538,0.105,2.64,2.817,5.184,0.606 c2.475-2.153,4.496-5.281,4.419-8.579l0.639-0.113c0.691-2.122,2.167-0.625,2.546,1.33c0.586,3.021,0.191,4.854-0.825,7.774 c0.737,3.161,3.89,2.563,6.631,3.634c1.956,0.766,5.396,4.485,6.938,2.972l-0.102-0.074c2.074-1.473,4.38,0.438,3.431,2.741 l-0.126-0.076c-1.071,1.917,8.64,7.671,10.654,9.463c2.508,2.228,10.074,0.109,11.345,4.323c3.401-1.906,8.761,0.214,12.537,0.307 c3.606,0.089,6.522,2.405,10.203,1.289c0.407-2.365,3.182-4.766,4.775-6.743c2.214-2.749,3.698-5.277,5.869-8.078 c0.855-1.102,1.933-3.252,3.116-4.016c2.54-1.642,3.516,0.102,3.925-3.32c0.263-2.202,1.707-3.301,0.296-5.378l1.2-0.28 C227.258,257.313,226.421,253.577,225.611,249.838z"
];


function $b1a481d659bc8190$export$2e2bcd8739ae039({ city: city, vendors: vendors }) {
    const [selectedAreas, setSelectedAreas] = (0, $bnENU.useState)([]);
    const cityAreas = (0, $a008cc9275029c4f$export$3ceb184d70dbd166).filter((area)=>area.city === city);
    const isVancouver = city === "Vancouver";
    (0, $bnENU.useEffect)(()=>{
        setSelectedAreas([]);
    }, [
        city
    ]);
    const handleAreaClick = (areaName)=>{
        if (selectedAreas.includes(areaName)) setSelectedAreas(selectedAreas.filter((name)=>name !== areaName));
        else setSelectedAreas([
            areaName,
            ...selectedAreas
        ]);
    };
    const convertKebabToTitle = (kebab)=>{
        return kebab.split("-").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    };
    const filterCallback = (area, vendor)=>{
        return vendor.locations.some((location)=>location.neighbourhood === area);
    };
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        className: "vendorsMap-main",
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                className: "vendorsMap-map",
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 640 556",
                    enableBackground: "new 0 0 640 556",
                    xmlSpace: "preserve",
                    children: [
                        isVancouver ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
                            children: (0, $a008cc9275029c4f$export$ad3b1d218268814f).map((path, index)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("polygon", {
                                    fill: "#dfe6e9",
                                    points: path
                                }, index))
                        }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("g", {
                            children: (0, $a008cc9275029c4f$export$c58a162a77a2ceb0).map((path, index)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                                    fill: "#dfe6e9",
                                    d: path
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("g", {
                            children: cityAreas.map((area, index)=>{
                                const hasVendors = vendors.some((vendor)=>vendor.locations[0].neighbourhood === area.name);
                                const isSelected = selectedAreas.indexOf(area.name) > -1;
                                const fillColour = hasVendors ? isSelected ? "#ee2123" : "#ccc" : "#dfe6e9";
                                return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                                    className: hasVendors ? "has-vendors" : "",
                                    id: area.name,
                                    d: area.dPath,
                                    strokeMiterlimit: "10",
                                    tabIndex: hasVendors ? 0 : undefined,
                                    "aria-label": hasVendors ? `Vendors in ${convertKebabToTitle(area.name)}` : undefined,
                                    role: hasVendors ? "button" : undefined,
                                    onClick: hasVendors ? ()=>handleAreaClick(area.name) : undefined,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleAreaClick(area.name);
                                        }
                                    },
                                    fill: fillColour,
                                    stroke: "#5F5E58"
                                }, index);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                className: "vendorsMap-vendors",
                children: selectedAreas.length > 0 ? selectedAreas.map((area, idx)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        className: "vendorsMap-vendors-group",
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h2", {
                                className: "h3",
                                children: convertKebabToTitle(area)
                            }),
                            vendors.filter((vendor)=>filterCallback(area, vendor)).map((vendor)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $474f6de71d24b8f5$export$2e2bcd8739ae039), {
                                    vendor: vendor,
                                    area: area
                                }, vendor.id))
                        ]
                    }, idx + "-" + area)) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("p", {})
            })
        ]
    });
}


function $14476599dbeb1ba1$export$2e2bcd8739ae039() {
    // const baseUrl =
    //   window.location.host === "dev-megaphone-wordpress.pantheonsite.io"
    //     ? "https://megaphone-magazine-staging-d857d30ff8e7.herokuapp.com"
    //     : "http://localhost:3000";
    const baseUrl = "https://app.megaphonemagazine.com";
    const [loading, setLoading] = (0, $bnENU.useState)(true);
    const [error, setError] = (0, $bnENU.useState)(null);
    const [vendors, setVendors] = (0, $bnENU.useState)([]);
    const [location, setLocation] = (0, $bnENU.useState)("Vancouver");
    (0, $bnENU.useEffect)(()=>{
        if (vendors.length > 0) return;
        Promise.all([
            fetch(baseUrl + "/vendors.json")
        ]).then((responses)=>{
            const errors = responses.filter((response)=>!response.ok);
            if (errors.length > 0) throw errors.map((response)=>Error(response.statusText));
            const json = responses.map((response)=>response.json());
            return Promise.all(json);
        }).then((data)=>{
            setLoading(false);
            setVendors(data[0]);
        }).catch((errors)=>{
            setLoading(false);
            console.error(errors);
            setError("Something went wrong fetching the vendors.");
        });
    });
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
        children: loading ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("p", {
            children: "Loading..."
        }) : error ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("p", {
            children: error
        }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $b1a481d659bc8190$export$2e2bcd8739ae039), {
                city: location,
                vendors: vendors
            })
        })
    });
}


document.addEventListener("DOMContentLoaded", function() {
    const element = document.getElementById("vendor-map");
    if (element) {
        const root = (0, $a818400b9257b505$export$882461b6382ed46c)(element);
        root.render(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $14476599dbeb1ba1$export$2e2bcd8739ae039), {}));
    }
});



const $ba9aa8ad1adabff4$var$header = document.querySelector(".header");
const $ba9aa8ad1adabff4$var$nav = $ba9aa8ad1adabff4$var$header?.querySelector(".header-nav-main");
const $ba9aa8ad1adabff4$var$isTouchDevice = matchMedia("(hover: none)").matches;
const $ba9aa8ad1adabff4$var$submenuButtons = $ba9aa8ad1adabff4$var$nav?.querySelectorAll('button[aria-haspopup="true"]');
$ba9aa8ad1adabff4$var$submenuButtons?.forEach((anchor)=>{
    anchor.addEventListener("mouseover", (e)=>{
        $ba9aa8ad1adabff4$var$openSubmenu(anchor);
    });
    anchor.addEventListener("mouseout", (e)=>{
        const subMenu = anchor.nextElementSibling;
        if (subMenu.contains(e.relatedTarget)) {
            subMenu.addEventListener("pointerout", (e)=>{
                // TODO: this will create a new event listener every time you hover over the submenu
                // is there any way to remove it?
                if (!subMenu.contains(e.relatedTarget)) $ba9aa8ad1adabff4$var$closeSubmenus();
            });
            return;
        }
        $ba9aa8ad1adabff4$var$closeSubmenus();
    });
});
const $ba9aa8ad1adabff4$var$toggleButton = $ba9aa8ad1adabff4$var$header?.querySelector(".menu-toggle");
$ba9aa8ad1adabff4$var$toggleButton?.addEventListener("click", $ba9aa8ad1adabff4$var$handleBurgerPress);
// if user touches outside of menu, close menu
document.addEventListener("click", (e)=>{
    if ($ba9aa8ad1adabff4$var$nav?.contains(e.target)) return;
    $ba9aa8ad1adabff4$var$closeSubmenus();
});
document.addEventListener("keydown", (e)=>{
    if (e.key === "Escape") $ba9aa8ad1adabff4$var$closeSubmenus();
});
document.addEventListener("click", (e)=>{
    if ($ba9aa8ad1adabff4$var$nav?.contains(e.target)) return;
    $ba9aa8ad1adabff4$var$closeSubmenus();
});
window.addEventListener("resize", ()=>{
    $ba9aa8ad1adabff4$var$closeMobileNav();
});
// if menu, add listener for keyboard controls
if ($ba9aa8ad1adabff4$var$nav) $ba9aa8ad1adabff4$var$nav.addEventListener("keydown", (e)=>{
    const activeElement = document.activeElement;
    const navList = $ba9aa8ad1adabff4$var$nav.querySelector(".header-nav-main-list");
    // const openSubmenu = navList.querySelector("button[aria-expanded='true']") as HTMLAnchorElement | null;
    // const activeTopLevel;
    if (e.key === "ArrowRight") {
        e.preventDefault();
        if (activeElement.closest(".header-nav-main-list-item").nextElementSibling) activeElement.closest(".header-nav-main-list-item").nextElementSibling?.firstElementChild.focus();
        else navList.firstElementChild?.firstElementChild?.focus();
        $ba9aa8ad1adabff4$var$closeSubmenus();
    }
    if (e.key === "ArrowLeft") {
        e.preventDefault();
        if (activeElement.closest(".header-nav-main-list-item").previousElementSibling) activeElement.closest(".header-nav-main-list-item").previousElementSibling?.firstElementChild.focus();
        else navList.lastElementChild?.firstElementChild?.focus();
        $ba9aa8ad1adabff4$var$closeSubmenus();
    }
    if (e.key === "ArrowDown" || e.key === "Enter") {
        e.preventDefault();
        if (activeElement.getAttribute("aria-haspopup") === "true") {
            $ba9aa8ad1adabff4$var$openSubmenu(activeElement);
            activeElement.nextElementSibling?.querySelector(".header-nav-secondary-link").focus();
        } else {
            // already in subnav, move to next item. if at end of list, wrap to first item
            const nextItem = activeElement.parentElement.nextElementSibling ? activeElement.parentElement.nextElementSibling?.firstElementChild : activeElement.closest(".sub-nav").firstElementChild?.firstElementChild;
            nextItem.focus();
        }
    }
    // arrow up should move within subnav
    if (e.key === "ArrowUp") {
        e.preventDefault();
        if (activeElement.getAttribute("aria-haspopup") === "true") return;
        else {
            const prevItem = activeElement.parentElement.previousElementSibling ? activeElement.parentElement.previousElementSibling?.firstElementChild : activeElement.closest(".sub-nav").lastElementChild?.firstElementChild;
            prevItem.focus();
        }
    }
});
// right arrow or tab should move right within nav, or wrap at last
// left arrow or shift-tab should move left, or wrap at first
// down arrow, or enter should open submenu
function $ba9aa8ad1adabff4$var$openSubmenu(submenu) {
    const list = submenu.nextElementSibling;
    list.classList.add("active");
    submenu.setAttribute("aria-expanded", "true");
    document.body.classList.add("nav-open");
}
function $ba9aa8ad1adabff4$var$closeSubmenus() {
    const submenu = document.querySelector(".header-nav-main button[aria-expanded='true']");
    if (!submenu) return;
    const list = submenu.nextElementSibling;
    list.classList.remove("active");
    submenu.setAttribute("aria-expanded", "false");
    document.body.classList.remove("nav-open");
}
function $ba9aa8ad1adabff4$var$handleBurgerPress() {
    const isNavOpen = $ba9aa8ad1adabff4$var$toggleButton.getAttribute("aria-pressed") === "true";
    console.log("handleBurgerPress", isNavOpen ? "closing" : "opening");
    if (isNavOpen) $ba9aa8ad1adabff4$var$closeMobileNav();
    else $ba9aa8ad1adabff4$var$openMobileNav();
}
function $ba9aa8ad1adabff4$var$openMobileNav() {
    const nav = $ba9aa8ad1adabff4$var$header?.querySelector(".header-nav-main");
    $ba9aa8ad1adabff4$var$toggleButton.setAttribute("aria-pressed", "true");
    (0, $b73088ac51b12d07$export$24fdf68abf432c44)(nav);
    nav.style.display = "block";
    setTimeout(()=>{
        nav?.classList.add("mobile-open");
    }, 100);
}
function $ba9aa8ad1adabff4$var$closeMobileNav() {
    const nav = $ba9aa8ad1adabff4$var$header?.querySelector(".header-nav-main");
    if (!nav?.classList.contains("mobile-open")) return;
    $ba9aa8ad1adabff4$var$toggleButton.setAttribute("aria-pressed", "false");
    (0, $b73088ac51b12d07$export$45a3ef215b2a5866)();
    nav?.classList.remove("mobile-open");
    setTimeout(()=>{
        nav.style.display = "none";
    }, 100);
}
// Sticky header
const $ba9aa8ad1adabff4$var$observer = new IntersectionObserver(([e])=>e.target.classList.toggle("is-stuck", e.intersectionRatio < 1), {
    threshold: [
        1
    ]
});
$ba9aa8ad1adabff4$var$observer.observe($ba9aa8ad1adabff4$var$header);



const $cf3c565bab13824a$var$onSaleSection = document.querySelector(".onSale");
if ($cf3c565bab13824a$var$onSaleSection) {
    const coverTitles = $cf3c565bab13824a$var$onSaleSection?.querySelector(".onSale-titles");
    const coverContent = $cf3c565bab13824a$var$onSaleSection?.querySelector(".onSale-cover-content");
    const titles = coverTitles && coverTitles.querySelectorAll(".onSale-titles-item") || document.querySelectorAll(".onSale-titles-item");
    titles.forEach((title)=>{
        title.addEventListener("mouseenter", (event)=>{
            const target = event.target;
            const idx = target.getAttribute("data-idx");
            const correspondingElement = document.querySelector(`.onSale-cover-image[data-for-idx="${idx}"]`);
            if (correspondingElement) {
                (0, $15b5f22af2a86faa$export$99ee26438460406a).to(correspondingElement, {
                    opacity: 1,
                    duration: 0.5
                });
                target.classList.add("active");
                $cf3c565bab13824a$var$onSaleSection?.classList.remove("default");
                if (idx && Number(idx) > 0) (0, $15b5f22af2a86faa$export$99ee26438460406a).to(coverContent, {
                    opacity: 0,
                    duration: 0.5
                });
            }
        });
        title.addEventListener("mouseleave", (event)=>{
            const target = event.target;
            const idx = target.getAttribute("data-idx");
            const correspondingElement = document.querySelector(`.onSale-cover-image[data-for-idx="${idx}"]`);
            if (correspondingElement) {
                $cf3c565bab13824a$var$onSaleSection?.classList.add("default");
                target.classList.remove("active");
                if (idx && Number(idx) > 0) {
                    (0, $15b5f22af2a86faa$export$99ee26438460406a).to(correspondingElement, {
                        opacity: 0,
                        duration: 0.5
                    });
                    (0, $15b5f22af2a86faa$export$99ee26438460406a).to(coverContent, {
                        opacity: 1,
                        duration: 0.5
                    });
                }
            }
        });
    });
}
const $cf3c565bab13824a$var$onSaleCoverImages = document.querySelector(".featured-onSale-cover-image picture");
if ($cf3c565bab13824a$var$onSaleCoverImages) setTimeout(()=>{
    $cf3c565bab13824a$var$onSaleCoverImages.classList.add("animate-in");
}, 500);


window.addEventListener("keydown", function(e) {
    if (e.key === "g" && e.ctrlKey) document.body.classList.toggle("show-grid-vertical");
    if (e.key === "l" && e.ctrlKey) document.body.classList.toggle("show-grid-horizontal");
});


const $285081ce4a6c0a3f$var$header = document.querySelector(".header");
// set css variable for header height
function $285081ce4a6c0a3f$var$recalculateHeaderHeight() {
    if ($285081ce4a6c0a3f$var$header) {
        const headerHeight = $285081ce4a6c0a3f$var$header.offsetHeight;
        document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
    }
}
// on resize, update header height
window.addEventListener("resize", ()=>{
    $285081ce4a6c0a3f$var$recalculateHeaderHeight();
});
$285081ce4a6c0a3f$var$recalculateHeaderHeight();


const $a4a8c7c71dafd0f2$var$lastParagraph = document.querySelector("article.content .channel:not(:has(~ .channel)) .left > p:last-of-type");
if ($a4a8c7c71dafd0f2$var$lastParagraph) {
    $a4a8c7c71dafd0f2$var$lastParagraph.insertAdjacentHTML("beforeend", '<span class="end-of-story-glyph"></span>');
    const glyph = $a4a8c7c71dafd0f2$var$lastParagraph.querySelector(".end-of-story-glyph");
    if (glyph) {
        const observer = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    glyph.classList.add("show");
                    observer.unobserve(glyph);
                }
            });
        });
        observer.observe(glyph);
    }
}







})();
//# sourceMappingURL=index.js.map
